import { policies } from"./policies.js";

function icon(name, cls = 'w-5 h-5') {
 const icons = {
 logo: `<div class="flex items-center gap-2 ${cls}"><svg class="w-7 h-7"viewBox="0 0 24 24"fill="none"stroke="currentColor"stroke-width="2.5"stroke-linecap="round"stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12"y1="22.08"x2="12"y2="12"></line></svg><span class="font-black text-[1.3rem] tracking-tighter"style="letter-spacing: -0.05em;">SMARTSITE<span class="font-medium opacity-100 text-slate-400">MAKER</span></span></div>`,
 business: '<svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 24 24"fill="none"stroke="currentColor"stroke-width="2"stroke-linecap="round"stroke-linejoin="round"class="lucide lucide-building-2 w-full max-w-[2rem] h-auto"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/><path d="M10 6h4"/><path d="M10 10h4"/><path d="M10 14h4"/><path d="M10 18h4"/></svg>',
 star: `<svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 24 24"fill="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path fill-rule="evenodd"d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"clip-rule="evenodd"/></svg>`,
 star_outline: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385c.148.621-.531 1.115-1.071.8l-4.87-2.923a.563.563 0 00-.536 0l-4.87 2.923c-.54.315-1.22-.179-1.071-.8l1.285-5.385a.563.563 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"/></svg>`,
 check: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="2"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M4.5 12.75l6 6 9-13.5"/></svg>`,
 check_circle: `<svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 24 24"fill="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path fill-rule="evenodd"d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"clip-rule="evenodd"/></svg>`,
 trophy: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M18.75 4.236c.982.143 1.954.317 2.916.52a6.003 6.003 0 01-5.395 4.972m0 0a8.001 8.001 0 00-10.522 0m10.522 0H9.497m5.007 0c-.092-.258-.192-.51-.3-.75m-4.407.75c.092-.258.192-.51.3-.75m4.107 0a7.502 7.502 0 00-4.707 0"/></svg>`,
 mail: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"/></svg>`,
 document: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/></svg>`,
 rocket: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.45c.019-.104.039-.208.06-.311m-2.75 2.75V21"/></svg>`,
 home: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"/></svg>`,
 palette: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42"/></svg>`,
 crown: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385c.148.621-.531 1.115-1.071.8l-4.87-2.923a.563.563 0 00-.536 0l-4.87 2.923c-.54.315-1.22-.179-1.071-.8l1.285-5.385a.563.563 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"/></svg>`,
 lock: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"/></svg>`,
 close: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="2"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M6 18L18 6M6 6l12 12"/></svg>`,
 dashboard: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"/></svg>`,
 warning: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>`,
 menu: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"/></svg>`,
 mobile: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"/></svg>`,
 bot: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H7.5A2.25 2.25 0 005.25 6.75v10.5A2.25 2.25 0 007.5 19.5z"/></svg>`,
 search: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/></svg>`,
 money: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>`,
 trash: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"/></svg>`,
 settings: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"/><path stroke-linecap="round"stroke-linejoin="round"d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>`,
 free: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"/></svg>`,
 plus: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M12 4.5v15m7.5-7.5h-15"/></svg>`,
 bolt: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"/></svg>`,
 bulb: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.82 1.508-2.316a7.5 7.5 0 10-7.516 0c.85.496 1.508 1.333 1.508 2.316V18"/></svg>`,
 error: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>`,
 bell: `<svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 24 24"fill="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path d="M5.85 3.5a.75.75 0 00-1.117-1 9.719 9.719 0 00-2.348 4.876.75.75 0 001.479.248A8.219 8.219 0 015.85 3.5zM19.267 2.5a.75.75 0 10-1.118 1 8.22 8.22 0 011.987 4.124.75.75 0 001.48-.248A9.72 9.72 0 0019.266 2.5z"/><path fill-rule="evenodd"d="M12 2.25A6.75 6.75 0 005.25 9v.75a8.217 8.217 0 01-2.119 5.52.75.75 0 00.298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 107.48 0 24.583 24.583 0 004.83-1.244.75.75 0 00.298-1.205 8.217 8.217 0 01-2.118-5.52V9A6.75 6.75 0 0012 2.25zM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 004.496 0l.002.1a2.25 2.25 0 11-4.5 0z"clip-rule="evenodd"/></svg>`,
 bell_outline: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"/></svg>`,
 users: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"/></svg>`,
 gift: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"/></svg>`,
 globe: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.974 0-5.699-1.084-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"/></svg>`,
 briefcase: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M20.25 14.15v4.25c0 1.094-.896 1.95-1.95 1.95H5.702c-1.054 0-1.95-.856-1.95-1.95v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"/></svg>`,
 shield: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>`,
 logout: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"/></svg>`,
 calendar: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"/></svg>`,
 image: `<svg xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"stroke-width="1.5"stroke="currentColor"class="${cls} w-full max-w-[2rem] h-auto"><path stroke-linecap="round"stroke-linejoin="round"d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/></svg>`,
 };
 return icons[name] || '';
}
import './bootstrap';


const apiBase = '/api/v1';
const state = {
 token: localStorage.getItem('ssm_token'),
 user: (() => { try { const u = localStorage.getItem('ssm_user'); return (u && u !== 'undefined') ? JSON.parse(u) : null; } catch(e) { return null; } })(),
 originalAdminToken: localStorage.getItem('ssm_orig_token'),
 originalAdminUser: (() => { try { const u = localStorage.getItem('ssm_orig_user'); return (u && u !== 'undefined') ? JSON.parse(u) : null; } catch(e) { return null; } })(),
 analytics: null,
 jobs: [],
 contracts: [],
 currentJob: null,
 currentContract: null,
 messages: [],
 messageCursor: null,
 notifications: [],
 notificationCursor: null,
 unreadNotifications: 0,
 invoice: null,
 kycDocuments: [],
 freelancerProfile: null,
 freelancerReviews: null,
 disputes: [],
 proposals: [],
 pendingPayments: [],
 adminUsers: [],
 adminContracts: [],
 adminJobs: [],
 adminWithdrawals: [],
 // Phase 2
 platformStats: null,
 freelancers: [],
 currentFreelancer: null,
 skillTests: [],
 currentSkillTest: null,
 membershipPlans: [],
 myMembership: null,
 portfolio: [],
 clientProfile: null,
 referralData: null,
 notificationPrefs: [],
 adminRevenue: null,
 searchResults: null,
 loading: false,
 modal: null,
 // Phase 3 — New features
 announcements: [],
 savedFreelancers: [],
 leaderboard: [],
 forumPosts: [],
 currentForumPost: null,
 myAchievements: [],
 adminReports: [],
 adminAnnouncements: [],
 adminFeatured: null,
 scheduledMessages: [],
 pricingSuggestion: null,
};

const h = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({
 '&': '&amp;', '<': '&lt;', '>': '&gt;',"'": '&#039;', '"': '&quot;',
}[char]));
const money = (value, currency = 'INR') => new Intl.NumberFormat('en-IN', {
 style: 'currency', currency, maximumFractionDigits: 0,
}).format(Number(value || 0));
const titleCase = (value = '') => String(value).replaceAll('_', ' ').replace(/\b\w/g, (char) => char.toUpperCase());
const route = () => location.hash.replace(/^#\/?/, '') || 'dashboard';
const formObject = (form) => Object.fromEntries(new FormData(form));

window.onlineCount = Math.floor(Math.random() * (1100 - 700 + 1)) + 700;
setInterval(() => {
 const change = Math.floor(Math.random() * 41) - 20; // -20 to +20
 window.onlineCount += change;
 if (window.onlineCount < 400) window.onlineCount = 400;
 if (window.onlineCount > 1500) window.onlineCount = 1500;
 document.querySelectorAll('.online-freelancers-count').forEach(el => {
 el.innerHTML = `<span class="w-2 h-2 rounded-full bg-amber-400 animate-pulse mr-1.5 inline-block"></span>${window.onlineCount} online now`;
 });
}, 8000);

function avatar(user, size = 'w-9 h-9 text-base') {
 let initials = '?';
 if (user?.name) {
    const parts = user.name.trim().split(/\s+/);
    if (parts.length > 1) {
        initials = (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    } else {
        initials = parts[0].substring(0, Math.min(2, parts[0].length)).toUpperCase();
    }
 }
 const rawSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="#6366f1"/><text x="50%" y="50%" font-family="sans-serif" font-weight="bold" font-size="45" fill="white" text-anchor="middle" dominant-baseline="central" letter-spacing="1">${initials}</text></svg>`;
 const fallbackSrc = `data:image/svg+xml,${encodeURIComponent(rawSvg)}`;

 if (user?.avatar_url) {
 return `<img class="${size} rounded-full object-cover" src="${h(user.avatar_url)}" alt="${h(user.name)}" onerror="this.onerror=null; this.src='${fallbackSrc}';">`;
 }
 
 return `<img class="${size} rounded-full object-cover" src="${fallbackSrc}" alt="${h(user?.name || '?')}">`;
}

function earningsSvgChart() {
 const months = ['Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'];
 const values = [12000, 18500, 15000, 24000, 29000, 35000];
 const maxVal = Math.max(...values);
 
 const barsHtml = values.map((val, idx) => {
 const height = (val / maxVal) * 80;
 const y = 90 - height;
 const x = 30 + idx * 42;
 

 return `
 <g class="group cursor-pointer">
 <rect x="${x}"y="${y}"width="20"height="${height}"rx="3"fill="url(#tealGrad)"class="transition-all duration-300 hover:fill-teal-300"/>
 <text x="${x + 10}"y="105"fill="#94a3b8"font-size="8"text-anchor="middle"font-weight="bold">${months[idx]}</text>
 <text x="${x + 10}"y="${y - 8}"fill="#51e2d4"font-size="8"text-anchor="middle"class="opacity-0 group-hover:opacity-100 transition-opacity font-bold">${money(val)}</text>
 </g>
 `;
 }).join('');

 

 return `
 <div class="mt-6 rounded-2xl neu-raised p-4">
 <p class="text-xs font-semibold text-slate-600 mb-4">Historical Income Trend (Last 6 Months)</p>
 <div class="relative w-full overflow-x-auto">
 <svg viewBox="0 0 280 120"class="w-full min-w-[260px] h-32">
 <defs>
 <linearGradient id="tealGrad"x1="0"y1="0"x2="0"y2="1">
 <stop offset="0%"stop-color="#2dd4bf"stop-opacity="0.85"/>
 <stop offset="100%"stop-color="#6366f1"stop-opacity="0.25"/>
 </linearGradient>
 </defs>
 <line x1="20"y1="30"x2="270"y2="30"stroke="rgba(255,255,255,0.03)"stroke-dasharray="3,3"/>
 <line x1="20"y1="60"x2="270"y2="60"stroke="rgba(255,255,255,0.03)"stroke-dasharray="3,3"/>
 <line x1="20"y1="90"x2="270"y2="90"stroke="rgba(255,255,255,0.05)"/>
 ${barsHtml}
 </svg>
 </div>
 </div>
 `;
}

function showPopup({ title, message, type = 'info', inputs = [], buttons = [] }) {
 return new Promise((resolve) => {
 const modalDiv = document.createElement('div');
 modalDiv.className = 'fixed inset-0 z-[100] grid place-items-center neu-raised/80 p-4 backdrop-blur-sm';
 
 let inputsHtml = '';
 if (inputs.length) {
 inputsHtml = inputs.map(input => {
 if (input.inputType === 'select') {
 const optionsHtml = (input.options || []).map(opt => `<option value="${h(opt.value)}"${opt.value === input.value ? 'selected' : ''}>${h(opt.label)}</option>`).join('');
 return `
 <div class="mt-4">
 <label class="block text-sm font-semibold text-slate-600 mb-1">${h(input.label)}</label>
 <select class="input-control mt-0 w-full"id="${input.id}">
 ${optionsHtml}
 </select>
 </div>
 `;
 }
 return `
 <div class="mt-4">
 <label class="block text-sm font-semibold text-slate-600 mb-1">${h(input.label)}</label>
 <input class="input-control mt-0 w-full"id="${input.id}"type="${input.type || 'text'}"placeholder="${h(input.placeholder || '')}"value="${h(input.value || '')}">
 </div>
 `;
 }).join('');
 }

 const buttonsHtml = buttons.map((btn, index) => `
 <button class="${btn.primary ? 'btn-primary' : 'btn-secondary'} px-4 py-2 text-sm"data-btn="${index}">
 ${h(btn.text)}
 </button>
 `).join('');

 modalDiv.innerHTML = `
 <div class="glass-panel w-full max-w-md rounded-3xl p-4 md:p-6 shadow-2xl bg-slate-990 animate-in fade-in zoom-in duration-200">
 <div class="flex items-center gap-3">
 <span class="text-2xl">${type === 'error' ? `${icon('error')}` : type === 'warn' ? `${icon('warning')}` : `${icon('bell')}`}</span>
 <h3 class="text-base md:text-xl font-black text-slate-900">${h(title)}</h3>
 </div>
 <p class="mt-4 text-sm text-slate-600 leading-6">${h(message)}</p>
 ${inputsHtml}
 <div class="mt-6 flex justify-end gap-3">
 ${buttonsHtml}
 </div>
 </div>
 `;

 document.body.appendChild(modalDiv);

 if (inputs.length) {
 const focusEl = modalDiv.querySelector('input, select');
 if (focusEl) focusEl.focus();
 }

 modalDiv.querySelectorAll('[data-btn]').forEach(btnEl => {
 btnEl.addEventListener('click', () => {
 const btnIdx = Number(btnEl.dataset.btn);
 const btnConfig = buttons[btnIdx];
 
 let result = true;
 if (btnConfig.value === 'confirm') {
 if (inputs.length) {
 const inputEl = modalDiv.querySelector('input, select');
 result = inputEl ? inputEl.value : true;
 }
 } else {
 result = false;
 }

 modalDiv.remove();
 resolve(result);
 });
 });
 });
}

function alertPopup(title, message) {
 return showPopup({
 title,
 message,
 type: 'info',
 buttons: [{ text: 'OK', primary: true, value: 'confirm' }]
 });
}

function confirmPopup(title, message) {
 return showPopup({
 title,
 message,
 type: 'warn',
 buttons: [
 { text: 'Cancel', value: 'cancel' },
 { text: 'Confirm', primary: true, value: 'confirm' }
 ]
 });
}

function promptPopup(title, message, placeholder = '', defaultValue = '') {
 return showPopup({
 title,
 message,
 type: 'info',
 inputs: [{ id: 'prompt-input', label: 'Response Details', placeholder, value: defaultValue }],
 buttons: [
 { text: 'Cancel', value: 'cancel' },
 { text: 'Submit', primary: true, value: 'confirm' }
 ]
 });
}

function selectPopup(title, message, options, defaultValue = '') {
 return showPopup({
 title,
 message,
 type: 'info',
 inputs: [{ id: 'prompt-input', inputType: 'select', label: 'Response Details', options, value: defaultValue }],
 buttons: [
 { text: 'Cancel', value: 'cancel' },
 { text: 'Submit', primary: true, value: 'confirm' }
 ]
 });
}

function notify(message, type = 'info') {
 const toast = document.querySelector('#toast');
 if (!toast) return;
 toast.textContent = message;
 toast.className = `fixed bottom-5 left-1/2 z-[70] -translate-x-1/2 rounded-2xl px-4 py-3 text-sm font-semibold shadow-2xl ${type === 'error' ? 'border-rose-200 bg-rose-50 text-rose-700' : 'border-teal-300/30 neu-raised text-blue-700'}`;
 clearTimeout(window.__toastTimer);
 window.__toastTimer = setTimeout(() => toast.classList.add('hidden-toast'), 3200);
}

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

async function subscribeToPushNotifications() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    
    try {
        const registration = await navigator.serviceWorker.ready;
        const vapidPublicKey = document.querySelector('meta[name="vapid-public-key"]')?.getAttribute('content');
        if (!vapidPublicKey) return;

        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
        });

        await request('/push-subscriptions', {
            method: 'POST',
            body: JSON.stringify(subscription)
        });
    } catch (e) {
        console.error('Push subscription failed:', e);
    }
}

function requestNotificationPermission() {
 if ("Notification"in window) {
 if (Notification.permission !=="granted"&& Notification.permission !=="denied") {
 notify('Requesting browser permission...', 'info');
 Notification.requestPermission().then(permission => {
 if (permission ==="granted") {
     notify('Browser notifications enabled!', 'success');
     subscribeToPushNotifications();
 } else {
     notify('Permission was not granted.', 'error');
 }
 });
 } else if (Notification.permission ==="granted") {
 notify('Browser notifications are already enabled! Subscribing to push...', 'success');
 subscribeToPushNotifications();
 } else {
 notify('Browser notifications are blocked. Please enable them in your browser settings (Site Settings > Notifications).', 'error');
 }
 } else {
 notify('Your browser does not support notifications.', 'error');
 }
}

window.requestNotificationPermission = requestNotificationPermission;

function nativeNotify(title, body = '') {
 if ("Notification"in window && Notification.permission ==="granted") {
 new Notification(title, { body: body, icon: '/favicon.ico' });
 }
}

async function request(path, options = {}) {
 const hasBody = options.body !== undefined;
 const response = await fetch(`${apiBase}${path}`, {
 cache: 'no-store',
 ...options,
 headers: {
 Accept: 'application/json',
 ...(hasBody && !(options.body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}),
 ...(state.token ? { Authorization: `Bearer ${state.token}` } : {}),
 ...(options.headers || {}),
 },
 });
 const payload = await response.json().catch(() => ({}));
 if (response.status === 401 && state.user) logout(false);
 if (!response.ok) {
 const specificError = Object.values(payload.errors || {}).flat()[0];
 const errorMessage = specificError || payload.message || 'Something went wrong.';
 const err = new Error(errorMessage);
 err.errors = payload.errors;
 throw err;
 }
 return payload;
}

async function loadNotifications() {
 if (!state.user) return;

 try {
 const result = await request(`/notifications`);
 state.notifications = result.data || [];
 state.unreadNotifications = result.meta?.unread_count || 0;
 state.notificationCursor = result.meta?.server_time || state.notificationCursor;
 if (state.notifications.length) {
 notify(`${state.notifications.length} new notification${state.notifications.length === 1 ? '' : 's'}.`);
 }
 render();
 } catch (error) {
 notify(error.message, 'error');
 }
}

async function loadCore() {
 state.loading = true;
 render();
 try {
 const tasks = [request('/jobs')];
 if (state.user) tasks.push(request('/analytics'), request('/contracts'));
 const [jobs, analytics, contracts] = await Promise.all(tasks);
 state.jobs = jobs.data || [];
 if (analytics) state.analytics = analytics;
 if (contracts) state.contracts = contracts.data || [];

 // Always load announcements for logged-in users
 try {
 const ann = await request('/announcements');
 state.announcements = ann.data || [];
 } catch (_) { state.announcements = []; }

 // Clients: pre-load their saved freelancer IDs for bookmark buttons
 if (state.user?.role === 'client') {
 try {
 const saved = await request('/saved-freelancers');
 state.savedFreelancers = (saved.data || []).map(u => u.id);
 } catch (_) { state.savedFreelancers = []; }
 }
 } catch (error) {
 notify(error.message, 'error');
 } finally {
 state.loading = false;
 render();
 }
}

async function navigate(path) {
 if (!path) return;
 path = path.replace(/^#/, '');
 
 // If we're already on this path, force a refresh of the data
 if (window.location.hash === `#${path}` || (window.location.hash === '' && path === 'home')) {
 await Promise.all([
 loadCore(),
 loadRouteData()
 ]);
 } else {
 window.location.hash = path;
 }
}

async function loadRouteData() {
  const path = route();
  const publicRoutes = ['marketplace', 'freelancers', 'skill-tests', 'leaderboard', 'forum', 'blog'];
  const jobMatch = path.match(/^jobs\/(\d+)$/);
  const isPublicRoute = publicRoutes.includes(path) || path.startsWith('freelancers/') || path.startsWith('forum/') || path.startsWith('blog/') || jobMatch;
  if (!state.user && !isPublicRoute) return render();
  const contractMatch = path.match(/^contracts\/(\d+)$/);
 state.loading = true;
 try {
 if (jobMatch) {
 const [jobRes, propRes] = await Promise.all([
 request(`/jobs/${jobMatch[1]}`),
 request(`/jobs/${jobMatch[1]}/proposals`).catch(e => {
 console.error('Failed to load proposals', e);
 return { data: [] };
 })
 ]);
 state.currentJob = jobRes.data;
 state.proposals = propRes.data || [];
 } else if (path === 'dashboard' && state.user.role !== 'admin') {
 if (state.user.role === 'client') {
 state.freelancers = (await request('/freelancers')).data || [];
 } else if (state.user.role === 'freelancer') {
 state.jobs = (await request('/jobs')).data || [];
 }
 } else if (path === 'marketplace') {
 state.jobs = (await request('/jobs')).data || [];
 } else if (path === 'contracts') {
 state.contracts = (await request('/contracts')).data || [];
 } else if (path === 'manage-jobs') {
 state.myJobs = (await request('/my-jobs')).data || [];
 } else if (contractMatch) {
 state.currentContract = (await request(`/contracts/${contractMatch[1]}`)).data;
 state.contractTasks = (await request(`/contracts/${contractMatch[1]}/tasks`)).data || [];
 if (state.currentContract.payment_type === 'hourly') {
 state.timeLogs = (await request(`/contracts/${contractMatch[1]}/time-logs`)).data || [];
 } else {
 state.timeLogs = [];
 }
 const messages = await request(`/contracts/${contractMatch[1]}/messages`);
 state.messages = messages.data?.data || messages.data || [];
 state.messageCursor = messages.meta?.next_after_id || state.messageCursor;
 await request(`/contracts/${contractMatch[1]}/messages/read`, { method: 'POST' });
 try {
 state.invoice = (await request(`/contracts/${contractMatch[1]}/invoice`)).data;
 } catch (_) {
 state.invoice = null;
 }
 } else if (path === 'freelancers') {
 const res = await request('/freelancers');
 state.freelancers = res.data || [];
 state.freelancersMeta = res.meta || null;
 } else if (path.startsWith('freelancers/')) {
 const uid = path.split('/')[1];
 const res = await request(`/freelancers/${uid}`);
 state.currentFreelancer = res.data;
 } else if (path === 'skill-tests') {
 const res = await request('/skill-tests');
 state.skillTests = res.data || [];
 } else if (path === 'membership' && state.user.role !== 'admin') {
 const [plans, mine] = await Promise.all([
 request('/memberships'),
 request('/memberships/mine'),
 ]);
 state.membershipPlans = plans.data || [];
 state.myMembership = mine.data || null;
 } else if (path === 'referrals' && state.user.role !== 'admin') {
 const res = await request('/referral');
 state.referralData = res.data;
 } else if (path === 'profile' && state.user.role === 'freelancer') {
 const [profile, kyc, reviews, portfolio, notifPrefs, agencies, invites] = await Promise.all([
 request('/freelancer-profile'),
 request('/kyc/mine'),
 request(`/users/${state.user.id}/reviews`),
 request('/portfolio'),
 request('/notification-preferences'),
 request('/agencies'),
 request('/agencies/invites')
 ]);
 state.freelancerProfile = profile.data;
 state.kycDocuments = kyc.data || [];
 state.freelancerReviews = reviews;
 state.portfolio = portfolio.data || [];
 state.notificationPrefs = notifPrefs.data || [];
 state.agencies = agencies.data || [];
 state.agencyInvites = invites.data || [];
 } else if (path === 'profile' && state.user.role === 'client') {
 const [clientProfile, notifPrefs] = await Promise.all([
 request('/client-profile'),
 request('/notification-preferences'),
 ]);
 state.clientProfile = clientProfile.data;
 state.notificationPrefs = notifPrefs.data || [];
 } else if (path === 'profile' && state.user.role === 'admin') {
 // Admin profile only needs basic user info - already in state.user
 } else if ((path === 'admin' || path === 'admin-payments' || path === 'dashboard') && state.user.role === 'admin') {
 const [kyc, disputes, settings, pendingPayments, users, contracts, jobs, withdrawals, deposits, revenue, categories, memberships, aiSettings] = await Promise.all([
 request('/kyc/documents'),
 request('/disputes'),
 request('/admin/settings'),
 request('/admin/pending-payments'),
 request('/admin/users'),
 request('/contracts'),
 request('/jobs'),
 request('/admin/withdrawals'),
 request('/admin/deposits'),
 request('/admin/revenue'),
 request('/categories'),
 request('/memberships'),
 request('/admin/ai-settings'),
 ]);
 state.kycDocuments = kyc.data || [];
 state.disputes = disputes.data || [];
 state.settings = settings.data || {};
 state.pendingPayments = pendingPayments.data || [];
 state.adminUsers = users.data || [];
 state.adminContracts = contracts.data || [];
 state.adminJobs = jobs.data || [];
 state.adminWithdrawals = withdrawals.data || [];
 state.adminDeposits = deposits.data || [];
 state.adminRevenue = revenue.data || null;
 state.adminCategories = categories.categories || [];
 state.adminMembershipPlans = memberships.data || [];
 state.aiSettings = aiSettings;
 } else if (path === 'leaderboard') {
 const res = await request('/leaderboard');
 state.leaderboard = res.data || [];
 } else if (path === 'forum') {
 const res = await request('/forum/posts');
 state.forumPosts = res.data || [];
 } else if (path.startsWith('forum/')) {
 const postId = path.split('/')[1];
 const res = await request(`/forum/posts/${postId}`);
 state.currentForumPost = res;
 } else if (path === 'saved-freelancers' && state.user.role === 'client') {
 const res = await request('/saved-freelancers');
 state.savedFreelancersData = res.data || [];
 } else if (path === 'blog') {
 state.blogPosts = (await request('/blog')).data || [];
 } else if (path.startsWith('blog/')) {
 const slug = path.split('/')[1];
 state.currentBlogPost = (await request(`/blog/${slug}`)).data;
 } else if (path === 'admin/blog') {
 state.adminBlogPosts = (await request('/admin/blog')).data || [];
 } else if (path === 'admin-reports') {
 state.adminReports = (await request('/admin/reports')).data || [];
 } else if (path === 'admin-announcements' && state.user.role === 'admin') {
 const res = await request('/admin/announcements');
 state.adminAnnouncements = res.data || [];
 } else if (path === 'admin-featured' && state.user.role === 'admin') {
 const res = await request('/admin/featured');
 state.adminFeatured = res;
 } else if (path === 'admin-ledger' && state.user.role === 'admin') {
 const params = new URLSearchParams(window.location.hash.split('?')[1] || '');
 state.adminLedger = await request(`/admin/ledger?${params.toString()}`);
 }
 } catch (error) {
 notify(error.message, 'error');
 } finally {
 state.loading = false;
 render();
 }
}

function initParticles() {
 const canvas = document.getElementById('bg-canvas');
 if (!canvas) return;
 const ctx = canvas.getContext('2d');
 let width, height;
 let particles = [];

 function resize() {
 width = canvas.width = window.innerWidth;
 height = canvas.height = window.innerHeight;
 }

 class Particle {
 constructor() {
 this.x = Math.random() * width;
 this.y = Math.random() * height;
 this.vx = (Math.random() - 0.5) * 0.5;
 this.vy = (Math.random() - 0.5) * 0.5;
 this.radius = Math.random() * 1.5 + 0.5;
 }
 update() {
 this.x += this.vx;
 this.y += this.vy;
 if (this.x < 0 || this.x > width) this.vx = -this.vx;
 if (this.y < 0 || this.y > height) this.vy = -this.vy;
 }
 draw() {
 ctx.beginPath();
 ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
 ctx.fillStyle = 'rgba(249, 115, 22, 0.5)'; // Orange from logo
 ctx.fill();
 }
 }

 function init() {
 resize();
 window.addEventListener('resize', resize);
 particles = [];
 const count = Math.min(Math.floor(width * height / 15000), 100);
 for (let i = 0; i < count; i++) {
 particles.push(new Particle());
 }
 animate();
 }

 function animate() {
 ctx.clearRect(0, 0, width, height);
 
 for (let i = 0; i < particles.length; i++) {
 particles[i].update();
 particles[i].draw();
 
 for (let j = i + 1; j < particles.length; j++) {
 const dx = particles[i].x - particles[j].x;
 const dy = particles[i].y - particles[j].y;
 const dist = Math.sqrt(dx * dx + dy * dy);
 
 if (dist < 150) {
 ctx.beginPath();
 ctx.strokeStyle = `rgba(249, 115, 22, ${0.15 * (1 - dist/150)})`;
 ctx.lineWidth = 1;
 ctx.moveTo(particles[i].x, particles[i].y);
 ctx.lineTo(particles[j].x, particles[j].y);
 ctx.stroke();
 }
 }
 }
 requestAnimationFrame(animate);
 }
 
 init();
}

function landingPage() {
 return `
 <main class="min-h-screen neu-raised text-slate-900 overflow-x-hidden selection:bg-blue-600 selection:text-white">
 <!-- Sticky Navbar -->
 <header class="fixed top-0 inset-x-0 z-50 bg-[#e9eef5]/80 backdrop-blur-xl border-b border-white/50 shadow-[0_4px_30px_rgba(0,0,0,0.05)] transition-all">
 <div class="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
 <a href="#dashboard"onclick="if(location.hash===''||location.hash==='#dashboard'){window.scrollTo({top:0,behavior:'smooth'});}"class="hover:opacity-80 transition-opacity scale-90 sm:scale-100 origin-left">
 ${icon('logo', 'text-slate-900')}
 </a>
    <div class="hidden xl:flex items-center gap-6 font-semibold text-sm">
        <a href="#how-it-works" class="text-slate-600 hover:text-blue-700 transition-colors">Find Talent</a>
        <a href="#register" class="text-slate-600 hover:text-blue-700 transition-colors">Find Work</a>
        <a href="#ai" class="text-slate-600 hover:text-blue-700 transition-colors flex items-center gap-1">
            <span class="w-2 h-2 rounded-full bg-teal-400 animate-pulse"></span> Smart AI Manager
        </a>
        <a href="#how-it-works" class="text-slate-600 hover:text-blue-700 transition-colors">Enterprise</a>
        <a href="#security" class="text-slate-600 hover:text-blue-700 transition-colors">Trust & Security</a>
    </div>
    <div class="flex items-center gap-1.5 sm:gap-4">
        <a href="#login" class="hidden sm:block font-bold text-slate-700 hover:text-blue-700 transition-colors px-2 sm:px-4 py-2">Sign In</a>
        <a href="#register" class="btn-primary shadow-blue-600/20 hover:-translate-y-1 transition-all hidden sm:flex text-sm sm:text-base py-1.5 px-4 sm:py-2.5 sm:px-6">Join Now</a>
        <button id="mobile-menu-btn" aria-label="Toggle Navigation" class="xl:hidden p-3 -mr-2 text-slate-600 hover:text-blue-700 transition-colors rounded-xl focus:outline-none active:neu-raised">
            <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
        </button>
    </div>
</div>

<!-- Mobile Menu Dropdown -->
<div id="mobile-menu" class="hidden xl:hidden bg-[#e9eef5] neu-raised backdrop-blur-md shadow-2xl absolute w-full left-0 transition-all">
    <div class="flex flex-col items-center text-center px-6 py-8 space-y-6 font-bold text-slate-700 text-xl">
        <a href="#how-it-works" class="hover:text-blue-700 mobile-link">Find Talent</a>
        <a href="#register" class="hover:text-blue-700 mobile-link">Find Work</a>
        <a href="#ai" class="hover:text-blue-700 flex items-center justify-center gap-2 mobile-link"><span class="w-2 h-2 rounded-full bg-teal-400 animate-pulse"></span> Smart AI Manager</a>
        <a href="#how-it-works" class="hover:text-blue-700 mobile-link">Enterprise</a>
        <a href="#security" class="hover:text-blue-700 mobile-link">Trust & Security</a>
        <div class="pt-6 flex flex-col gap-4 w-full max-w-sm">
            <a href="#login" class="w-full text-center py-3 text-lg font-bold border-2 border-slate-200/50 rounded-2xl text-slate-700 hover:border-blue-500 hover:text-blue-700 transition-all mobile-link">Sign In</a>
            <a href="#register" class="w-full btn-primary text-center py-4 text-xl mobile-link">Join Now for Free</a>
        </div>
    </div>
</div>
 </header>

 <!-- Hero Section -->
 <section class="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
 <!-- Animated Background Grid -->
 <div class="absolute inset-0 neu-raised"style="background-image: radial-gradient(#cbd5e1 1px, transparent 1px); background-size: 40px 40px; opacity: 0.5;"></div>
 <div class="absolute inset-0 bg-gradient-to-b from-transparent via-slate-50/80 to-slate-50 pointer-events-none"></div>
 <div class="absolute top-0 inset-x-0 h-full overflow-hidden pointer-events-none" aria-hidden="true">
 <div class="absolute -top-[20%] -right-[10%] w-[20rem] h-[20rem] sm:w-[60rem] sm:h-[60rem] rounded-full bg-blue-500/10 mix-blend-multiply blur-[6rem] opacity-70 animate-pulse"></div>
 <div class="absolute top-[30%] -left-[20%] w-[20rem] h-[20rem] sm:w-[60rem] sm:h-[60rem] rounded-full bg-teal-500/10 mix-blend-multiply blur-[6rem] opacity-70 animate-pulse"style="animation-delay: 2s"></div>
 </div>

 <div class="relative max-w-7xl mx-auto px-4 sm:px-6 text-center z-10">
 <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border-blue-200 text-blue-700 font-bold text-xs uppercase tracking-widest mb-8">
 <span class="relative flex h-2 w-2">
 <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
 <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-600"></span>
 </span>
 Next-Generation Autonomous Hub
 </div>
 <h1 class="text-4xl sm:text-6xl lg:text-8xl font-black tracking-tighter leading-[1.1] text-slate-900 px-2">
 Where Elite<br/>
 <span class="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-teal-500">Talent</span> Works.
 </h1>
 <p class="mt-8 text-lg sm:text-xl md:text-2xl text-slate-600 max-w-3xl mx-auto font-medium leading-relaxed px-4">
 Scale your enterprise with elite digital talent, intelligent milestone tracking, and autonomous AI management. No glitches. Absolute trust.
 </p>
 <div class="mt-8 sm:mt-12 flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 px-4 sm:px-6">
 <a href="#register"class="btn-primary text-lg px-5 md:px-8 py-4 shadow-xl shadow-blue-600/20 hover:-translate-y-1 w-full sm:w-auto text-center">Hire Elite Talent</a>
 <a href="#register"class="btn-secondary text-lg px-5 md:px-8 py-4 hover:-translate-y-1 w-full sm:w-auto text-center">Apply as Freelancer</a>
 </div>
 
 <!-- Live Platform Stats -->
 <div class="mt-16 grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 max-w-4xl mx-auto">
 <div class="neu-raised rounded-2xl p-4">
 <p class="text-xl md:text-3xl font-black text-slate-900">₹2.5M+</p>
 <p class="text-xs font-bold text-slate-600 uppercase tracking-wide mt-1">Processed in Escrow</p>
 </div>
 <div class="neu-raised rounded-2xl p-4">
 <p class="text-xl md:text-3xl font-black text-slate-900">1,200+</p>
 <p class="text-xs font-bold text-slate-600 uppercase tracking-wide mt-1">Vetted Experts</p>
 </div>
 <div class="neu-raised rounded-2xl p-4">
 <p class="text-xl md:text-3xl font-black text-slate-900">99.9%</p>
 <p class="text-xs font-bold text-slate-600 uppercase tracking-wide mt-1">Project Success Rate</p>
 </div>
 <div class="neu-raised rounded-2xl p-4">
 <p class="text-xl md:text-3xl font-black text-slate-900">&lt;1hr</p>
 <p class="text-xs font-bold text-slate-600 uppercase tracking-wide mt-1">Avg. Time to Hire</p>
 </div>
 </div>
 </div>
 </section>

 <!-- Featured On Banner -->
 <section class="neu-raised overflow-hidden py-8">
 <div class="max-w-7xl mx-auto px-6 text-center">
 <p class="text-xs font-bold text-slate-600 uppercase tracking-widest mb-6">Trusted by & Featured in</p>
 <div class="flex flex-wrap justify-center gap-8 md:gap-16 grayscale hover:grayscale-0 text-slate-700 hover:text-slate-900 transition-all duration-500">
 <span class="text-xl md:text-2xl font-black text-slate-700 tracking-tighter">Forbes</span>
 <span class="text-xl md:text-2xl font-black text-slate-700 tracking-tighter">TechCrunch</span>
 <span class="text-xl md:text-2xl font-black text-slate-700 tracking-tighter">ECONOMIC TIMES</span>
 <span class="text-xl md:text-2xl font-black text-slate-700 tracking-tighter">YOURSTORY</span>
 <span class="text-xl md:text-2xl font-black text-slate-700 tracking-tighter">WIRED</span>
 </div>
 </div>
 </section>

 <!-- Top Skills Grid -->
 <section class="py-10 md:py-16 neu-raised">
 <div class="max-w-7xl mx-auto px-6">
 <div class="text-center mb-12">
 <span class="eyebrow">Top Talent</span>
 <h2 class="text-3xl md:text-4xl font-black tracking-tight text-slate-900 mt-2">Skills in High Demand</h2>
 </div>
 <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
 <!-- Skill Cards -->
 <div class="neu-raised rounded-2xl p-4 md:p-6 text-center hover:shadow-[0_20px_40px_-15px_rgba(0,0,0,0.1)] hover:-translate-y-2 hover:neu-raised transition-all duration-300 cursor-pointer group">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center mx-auto mb-3 font-bold group-hover:scale-110 transition-transform">AI</div>
 <p class="font-bold text-slate-900 text-sm">AI Engineers</p>
 </div>
 <div class="neu-raised rounded-2xl p-4 md:p-6 text-center hover:shadow-[0_20px_40px_-15px_rgba(0,0,0,0.1)] hover:-translate-y-2 hover:neu-raised transition-all duration-300 cursor-pointer group">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-emerald-100 text-emerald-700 rounded-full flex items-center justify-center mx-auto mb-3 font-bold group-hover:scale-110 transition-transform">FS</div>
 <p class="font-bold text-slate-900 text-sm">Full Stack</p>
 </div>
 <div class="neu-raised rounded-2xl p-4 md:p-6 text-center hover:shadow-[0_20px_40px_-15px_rgba(0,0,0,0.1)] hover:-translate-y-2 hover:neu-raised transition-all duration-300 cursor-pointer group">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mx-auto mb-3 font-bold group-hover:scale-110 transition-transform">SC</div>
 <p class="font-bold text-slate-900 text-sm">Smart Contracts</p>
 </div>
 <div class="neu-raised rounded-2xl p-4 md:p-6 text-center hover:shadow-[0_20px_40px_-15px_rgba(0,0,0,0.1)] hover:-translate-y-2 hover:neu-raised transition-all duration-300 cursor-pointer group">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-rose-100 text-rose-700 rounded-full flex items-center justify-center mx-auto mb-3 font-bold group-hover:scale-110 transition-transform">UI</div>
 <p class="font-bold text-slate-900 text-sm">UI/UX Design</p>
 </div>
 <div class="neu-raised rounded-2xl p-4 md:p-6 text-center hover:shadow-[0_20px_40px_-15px_rgba(0,0,0,0.1)] hover:-translate-y-2 hover:neu-raised transition-all duration-300 cursor-pointer group">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-amber-100 text-amber-800 rounded-full flex items-center justify-center mx-auto mb-3 font-bold group-hover:scale-110 transition-transform">DO</div>
 <p class="font-bold text-slate-900 text-sm">DevOps</p>
 </div>
 <div class="neu-raised rounded-2xl p-4 md:p-6 text-center hover:shadow-[0_20px_40px_-15px_rgba(0,0,0,0.1)] hover:-translate-y-2 hover:neu-raised transition-all duration-300 cursor-pointer group">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-3 font-bold group-hover:scale-110 transition-transform">DA</div>
 <p class="font-bold text-slate-900 text-sm">Data Science</p>
 </div>
 </div>
 </div>
 </section>


 <section class="neu-raised py-12 overflow-hidden">
 <p class="text-center text-sm font-bold text-slate-600 uppercase tracking-widest mb-8">Trusted by India's most innovative teams</p>
 <div class="relative w-full max-w-7xl mx-auto flex overflow-hidden">
 <div class="flex gap-16 items-center animate-marquee whitespace-nowrap opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
 <span class="text-2xl font-black text-slate-900 tracking-tighter">Psychseva</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">KarloDeal</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">Krama by Anjana</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">GDPower</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">BrightElectricalWorks</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">Net99</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">SmartFix</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">QuickServe</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">UrbanTalent</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">TechHub</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">RapidBuild</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">ConnectPro</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">FutureWorks</span>
 <!-- Duplicate for infinite effect -->
 <span class="text-2xl font-black text-slate-900 tracking-tighter ml-16">Psychseva</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">KarloDeal</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">Krama by Anjana</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">GDPower</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">BrightElectricalWorks</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">Net99</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">SmartFix</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">QuickServe</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">UrbanTalent</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">TechHub</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">RapidBuild</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">ConnectPro</span>
 <span class="text-2xl font-black text-slate-900 tracking-tighter">FutureWorks</span>
 </div>
 </div>
 </section>

 <!-- App Download Section -->
 <section class="py-16 md:py-24 relative overflow-hidden bg-slate-900 text-white neu-raised border-y border-slate-800">
 <div class="absolute inset-0 opacity-20 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMzMzQxNTUiIGZpbGwtb3BhY2l0eT0iMC40Ij48cGF0aCBkPSJNMzYuNDEzIDMwLjQxM0w2MCA1My45OTZWMzAuNDEzaC0yMy41ODd6TTM2LjQxMyAwaDIzLjU4N3YyMy41ODdMMzYuNDEzIDB6TTAgM2gzdjNoLTN6TTAgMjFoM3YzaC0zek0wIDM5aDN2M2gtM3pNMCA1N2gzdjNoLTN6TTIxIDBoM3YzaC0zek0zOSAwaDN2M2gtM3pNMjEgNTdoM3YzaC0zek0zOSA1N2gzdjNoLTN6Ii8+PC9nPjwvZz48L3N2Zz4=')] "></div>
 <div class="absolute inset-0 bg-gradient-to-b from-slate-900 via-emerald-900/10 to-slate-900 pointer-events-none"></div>
 <div class="absolute -top-40 -right-40 w-96 h-96 bg-emerald-500 rounded-full mix-blend-multiply filter blur-[128px] opacity-40 animate-pulse"></div>
 <div class="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-[128px] opacity-40 animate-pulse" style="animation-delay: 2s;"></div>

 <div class="max-w-7xl mx-auto px-6 relative z-10">
 <div class="glass-panel border-slate-700/50 bg-slate-800/40 rounded-[2.5rem] p-8 md:p-16 shadow-2xl flex flex-col md:flex-row items-center justify-between gap-10 overflow-hidden relative">
 <!-- Shine effect -->
 <div class="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/10 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 ease-in-out pointer-events-none"></div>

 <div class="max-w-xl">
 <div class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-400/20 text-emerald-400 text-xs font-bold uppercase tracking-widest mb-6 shadow-[0_0_15px_rgba(52,211,153,0.3)]">
 <span class="relative flex h-2 w-2">
 <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
 <span class="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
 </span>
 Now Available
 </div>
 <h2 class="text-3xl md:text-5xl font-black tracking-tight mb-4 text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-300">Experience the App on Android & iOS</h2>
 <p class="text-slate-400 text-lg mb-8 leading-relaxed">Get the world-class freelancing experience right in your pocket. Real-time updates, instant chat, and lightning-fast project management—built exclusively for our premium users.</p>
 
 <div class="flex flex-col sm:flex-row flex-wrap gap-4">
 <div class="flex flex-col items-center">
 <a href="/downloads/smartsitemaker.apk" download class="group relative inline-flex items-center justify-center gap-4 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 text-white font-bold py-4 px-8 rounded-2xl shadow-xl shadow-emerald-900/30 transition-all hover:scale-105 active:scale-95 overflow-hidden">
 <div class="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out"></div>
 <svg class="w-8 h-8 relative z-10" fill="currentColor" viewBox="0 0 24 24"><path d="M17.523 15.3414C17.523 15.3414 16.9213 15.008 16.7213 14.9414C16.5213 14.8747 16.3213 14.8747 16.1213 14.8747C15.9213 14.8747 15.7213 15.008 15.6213 15.1414L15.3213 15.5414C15.2213 15.6747 15.0213 15.7414 14.8213 15.6747C14.6213 15.608 14.3213 15.4747 13.9213 15.208C13.5213 14.9414 13.2213 14.5414 13.0213 14.3414C12.8213 14.1414 12.6213 13.8747 12.5213 13.5414C12.4213 13.208 12.5213 13.008 12.6213 12.8747C12.7213 12.7414 12.8213 12.5414 12.9213 12.3414C13.0213 12.1414 13.0213 11.9414 12.9213 11.7414L12.5213 10.8747C12.4213 10.6747 12.1213 10.008 12.0213 9.87471C11.9213 9.74137 11.8213 9.74137 11.7213 9.74137C11.6213 9.74137 11.4213 9.74137 11.2213 9.74137C11.0213 9.74137 10.7213 9.87471 10.5213 10.0747C10.3213 10.2747 9.82129 10.7414 9.82129 11.7414C9.82129 12.7414 10.5213 13.7414 10.6213 13.8747C10.7213 14.008 12.0213 16.008 14.0213 16.8747C16.0213 17.7414 16.0213 17.208 16.5213 17.1414C17.0213 17.0747 17.6213 16.5414 17.7213 15.9414C17.8213 15.3414 17.8213 14.8747 17.7213 14.7414C17.6213 14.608 17.523 15.3414 17.523 15.3414Z"/><path d="M17.518 5.759l1.703-2.951a.332.332 0 00-.12-.452.333.333 0 00-.453.12l-1.74 3.013A12.052 12.052 0 0012 5.021c-1.725 0-3.355.4-4.908 1.107L5.352 3.116a.334.334 0 00-.453-.12.332.332 0 00-.12.452l1.703 2.95C3.393 7.825 1.258 10.96 1 14.646h22c-.258-3.686-2.393-6.821-5.482-8.887zM7.228 12.378a1.05 1.05 0 01-1.047-1.05c0-.58.468-1.05 1.047-1.05.578 0 1.047.47 1.047 1.05 0 .58-.469 1.05-1.047 1.05zm9.544 0a1.05 1.05 0 01-1.047-1.05c0-.58.468-1.05 1.047-1.05.579 0 1.048.47 1.048 1.05 0 .58-.469 1.05-1.048 1.05z"/></svg>
 <span class="relative z-10 flex flex-col items-start leading-none">
 <span class="text-[10px] uppercase font-bold text-emerald-200 tracking-wider">Download for free</span>
 <span class="text-xl">Android APK</span>
 </span>
 </a>
 </div>
 
 <div class="flex flex-col items-center">
 <a href="/downloads/SmartSiteMaker%20Ios%20%26%20Mac.zip" download class="group relative inline-flex items-center justify-center gap-4 bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-600 hover:to-slate-700 text-white font-bold py-4 px-8 rounded-2xl shadow-xl shadow-slate-900/50 transition-all hover:scale-105 active:scale-95 overflow-hidden border border-slate-600">
 <div class="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out"></div>
 <svg class="w-8 h-8 relative z-10" fill="currentColor" viewBox="0 0 24 24"><path d="M15.421 9.071c-.702 0-1.571-.432-2.046-.984-.442-.511-.798-1.282-.798-2.036 0-.106.012-.224.032-.331.785.031 1.621.521 2.083 1.066.425.495.836 1.25.836 2.012 0 .117-.015.244-.035.344-.047.01-.157.019-.283.019zm3.896 9.426c-.328.989-1.391 3.504-2.812 3.504-1.42 0-1.782-.914-3.665-.914-1.87 0-2.296.914-3.619.914-1.39 0-2.529-2.613-2.827-3.468C4.542 12.83 6.136 7.42 9.539 7.42c1.378 0 2.502.946 3.298.946.786 0 2.073-.974 3.639-.974 1.579 0 2.859.626 3.666 1.794-3.044 1.706-2.534 5.922.508 7.085-.367 1.096-.867 2.193-1.333 3.226z"/></svg>
 <span class="relative z-10 flex flex-col items-start leading-none">
 <span class="text-[10px] uppercase font-bold text-slate-300 tracking-wider">Download For Free</span>
 <span class="text-xl">iOS & Mac App</span>
 </span>
 </a>
 <p class="mt-3 text-xs font-semibold text-slate-400 tracking-wide text-center">Download, Unzip and Run</p>
 </div>

 <div class="flex flex-col items-center">
 <a href="/downloads/Smart%20Site%20Maker_chrome.zip" download class="group relative inline-flex items-center justify-center gap-4 bg-gradient-to-r from-yellow-500 to-amber-600 hover:from-yellow-400 hover:to-amber-500 text-white font-bold py-4 px-8 rounded-2xl shadow-xl shadow-amber-900/30 transition-all hover:scale-105 active:scale-95 overflow-hidden border border-yellow-500">
 <div class="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out"></div>
 <svg class="w-8 h-8 relative z-10" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM12 5.5c-2.33 0-4.32 1.45-5.12 3.5h10.24c-.8-2.05-2.79-3.5-5.12-3.5zM6.28 10.5c.31 1.77 1.45 3.26 3.01 4.16l-3.32 5.76C3.51 18.25 2 15.3 2 12c0-1.87.58-3.58 1.55-5h2.73zM12 18.5c-1.32 0-2.52-.46-3.48-1.22l3.32-5.76c1.19.33 2.11 1.25 2.43 2.44L17.59 9.8c1.39 1.42 2.27 3.39 2.27 5.57 0 3.59-2.91 6.5-6.5 6.5v-3.37z"/></svg>
 <span class="relative z-10 flex flex-col items-start leading-none">
 <span class="text-[10px] uppercase font-bold text-yellow-100 tracking-wider">Download For Free</span>
 <span class="text-xl">Chrome App</span>
 </span>
 </a>
 <p class="mt-3 text-xs font-semibold text-slate-400 tracking-wide text-center">Download, Unzip and Run</p>
 </div>
 </div>
 </div>
 <div class="relative w-48 h-48 md:w-64 md:h-64 flex-shrink-0 mt-8 md:mt-0 perspective-1000">
 <!-- Floating Android Mockup -->
 <div class="absolute inset-0 bg-gradient-to-br from-emerald-400 to-teal-700 rounded-[3rem] shadow-[0_20px_50px_rgba(52,211,153,0.5)] transform -rotate-6 hover:rotate-0 transition-transform duration-500 flex items-center justify-center border-4 border-slate-800 animate-float" style="animation-duration: 4s;">
 <svg class="w-24 h-24 text-white opacity-80" fill="currentColor" viewBox="0 0 24 24"><path d="M17.518 5.759l1.703-2.951a.332.332 0 00-.12-.452.333.333 0 00-.453.12l-1.74 3.013A12.052 12.052 0 0012 5.021c-1.725 0-3.355.4-4.908 1.107L5.352 3.116a.334.334 0 00-.453-.12.332.332 0 00-.12.452l1.703 2.95C3.393 7.825 1.258 10.96 1 14.646h22c-.258-3.686-2.393-6.821-5.482-8.887zM7.228 12.378a1.05 1.05 0 01-1.047-1.05c0-.58.468-1.05 1.047-1.05.578 0 1.047.47 1.047 1.05 0 .58-.469 1.05-1.047 1.05zm9.544 0a1.05 1.05 0 01-1.047-1.05c0-.58.468-1.05 1.047-1.05.579 0 1.048.47 1.048 1.05 0 .58-.469 1.05-1.048 1.05z"/><path d="M2.5 16h19v3.5A2.5 2.5 0 0119 22H5a2.5 2.5 0 01-2.5-2.5V16z"/></svg>
 <div class="absolute inset-0 bg-white/10 rounded-[3rem] overflow-hidden pointer-events-none"><div class="w-full h-full bg-gradient-to-b from-white/30 to-transparent -translate-y-1/2 rounded-full blur-2xl transform -rotate-12"></div></div>
 </div>
 </div>
 </div>
 </div>
 </section>

 <!-- Live Activity & Elite Talent Grid -->
 <section class="py-10 md:py-24 neu-raised"id="talent">
 <div class="max-w-7xl mx-auto px-6">
 <div class="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
 <div class="max-w-2xl">
 <span class="eyebrow">Elite Professionals</span>
 <h2 class="text-2xl md:text-4xl font-black tracking-tight text-slate-900 mt-2">Hire the world's best, instantly.</h2>
 <p class="mt-4 text-lg text-slate-600">Our rigorous vetting process ensures you only work with elite engineers, designers, and strategists.</p>
 </div>
 <a href="#register"class="btn-secondary whitespace-nowrap">Browse All Talent &rarr;</a>
 </div>

 <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
 <!-- Talent Card 1 -->
 <div class="neu-raised rounded-3xl p-4 md:p-6 hover:shadow-xl transition-all">
 <div class="flex flex-row justify-between items-start mb-3">
 <div class="w-10 h-10 md:w-16 md:h-16 bg-blue-100 rounded-full flex items-center justify-center text-blue-700 font-bold text-base md:text-xl border-4 border-white">
 AS
 </div>
 <span class="bg-emerald-50 text-emerald-700 font-bold text-xs px-2 py-1 rounded-lg border-emerald-200">Available</span>
 </div>
 <h3 class="font-black text-lg text-slate-900">Arjun S.</h3>
 <p class="text-blue-700 font-semibold text-sm mb-3">Senior React Native Dev</p>
 <div class="flex gap-2 mb-3">
 <span class="text-xs font-bold bg-slate-100 px-2 py-1 rounded text-slate-600">React</span>
 <span class="text-xs font-bold bg-slate-100 px-2 py-1 rounded text-slate-600">TypeScript</span>
 </div>
 <div class="pt-3 border-t border-slate-100 flex flex-row justify-between items-center">
 <div>
 <span class="text-lg font-black text-slate-900">₹1,500</span><span class="text-xs text-slate-600">/hr</span>
 </div>
 <span class="text-sm font-bold text-amber-800">★ 5.0</span>
 </div>
 </div>

 <!-- Talent Card 2 -->
 <div class="neu-raised rounded-3xl p-4 md:p-6 hover:shadow-xl transition-all">
 <div class="flex flex-row justify-between items-start mb-3">
 <div class="w-10 h-10 md:w-16 md:h-16 bg-rose-100 rounded-full flex items-center justify-center text-rose-700 font-bold text-base md:text-xl border-4 border-white">
 PJ
 </div>
 <span class="bg-emerald-50 text-emerald-700 font-bold text-xs px-2 py-1 rounded-lg border-emerald-200">Available</span>
 </div>
 <h3 class="font-black text-lg text-slate-900">Priya J.</h3>
 <p class="text-blue-700 font-semibold text-sm mb-3">Principal UX Designer</p>
 <div class="flex gap-2 mb-3">
 <span class="text-xs font-bold bg-slate-100 px-2 py-1 rounded text-slate-600">Figma</span>
 <span class="text-xs font-bold bg-slate-100 px-2 py-1 rounded text-slate-600">Prototyping</span>
 </div>
 <div class="pt-3 border-t border-slate-100 flex flex-row justify-between items-center">
 <div>
 <span class="text-lg font-black text-slate-900">₹2,000</span><span class="text-xs text-slate-600">/hr</span>
 </div>
 <span class="text-sm font-bold text-amber-800">★ 5.0</span>
 </div>
 </div>

 <!-- Talent Card 3 -->
 <div class="neu-raised rounded-3xl p-4 md:p-6 hover:shadow-xl transition-all">
 <div class="flex flex-row justify-between items-start mb-3">
 <div class="w-10 h-10 md:w-16 md:h-16 bg-teal-100 rounded-full flex items-center justify-center text-teal-700 font-bold text-base md:text-xl border-4 border-white">
 RK
 </div>
 <span class="neu-raised text-slate-600 font-bold text-xs px-2 py-1 rounded-lg">In Contract</span>
 </div>
 <h3 class="font-black text-lg text-slate-900">Rohan K.</h3>
 <p class="text-blue-700 font-semibold text-sm mb-3">AI & ML Engineer</p>
 <div class="flex gap-2 mb-3">
 <span class="text-xs font-bold bg-slate-100 px-2 py-1 rounded text-slate-600">Python</span>
 <span class="text-xs font-bold bg-slate-100 px-2 py-1 rounded text-slate-600">PyTorch</span>
 </div>
 <div class="pt-3 border-t border-slate-100 flex flex-row justify-between items-center">
 <div>
 <span class="text-lg font-black text-slate-900">₹2,500</span><span class="text-xs text-slate-600">/hr</span>
 </div>
 <span class="text-sm font-bold text-amber-800">★ 4.9</span>
 </div>
 </div>

 <!-- Live Activity Feed -->
 <div class="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-4 md:p-6 shadow-xl relative overflow-hidden flex flex-col justify-between">
 <div class="absolute top-0 right-0 w-32 h-32 bg-teal-500/10 rounded-full blur-2xl"></div>
 <div>
 <div class="flex items-center gap-2 mb-6">
 <span class="relative flex h-3 w-3">
 <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75"></span>
 <span class="relative inline-flex rounded-full h-3 w-3 bg-teal-500"></span>
 </span>
 <span class="text-teal-400 font-bold text-xs uppercase tracking-widest">Live Activity</span>
 </div>
 
 <div class="space-y-4"id="live-activity-feed">
 <!-- Dynamic content rendered by JS -->
 </div>
 </div>
 </div>
 </div>
 </div>
 </section>

 <!-- Deep Dive AI Section -->
 <section class="py-32 bg-slate-900 text-white relative z-10 overflow-hidden"id="ai">
 <div class="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMzMzQxNTUiIGZpbGwtb3BhY2l0eT0iMC4yIj48cGF0aCBkPSJNMzYuNDEzIDMwLjQxM0w2MCA1My45OTZWMzAuNDEzaC0yMy41ODd6TTM2LjQxMyAwaDIzLjU4N3YyMy41ODdMMzYuNDEzIDB6TTAgM2gzdjNoLTN6TTAgMjFoM3YzaC0zek0wIDM5aDN2M2gtM3pNMCA1N2gzdjNoLTN6TTIxIDBoM3YzaC0zek0zOSAwaDN2M2gtM3pNMjEgNTdoM3YzaC0zek0zOSA1N2gzdjNoLTN6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-20"></div>
 
 <div class="max-w-7xl mx-auto px-6 relative z-10">
 <div class="grid lg:grid-cols-2 gap-16 items-center">
 <div>
 <span class="inline-block py-1 px-3 rounded-full bg-teal-500/20 text-teal-400 border-teal-500/30 text-xs font-bold uppercase tracking-widest mb-6">SmartSiteMaker AI</span>
 <h2 class="text-2xl sm:text-4xl lg:text-5xl font-black tracking-tighter mb-6 leading-tight">The first platform that manages itself.</h2>
 <p class="text-lg text-slate-400 mb-8 leading-relaxed">
 Stop wasting time micromanaging freelancers. Our proprietary AI acts as an impartial project manager. It tracks Git commits, reviews Figma files, validates code quality, and automatically releases escrow payments when milestones are truly met.
 </p>
 <ul class="space-y-4 mb-10">
 <li class="flex items-center gap-3">
 <div class="w-8 h-8 rounded-full bg-teal-500/20 flex items-center justify-center text-teal-400">✓</div>
 <span class="font-semibold">Automated Deliverable Analysis</span>
 </li>
 <li class="flex items-center gap-3">
 <div class="w-8 h-8 rounded-full bg-teal-500/20 flex items-center justify-center text-teal-400">✓</div>
 <span class="font-semibold">Impartial Dispute Resolution in Seconds</span>
 </li>
 <li class="flex items-center gap-3">
 <div class="w-8 h-8 rounded-full bg-teal-500/20 flex items-center justify-center text-teal-400">✓</div>
 <span class="font-semibold">Smart Contract Escrow Execution</span>
 </li>
 </ul>
 <a href="#register" class="inline-flex items-center justify-center rounded-xl font-bold bg-teal-500 hover:bg-teal-400 text-slate-900 px-5 md:px-8 py-4 text-lg shadow-[0_4px_20px_rgba(20,184,166,0.3)] hover:-translate-y-1 transition-all">Experience the AI</a>
 </div>
 
 <div class="relative">
 <!-- Playable AI Demo -->
 <div class="absolute inset-0 bg-gradient-to-tr from-teal-500/20 to-blue-500/20 blur-3xl rounded-full"></div>
 <div class="relative bg-slate-800/90 backdrop-blur-xl border-slate-700 p-5 sm:p-8 rounded-3xl shadow-2xl h-72 sm:h-96 flex flex-col overflow-hidden">
 <div class="flex justify-between items-center mb-6 border-slate-700 pb-4">
 <div class="flex items-center gap-3">
 <div class="w-3 h-3 rounded-full bg-rose-500"></div>
 <div class="w-3 h-3 rounded-full bg-amber-500"></div>
 <div class="w-3 h-3 rounded-full bg-emerald-500"></div>
 </div>
 <span class="font-bold text-slate-300">AI Dispute Resolution Terminal</span>
 </div>
 
 <div class="flex-1 overflow-y-auto space-y-4 font-mono text-sm"id="ai-demo-terminal">
 <div class="text-slate-400">Waiting for user input...</div>
 </div>
 
 <div class="mt-4 flex gap-2">
 <button id="ai-demo-btn"class="w-full bg-teal-500/20 hover:bg-teal-500/30 text-teal-400 font-bold py-3 rounded-xl border-teal-500/50 transition-colors flex items-center justify-center gap-2">
 <svg class="w-5 h-5"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
 Run Live Analysis
 </button>
 </div>
 </div>
 </div>
 </div>
 </div>
 </section>

 <!-- Automated Pipeline -->
 <section class="py-10 md:py-24 neu-raised">
 <div class="max-w-7xl mx-auto px-6">
 <div class="text-center max-w-2xl mx-auto mb-16">
 <span class="eyebrow">The Pipeline</span>
 <h2 class="text-2xl md:text-4xl font-black tracking-tight text-slate-900 mt-2">How autonomous escrow works.</h2>
 </div>
 
 <div class="flex flex-col md:flex-row justify-between items-center relative gap-4">
 <!-- connecting line -->
 <div class="absolute top-1/2 left-0 right-0 h-1 bg-slate-200 hidden md:block -z-10 -translate-y-1/2"></div>
 
 <div class="neu-raised p-4 md:p-6 rounded-2xl text-center relative z-10 w-full md:flex-1 mb-8 md:mb-0">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center mx-auto mb-4 font-black text-base md:text-xl">1</div>
 <p class="font-bold text-slate-900">Define Scope</p>
 <p class="text-xs text-slate-600 mt-2">Create contract & deposit funds</p>
 </div>
 
 <div class="neu-raised p-4 md:p-6 rounded-2xl text-center relative z-10 w-full md:flex-1 mb-8 md:mb-0">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4 font-black text-base md:text-xl">2</div>
 <p class="font-bold text-slate-900">AI Match</p>
 <p class="text-xs text-slate-600 mt-2">Top tier Indian talent assigned</p>
 </div>
 
 <div class="bg-slate-900 p-4 md:p-6 rounded-2xl shadow-xl border-slate-700 text-center relative z-10 w-full md:flex-1 mb-8 md:mb-0 transform md:-translate-y-4">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-teal-500/20 text-teal-400 border-teal-500/30 rounded-full flex items-center justify-center mx-auto mb-4 font-black text-base md:text-xl">3</div>
 <p class="font-bold text-white">Funds Secured</p>
 <p class="text-xs text-teal-200 mt-2">Locked in Smart Contract</p>
 </div>
 
 <div class="neu-raised p-4 md:p-6 rounded-2xl text-center relative z-10 w-full md:flex-1 mb-8 md:mb-0">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-amber-100 text-amber-800 rounded-full flex items-center justify-center mx-auto mb-4 font-black text-base md:text-xl">4</div>
 <p class="font-bold text-slate-900">Delivery</p>
 <p class="text-xs text-slate-600 mt-2">AI validates milestone code</p>
 </div>
 
 <div class="neu-raised p-4 md:p-6 rounded-2xl text-center relative z-10 w-full md:flex-1">
 <div class="w-8 h-8 md:w-12 md:h-12 bg-emerald-100 text-emerald-700 rounded-full flex items-center justify-center mx-auto mb-4 font-black text-base md:text-xl">5</div>
 <p class="font-bold text-slate-900">Auto Payout</p>
 <p class="text-xs text-slate-600 mt-2">Instant transfer to freelancer</p>
 </div>
 </div>
 </div>
 </section>

 <!-- SmartSiteMaker Enterprise Banner -->
 <section class="bg-slate-900 border-slate-800 relative z-10 overflow-hidden">
 <div class="absolute inset-0 bg-gradient-to-r from-teal-500/10 to-blue-500/10 mix-blend-overlay"></div>
 <div class="max-w-7xl mx-auto px-6 py-12 md:py-20 relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 md:gap-12">
 <div class="max-w-2xl">
 <span class="inline-block py-1 px-3 rounded-full bg-amber-500/20 text-amber-400 border-amber-500/30 text-xs font-bold uppercase tracking-widest mb-6">For Large Corporations</span>
 <h2 class="text-2xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white mb-6">SmartSiteMaker <span class="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-500">Enterprise</span></h2>
 <p class="text-lg text-slate-400 leading-relaxed">Need to build an entire department overnight? Get a dedicated AI Account Manager. We will source, vet, and onboard a massive team of elite talent tailored specifically to your tech stack within 48 hours.</p>
 </div>
 <div class="flex-shrink-0">
 <a href="mailto:smartsitemaker@gmail.com" class="px-5 md:px-8 py-4 shadow-xl whitespace-nowrap inline-block text-center rounded-xl font-bold" style="background-color: #000000 !important; color: #ffffff !important;">Contact Enterprise Sales</a>
 </div>
 </div>
 </section>

 <!-- Features Grid -->
 <section class="py-10 md:py-24 neu-raised relative"id="how-it-works">
 <div class="max-w-7xl mx-auto px-6">
 <div class="text-center max-w-2xl mx-auto mb-16">
 <span class="eyebrow">Enterprise Grade</span>
 <h2 class="text-2xl md:text-4xl font-black tracking-tight text-slate-900 mt-2">Engineered for perfection.</h2>
 </div>
 
 <div class="grid md:grid-cols-3 gap-4 md:gap-8 max-w-5xl mx-auto">
 <!-- Feature 1 -->
 <div class="neu-raised rounded-3xl p-5 md:p-8 hover:-translate-y-1 transition-all group">
 <div class="w-8 h-8 md:w-14 md:h-14 bg-blue-100 text-blue-700 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-blue-600 group-hover:text-white transition-colors">
 <svg class="w-7 h-7"fill="none"viewBox="0 0 24 24"stroke="currentColor"stroke-width="2"><path stroke-linecap="round"stroke-linejoin="round"d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>
 </div>
 <h3 class="text-base md:text-xl font-bold text-slate-900 mb-3">100% Escrow Protection</h3>
 <p class="text-slate-600 leading-relaxed">Funds are secured before work begins. Payments are released automatically upon milestone approval. Zero risk for both sides.</p>
 </div>
 
 <!-- Feature 2 -->
 <div class="neu-raised rounded-3xl p-5 md:p-8 hover:-translate-y-1 transition-all group">
 <div class="w-8 h-8 md:w-14 md:h-14 bg-teal-100 text-teal-700 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-teal-600 group-hover:text-white transition-colors">
 <svg class="w-7 h-7"fill="none"viewBox="0 0 24 24"stroke="currentColor"stroke-width="2"><path stroke-linecap="round"stroke-linejoin="round"d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
 </div>
 <h3 class="text-base md:text-xl font-bold text-slate-900 mb-3">Global Compliance</h3>
 <p class="text-slate-600 leading-relaxed">Built-in KYC verification, automated invoicing, and multi-currency payout routing across 150+ countries. We handle the legal overhead.</p>
 </div>

 <!-- Feature 3 -->
 <div class="neu-raised rounded-3xl p-5 md:p-8 hover:-translate-y-1 transition-all group">
 <div class="w-8 h-8 md:w-14 md:h-14 bg-indigo-100 text-indigo-600 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-indigo-600 group-hover:text-white transition-colors">
 <svg class="w-7 h-7"fill="none"viewBox="0 0 24 24"stroke="currentColor"stroke-width="2"><path stroke-linecap="round"stroke-linejoin="round"d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg>
 </div>
 <h3 class="text-base md:text-xl font-bold text-slate-900 mb-3">Military-Grade Security</h3>
 <p class="text-slate-600 leading-relaxed">End-to-end encrypted messaging, secure file delivery pipelines, and robust identity verification ensure your IP is always protected.</p>
 </div>
 </div>
 </div>
 </section>

 <!-- Case Studies -->
 <section class="py-10 md:py-24 neu-raised border-y">
 <div class="max-w-7xl mx-auto px-6">
 <div class="text-center mb-16">
 <span class="eyebrow">Proven Results</span>
 <h2 class="text-2xl md:text-4xl font-black tracking-tight text-slate-900 mt-2">Enterprise Success Stories</h2>
 </div>
 <div class="grid lg:grid-cols-2 gap-4 md:gap-8">
 <!-- Case Study 1 -->
 <div class="neu-raised rounded-[2rem] overflow-hidden flex flex-col md:flex-row hover:-translate-y-1 transition-all">
 <div class="bg-slate-900 p-5 md:p-8 md:w-2/5 flex flex-col justify-center text-white relative overflow-hidden">
 <div class="absolute -right-10 -bottom-10 w-20 h-20 md:w-40 md:h-40 bg-blue-500 rounded-full blur-[3rem] opacity-30"></div>
 <p class="text-2xl md:text-4xl font-black text-blue-400 relative z-10">40%</p>
 <p class="text-xs font-bold uppercase tracking-widest mt-1 mb-6 text-slate-400 relative z-10">Budget Saved</p>
 <p class="text-2xl md:text-4xl font-black text-teal-400 relative z-10">2 Mo</p>
 <p class="text-xs font-bold uppercase tracking-widest mt-1 text-slate-400 relative z-10">Time to Market</p>
 </div>
 <div class="p-5 md:p-8 md:w-3/5">
 <div class="flex text-amber-400 mb-4 text-sm">★★★★★</div>
 <h3 class="text-base md:text-xl font-bold text-slate-900 mb-3">FinTech scale-up built core banking app using AI Manager</h3>
 <p class="text-slate-600 font-medium mb-6 text-sm leading-relaxed">"The AI milestone tracking is witchcraft. It perfectly analyzed a Next.js codebase delivery and released the escrow automatically. We scaled our dev team by 400% using SmartSiteMaker."</p>
 <div class="flex items-center gap-3">
 <div class="w-7 h-7 md:w-10 md:h-10 bg-slate-200 rounded-full"></div>
 <div>
 <p class="font-bold text-slate-900 text-sm">Sarah Jenkins</p>
 <p class="text-xs text-slate-600">CTO, TechFlow</p>
 </div>
 </div>
 </div>
 </div>
 
 <!-- Case Study 2 -->
 <div class="neu-raised rounded-[2rem] overflow-hidden flex flex-col md:flex-row hover:-translate-y-1 transition-all">
 <div class="bg-slate-900 p-5 md:p-8 md:w-2/5 flex flex-col justify-center text-white relative overflow-hidden">
 <div class="absolute -right-10 -bottom-10 w-20 h-20 md:w-40 md:h-40 bg-indigo-500 rounded-full blur-[3rem] opacity-30"></div>
 <p class="text-2xl md:text-4xl font-black text-indigo-400 relative z-10">100%</p>
 <p class="text-xs font-bold uppercase tracking-widest mt-1 mb-6 text-slate-400 relative z-10">Escrow Security</p>
 <p class="text-2xl md:text-4xl font-black text-emerald-400 relative z-10">&lt;24hr</p>
 <p class="text-xs font-bold uppercase tracking-widest mt-1 text-slate-400 relative z-10">Avg. Match Time</p>
 </div>
 <div class="p-5 md:p-8 md:w-3/5">
 <div class="flex text-amber-400 mb-4 text-sm">★★★★★</div>
 <h3 class="text-base md:text-xl font-bold text-slate-900 mb-3">Enterprise marketplace launched with elite autonomous talent</h3>
 <p class="text-slate-600 font-medium mb-6 text-sm leading-relaxed">"I've tried Upwork and Toptal. Nothing comes close to the quality of talent here. The interface is impossibly fast and the escrow system gives complete peace of mind."</p>
 <div class="flex items-center gap-3">
 <div class="w-7 h-7 md:w-10 md:h-10 bg-slate-200 rounded-full"></div>
 <div>
 <p class="font-bold text-slate-900 text-sm">Marcus Chen</p>
 <p class="text-xs text-slate-600">Founder, BuildAI</p>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 </section>

 <!-- Global Reach -->
 <section class="py-10 md:py-24 neu-raised overflow-hidden">
 <div class="max-w-7xl mx-auto px-4 sm:px-6">
 <div class="text-center mb-10 md:mb-16">
 <span class="eyebrow">Worldwide Network</span>
 <h2 class="text-2xl md:text-4xl font-black tracking-tight text-slate-900 mt-2">Connecting India to the World</h2>
 <p class="text-base md:text-lg text-slate-600 max-w-2xl mx-auto mt-4">We've bridged the gap between elite Indian engineering and top-tier global enterprise clients.</p>
 </div>
 
 <div class="relative w-full aspect-[4/3] sm:aspect-video md:aspect-auto md:h-[32rem] rounded-3xl md:rounded-[2.5rem] bg-slate-900 border border-slate-800 flex items-center justify-center overflow-hidden shadow-2xl shadow-blue-900/20">
 <!-- Global Network Map Background -->
 <div class="absolute inset-0 opacity-20 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMzMzQxNTUiIGZpbGwtb3BhY2l0eT0iMC40Ij48cGF0aCBkPSJNMzYuNDEzIDMwLjQxM0w2MCA1My45OTZWMzAuNDEzaC0yMy41ODd6TTM2LjQxMyAwaDIzLjU4N3YyMy41ODdMMzYuNDEzIDB6TTAgM2gzdjNoLTN6TTAgMjFoM3YzaC0zek0wIDM5aDN2M2gtM3pNMCA1N2gzdjNoLTN6TTIxIDBoM3YzaC0zek0zOSAwaDN2M2gtM3pNMjEgNTdoM3YzaC0zek0zOSA1N2gzdjNoLTN6Ii8+PC9nPjwvZz48L3N2Zz4=')] mix-blend-overlay"></div>
 <div class="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-slate-900"></div>

 <!-- Glowing Hubs -->
 <!-- North America -->
 <div class="absolute top-[30%] left-[20%] group">
 <div class="w-2 h-2 md:w-3 md:h-3 bg-blue-400 rounded-full shadow-[0_0_20px_rgba(96,165,250,1)] animate-pulse"></div>
 <div class="absolute -inset-2 rounded-full border-blue-400/30 animate-ping"></div>
 <span class="absolute top-4 left-1/2 -translate-x-1/2 md:-translate-x-0 md:left-4 text-[10px] md:text-xs font-bold text-blue-300 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap bg-slate-800/80 px-2 py-1 rounded backdrop-blur z-20">New York</span>
 </div>
 <div class="absolute top-[38%] left-[12%] group">
 <div class="w-1.5 h-1.5 md:w-2 md:h-2 bg-blue-500 rounded-full shadow-[0_0_15px_rgba(59,130,246,0.8)] animate-pulse"style="animation-delay: 0.5s"></div>
 <span class="absolute top-3 left-1/2 -translate-x-1/2 md:-translate-x-0 md:left-3 text-[10px] md:text-xs font-bold text-blue-300 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap bg-slate-800/80 px-2 py-1 rounded backdrop-blur z-20">San Francisco</span>
 </div>
 
 <!-- Europe -->
 <div class="absolute top-[25%] left-[48%] group">
 <div class="w-2 h-2 md:w-3 md:h-3 bg-teal-400 rounded-full shadow-[0_0_20px_rgba(45,212,191,1)] animate-pulse"style="animation-delay: 1.2s"></div>
 <div class="absolute -inset-2 rounded-full border-teal-400/30 animate-ping"style="animation-delay: 1s"></div>
 <span class="absolute top-4 left-1/2 -translate-x-1/2 md:-translate-x-0 md:left-4 text-[10px] md:text-xs font-bold text-teal-300 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap bg-slate-800/80 px-2 py-1 rounded backdrop-blur z-20">London</span>
 </div>
 <div class="absolute top-[28%] left-[53%] group">
 <div class="w-1.5 h-1.5 md:w-2 md:h-2 bg-teal-500 rounded-full shadow-[0_0_15px_rgba(20,184,166,0.8)] animate-pulse"style="animation-delay: 0.8s"></div>
 <span class="absolute top-3 left-1/2 -translate-x-1/2 md:-translate-x-0 md:left-3 text-[10px] md:text-xs font-bold text-teal-300 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap bg-slate-800/80 px-2 py-1 rounded backdrop-blur z-20">Berlin</span>
 </div>

 <!-- India (Main Hub) -->
 <div class="absolute top-[38%] left-[68%] group z-10">
 <div class="w-3 h-3 md:w-4 md:h-4 bg-emerald-400 rounded-full shadow-[0_0_30px_rgba(52,211,153,1)] animate-pulse"></div>
 <div class="absolute -inset-2 md:-inset-3 rounded-full border-emerald-400/50 animate-ping"></div>
 <div class="absolute -inset-4 md:-inset-6 rounded-full border-emerald-400/20 animate-pulse"></div>
 <span class="absolute top-5 md:top-6 left-1/2 -translate-x-1/2 md:-translate-x-0 md:left-6 text-xs md:text-sm font-black text-emerald-300 whitespace-nowrap bg-slate-800/90 px-2 py-1 md:px-3 md:py-1 rounded-lg border border-emerald-500/30 backdrop-blur">Delhi (HQ)</span>
 </div>
 <!-- Ghaziabad Sub Branch -->
 <div class="absolute top-[39.5%] left-[69%] group z-10">
 <div class="w-2 h-2 md:w-2.5 md:h-2.5 bg-emerald-500 rounded-full shadow-[0_0_15px_rgba(16,185,129,0.9)] animate-pulse"style="animation-delay: 0.5s"></div>
 <div class="absolute -inset-1 rounded-full border-emerald-400/40 animate-ping"style="animation-delay: 0.8s"></div>
 <span class="absolute top-4 left-1/2 -translate-x-1/2 md:-translate-x-0 md:left-4 text-[10px] md:text-xs font-bold text-emerald-300 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap bg-slate-800/80 px-2 py-1 rounded backdrop-blur z-20">Ghaziabad</span>
 </div>
 
 <div class="absolute top-[45%] left-[70%] group">
 <div class="w-1.5 h-1.5 md:w-2 md:h-2 bg-emerald-500 rounded-full shadow-[0_0_15px_rgba(16,185,129,0.8)] animate-pulse"style="animation-delay: 1.5s"></div>
 </div>
 <div class="absolute top-[48%] left-[66%] group">
 <div class="w-1.5 h-1.5 md:w-2 md:h-2 bg-emerald-500 rounded-full shadow-[0_0_15px_rgba(16,185,129,0.8)] animate-pulse"style="animation-delay: 0.3s"></div>
 </div>

 <!-- Asia/Australia -->
 <div class="absolute top-[42%] left-[82%] group">
 <div class="w-1.5 h-1.5 md:w-2 md:h-2 bg-indigo-400 rounded-full shadow-[0_0_15px_rgba(129,140,248,0.8)] animate-pulse"style="animation-delay: 2.1s"></div>
 <span class="absolute top-3 right-0 md:left-3 md:right-auto text-[10px] md:text-xs font-bold text-indigo-300 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap bg-slate-800/80 px-2 py-1 rounded backdrop-blur z-20">Tokyo</span>
 </div>
 <div class="absolute top-[65%] left-[85%] group">
 <div class="w-2 h-2 md:w-3 md:h-3 bg-indigo-500 rounded-full shadow-[0_0_20px_rgba(99,102,241,1)] animate-pulse"style="animation-delay: 1.7s"></div>
 <div class="absolute -inset-2 rounded-full border-indigo-400/30 animate-ping"style="animation-delay: 2s"></div>
 <span class="absolute top-4 right-0 md:left-4 md:right-auto text-[10px] md:text-xs font-bold text-indigo-300 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap bg-slate-800/80 px-2 py-1 rounded backdrop-blur z-20">Sydney</span>
 </div>

 <!-- Middle East / Africa -->
 <div class="absolute top-[48%] left-[58%] group">
 <div class="w-1.5 h-1.5 md:w-2 md:h-2 bg-amber-400 rounded-full shadow-[0_0_15px_rgba(251,191,36,0.8)] animate-pulse"style="animation-delay: 2.5s"></div>
 <span class="absolute top-3 left-1/2 -translate-x-1/2 md:-translate-x-0 md:left-3 text-[10px] md:text-xs font-bold text-amber-300 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap bg-slate-800/80 px-2 py-1 rounded backdrop-blur z-20">Dubai</span>
 </div>
 <div class="absolute top-[60%] left-[52%] group">
 <div class="w-1.5 h-1.5 md:w-2 md:h-2 bg-amber-500 rounded-full shadow-[0_0_15px_rgba(245,158,11,0.8)] animate-pulse"style="animation-delay: 0.9s"></div>
 </div>

 <!-- South America -->
 <div class="absolute top-[65%] left-[28%] group">
 <div class="w-1.5 h-1.5 md:w-2 md:h-2 bg-rose-400 rounded-full shadow-[0_0_15px_rgba(251,113,133,0.8)] animate-pulse"style="animation-delay: 1.4s"></div>
 <span class="absolute top-3 left-1/2 -translate-x-1/2 md:-translate-x-0 md:left-3 text-[10px] md:text-xs font-bold text-rose-300 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap bg-slate-800/80 px-2 py-1 rounded backdrop-blur z-20">São Paulo</span>
 </div>

 <!-- Connection Lines (SVG) -->
 <svg class="absolute inset-0 w-full h-full pointer-events-none opacity-20 md:opacity-30" preserveAspectRatio="none" viewBox="0 0 100 100">
 <!-- Path from Delhi to NY -->
 <path d="M 68 38 Q 45 20 20 30"fill="none"stroke="url(#grad1)"stroke-width="1.5"stroke-dasharray="4,4"class="animate-dash"/>
 <!-- Path from Delhi to London -->
 <path d="M 68 38 Q 60 25 48 25"fill="none"stroke="url(#grad2)"stroke-width="1.5"stroke-dasharray="4,4"class="animate-dash"/>
 <!-- Path from Delhi to Sydney -->
 <path d="M 68 38 Q 80 55 85 65"fill="none"stroke="url(#grad3)"stroke-width="1.5"stroke-dasharray="4,4"class="animate-dash"/>
 <!-- Path from Delhi to Dubai -->
 <path d="M 68 38 Q 65 40 58 48"fill="none"stroke="url(#grad4)"stroke-width="1.5"stroke-dasharray="4,4"class="animate-dash"/>

 <defs>
 <linearGradient id="grad1"><stop offset="0%"stop-color="#34d399"/><stop offset="100%"stop-color="#60a5fa"/></linearGradient>
 <linearGradient id="grad2"><stop offset="0%"stop-color="#34d399"/><stop offset="100%"stop-color="#2dd4bf"/></linearGradient>
 <linearGradient id="grad3"><stop offset="0%"stop-color="#34d399"/><stop offset="100%"stop-color="#818cf8"/></linearGradient>
 <linearGradient id="grad4"><stop offset="0%"stop-color="#34d399"/><stop offset="100%"stop-color="#fbbf24"/></linearGradient>
 </defs>
 </svg>
 
 <div class="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-900/20 via-transparent to-transparent pointer-events-none"></div>
 
 <div class="relative z-20 text-center bg-slate-900/60 p-3 md:p-6 rounded-2xl backdrop-blur-md border border-slate-700/50 pointer-events-none shadow-xl scale-90 md:scale-100">
 <p class="text-lg md:text-3xl font-black text-white tracking-widest uppercase">Global Ecosystem</p>
 <p class="text-emerald-400 font-bold mt-1 md:mt-2 text-[10px] md:text-sm uppercase tracking-widest flex items-center justify-center gap-2">
 <span class="relative flex h-2 w-2">
 <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
 <span class="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
 </span>
 120+ Countries Active
 </p>
 </div>
 </div>
 </div>
 </section>

 <!-- Calculate Savings Interactive -->
 <section class="py-10 md:py-24 neu-raised">
 <div class="max-w-7xl mx-auto px-6">
 <div class="grid md:grid-cols-2 gap-12 lg:gap-24 items-center">
 <div>
 <span class="eyebrow">ROI Calculator</span>
 <h2 class="text-2xl md:text-4xl font-black tracking-tight text-slate-900 mt-2 mb-6">See how much you save.</h2>
 <p class="text-lg text-slate-600 mb-8">By eliminating bloated agency retainers, office space, and HR benefits, SmartSiteMaker delivers elite talent at a fraction of the cost.</p>
 
 <div class="mb-8">
 <label class="block text-sm font-bold text-slate-700 mb-4 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0">
 <span>Monthly Project Budget</span>
 <span class="text-blue-700 font-black"id="budget-display">₹500,000</span>
 </label>
                            <input type="range" id="budget-slider" aria-label="Set Budget" min="50000" max="2000000" step="50000" value="500000" class="w-full h-2 bg-slate-200 rounded-lg appearance-none cursor-pointer accent-blue-600">
 </div>
 </div>
 
 <div class="neu-raised rounded-3xl p-5 md:p-8 shadow-xl relative overflow-hidden flex flex-col justify-between">
 <div class="absolute top-0 right-0 w-32 h-32 bg-emerald-500/10 rounded-full blur-3xl"></div>
 <div>
 <h3 class="font-bold text-slate-600 text-sm uppercase tracking-widest mb-6">Estimated Breakdown</h3>
 
 <div class="space-y-6">
 <div class="flex flex-col sm:flex-row justify-between sm:items-end gap-2 pb-4">
 <div>
 <p class="text-slate-900 font-bold">Traditional Agency Cost</p>
 <p class="text-xs text-slate-600">Includes 40%+ overhead</p>
 </div>
 <p class="text-base md:text-xl font-bold text-slate-600 line-through shrink-0"id="calc-agency">₹800,000</p>
 </div>
 
 <div class="flex flex-col sm:flex-row justify-between sm:items-end gap-2 pb-4">
 <div>
 <p class="text-slate-900 font-bold text-base sm:text-lg">SmartSiteMaker Cost</p>
 <p class="text-xs text-emerald-700 font-bold">Direct to Talent</p>
 </div>
 <p class="text-2xl sm:text-3xl font-black text-slate-900 shrink-0"id="calc-platform">₹500,000</p>
 </div>
 
 <div class="bg-emerald-50 rounded-xl p-4 flex flex-col sm:flex-row justify-between sm:items-center gap-2 border-emerald-100">
 <span class="font-bold text-emerald-800">Your Monthly Savings</span>
 <span class="text-xl sm:text-2xl font-black text-emerald-700 shrink-0"id="calc-savings">₹300,000</span>
 </div>
 </div>
 </div>
 
 <!-- Animated Graph -->
 <div class="mt-8 pt-6">
 <p class="text-xs font-bold text-slate-600 uppercase tracking-widest mb-4">Live Platform Volume</p>
 <div class="relative h-16 w-full flex items-end justify-between gap-1 opacity-70">
 <!-- Bars animated via CSS -->
 <div class="w-full bg-blue-100 rounded-t-sm animate-[pulse_2s_infinite]"></div>
 <div class="w-full bg-blue-100 rounded-t-sm h-[40%] animate-[pulse_2.5s_infinite]"></div>
 <div class="w-full bg-blue-200 rounded-t-sm h-[30%] animate-[pulse_2s_infinite_400ms]"></div>
 <div class="w-full bg-blue-300 rounded-t-sm h-[60%] animate-[pulse_3s_infinite_600ms]"></div>
 <div class="w-full bg-blue-400 rounded-t-sm h-[50%] animate-[pulse_2.2s_infinite_800ms]"></div>
 <div class="w-full bg-blue-500 rounded-t-sm h-[80%] animate-[pulse_2.8s_infinite_100ms]"></div>
 <div class="w-full bg-teal-400 rounded-t-sm h-[70%] animate-[pulse_2.4s_infinite_300ms]"></div>
 <div class="w-full bg-emerald-500 rounded-t-sm h-[100%] animate-[pulse_2s_infinite_500ms]"></div>
 </div>
 </div>
 </div>
 </div>
 </div>
 </section>

 <!-- Deep Dive Security & Compliance -->
 <section class="py-10 md:py-24 bg-slate-900 border-slate-800 relative z-10 overflow-hidden"id="security">
 <div class="max-w-7xl mx-auto px-6 relative z-10 text-center">
 <div class="w-7 h-7 md:w-10 md:h-10 md:w-16 md:h-16 bg-blue-500/10 text-blue-400 rounded-full flex items-center justify-center mx-auto mb-6">
 <svg class="w-8 h-8"fill="none"viewBox="0 0 24 24"stroke="currentColor"stroke-width="2"><path stroke-linecap="round"stroke-linejoin="round"d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>
 </div>
 <h2 class="text-2xl md:text-4xl font-black tracking-tight text-white mb-6">Bank-level security. Built in.</h2>
 <p class="text-base md:text-xl text-slate-400 max-w-2xl mx-auto mb-16">Every freelancer is cryptographically verified via Aadhar/PAN KYC. All intellectual property is secured with 256-bit AES encryption.</p>
 
 <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 text-left">
 <div class="bg-slate-800/50 p-4 md:p-6 rounded-2xl border-slate-700/50">
 <p class="font-bold text-white mb-2">SOC 2 Type II</p>
 <p class="text-sm text-slate-400">Independently audited for security and availability.</p>
 </div>
 <div class="bg-slate-800/50 p-4 md:p-6 rounded-2xl border-slate-700/50">
 <p class="font-bold text-white mb-2">Identity KYC</p>
 <p class="text-sm text-slate-400">Strict biometric and document verification.</p>
 </div>
 <div class="bg-slate-800/50 p-4 md:p-6 rounded-2xl border-slate-700/50">
 <p class="font-bold text-white mb-2">Zero-Knowledge IP</p>
 <p class="text-sm text-slate-400">Your code is encrypted at rest and in transit.</p>
 </div>
 <div class="bg-slate-800/50 p-4 md:p-6 rounded-2xl border-slate-700/50">
 <p class="font-bold text-white mb-2">Dispute Escrow</p>
 <p class="text-sm text-slate-400">Funds are ring-fenced in RBI-compliant accounts.</p>
 </div>
 </div>
 </div>
 </section>

 <!-- Final CTA -->
 <section class="py-10 md:py-24 neu-raised text-center">
 <div class="max-w-3xl mx-auto px-6">
 <h2 class="text-2xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight mb-6">Ready to build the future?</h2>
 <p class="text-lg md:text-xl text-slate-600 mb-10 px-4">Join the world's most exclusive network of enterprise clients and elite freelancers today.</p>
 <div class="flex flex-col sm:flex-row justify-center gap-4 px-6">
 <a href="#register"class="btn-primary text-lg px-10 py-5 shadow-xl shadow-blue-600/20 w-full sm:w-auto">Get Started for Free</a>
 </div>
 </div>
 </section>

 <!-- Trust & FAQ Section -->
 <section class="py-32 neu-raised relative overflow-hidden"id="faq-section">
 <!-- Premium Background Gradients -->
 <div class="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent"></div>
 <div class="absolute -top-[10rem] -right-[10rem] w-[15rem] h-[15rem] sm:w-[40rem] sm:h-[40rem] rounded-full bg-blue-600/5 blur-[5rem] pointer-events-none"></div>
 <div class="absolute -bottom-[10rem] -left-[10rem] w-[15rem] h-[15rem] sm:w-[40rem] sm:h-[40rem] rounded-full bg-emerald-600/5 blur-[5rem] pointer-events-none"></div>
 
 <div class="max-w-4xl mx-auto px-6 relative z-10">
 <div class="text-center mb-16">
 <p class="eyebrow flex items-center justify-center gap-2 mb-4">
 <svg class="w-4 h-4 text-emerald-500"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg>
 The 100% Secure Guarantee
 </p>
 <h2 class="text-2xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900 mb-6">Built on absolute trust.</h2>
 <p class="text-lg text-slate-600 max-w-2xl mx-auto">We've engineered out the risk. Whether you're hiring elite talent or delivering exceptional work, our Smart Escrow and Admin Mediation protocol ensures everyone wins.</p>
 </div>

 <!-- Tabs -->
 <div class="flex justify-center mb-12">
 <div class="bg-slate-200/50 p-1.5 rounded-2xl inline-flex backdrop-blur-md -inner">
 <button onclick="document.getElementById('faq-client').classList.remove('hidden'); document.getElementById('faq-talent').classList.add('hidden'); this.classList.add('neu-raised', 'text-blue-700'); this.classList.remove('text-slate-600', 'hover:text-slate-700'); this.nextElementSibling.classList.remove('neu-raised', 'text-blue-700'); this.nextElementSibling.classList.add('text-slate-600', 'hover:text-slate-700');"class="px-5 md:px-8 py-3 rounded-xl font-bold text-sm transition-all neu-raised text-blue-700">For Clients</button>
 <button onclick="document.getElementById('faq-talent').classList.remove('hidden'); document.getElementById('faq-client').classList.add('hidden'); this.classList.add('neu-raised', 'text-blue-700'); this.classList.remove('text-slate-600', 'hover:text-slate-700'); this.previousElementSibling.classList.remove('neu-raised', 'text-blue-700'); this.previousElementSibling.classList.add('text-slate-600', 'hover:text-slate-700');"class="px-5 md:px-8 py-3 rounded-xl font-bold text-sm transition-all text-slate-600 hover:text-slate-700">For Talent</button>
 </div>
 </div>

 <!-- Client FAQs -->
 <div id="faq-client"class="space-y-4">
 <div class="neu-raised/80 backdrop-blur-md rounded-2xl overflow-hidden faq-item cursor-pointer shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_-4px_rgba(0,0,0,0.1)] transition-all">
 <div class="p-4 md:p-6 font-bold text-slate-900 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center group">
 <span class="flex items-center gap-3"><span class="w-8 h-8 rounded-full bg-blue-50 text-blue-700 flex items-center justify-center shrink-0">🔒</span> How does the Smart Escrow guarantee protect my capital?</span>
 <span class="text-slate-400 faq-icon text-base md:text-xl group-hover:text-blue-700 transition-colors">+</span>
 </div>
 <div class="px-6 pb-6 text-slate-600 hidden faq-content text-sm leading-relaxed pt-4">
 When you fund a project, your capital is locked in a mathematically secure smart contract. The freelancer can see the funds exist, but cannot touch them. Only when you explicitly approve the deliverables in the workspace are the funds released. If requirements aren't met, the capital never leaves the vault.
 </div>
 </div>
 
 <div class="neu-raised/80 backdrop-blur-md rounded-2xl overflow-hidden faq-item cursor-pointer shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_-4px_rgba(0,0,0,0.1)] transition-all">
 <div class="p-4 md:p-6 font-bold text-slate-900 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center group">
 <span class="flex items-center gap-3"><span class="w-8 h-8 rounded-full bg-emerald-50 text-emerald-700 flex items-center justify-center shrink-0">⚖️</span> What is the Zero-Risk Dispute Resolution?</span>
 <span class="text-slate-400 faq-icon text-base md:text-xl group-hover:text-emerald-700 transition-colors">+</span>
 </div>
 <div class="px-6 pb-6 text-slate-600 hidden faq-content text-sm leading-relaxed pt-4">
 In the rare event of a disagreement, you can freeze the contract instantly by raising a dispute. Our Super Admins act as impartial judges. They review the chat logs, the contract hash, and the submitted files. If the freelancer failed to deliver the agreed scope, the admin executes a forced refund directly back to your wallet. You never pay for incomplete work.
 </div>
 </div>

 <div class="neu-raised/80 backdrop-blur-md rounded-2xl overflow-hidden faq-item cursor-pointer shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_-4px_rgba(0,0,0,0.1)] transition-all">
 <div class="p-4 md:p-6 font-bold text-slate-900 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center group">
 <span class="flex items-center gap-3"><span class="w-8 h-8 rounded-full bg-purple-50 text-purple-600 flex items-center justify-center shrink-0">⭐</span> How do you verify the talent?</span>
 <span class="text-slate-400 faq-icon text-base md:text-xl group-hover:text-purple-600 transition-colors">+</span>
 </div>
 <div class="px-6 pb-6 text-slate-600 hidden faq-content text-sm leading-relaxed pt-4">
 Our Verified Talent Protocol enforces a strict Identity KYC process. Furthermore, we monitor historical performance, dispute ratios, and project completion rates. Only elite professionals who consistently deliver quality are allowed to bid on your projects.
 </div>
 </div>
 </div>

 <!-- Talent FAQs -->
 <div id="faq-talent"class="space-y-4 hidden">
 <div class="neu-raised/80 backdrop-blur-md rounded-2xl overflow-hidden faq-item cursor-pointer shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_-4px_rgba(0,0,0,0.1)] transition-all">
 <div class="p-4 md:p-6 font-bold text-slate-900 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center group">
 <span class="flex items-center gap-3"><span class="w-8 h-8 rounded-full bg-emerald-50 text-emerald-700 flex items-center justify-center shrink-0">💰</span> Is my payment guaranteed?</span>
 <span class="text-slate-400 faq-icon text-base md:text-xl group-hover:text-emerald-700 transition-colors">+</span>
 </div>
 <div class="px-6 pb-6 text-slate-600 hidden faq-content text-sm leading-relaxed pt-4">
 Absolutely. Before you write a single line of code or design a single pixel, the client's capital is locked in the Smart Escrow Vault. You can verify the funds are secured in the Workspace. Once you submit the deliverables, the client cannot retract the funds without administrative approval. You never have to chase invoices again.
 </div>
 </div>

 <div class="neu-raised/80 backdrop-blur-md rounded-2xl overflow-hidden faq-item cursor-pointer shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_-4px_rgba(0,0,0,0.1)] transition-all">
 <div class="p-4 md:p-6 font-bold text-slate-900 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center group">
 <span class="flex items-center gap-3"><span class="w-8 h-8 rounded-full bg-rose-50 text-rose-700 flex items-center justify-center shrink-0">🛡️</span> What if the client refuses to release funds?</span>
 <span class="text-slate-400 faq-icon text-base md:text-xl group-hover:text-rose-700 transition-colors">+</span>
 </div>
 <div class="px-6 pb-6 text-slate-600 hidden faq-content text-sm leading-relaxed pt-4">
 If a client attempts to withhold payment for completed work, you can raise a dispute. Our Admins will review your submitted deliverables against the contract requirements. If you met the specifications, the Admin will execute a forced release of the escrowed funds directly to your wallet. You are fully protected from scope creep and non-payment.
 </div>
 </div>
 </div>
 </div>
 </section>

 <!-- Dark Mega-Footer -->
 <footer class="bg-slate-950 text-slate-400 pt-24 pb-12 border-slate-900 relative z-10 overflow-hidden">
 <div class="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-500/50 to-transparent"></div>
 <div class="absolute -top-[20rem] left-[20%] w-[15rem] h-[15rem] sm:w-[40rem] sm:h-[40rem] rounded-full bg-blue-600/5 blur-[5rem] pointer-events-none"></div>
 
 <div class="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-x-6 gap-y-12 relative z-10">
 <div class="col-span-2 md:col-span-4 lg:col-span-2">
 <div class="flex items-center gap-2 grayscale brightness-200 mb-6 drop-shadow-[0_0_15px_rgba(255,255,255,0.3)]">
 ${icon('logo', 'text-white')}
 </div>
 <p class="text-sm max-w-sm leading-relaxed mb-8">SmartSiteMaker Inc. is the autonomous engine powering the world's elite digital workforce. Built for enterprise scale, secured by smart contracts.</p>
 
 <div class="bg-slate-900/50 border-slate-800 rounded-2xl p-4 md:p-6 backdrop-blur">
 <p class="text-white font-bold text-sm mb-3">Join our newsletter</p>
 <div class="flex">
 <input type="email"id="newsletter-email"placeholder="work@company.com"class="bg-slate-800 border-slate-700 rounded-l-xl px-4 py-2 text-sm w-full focus:outline-none focus:border-blue-500 text-white">
 <button id="newsletter-btn"class="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded-r-xl font-bold transition-colors">Subscribe</button>
 </div>
 </div>
 </div>
 
 <div class="col-span-1">
 <p class="text-white font-black uppercase tracking-widest text-xs mb-6">Talent</p>
 <ul class="space-y-4 text-sm font-medium">
 <li><a href="#freelancers"class="hover:text-blue-400 transition-colors">Find Elite Experts</a></li>
 <li><a href="#register"class="hover:text-blue-400 transition-colors">Post a Contract</a></li>
 <li><a href="#register"class="hover:text-blue-400 transition-colors">Enterprise Solutions</a></li>
 <li><a href="#register"class="hover:text-blue-400 transition-colors">Agency Partners</a></li>
 </ul>
 </div>
 
 <div class="col-span-1">
 <p class="text-white font-black uppercase tracking-widest text-xs mb-6">Platform</p>
 <ul class="space-y-4 text-sm font-medium">
 <li><a href="#ai"class="hover:text-blue-400 transition-colors">Smart AI Manager</a></li>
 <li><a href="#security"class="hover:text-blue-400 transition-colors">Smart Contracts</a></li>
 <li><a href="#pricing"class="hover:text-blue-400 transition-colors">Pricing</a></li>
 <li><a href="#docs"class="hover:text-blue-400 transition-colors">Developer API</a></li>
 <li><a href="#status"class="flex items-center gap-2 hover:text-blue-400 transition-colors">
 System Status <span class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
 </a></li>
 </ul>
 </div>
 
 <div class="col-span-1">
 <p class="text-white font-black uppercase tracking-widest text-xs mb-6">Company</p>
 <ul class="space-y-4 text-sm font-medium">
 <li><a href="#about"class="hover:text-blue-400 transition-colors">About Us</a></li>
 <li><a href="#careers"class="hover:text-blue-400 transition-colors">Careers (Hiring)</a></li>
 <li><a href="#press"class="hover:text-blue-400 transition-colors">Press & Media</a></li>
 </ul>
 </div>
 
 <div class="col-span-1">
 <p class="text-white font-black uppercase tracking-widest text-xs mb-6">Legal</p>
 <ul class="space-y-4 text-sm font-medium">
 <li><a href="#policy-terms"class="hover:text-blue-400 transition-colors">Terms of Service</a></li>
 <li><a href="#policy-privacy"class="hover:text-blue-400 transition-colors">Privacy Policy</a></li>
 <li><a href="#policy-conduct"class="hover:text-blue-400 transition-colors">Code of Conduct</a></li>
 <li><a href="#policy-fees"class="hover:text-blue-400 transition-colors">Fees</a></li>
 </ul>
 </div>
 </div>
 
 <div class="max-w-7xl mx-auto px-6 mt-20 pt-8 border-slate-800/50 flex flex-col md:flex-row justify-center items-center gap-6 text-center md:text-left">
 <p class="text-xs font-medium opacity-100 text-slate-400">© ${new Date().getFullYear()} SmartSiteMaker Inc. Powered by advanced autonomous infrastructure.</p>
 </div>
 </footer>
 </main>
 `;
}

function authView() {
 const isRegister = window.location.hash === '#register';
 return `
 <main class="min-h-screen neu-raised flex">
 <div class="hidden lg:flex lg:w-1/2 bg-blue-600 p-12 flex-col justify-between relative overflow-hidden">
 <div class="absolute inset-0 bg-gradient-to-br from-blue-700 to-blue-900 opacity-50"></div>
 <div class="relative z-10">
 ${icon('logo', 'mb-10 text-white')}
 <p class="text-blue-200 font-bold tracking-widest uppercase text-sm mb-4">Enterprise Freelancing</p>
 <h1 class="text-3xl md:text-5xl font-extrabold text-white leading-tight">The world's most trusted hub for digital work.</h1>
 <p class="mt-6 text-base md:text-xl text-blue-100 max-w-lg font-medium">Find elite talent, manage secure milestones, and scale your projects with absolute confidence.</p>
 </div>
 <div class="relative z-10 flex gap-4 text-sm font-bold text-white">
 <span class="neu-raised/10 px-4 py-2 rounded-xl backdrop-blur-md border-white/20">✓ Escrow Protected</span>
 <span class="neu-raised/10 px-4 py-2 rounded-xl backdrop-blur-md border-white/20">✓ Verified Talent</span>
 </div>
 </div>
 <div class="w-full lg:w-1/2 flex items-center justify-center p-8 sm:p-12 relative neu-raised">
 <div class="w-full max-w-md">
 <div class="lg:hidden mb-10 flex justify-center">
 ${icon('logo', 'h-8 md:h-14 w-auto text-blue-700')}
 </div>
 <h2 class="text-xl md:text-3xl font-extrabold text-slate-900 text-center tracking-tight">Welcome back</h2>
 <div class="flex justify-center mt-3"><span class="online-freelancers-count rounded-full bg-blue-50 px-3 py-1 border-blue-200 text-blue-700 text-xs font-bold flex items-center"><span class="w-2 h-2 rounded-full bg-blue-500 animate-pulse mr-1.5 inline-block"></span>${window.onlineCount || 850} professionals online now</span></div>
 <p class="mt-3 text-slate-600 text-center font-medium">Sign in to your professional workspace.</p>
 <form id="auth-form"class="mt-10 flex flex-col gap-5">
 <div style="order: 1;">
 <label class="block text-sm font-bold text-slate-700 mb-1.5">Work Email</label>
 <div class="relative flex items-center mt-2">
 <input class="input-control !mt-0 pr-20"id="auth-email"name="email"type="email"required autocomplete="email"placeholder="name@company.com">
 <button type="button"id="btn-verify-email"class="absolute right-1 top-1/2 -translate-y-1/2 px-3 py-1.5 bg-blue-100 hover:bg-blue-200 text-blue-700 text-xs font-bold rounded-lg transition-colors hidden">Verify</button>
 <button type="button"id="btn-edit-email"class="absolute right-1 top-1/2 -translate-y-1/2 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-bold rounded-lg transition-colors hidden">Edit</button>
 </div>
 </div>
 <div class="reg-field hidden"id="register-otp"style="order: 2; display: none;">
 <label class="block text-sm font-bold text-slate-700 mb-1.5">Verification Code (OTP)</label>
 <input class="input-control text-center tracking-[0.5em] font-mono font-bold"id="auth-otp"name="otp"type="text"maxlength="6"placeholder="------">
 <p class="text-xs text-blue-700 mt-1.5 font-semibold">We sent a 6-digit code to your email.</p>
 </div>
 <div class="reg-field hidden"style="order: 3;">
 <label class="block text-sm font-bold text-slate-700 mb-1.5">Phone Number</label>
 <div class="relative flex items-center mt-2">
 <div class="absolute inset-y-0 left-0 flex items-center neu-raised/50 rounded-l-xl">
 <select name="country_code"class="h-full bg-transparent border-0 text-sm text-slate-700 pl-3 pr-6 focus:ring-0 cursor-pointer font-bold appearance-none outline-none z-10"style="-webkit-appearance: none; -moz-appearance: none;">
 <option value="+91">🇮🇳 +91</option>
 <option value="+1">🇺🇸 +1</option>
 <option value="+44">🇬🇧 +44</option>
 <option value="+61">🇦🇺 +61</option>
 <option value="+971">🇦🇪 +971</option>
 </select>
 <svg class="w-3 h-3 text-slate-400 absolute right-2 pointer-events-none"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M19 9l-7 7-7-7"></path></svg>
 </div>
 <input class="input-control !mt-0 pl-24"id="auth-phone"name="phone"type="tel"placeholder="9876543210">
 </div>
 </div>
 <div class="reg-field hidden"style="order: 4;">
 <label class="block text-sm font-bold text-slate-700 mb-1.5">Full Name</label>
 <input class="input-control"id="auth-name"name="name"autocomplete="name"placeholder="John Doe">
 </div>
 <div style="order: 5;">
 <label class="block text-sm font-bold text-slate-700 mb-1.5">Password</label>
 <div class="relative flex items-center mt-2">
 <input class="input-control !mt-0 pr-10"id="auth-password"name="password"type="password"required minlength="8"autocomplete="current-password"placeholder="••••••••">
 <button type="button"class="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 focus:outline-none"onclick="window.togglePasswordVisibility(this, 'auth-password')">
 <svg class="w-5 h-5 eye-icon"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
 </button>
 </div>
 </div>
 <div class="reg-field hidden"style="order: 6;">
 <label class="block text-sm font-bold text-slate-700 mb-1.5">Confirm Password</label>
 <div class="relative flex items-center mt-2">
 <input class="input-control !mt-0 pr-10"id="auth-confirm"name="password_confirmation"type="password"placeholder="••••••••">
 <button type="button"class="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 focus:outline-none"onclick="window.togglePasswordVisibility(this, 'auth-confirm')">
 <svg class="w-5 h-5 eye-icon"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
 </button>
 </div>
 </div>
 <div class="reg-field hidden"style="order: 7;">
 <label class="block text-sm font-bold text-slate-700 mb-1.5">I want to</label>
 <select class="input-control font-semibold"id="auth-role"name="role">
 <option value="client">Hire elite talent (Client)</option>
 <option value="freelancer">Work as a professional (Freelancer)</option>
 </select>
 </div>
 <button style="order: 8;"class="btn-primary w-full py-3.5 text-base shadow-blue-600/20"type="submit"><span id="auth-submit">${isRegister ? 'Create account' : 'Sign in'}</span></button>
 </form>
 <div class="mt-4 flex flex-col items-center gap-3 w-full text-sm font-bold">
 <button id="toggle-auth"class="text-slate-600 hover:text-blue-700 transition-colors">${isRegister ? 'Already have an account? Sign in' : 'Need an account? Create one'}</button>
 ${!isRegister ? `<a href="#forgot-password"class="text-slate-600 hover:text-blue-700 transition-colors">Forgot password?</a>` : ''}
 </div>
 </div>
 </div>
 </main>`;
}

function forgotPasswordView() {
 return `
 <main class="min-h-screen neu-raised flex">
 <div class="w-full flex items-center justify-center p-8 sm:p-12 relative neu-raised">
 <div class="w-full max-w-md">
 <div class="mb-10 flex justify-center">
 ${icon('logo', 'h-8 md:h-14 w-auto text-blue-700')}
 </div>
 <h2 class="text-xl md:text-3xl font-extrabold text-slate-900 text-center tracking-tight">Forgot Password</h2>
 <p class="mt-3 text-slate-600 text-center font-medium">Enter your work email and we will send you a link to reset your password.</p>
 <form id="forgot-password-form"class="mt-10 space-y-5">
 <div>
 <label class="block text-sm font-bold text-slate-700 mb-1.5">Work Email</label>
 <input class="input-control"name="email"type="email"required autocomplete="email"placeholder="name@company.com">
 </div>
 <button class="btn-primary w-full py-3.5 text-base shadow-blue-600/20"type="submit">Send Reset Link</button>
 </form>
 <div class="mt-6 text-center">
 <a href="#login"class="text-sm font-bold text-slate-600 hover:text-blue-700 transition-colors">Back to Login</a>
 </div>
 </div>
 </div>
 </main>`;
}

function resetPasswordView() {
    const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const token = urlParams.get('token') || '';
    const email = urlParams.get('email') || '';
    
    return `
    <main class="min-h-screen neu-raised flex">
        <div class="w-full flex items-center justify-center p-8 sm:p-12 relative neu-raised">
            <div class="w-full max-w-md">
                <div class="mb-10 flex justify-center">
                    ${icon('logo', 'h-8 md:h-14 w-auto text-blue-700')}
                </div>
                <h2 class="text-xl md:text-3xl font-extrabold text-slate-900 text-center tracking-tight">Reset Password</h2>
                <p class="mt-3 text-slate-600 text-center font-medium">Enter your new password below.</p>
                <form id="reset-password-form" class="mt-10 space-y-5">
                    <input type="hidden" name="token" value="${token}">
                    <div>
                        <label class="block text-sm font-bold text-slate-700 mb-1.5">Email</label>
                        <input class="input-control bg-slate-100 text-slate-600" name="email" type="email" value="${email}" readonly>
                    </div>
                    <div>
                        <label class="block text-sm font-bold text-slate-700 mb-1.5">New Password</label>
                        <input class="input-control" name="password" type="password" required>
                    </div>
                    <div>
                        <label class="block text-sm font-bold text-slate-700 mb-1.5">Confirm Password</label>
                        <input class="input-control" name="password_confirmation" type="password" required>
                    </div>
                    <button class="btn-primary w-full py-3.5 text-base shadow-blue-600/20" type="submit">Reset Password</button>
                </form>
                <div class="mt-6 text-center">
                    <a href="#login" class="text-sm font-bold text-slate-600 hover:text-blue-700 transition-colors">Back to Login</a>
                </div>
            </div>
        </div>
    </main>`;
}

function verifyEmailView() {
 return `
 <main class="min-h-screen neu-raised flex">
 <div class="w-full flex items-center justify-center p-8 sm:p-12 relative neu-raised">
 <div class="w-full max-w-md">
 <div class="mb-10 flex justify-center">
 ${icon('logo', 'h-8 md:h-14 w-auto text-blue-700')}
 </div>
 <h2 class="text-xl md:text-3xl font-extrabold text-slate-900 text-center tracking-tight">Verify your Email</h2>
 <p class="mt-3 text-slate-600 text-center font-medium">We sent a 6-digit OTP to your email address. Please enter it below to verify your account.</p>
 <form id="verify-email-form"class="mt-10 space-y-5">
 <div>
 <label class="block text-sm font-bold text-slate-700 mb-1.5">6-Digit OTP</label>
 <input class="input-control text-center text-2xl tracking-widest font-mono"name="otp_code"type="text"required maxlength="6"pattern="\\d{6}"placeholder="------">
 </div>
 <button class="btn-primary w-full py-3.5 text-base shadow-blue-600/20"type="submit">Verify & Continue</button>
 </form>
 <div class="mt-4 text-center">
 <p id="otp-timer-text"class="text-sm font-medium text-slate-600">Resend OTP in <span id="otp-timer"class="font-bold text-slate-700">60</span>s</p>
 <button type="button"id="resend-otp-btn"class="text-sm font-bold text-blue-700 hover:text-blue-700 transition-colors hidden">Resend OTP</button>
 </div>
 <div class="mt-6 text-center">
 <a href="#login"class="text-sm font-bold text-slate-600 hover:text-blue-700 transition-colors">Back to Login</a>
 </div>
 </div>
 </div>
 </main>`;
}

function sidebar() {
 const path = route();
 const active = (key, exact = false) => path === key || (!exact && key !== 'dashboard' && path.startsWith(`${key}/`)) ? ' active' : '';
 const isFreelancer = state.user?.role === 'freelancer';
 const isClient = state.user?.role === 'client';
 const isAdmin = state.user?.role === 'admin';

 return `<aside id="sidebar"class="fixed inset-y-0 left-0 z-[70] flex w-[75vw] max-w-[300px] md:w-72 md:max-w-none -translate-x-full flex-col neu-raised p-4 transition-transform lg:static lg:translate-x-0">
 <div class="relative px-2 py-6 mb-4 flex justify-center">
 ${icon('logo', 'h-8 md:h-14 w-auto text-slate-900')}
 <button id="close-menu"class="btn-ghost absolute right-0 top-2 lg:hidden"aria-label="Close menu">&times;</button>
 </div>
 <div class="mt-2 px-3 mb-6 neu-raised rounded-2xl py-3">
 <p class="text-[10px] font-black uppercase tracking-widest text-blue-700/80 mb-1 flex items-center gap-1">${icon('star', 'w-3 h-3')} ${h(state.user.role)} WORKSPACE</p>
 <p class="truncate text-base font-bold text-slate-900">${h(state.user.name)}</p>
 </div>
 <nav class="space-y-1.5 overflow-y-auto flex-1 px-1 pb-2 hide-scrollbar">
 ${!isAdmin ? `<a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('dashboard')}"href="#dashboard">${icon('dashboard', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Overview</span></a>` : ''}
 <a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('marketplace')}"href="#marketplace">${icon('globe', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>${isFreelancer ? 'Find work' : 'Marketplace'}</span></a>
 <a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('freelancers')}"href="#freelancers">${icon('users', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Freelancers</span></a>
 <a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('contracts')}"href="#contracts">${icon('briefcase', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Workspaces</span></a>
 ${isClient ? `<a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('manage-jobs')}"href="#manage-jobs">${icon('document', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Manage Jobs</span></a>` : ''}
 <a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('leaderboard')}"href="#leaderboard">${icon('trophy', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Leaderboard</span></a>
 <a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('forum')}"href="#forum">${icon('comment', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Community Forum</span></a>
 <a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('blog')}"href="#blog">${icon('document', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Blog & Resources</span></a>
 ${isClient ? `<a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('saved-freelancers')}"href="#saved-freelancers"><svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 24 24"fill="none"stroke="currentColor"stroke-width="2"class="w-5 h-5 opacity-70"><path stroke-linecap="round"stroke-linejoin="round"d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"/></svg> <span>Saved Freelancers</span></a>` : ''}
 ${(isFreelancer || isAdmin) ? `<a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('skill-tests')}"href="#skill-tests">${icon('star', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Skill Tests</span></a>` : ''}
 ${isFreelancer ? `<a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('membership')}"href="#membership">${icon('shield', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Membership</span></a>` : ''}
 ${!isAdmin ? `<a class="nav-link font-semibold hover:bg-blue-50/50 hover:text-blue-700 rounded-xl transition-all ${active('referrals')}"href="#referrals">${icon('gift', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Refer &amp; Earn</span></a>` : ''}
 ${isAdmin ? `
 <div class="pt-3 pb-1 mt-2"><p class="text-[10px] font-black uppercase tracking-widest text-slate-400 px-2">Admin Tools</p></div>
 <a class="nav-link font-semibold hover:bg-slate-100 hover:text-slate-900 rounded-xl transition-all ${active('admin', true)}"href="#admin">${icon('shield', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Admin Center</span></a>
 <a class="nav-link font-semibold hover:bg-slate-100 hover:text-slate-900 rounded-xl transition-all ${active('admin-ledger')}"href="#admin-ledger">${icon('document', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Ledger</span></a>
 <a class="nav-link font-semibold hover:bg-slate-100 hover:text-slate-900 rounded-xl transition-all ${active('admin-payments')}"href="#admin-payments">${icon('money', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Payments</span></a>
 <a class="nav-link font-semibold hover:bg-slate-100 hover:text-slate-900 rounded-xl transition-all ${active('admin-reports')}"href="#admin-reports">${icon('alert', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>User Reports</span></a>
 <a class="nav-link font-semibold hover:bg-slate-100 hover:text-slate-900 rounded-xl transition-all ${active('admin-announcements')}"href="#admin-announcements">${icon('bell_outline', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Announcements</span></a>
 <a class="nav-link font-semibold hover:bg-slate-100 hover:text-slate-900 rounded-xl transition-all ${active('admin-featured')}"href="#admin-featured">${icon('star', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Featured Items</span></a>
 <a class="nav-link font-semibold hover:bg-slate-100 hover:text-slate-900 rounded-xl transition-all ${active('admin/blog')}"href="#admin/blog">${icon('document', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Blog Manager</span></a>
 <a class="nav-link font-semibold hover:bg-slate-100 hover:text-slate-900 rounded-xl transition-all ${active('admin-seo')}"href="#admin-seo">${icon('globe', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>SEO Manager</span></a>
 ` : ''}
 <a class="nav-link font-semibold hover:bg-slate-100 hover:text-slate-900 rounded-xl transition-all mt-2 ${active('profile')}"href="#profile">${icon('settings', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 opacity-70')} <span>Profile &amp; Settings</span></a>
 <button id="logout"class="nav-link mt-1 w-full text-rose-500 hover:bg-rose-50 hover:text-rose-700 rounded-xl font-bold transition-all">${icon('logout', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5')} <span>Sign Out</span></button>
 </nav>
 </aside>`;
}

function pageHeader() {
 const label = titleCase(route().split('/')[0]);
 const balancePill = (state.user && state.user.role !== 'admin') ? `<button id="wallet-balance-btn"class="flex items-center gap-1.5 rounded-xl border-blue-200 bg-blue-50 px-3 py-1.5 text-xs font-bold text-blue-700 hover:bg-blue-100 transition-colors"title="Wallet balance — click to manage">${money(state.user.balance ?? 0)} <span class="text-blue-500">${icon('money')}</span></button>` : '';
 
 return `
<header class="sticky top-0 z-50 flex items-center justify-between bg-[#e9eef5]/80 px-5 py-4 backdrop-blur-xl sm:px-8 border-b border-slate-200/50">
    <button id="open-menu" class="btn-ghost lg:hidden" aria-label="Open menu">${icon('menu')}</button>
    <div class="hidden text-sm text-slate-600 sm:block font-medium tracking-tight">Workspace / <span class="text-slate-900 font-bold ml-1">${h(label)}</span></div>
    <div class="flex items-center gap-4">
        ${balancePill}
        <button id="notifications-button" class="btn-ghost relative text-slate-600 hover:text-blue-700 transition-colors rounded-full h-10 w-10 flex items-center justify-center" aria-label="Notifications">
            ${icon('bell_outline')}
            ${state.unreadNotifications ? `<span class="absolute 0 top-0 right-0 grid h-4 min-w-4 place-items-center rounded-full bg-rose-500 px-1 text-[9px] font-black text-white ring-2 ring-white animate-pulse">${state.unreadNotifications}</span>` : ''}
        </button>
        <div class="relative group">
            <button id="profile-dropdown-btn" class="focus:outline-none flex items-center gap-2 ring-2 ring-transparent hover:ring-blue-100 rounded-full transition-all">${avatar(state.user, 'h-10 w-10 text-sm')}</button>
            <div class="absolute right-0 mt-3 w-56 rounded-2xl bg-[#e9eef5] neu-raised py-2 shadow-2xl invisible opacity-0 transition-all duration-200 origin-top-right scale-95 group-focus-within:scale-100 group-focus-within:visible group-focus-within:opacity-100 group-hover:scale-100 group-hover:visible group-hover:opacity-100 z-50">
                <div class="px-5 py-3 border-b border-slate-300/50 mb-1">
                    <p class="truncate text-sm font-black text-slate-900">${h(state.user.name)}</p>
                    <p class="truncate text-xs text-slate-600 font-medium">${h(state.user.email)}</p>
                </div>
                <a href="#profile" onclick="setTimeout(()=>document.activeElement.blur(),10)" class="block px-5 py-2.5 text-sm text-slate-600 hover:neu-pressed hover:text-blue-700 transition-colors font-semibold">Your Profile & Settings</a>
                <button id="header-logout" class="block w-full text-left px-5 py-2.5 text-sm font-semibold text-rose-500 hover:bg-rose-100/50 hover:text-rose-700 transition-colors">Sign out securely</button>
            </div>
        </div>
    </div>
</header>
`;
}

function metric(label, value, detail) {
 

 return `<div class="soft-panel p-4 md:p-6 bg-gradient-to-br from-white to-slate-50 hover:-translate-y-0.5 transition-all duration-300 rounded-3xl"><p class="text-sm font-semibold text-slate-600 mb-2 tracking-tight">${h(label)}</p><p class="text-2xl md:text-4xl font-black tracking-tight text-slate-900 mb-1">${value}</p><p class="text-[11px] font-bold text-teal-700 bg-teal-50 px-2 py-0.5 rounded-full inline-block uppercase tracking-wider">${h(detail)}</p></div>`;
}

function jobCard(job) {
 const badges = [
 job.is_contest ? `<span class="inline-flex items-center gap-1.5 rounded-full bg-[#8B5CF6] px-3 py-1 text-[10px] font-black uppercase tracking-widest text-white shadow-sm">${icon('trophy', 'w-3 h-3')} CONTEST</span>` : '',
 job.is_urgent ? `<span class="inline-flex items-center gap-1.5 rounded-full bg-[#EF4444] px-3 py-1 text-[10px] font-black uppercase tracking-widest text-white shadow-sm">${icon('bolt', 'w-3 h-3')} URGENT</span>` : '',
 job.is_featured ? `<span class="inline-flex items-center gap-1.5 rounded-full bg-[#F59E0B] px-3 py-1 text-[10px] font-black uppercase tracking-widest text-white shadow-sm">${icon('star', 'w-3 h-3')} FEATURED</span>` : '',
 job.is_private ? `<span class="inline-flex items-center gap-1.5 rounded-full bg-[#14B8A6] px-3 py-1 text-[10px] font-black uppercase tracking-widest text-white shadow-sm">${icon('shield-check', 'w-3 h-3')} PRIVATE</span>` : '',
 job.is_sealed ? `<span class="inline-flex items-center gap-1.5 rounded-full bg-[#94A3B8] px-3 py-1 text-[10px] font-black uppercase tracking-widest text-[#1E293B] shadow-sm">${icon('lock', 'w-3 h-3')} SEALED</span>` : '',
 ].filter(Boolean).join('');
 
 return `<article class="rounded-3xl neu-raised p-7 hover:-translate-y-0.5 transition-all duration-300 flex flex-col justify-between group hover:border-blue-300"><div class="flex items-start justify-between gap-4"><div class="flex-1 min-w-0"><span class="text-[10px] font-black text-blue-700 uppercase tracking-widest bg-blue-50 px-2 py-0.5 rounded-full inline-block mb-3">${h(job.category)}</span><h3 class="text-base md:text-xl font-black text-slate-900 leading-tight group-hover:text-blue-700 transition-colors break-words">${h(job.title)}</h3></div><span class="flex-shrink-0 bg-emerald-50 text-emerald-700 border-emerald-100 px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider whitespace-nowrap">${h(job.status)}</span></div>${badges ? `<div class="mt-4 flex flex-wrap gap-2">${badges}</div>` : ''}<p class="mt-4 line-clamp-3 text-sm leading-relaxed text-slate-600 font-medium">${h(job.description)}</p><div class="mt-5 flex flex-wrap gap-2">${(job.skills || []).slice(0, 4).map((skill) => `<span class="rounded-lg neu-raised px-2.5 py-1 text-[11px] font-bold text-slate-700">${h(skill)}</span>`).join('')}</div><div class="mt-6 flex flex-wrap items-center justify-between gap-4 pt-5"><div class="flex gap-6"><div class="min-w-0"><p class="text-[10px] text-slate-400 font-black uppercase tracking-widest mb-1 truncate">${job.payment_type === 'hourly' ? 'Hourly Rate' : (job.is_contest ? 'Prize' : 'Budget')}</p><p class="text-lg font-black text-slate-900 truncate">${money(job.budget?.max ?? job.budget?.min, job.budget?.currency)}${job.payment_type === 'hourly' ? '<span class="text-sm font-bold text-slate-600">/hr</span>' : ''}</p></div><div class="text-left"><p class="text-[10px] text-slate-400 font-black uppercase tracking-widest mb-1">Proposals</p><p class="text-lg font-black text-slate-900">${job.proposals_count ?? 0}</p></div></div><a class="btn-primary py-2.5 px-6 shadow-xl shadow-blue-500/20 whitespace-nowrap"href="#jobs/${job.id}">View Details</a></div></article>`;
}

function dashboardPage() {
 // Admin should always see the admin command center, not the user dashboard
 if (state.user?.role === 'admin') {
 return adminPage();
 }
 
 const a = state.analytics || {};
 const role = state.user.role;
 const isClient = role === 'client';
 
 // Quick Actions
 const quickActions = isClient 
 ? `<button class="btn-primary"data-open-modal="job">${icon('plus', 'w-3 h-3 md:w-4 md:h-4 inline-block')} Post a new job</button>`
 : `<a class="btn-primary"href="#marketplace">Find Work</a>`;
 
 // Dashboard Header
 const headerHtml = `
 <section class="relative overflow-hidden rounded-3xl bg-slate-900 text-white p-8 sm:p-10 shadow-2xl shadow-blue-900/20 mb-8 border-slate-800">
 <div class="absolute top-0 right-0 w-32 h-32 md:w-64 md:h-64 bg-blue-500/20 rounded-full blur-3xl"></div>
 <div class="absolute bottom-0 left-10 w-24 h-24 md:w-48 md:h-48 bg-teal-500/10 rounded-full blur-3xl"></div>
 <div class="relative z-10 flex flex-col justify-between gap-6 md:flex-row md:items-end">
 <div>
 <div class="inline-flex items-center gap-2 neu-raised/10 backdrop-blur-md px-3 py-1.5 rounded-full mb-4 border-white/10">
 <span class="relative flex h-2.5 w-2.5">
 <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
 <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500"></span>
 </span>
 <span class="text-[11px] font-black uppercase tracking-widest text-emerald-300">AI Manager Online</span>
 </div>
 <h1 class="text-3xl font-black tracking-tight sm:text-5xl text-white mb-2">Welcome back, ${h(state.user.name.split(' ')[0])}.</h1>
 <p class="text-base sm:text-lg text-slate-300 font-medium">Your enterprise workspace is perfectly synced and ready for action.</p>
 </div>
 <div class="flex-shrink-0 flex flex-col sm:flex-row gap-3">
 ${state.user?.kyc_status !== 'approved' ? `<button class="inline-flex items-center justify-center rounded-xl font-bold bg-gradient-to-r from-blue-500 to-indigo-600 text-white hover:from-blue-600 hover:to-indigo-700 shadow-[0_0_15px_rgba(59,130,246,0.5)] animate-pulse px-6 py-3 transition-all duration-300" onclick="navigate('profile')">✨ Get Instant Verified</button>` : ''}
 ${isClient 
 ? `<button class="inline-flex items-center justify-center rounded-xl font-bold bg-white/95 text-slate-900 hover:bg-white shadow-[0_4px_20px_rgba(0,0,0,0.3)] px-6 py-3 transition-all duration-300" data-open-modal="job">${icon('plus', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 inline-block mr-1')} Post a New Job</button>`
 : `<a class="inline-flex items-center justify-center rounded-xl font-bold bg-white/95 text-slate-900 hover:bg-white shadow-[0_4px_20px_rgba(0,0,0,0.3)] px-6 py-3 transition-all duration-300" href="#marketplace">Find Premium Work</a>`
 }
 </div>
 </div>
 </section>
 `;

 // Analytics Cards
 const cards = isClient
 ? [metric('Posted jobs', a.posted_jobs ?? 0, 'Your listings'), metric('Active contracts', a.active_contracts ?? 0, 'Projects in motion'), metric('Gross funded', money(a.gross_funded), 'Protected in escrow'), metric('Completed', a.completed_contracts ?? 0, 'Successful outcomes')]
 : [metric('Active contracts', a.active_contracts ?? 0, 'Projects in motion'), metric('Completed', a.completed_contracts ?? 0, 'Successful outcomes'), metric('Gross payout', money(a.gross_payout), 'Before platform fees'), metric('Rating', Number(a.average_rating || 0).toFixed(1), `${a.review_count ?? 0} reviews`)];
 
 const cardsHtml = `<section class="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">${cards.join('')}</section>`;

 // Active Contracts Section
 const activeContractsList = state.contracts.filter(c => c.status === 'active');
 const contractsHtml = `
 <section class="soft-panel p-5 sm:p-6">
 <div class="flex items-center justify-between">
 <div>
 <p class="eyebrow">Projects in motion</p>
 <h2 class="mt-2 text-base md:text-xl font-black">Active Contracts</h2>
 </div>
 <a class="btn-ghost"href="#contracts">View all</a>
 </div>
 <div class="mt-5 grid gap-4 ${activeContractsList.length > 0 ? 'md:grid-cols-2 lg:grid-cols-3' : ''}">
 ${activeContractsList.length > 0 ? activeContractsList.map(contract => `
 <div class="rounded-3xl neu-raised p-4 md:p-6 flex flex-col justify-between h-full group hover:border-blue-300 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] transition-all duration-300">
 <div>
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-start gap-4">
 <h3 class="font-bold text-lg text-slate-900 line-clamp-2 leading-tight">${h(contract.job?.title || 'Contract #' + contract.id)}</h3>
 <span class="bg-blue-50 text-blue-700 border-blue-100 px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider whitespace-nowrap">Active</span>
 </div>
 <p class="text-sm text-slate-600 font-medium mt-3 flex items-center gap-2">
 ${icon('user', 'w-3 h-3 md:w-4 md:h-4 text-slate-400')}
 ${isClient ? 'Freelancer' : 'Client'}: <span class="text-slate-900 font-bold">${h(isClient ? contract.freelancer?.name : contract.client?.name)}</span>
 </p>
 </div>
 <div class="mt-6 pt-5 flex gap-3">
 <a href="#contracts/${contract.id}"class="btn-secondary flex-1 py-2 text-sm text-center font-bold neu-raised hover:bg-slate-100 hover:">${contract.payment_type === 'hourly' ? icon('clock', 'w-3 h-3 md:w-4 md:h-4 inline-block mr-1') + 'Time Tracker' : 'Manage Contract'}</a>
 </div>
 </div>
 `).join('') : empty('No active contracts currently.')}
 </div>
 </section>
 `;

 // Secondary Section (My Job Postings for Clients, Recommended for Freelancers)
 let secondaryHtml = '';
 
 if (isClient) {
 const myJobs = state.jobs.filter(j => j.client_id === state.user.id).slice(0, 3);
 secondaryHtml = `
 <section class="soft-panel p-5 sm:p-6">
 <div class="flex items-center justify-between">
 <div>
 <p class="eyebrow">Listings</p>
 <h2 class="mt-2 text-base md:text-xl font-black">My Job Postings</h2>
 </div>
 <button class="btn-ghost"data-open-modal="job">Post New</button>
 </div>
 <div class="mt-5 grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:grid-cols-3">
 ${myJobs.length > 0 ? myJobs.map(jobCard).join('') : empty('You have not posted any jobs yet.')}
 </div>
 </section>
 `;
 } else {
 const mySkills = (state.freelancerProfile?.skills || []).map(s => s.toLowerCase());
 const recommended = state.jobs.filter(job => (job.skills || []).some(s => mySkills.includes(s.toLowerCase()))).slice(0, 3);
 
 secondaryHtml = `
 <section class="soft-panel p-5 sm:p-6">
 <div class="flex items-center justify-between">
 <div>
 <p class="eyebrow">Smart Feed</p>
 <h2 class="mt-2 text-base md:text-xl font-black">Recommended For You</h2>
 </div>
 <a class="btn-ghost"href="#marketplace">Browse all</a>
 </div>
 <div class="mt-5 grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:grid-cols-3">
 ${recommended.length > 0 ? recommended.map(jobCard).join('') : empty('Add skills to your profile to see recommended jobs, or browse the marketplace.')}
 </div>
 </section>
 `;
 }

 let tertiaryHtml = '';
 if (isClient) {
 // Suggested Freelancers Widget
 const suggested = (state.freelancers || []).slice(0, 4);
 
 tertiaryHtml = `
 <div class="grid gap-6 xl:grid-cols-3">
 <section class="soft-panel p-5 sm:p-6 xl:col-span-2">
 <div class="flex items-center justify-between">
 <div>
 <p class="eyebrow">Discover Talent</p>
 <h2 class="mt-2 text-base md:text-xl font-black">Top Rated Professionals</h2>
 </div>
 <a class="btn-ghost"href="#freelancers">View all</a>
 </div>
 
  ${state.agencyInvites && state.agencyInvites.length > 0 ? `
  <div class="mt-6 border border-amber-200 bg-amber-50 rounded-2xl p-5">
    <h3 class="font-bold text-amber-800 mb-3">Pending Invitations</h3>
    <div class="grid gap-3">
    ${state.agencyInvites.map(invite => `
      <div class="flex items-center justify-between bg-white p-3 rounded-xl border border-amber-100 shadow-sm">
        <div>
          <p class="font-bold text-sm">${h(invite.name)}</p>
          <p class="text-xs text-slate-600">Invited by ${h(invite.owner?.name || 'Owner')}</p>
        </div>
        <div class="flex gap-2">
          <button class="btn-primary py-1 px-3 text-[10px]" onclick="window.acceptAgencyInvite(${invite.id})">Accept</button>
          <button class="btn-secondary py-1 px-3 text-[10px] text-rose-700 border-rose-200 hover:bg-rose-50" onclick="window.declineAgencyInvite(${invite.id})">Decline</button>
        </div>
      </div>
    `).join('')}
    </div>
  </div>
  ` : ''}

 <div class="mt-5 grid gap-4 sm:grid-cols-2">
 ${suggested.length > 0 ? suggested.map(fp => {
 const u = fp.user || {};
 return `
 <div class="rounded-xl neu-raised/50 p-4 flex gap-4 items-center hover:neu-raised transition cursor-pointer"onclick="navigate('freelancers/${u.id}')">
 ${avatar(u, 'w-12 h-12 rounded-full')}
 <div class="min-w-0">
 <p class="font-bold text-sm truncate">${h(u.name || 'Freelancer')}</p>
 <p class="text-xs text-slate-600 truncate">${h(fp.headline || 'Professional')}</p>
 <div class="mt-1 flex items-center gap-2 text-xs">
 <span class="text-amber-800">${icon('star', 'w-3 h-3 inline')} ${Number(fp.avg_rating || 5).toFixed(1)}</span>
 <span class="text-emerald-400 font-semibold">${money(fp.hourly_rate || 0)}/hr</span>
 </div>
 </div>
 </div>
 `}).join('') : empty('Loading top freelancers...')}
 </div>
 </section>
 
 <div class="flex flex-col gap-6">
 <section class="p-5 sm:p-6 rounded-3xl bg-gradient-to-br from-slate-900 to-slate-950 border border-slate-800 shadow-2xl relative overflow-hidden">
 <div class="absolute inset-0 bg-blue-500/5 blur-2xl rounded-full"></div>
 <div class="relative z-10">
 <div class="flex items-center justify-between mb-4">
 <div>
 <p class="text-[11px] font-black tracking-widest text-blue-400 uppercase">Escrow & Billing</p>
 <h2 class="mt-2 text-base md:text-xl font-black text-white">Wallet Balance</h2>
 </div>
 <div class="w-7 h-7 md:w-10 md:h-10 rounded-full bg-blue-50/10 flex items-center justify-center text-blue-400">
 ${icon('money', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5')}
 </div>
 </div>
 <p class="text-xl md:text-3xl font-black text-white">${money(state.user?.balance ?? 0)}</p>
 <p class="text-sm text-slate-400 mt-1">Available for funding projects</p>
 <button onclick="showWalletModal()" class="w-full mt-6 inline-flex items-center justify-center rounded-xl font-bold bg-blue-600 hover:bg-blue-500 text-white shadow-[0_4px_20px_rgba(37,99,235,0.4)] px-6 py-3 transition-all hover:-translate-y-0.5">Deposit Funds</button>
 </div>
 </section>
 
 <section class="soft-panel p-5 sm:p-6 relative overflow-hidden group cursor-pointer"onclick="navigate('referrals')">
 <div class="absolute inset-0 bg-gradient-to-r from-amber-500/10 to-orange-500/5 opacity-50 group-hover:opacity-100 transition duration-500"></div>
 <div class="relative z-10">
 <div class="flex items-center gap-3">
 <div class="w-7 h-7 md:w-10 md:h-10 rounded-full bg-amber-500/20 flex items-center justify-center text-amber-800">
 ${icon('gift', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5')}
 </div>
 <div>
 <h3 class="font-bold text-amber-800">Refer & Earn</h3>
 <p class="text-xs text-slate-600 mt-0.5">Invite friends, earn ₹200</p>
 </div>
 </div>
 <div class="mt-4 flex items-center justify-between text-sm font-semibold text-slate-900">
 Get Invite Link <span>&rarr;</span>
 </div>
 </div>
 </section>
 </div>
 </div>
 `;
 }

 const telegramPromoHtml = `
    <section class="relative overflow-hidden rounded-3xl bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-4 sm:p-6 shadow-xl shadow-blue-900/20 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300">
        <div class="absolute -right-10 -top-10 w-20 h-20 md:w-40 md:h-40 neu-raised/10 rounded-full blur-2xl"></div>
        <div class="absolute -left-10 -bottom-10 w-20 h-20 md:w-40 md:h-40 bg-indigo-400/20 rounded-full blur-2xl"></div>
        <div class="relative z-10 flex-1">
            <div class="inline-flex items-center gap-2 neu-raised/20 backdrop-blur-md px-3 py-1.5 rounded-full mb-2 md:mb-3 border-white/20">
                ${icon('bot', 'w-3 h-3 md:w-4 md:h-4 text-white')}
                <span class="text-[11px] font-black uppercase tracking-widest text-white">New Feature</span>
            </div>
            <h2 class="text-xl md:text-2xl font-black tracking-tight text-white mb-2">Connect with our Official Telegram Bot</h2>
            <ul class="text-blue-100 font-medium text-sm space-y-1.5 md:space-y-2 mt-3 md:mt-4">
                <li class="flex items-center gap-2">${icon('check_circle', 'w-3 h-3 md:w-4 md:h-4 text-emerald-300')} Get instant notifications for new jobs & proposals</li>
                <li class="flex items-center gap-2">${icon('check_circle', 'w-3 h-3 md:w-4 md:h-4 text-emerald-300')} Receive real-time chat messages and updates directly</li>
                <li class="flex items-center gap-2">${icon('check_circle', 'w-3 h-3 md:w-4 md:h-4 text-emerald-300')} 24/7 access to your account status securely</li>
            </ul>
        </div>
        <div class="relative z-10 flex-shrink-0">
            <a href="https://t.me/smartsitemakerBot" target="_blank" rel="noopener noreferrer" class="inline-flex items-center justify-center gap-2 bg-white text-indigo-700 hover:bg-blue-50 font-bold text-sm md:text-base px-4 md:px-8 py-2.5 md:py-4 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.2)] transition-all duration-300 hover:scale-105 active:scale-95">
                <svg class="w-5 h-5 md:w-6 md:h-6 text-[#229ED9]" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.664 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
                Connect Telegram
            </a>
        </div>
    </section>
    `;

 return `<div class="space-y-4 md:space-y-8">${headerHtml}${telegramPromoHtml}${cardsHtml}${contractsHtml}${secondaryHtml}${tertiaryHtml}</div>`;
}

function marketplacePage() {
 const isFreelancer = state.user?.role === 'freelancer';
 const smartFeedCheckbox = isFreelancer
 ? `<label class="inline-flex items-center gap-2.5 text-xs font-semibold cursor-pointer text-slate-600 select-none px-4 py-3 neu-raised rounded-2xl hover:neu-raised/[0.06] transition sm:max-w-xs shrink-0">
 <input type="checkbox"id="job-smart-feed"class="h-4 w-4 rounded neu-raised text-blue-700 focus:ring-teal-400/50">
 <span>Smart Feed (Match Skills)</span>
 </label>`
 : '';
 

 return `<div class="space-y-7"><section class="flex flex-col justify-between gap-5 md:flex-row md:items-end"><div><p class="eyebrow">Marketplace</p><h1 class="mt-2 text-xl md:text-3xl font-black">Find the right opportunity</h1><p class="mt-2 text-sm text-slate-600">Browse open digital projects with protected milestone workflows.</p></div>${state.user.role === 'client' ? `<button class="btn-primary"data-open-modal="job">${icon('plus', 'w-3 h-3 md:w-4 md:h-4 inline-block')} Post a new job</button>` : ''}</section><div class="soft-panel p-4 space-y-4">
 <div class="flex flex-col gap-3 sm:flex-row items-stretch sm:items-center">
 <input id="job-search"class="input-control mt-0"placeholder="Search title, description, or skill">
 <select id="job-category"class="input-control mt-0 sm:max-w-40"><option value="">All categories</option><option value="web">Web</option><option value="mobile">Mobile</option><option value="design">Design</option></select>
 <select id="job-payment-type"class="input-control mt-0 sm:max-w-40"><option value="">Any Payment</option><option value="fixed">Fixed Price</option><option value="hourly">Hourly</option></select>
 ${smartFeedCheckbox}
 </div>
 <div class="flex items-center gap-3">
 <input id="job-min-budget"type="number"class="input-control mt-0 w-32"placeholder="Min budget">
 <span class="text-slate-600 text-sm">to</span>
 <input id="job-max-budget"type="number"class="input-control mt-0 w-32"placeholder="Max budget">
 </div>
</div><section id="job-grid"class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:grid-cols-3">${state.jobs.map(jobCard).join('') || empty('No matching jobs are open.')}</section></div>`;
}

function jobPage() {
 const job = state.currentJob;
 if (!job) return empty('Job not found.');
 const owner = state.user.role === 'client' && job.client?.id === state.user.id;
 const isAdmin = state.user.role === 'admin';
 const isClient = state.user.role === 'client';
 const isFeatured = job.is_featured;

 return `<div class="space-y-6"><a class="btn-ghost -ml-3"href="#marketplace">← Back to marketplace</a><section class="soft-panel p-6 sm:p-8"><div class="flex flex-col justify-between gap-6 md:flex-row"><div class="max-w-3xl"><div class="flex flex-wrap items-center gap-2 mb-2">${isFeatured ? `<span class="inline-flex items-center gap-1.5 rounded-full bg-[#F59E0B] px-3 py-1 text-[11px] font-black uppercase tracking-widest text-white shadow-sm">${icon('star', 'w-3 h-3')} FEATURED</span>` : ''}</div><span class="eyebrow">${h(job.category)} project</span><h1 class="mt-3 text-xl md:text-3xl font-black tracking-tight">${h(job.title)}</h1><p class="mt-5 whitespace-pre-wrap text-sm leading-7 text-slate-600">${h(job.description)}</p><div class="mt-5 flex flex-wrap gap-2">${(job.skills || []).map((skill) => `<span class="rounded-full bg-teal-300/10 px-3 py-1.5 text-xs font-semibold text-blue-700">${h(skill)}</span>`).join('')}</div></div><aside class="h-fit min-w-64 rounded-2xl neu-raised/50 p-5"><p class="text-xs text-slate-600">${job.payment_type === 'hourly' ? 'Hourly Rate Range' : 'Budget range'}</p><p class="mt-1 text-base md:text-xl font-black">${money(job.budget?.min, job.budget?.currency)} – ${money(job.budget?.max, job.budget?.currency)}${job.payment_type === 'hourly' ? '/hr' : ''}</p><p class="mt-4 text-xs text-slate-600">Client</p><p class="mt-1 font-semibold">${h(job.client?.name || 'Smart Site Maker client')}</p><p class="mt-4 text-xs text-slate-600">Deadline</p><p class="mt-1 font-semibold">${h(job.deadline || 'Flexible')}</p>${(state.user.role === 'freelancer' || state.user.role === 'admin') ? `<button class="btn-primary mt-6 w-full"data-open-modal="proposal">Submit proposal${state.user.role === 'admin' ? ' as Ghost' : ''}</button>` : ''}${owner && !isFeatured ? `<button onclick="window.featureJob(${job.id})"class="mt-3 w-full flex items-center justify-center gap-2 btn-secondary text-amber-800 border-amber-200 hover:bg-amber-400/10">⭐ Feature this Job — 49 Coins</button>` : ''}${owner && isFeatured ? '<p class="mt-3 text-center text-xs text-amber-800 font-semibold">⭐ Featured until ' + new Date(job.featured_until).toLocaleDateString() + '</p>' : ''}${isAdmin ? `<button onclick="window.deletePostedJob(${job.id})"class="mt-3 w-full flex items-center justify-center gap-2 btn-secondary text-rose-700 border-rose-200 hover:bg-rose-50">🗑️ Delete Job (Admin)</button>` : ''}</aside></div></section><section class="soft-panel p-4 md:p-6"><p class="eyebrow">Public review</p><h2 class="mt-2 text-base md:text-xl font-black">Proposals (${state.proposals?.length || 0})</h2><div class="mt-5 space-y-3 max-h-[750px] overflow-y-auto overflow-x-hidden pr-2">${(state.proposals || []).map(proposalCard).join('') || empty('No proposals have arrived yet.')}</div></section></div>`;
}

function proposalCard(proposal) {

 const badges = [
 proposal.is_sponsored ? `<span class="inline-flex items-center gap-1.5 rounded-full bg-[#0F172A] px-3 py-1 text-[10px] font-black uppercase tracking-widest text-[#FBBF24] shadow-sm">${icon('star', 'w-3 h-3')} SPONSORED</span>` : '',
 proposal.is_sealed ? `<span class="inline-flex items-center gap-1.5 rounded-full bg-[#94A3B8] px-3 py-1 text-[10px] font-black uppercase tracking-widest text-[#1E293B] shadow-sm">${icon('lock', 'w-3 h-3')} SEALED</span>` : '',
 ].filter(Boolean).join('');
 
 let cardClass = ' neu-raised'; // Normal Bid
 const sp = proposal.is_sponsored;
 const hl = proposal.is_highlighted;
 const sl = proposal.is_sealed;

 if (sp && hl && sl) {
 cardClass = 'border-amber-400 bg-gradient-to-br from-amber-50/50 via-white to-indigo-50/50 shadow-[0_0_20px_rgba(251,191,36,0.2)]';
 } else if (sp && hl) {
 cardClass = 'border-amber-400 bg-gradient-to-br from-amber-50/50 to-white shadow-[0_0_15px_rgba(251,191,36,0.2)]';
 } else if (sp && sl) {
 cardClass = 'border-amber-500/60 bg-amber-50/30 ';
 } else if (hl && sl) {
 cardClass = 'border-indigo-500/50 bg-indigo-50/50 shadow-[0_0_15px_rgba(99,102,241,0.15)]';
 } else if (sp) {
 cardClass = 'border-amber-400/80 bg-amber-50/20';
 } else if (hl) {
 cardClass = 'border-indigo-400/60 bg-indigo-50/30 shadow-[0_0_12px_rgba(99,102,241,0.1)]';
 } else if (sl) {
 cardClass = ' bg-slate-100/50';
 }

 const score = proposal.match_score;
 const badgeColor = score >= 80 
 ? 'border-emerald-500/30 bg-emerald-500/10 text-emerald-300' 
 : (score >= 60 ? 'border-amber-200 bg-amber-500/10 text-amber-800' : 'border-rose-200 bg-rose-500/10 text-rose-700');
 
 const matchBadge = score !== null && score !== undefined
 ? `<div class="mt-3 flex items-center gap-2">
 <span class="rounded-full px-2.5 py-0.5 text-xs font-semibold ${badgeColor}">
 ${score}% Match ${proposal.is_ai_match ? '(AI)' : '(Local)'}
 </span>
 </div>
 <p class="mt-2 text-xs text-slate-600">${icon('bulb', 'w-3 h-3 md:w-4 md:h-4 inline-block')} ${h(proposal.match_justification)}</p>`
 : '';

 const flProfile = proposal.freelancer?.freelancer_profile;
 let profileDetails = '';
 if (flProfile) {
 const skillsHtml = (flProfile.skills || []).map(skill => `<span class="rounded bg-blue-50 px-2 py-0.5 text-[11px] font-semibold text-blue-700">${h(skill)}</span>`).join('');

 profileDetails = `
 <div class="mt-3 border-l-2 pl-3 py-1 neu-raised/[0.01] rounded-r-xl">
 <p class="text-xs font-bold text-slate-600">${h(flProfile.headline || 'Professional Freelancer')}</p>
 <p class="mt-1 text-[11px] text-slate-600 leading-relaxed line-clamp-2"title="${h(flProfile.bio || '')}">${h(flProfile.bio || '')}</p>
 <div class="mt-2 flex flex-wrap gap-1">${skillsHtml}</div>
 </div>
 `;
 }

 

 const coverLetterHtml = proposal.bid_amount === null
 ? `<div class="mt-3 max-w-2xl relative flex items-center justify-center p-4 bg-slate-100/50 rounded-xl overflow-hidden">
 <p class="text-sm font-bold text-slate-300 select-none blur-[4px]">This proposal is completely sealed and the cover letter is hidden from other freelancers on the platform.</p>
 <span class="absolute flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-slate-800 text-white text-xs font-bold shadow-slate-900/20">${icon('lock', 'w-3.5 h-3.5')} Proposal is Sealed</span>
 </div>`
 : `<p class="mt-3 max-w-2xl text-sm leading-6 text-slate-600 font-medium">${h(proposal.cover_letter)}</p>`;

 const bidAmountHtml = proposal.bid_amount === null
 ? `<div class="relative inline-block px-4 py-2 bg-slate-100/80 rounded-lg">
 <p class="text-lg font-black text-slate-300 blur-sm select-none">₹99,999</p>
 <span class="absolute inset-0 flex items-center justify-center text-slate-600">${icon('lock', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5')}</span>
 </div>`
 : `<p class="text-lg font-black">${money(proposal.bid_amount, state.currentJob?.budget?.currency)}</p>`;

 return `<article class="rounded-2xl ${cardClass} p-5 transition-all"><div class="flex flex-col justify-between gap-4 sm:flex-row"><div><div class="flex items-center gap-2.5">${avatar(proposal.freelancer, 'h-7 w-7 text-xs')}<h3 class="font-bold">${h(proposal.freelancer?.name || 'Freelancer')}</h3>${proposal.agency ? `<span class="ml-2 rounded-full border-blue-200 bg-blue-50 px-2 py-0.5 text-[10px] font-bold text-blue-700">${icon('business', 'w-3 h-3 inline-block')} ${h(proposal.agency.name)}</span>` : ''}${badges ? `<div class="flex gap-1.5 ml-2">${badges}</div>` : ''}</div><p class="mt-1.5 text-xs text-slate-600">${proposal.delivery_days} days · ${titleCase(proposal.status)}</p>${profileDetails}${coverLetterHtml}${matchBadge}</div><div class="text-left sm:text-right">${bidAmountHtml}${proposal.status === 'pending' && state.user?.id == state.currentJob?.client?.id ? `<button class="btn-primary mt-3 px-3 py-2 text-xs"data-accept-proposal="${proposal.id}">Accept proposal</button>` : ''}</div></div></article>`;
}

function contractCard(contract) {
 const isAdmin = state.user.role === 'admin';
 const counterpart = state.user.role === 'freelancer' ? contract.client : contract.freelancer;
 const settled = (contract.milestones || []).filter((m) => ['released', 'refunded'].includes(m.status)).length;
 
 let titleHtml = `<h3 class="mt-2 text-lg font-black">${h(counterpart?.name || 'Marketplace contract')}</h3>`;
 if (isAdmin) {
 titleHtml = `<h3 class="mt-2 text-sm font-bold text-slate-900">Client: <span class="font-normal">${h(contract.client?.name || 'Unknown')}</span></h3>
 <h3 class="text-sm font-bold text-slate-900 mt-1">Freelancer: <span class="font-normal">${h(contract.freelancer?.name || 'Unknown')}</span></h3>`;
 }

 const deleteBtn = isAdmin ? `<button class="btn-ghost mt-2 w-full text-rose-500 hover:bg-rose-50 hover:text-rose-700 text-xs font-bold py-2 border-rose-100 rounded-xl"data-delete-contract="${contract.id}">Delete Contract</button>` : '';

 return `<article class="soft-panel p-5"><div class="flex items-start justify-between gap-4"><div><p class="eyebrow">Contract #${contract.id}</p>${titleHtml}</div><span class="status-pill ${contract.status === 'active' ? 'status-open' : 'status-muted'}">${h(contract.status)}</span></div><div class="mt-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 border-y py-4"><div><p class="text-xs text-slate-600">Value</p><p class="font-bold">${money(contract.total_amount, contract.currency)}</p></div><div><p class="text-xs text-slate-600">Milestones</p><p class="font-bold">${settled}/${contract.milestones?.length || 0} settled</p></div></div><button class="btn-secondary mt-4 w-full"data-contract="${contract.id}">Open workspace</button>${deleteBtn}</article>`;
}

function manageJobsPage() {
 return `<div class="space-y-6">
 <div>
 <h1 class="text-xl md:text-3xl font-black tracking-tight text-slate-900">Manage Your Jobs</h1>
 <p class="mt-2 text-slate-600">View and delete jobs you have posted on the marketplace.</p>
 </div>
 <div class="grid gap-4">
 ${(state.myJobs || []).map(job => `
 <div class="flex items-center justify-between gap-4 p-4 rounded-2xl neu-raised">
 <div>
 <h3 class="font-bold text-slate-900">${h(job.title)}</h3>
 <p class="text-xs text-slate-600 mt-1">Proposals: ${job.proposals_count || 0} · Posted: ${new Date(job.created_at).toLocaleDateString()}</p>
 <p class="text-sm text-slate-600 mt-2 line-clamp-1">${h(job.description)}</p>
 </div>
 <div class="flex items-center gap-2">
 <button class="btn-secondary text-xs"onclick="navigate('jobs/${job.id}')">View</button>
 <button class="btn-secondary text-xs text-rose-500 border-rose-200 hover:bg-rose-50"onclick="window.deletePostedJob(${job.id})">Delete</button>
 </div>
 </div>
 `).join('') || empty('You have not posted any jobs yet.')}
 </div>
 </div>`;
}

function contractsPage() {
 

 return `<div class="space-y-7"><section><p class="eyebrow">Collaboration</p><h1 class="mt-2 text-xl md:text-3xl font-black">Contract workspaces</h1><p class="mt-2 text-sm text-slate-600">Milestones, escrow, deliverables, and communication in one place.</p></section><section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:grid-cols-3">${state.contracts.map(contractCard).join('') || empty('No contract workspaces yet.')}</section></div>`;
}

function contractPage() {
 const contract = state.currentContract;
 if (!contract) return empty('Contract not found.');
 const isClient = state.user.id === contract.client_id;
 const milestones = contract.milestones || [];

 const total = Number(contract.total_amount) || 1;
 const released = milestones.filter(m => m.status === 'released').reduce((sum, m) => sum + Number(m.amount), 0);
 const funded = milestones.filter(m => m.status === 'funded' || m.status === 'submitted').reduce((sum, m) => sum + Number(m.amount), 0);
 const disputed = milestones.filter(m => m.status === 'disputed').reduce((sum, m) => sum + Number(m.amount), 0);
 const pending = milestones.filter(m => m.status === 'pending').reduce((sum, m) => sum + Number(m.amount), 0);

 const pctReleased = (released / total) * 100;
 const pctFunded = (funded / total) * 100;
 const pctDisputed = (disputed / total) * 100;
 const pctPending = (pending / total) * 100;

 const escrowTracker = `
 <div class="soft-panel p-5 mt-6 mb-6">
 <div class="flex items-center justify-between mb-3">
 <span class="text-sm font-bold text-slate-600">Escrow Payment Progress Tracker</span>
 <span class="text-xs font-semibold text-slate-600">Total: ${money(total, contract.currency)}</span>
 </div>
 <div class="h-4 w-full neu-raised rounded-full overflow-hidden flex -inner">
 <div style="width: ${pctReleased}%"class="bg-gradient-to-r from-teal-500 to-emerald-400 h-full"title="Paid: ${money(released, contract.currency)}"></div>
 <div style="width: ${pctFunded}%"class="bg-gradient-to-r from-indigo-500 to-violet-400 h-full"title="Escrow Locked: ${money(funded, contract.currency)}"></div>
 <div style="width: ${pctDisputed}%"class="bg-gradient-to-r from-rose-500 to-pink-500 h-full"title="Disputed: ${money(disputed, contract.currency)}"></div>
 <div style="width: ${pctPending}%"class="bg-slate-700 h-full"title="Pending: ${money(pending, contract.currency)}"></div>
 </div>
 <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:grid-cols-4 gap-3 mt-4 text-xs font-medium">
 <div class="flex items-center gap-2"><span class="w-2.5 h-2.5 rounded bg-teal-400"></span> <span>Released: ${money(released, contract.currency)} (${Math.round(pctReleased)}%)</span></div>
 <div class="flex items-center gap-2"><span class="w-2.5 h-2.5 rounded bg-indigo-400"></span> <span>Escrow Locked: ${money(funded, contract.currency)} (${Math.round(pctFunded)}%)</span></div>
 <div class="flex items-center gap-2"><span class="w-2.5 h-2.5 rounded bg-rose-400"></span> <span>Disputed: ${money(disputed, contract.currency)} (${Math.round(pctDisputed)}%)</span></div>
 <div class="flex items-center gap-2"><span class="w-2.5 h-2.5 rounded bg-slate-500"></span> <span>Pending: ${money(pending, contract.currency)} (${Math.round(pctPending)}%)</span></div>
 </div>
 </div>
 `;

 const timeTracker = `
 <div class="soft-panel p-5 mt-6 mb-6">
 <div class="flex items-center justify-between mb-3 pb-4">
 <span class="text-sm font-bold text-slate-600">${icon('clock', 'w-3 h-3 md:w-4 md:h-4 inline-block mr-2')}Time Tracker (Hourly Contract)</span>
 <span class="text-xs font-semibold text-slate-600">Weekly Limit: ${contract.weekly_limit || 'No limit'} hrs</span>
 </div>
 ${!isClient ? `<button class="btn-primary w-full text-xs py-2 mb-4"data-open-modal="log_time">Log Hours</button>` : ''}
 <div class="space-y-3">
 ${state.timeLogs && state.timeLogs.length > 0 ? state.timeLogs.map(log => `
 <div class="flex items-center justify-between neu-raised p-3 rounded-xl">
 <div>
 <p class="text-xs font-bold">${log.logged_date} &middot; ${log.hours} hrs</p>
 <p class="text-[11px] text-slate-600 mt-1">${h(log.memo || 'No memo')}</p>
 </div>
 <div class="text-right">
 <span class="status-pill ${log.status === 'approved' ? 'status-open' : log.status === 'disputed' ? 'status-danger' : 'status-muted'}">${titleCase(log.status)}</span>
 ${isClient && log.status === 'pending' ? `<div class="mt-2 flex gap-2"><button class="btn-primary px-2 py-1 text-[10px]"data-approve-time="${log.id}">Approve</button> <button class="btn-ghost text-rose-700 px-2 py-1 text-[10px]"data-dispute-time="${log.id}">Dispute</button></div>` : ''}
 </div>
 </div>
 `).join('') : '<p class="text-xs text-slate-600 text-center py-4">No time logged yet.</p>'}
 </div>
 </div>
 `;

 const paymentUI = contract.payment_type === 'hourly' ? timeTracker : escrowTracker;


 

 return `<div class="space-y-6"><a class="btn-ghost -ml-3"href="#contracts">← Back to workspaces</a><section class="soft-panel p-6 sm:p-8"><div class="flex flex-col justify-between gap-5 md:flex-row md:items-start"><div><p class="eyebrow">Contract #${contract.id}</p><h1 class="mt-2 text-xl md:text-3xl font-black tracking-tight">${h(isClient ? contract.freelancer?.name : contract.client?.name)}</h1><p class="mt-2 text-sm text-slate-600">${h(isClient ? 'Freelancer workspace' : 'Client workspace')} · Started ${h(contract.started_at || contract.created_at || 'Recently')}</p></div><div class="text-left md:text-right"><span class="status-pill ${contract.status === 'active' ? 'status-open' : 'status-muted'}">${h(titleCase(contract.status))}</span><p class="mt-3 text-2xl font-black">${money(contract.total_amount, contract.currency)}</p></div></div></section>${paymentUI}${kanbanBoardPanel(contract)}<section><div class="mb-4 flex items-end justify-between"><div><p class="eyebrow">Delivery plan</p><h2 class="mt-2 text-2xl font-black">Milestones</h2></div><div class="flex items-center gap-3"><button type="button"class="btn-ai text-xs px-2.5 py-1.5"onclick="window.suggestMilestones(this)">✨ AI Plan</button><span class="text-sm text-slate-600">${milestones.length} total</span></div></div><div class="space-y-4">${milestones.map(milestoneCard).join('') || empty('No milestones defined.')}</div></section><div class="grid gap-6 xl:grid-cols-[1.1fr_.9fr]">${messagePanel(contract.id)}${invoicePanel()}</div>${contract.status === 'completed' ? reviewPanel(contract) : ''}</div>`;
}

function kanbanBoardPanel(contract) {
 const tasks = state.contractTasks || [];
 const columns = [
 { id: 'todo', label: 'To Do', color: 'bg-slate-100 ' },
 { id: 'in_progress', label: 'In Progress', color: 'bg-blue-50 border-blue-200' },
 { id: 'review', label: 'Review', color: 'bg-amber-50 border-amber-200' },
 { id: 'done', label: 'Done', color: 'bg-emerald-50 border-emerald-200' },
 ];

 return `
 <section class="mb-8">
 <div class="flex items-center justify-between mb-4">
 <div>
 <p class="eyebrow">Task Management</p>
 <h2 class="mt-1 text-2xl font-black">Project Kanban Board</h2>
 </div>
 <button class="btn-primary py-2 text-sm"onclick="openCreateTaskModal()">+ Add Task</button>
 </div>
 
 <div class="overflow-x-auto pb-4 -mx-1 px-1"><div class="flex gap-3 md:gap-4 min-w-max md:min-w-0 md:grid md:grid-cols-4">
 ${columns.map(col => `
 <div class="flex flex-col rounded-xl min-h-[300px] p-3 ${col.color}"
 ondragover="window.allowDropTask(event)"
 ondrop="window.dropTask(event, '${col.id}')">
 <h3 class="font-bold text-sm mb-3 flex items-center justify-between">
 ${col.label}
 <span class="neu-raised text-slate-700 font-bold text-[10px] px-2 py-0.5 rounded-full">${tasks.filter(t => t.status === col.id).length}</span>
 </h3>
 <div class="flex-1 space-y-3">
 ${tasks.filter(t => t.status === col.id).map(t => `
 <div class="neu-raised p-3 rounded-lg cursor-grab active:cursor-grabbing hover:text-blue-700 transition-colors"
 draggable="true"
 ondragstart="window.dragTask(event, ${t.id})">
 <p class="font-semibold text-sm leading-snug">${h(t.title)}</p>
 ${t.description ? `<p class="text-xs text-slate-600 mt-2 line-clamp-2">${h(t.description)}</p>` : ''}
 <div class="flex items-center justify-between mt-3">
 <div class="flex gap-2 text-[10px] text-slate-600">
 <button onclick="window.deleteTask(${t.id})"class="hover:text-rose-400 transition-colors">Delete</button>
 </div>
 </div>
 </div>
 `).join('')}
 </div>
 </div>
 `).join('')}
 </div>
 </section>
 `;
}

window.dragTask = function(ev, taskId) {
 ev.dataTransfer.setData("taskId", taskId);
};

window.allowDropTask = function(ev) {
 ev.preventDefault();
};

window.dropTask = async function(ev, newStatus) {
 ev.preventDefault();
 const taskId = ev.dataTransfer.getData("taskId");
 if (!taskId) return;
 
 const task = state.contractTasks.find(t => t.id == taskId);
 if (!task || task.status === newStatus) return;

 task.status = newStatus;
 render();

 try {
 await request(`/contracts/${state.currentContract.id}/tasks/${taskId}`, 'PUT', { status: newStatus });
 } catch (e) {
 await loadRouteData();
 }
};

window.deleteTask = async function(taskId) {
 if (!confirm('Are you sure you want to delete this task?')) return;
 try {
 await request(`/contracts/${state.currentContract.id}/tasks/${taskId}`, 'DELETE');
 state.contractTasks = state.contractTasks.filter(t => t.id != taskId);
 render();
 } catch (e) {
 alert('Failed to delete task.');
 }
};

window.openCreateTaskModal = function() {
 state.modal = 'create_task';
 render();
};

window.createTask = async function(e) {
 e.preventDefault();
 const form = e.target;
 const btn = form.querySelector('button[type="submit"]');
 btn.disabled = true;
 btn.innerText = 'Creating...';
 try {
 const res = await request(`/contracts/${state.currentContract.id}/tasks`, 'POST', {
 title: form.title.value,
 description: form.description.value,
 status: 'todo'
 });
 state.contractTasks.push(res.data);
 state.modal = null;
 render();
 } catch (err) {
 alert(err.message || 'Error creating task');
 btn.disabled = false;
 btn.innerText = 'Create Task';
 }
};
function milestoneCard(milestone) {
 const isClient = state.user.id === state.currentContract.client_id;
 const canDeliver = state.user.role === 'freelancer' && ['funded', 'submitted'].includes(milestone.status);
 const canDispute = ['funded', 'submitted'].includes(milestone.status) && !milestone.dispute;

 const deliverablesList = (milestone.deliverables || []).map((d) => {
 let previewHtml = '';
 if (d.external_url && d.external_url.includes('figma.com')) {
 previewHtml = `<div class="mt-3 aspect-video w-full rounded-2xl overflow-hidden"><iframe class="w-full h-full border-none"src="https://www.figma.com/embed?embed_host=share&url=${encodeURIComponent(d.external_url)}"allowfullscreen></iframe></div>`;
 } else if (d.file_path && d.file_path.toLowerCase().endsWith(`.apk`)) {
 previewHtml = `
 <div class="mt-3 rounded-2xl neu-raised/80 p-4 flex items-center gap-4">
 <div class="grid h-12 w-12 place-items-center rounded-xl bg-emerald-500/20 text-emerald-400 text-base md:text-xl font-bold">${icon('bot', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 md:w-6 md:h-6')}</div>
 <div class="min-w-0 flex-1">
 <p class="font-bold text-sm text-slate-700">Android Application Package (APK)</p>
 <p class="text-xs text-slate-600 mt-0.5">${h(d.file_path.split(`/`).pop())} · Ready to Install</p>
 </div>
 <button onclick="alertPopup('Emulator Setup', 'Starting Android Virtual Device emulator download for live testing...')"class="btn-secondary px-3 py-1.5 text-xs">Run in Emulator</button>
 </div>
 `;
 } else if (d.file_path && (d.file_path.toLowerCase().endsWith('.php') || d.file_path.toLowerCase().endsWith('.js') || d.file_path.toLowerCase().endsWith('.css') || d.file_path.toLowerCase().endsWith('.html') || d.file_path.toLowerCase().endsWith('.txt') || d.file_path.toLowerCase().endsWith('.json') || d.file_path.toLowerCase().endsWith('.csv'))) {
 const fileUrl = `/api/v1/files/deliverables/${d.id}`;
 previewHtml = `
 <div class="mt-3">
 <button onclick="event.preventDefault(); const block = this.nextElementSibling; block.classList.toggle('hidden'); if(!block.classList.contains('hidden') && !block.dataset.loaded) { block.dataset.loaded = true; fetch('${fileUrl}', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('ssm_token') } }).then(r=>r.text()).then(t=>{ block.querySelector('pre').textContent = t; }).catch(err=>{ block.querySelector('pre').textContent = 'Error reading file: ' + err.message; }); }"class="btn-secondary text-xs px-3 py-1">Toggle Source Code Preview</button>
 <div class="hidden mt-2 p-3 rounded-xl neu-raised max-h-60 overflow-y-auto">
 <pre class="text-[11px] font-mono text-blue-700 whitespace-pre-wrap">Loading code stream...</pre>
 </div>
 </div>
 `;
 }

 

 return `<div class="rounded-xl neu-raised p-3"><p class="font-semibold">${h(d.title)} <span class="text-xs text-slate-600">v${h(d.version || '1')}</span></p><p class="mt-1 text-xs text-slate-600">${h(d.description || d.external_url || d.file_path || 'Submitted deliverable')}</p>${previewHtml}</div>`;
 }).join('') || '<p class="text-sm text-slate-600">No deliverables submitted.</p>';

 let disputeHtml = '';
 if (milestone.dispute) {
 const disp = milestone.dispute;
 const resolutionDetails = disp.status === 'resolved'
 ? `<div class="mt-2 border-rose-500/10 pt-2 text-xs text-rose-700">
 <b>Arbitrator Ruling:</b> ${h(titleCase(disp.resolution))} <br>
 <b>Arbitrator Comments:</b> ${h(disp.resolution_notes || 'No comments provided.')}
 </div>`
 : '';
 disputeHtml = `
 <div class="mt-4 rounded-xl border-rose-400/20 bg-rose-50/20 p-3 text-sm leading-relaxed text-rose-100">
 <b>Dispute Status:</b> <span class="capitalize font-bold text-rose-700">${h(disp.status)}</span> <br>
 <b>Claim Reason:</b> ${h(disp.reason)} <br>
 <b>Description:</b> ${h(disp.description || 'No description.')}
 ${resolutionDetails}
 </div>
 `;
 }

 

 return `<article class="soft-panel p-5"><div class="flex flex-col justify-between gap-4 sm:flex-row"><div><div class="flex flex-wrap items-center gap-3"><span class="eyebrow">Milestone ${milestone.position}</span><span class="status-pill ${milestone.status === 'released' ? 'status-open' : milestone.status === 'disputed' ? 'status-danger' : 'status-muted'}">${h(titleCase(milestone.status))}</span></div><h3 class="mt-3 text-lg font-black">${h(milestone.title)}</h3><p class="mt-2 text-sm leading-6 text-slate-600">${h(milestone.description || 'No description provided.')}</p></div><p class="text-base md:text-xl font-black">${money(milestone.amount, state.currentContract.currency)}</p></div><div class="mt-5 grid gap-3 border-y py-4 text-sm sm:grid-cols-3"><div><p class="text-xs text-slate-600">Due date</p><p class="mt-1 font-semibold">${h(milestone.due_date || 'Flexible')}</p></div><div><p class="text-xs text-slate-600">Funded</p><p class="mt-1 font-semibold">${h(milestone.funded_at || 'Not yet')}</p></div><div><p class="text-xs text-slate-600">Released</p><p class="mt-1 font-semibold">${h(milestone.released_at || 'Not yet')}</p></div></div><div class="mt-4 space-y-3">${deliverablesList}</div>${disputeHtml}<div class="mt-5 flex flex-wrap gap-2">${isClient && milestone.status === 'pending' ? (milestone.has_pending_verification ? `<span class="status-pill status-warn px-3 py-2">Verification Pending (UTR: ${h(milestone.pending_utr)})</span>` : `<button class="btn-primary px-3 py-2 text-xs"data-fund="${milestone.id}">Fund milestone</button>`) : ''}${isClient && milestone.status === 'submitted' ? `<button class="btn-primary px-3 py-2 text-xs"data-release="${milestone.id}">Release payment</button>` : ''}${canDeliver ? `<button class="btn-secondary px-3 py-2 text-xs"data-open-deliverable="${milestone.id}">Submit deliverable</button>` : ''}${canDispute ? `<button class="btn-ghost px-3 py-2 text-xs text-rose-700"data-open-dispute="${milestone.id}">Open dispute</button>` : ''}</div></article>`;
}

function messagePanel(contractId) {
 return `<section class="soft-panel p-5"><div class="flex items-center justify-between mb-4"><div><p class="eyebrow">Communication</p><h2 class="mt-1 text-base md:text-xl font-black">Workspace Messages</h2></div><button onclick="window.openScheduleMessageModal(${contractId})"class="text-[11px] neu-raised text-slate-600 px-3 py-1.5 rounded-full font-bold hover:border-teal-400 hover:text-blue-700 transition-colors">🕐 Schedule</button></div><div id="chat-messages-list"class="mt-3 max-h-80 space-y-3 overflow-y-auto scroll-smooth">${state.messages.map((message) => message.is_deleted ? `<div class="rounded-2xl neu-raised p-3 opacity-40"><p class="text-xs italic text-slate-600">Message deleted</p></div>` : `<div class="rounded-2xl neu-raised p-3 group relative"><div class="flex items-center justify-between gap-2"><p class="text-xs font-semibold text-blue-700">${h(message.sender?.name || 'Participant')}</p>${message.version_number > 1 ? `<span class="text-[10px] text-slate-600 neu-raised rounded-full px-2 py-0.5">v${message.version_number}</span>` : ''}</div><p class="mt-1 whitespace-pre-wrap text-sm text-slate-600">${h(message.body || message.attachment_path || '')}</p>${message.attachment_path ? `<a href="/storage/${h(message.attachment_path)}"target="_blank"class="mt-2 inline-flex items-center gap-1 text-xs text-blue-700 hover:underline">📎 View attachment</a>` : ''}</div>`).join('') || `<p class="text-sm text-slate-600 p-2">Start the conversation.</p>`}</div><form id="message-form"data-contract-id="${contractId}"class="mt-5 flex gap-2"><input class="input-control mt-0"name="body"id="contractMessageInput"placeholder="Write a message…"required maxlength="10000"autocomplete="off"><button type="button"class="btn-ai px-3 flex-shrink-0"onclick="window.rewriteMessage(this)">✨ Polish</button><button class="btn-primary px-4 flex-shrink-0"type="submit">Send</button></form></section>`;
}


function notificationPanel() {
 

 return `<section id="notifications-panel"class="fixed right-5 top-16 z-[60] w-[min(24rem,calc(100vw-2.5rem))] rounded-2xl neu-raised p-4 shadow-2xl">
 <div class="flex items-center justify-between">
 <h2 class="font-black">Notifications</h2>
 <div class="flex items-center gap-2">
 ${"Notification"in window && Notification.permission !=="granted"? `<button class="btn-ghost text-xs"onclick="requestNotificationPermission()">Enable Push</button>` : ''}
 <button class="btn-ghost text-xs"data-clear-all>Clear all</button>
 </div>
 </div>
 <div class="mt-3 max-h-80 space-y-2 overflow-y-auto">
 ${state.notifications.map((notification) => 
 `<button class="block w-full rounded-xl p-3 text-left transition-colors ${notification.read_at ? 'neu-raised opacity-70 hover:opacity-100' : 'neu-raised border-blue-200 hover:bg-slate-700/80'}"data-notification-route="${h(notification.data?.route || '')}"data-notification-id="${h(notification.id)}">
 <div class="flex items-start justify-between">
 <p class="text-xs font-semibold ${notification.read_at ? 'text-slate-600' : 'text-blue-700'}">${h(titleCase(notification.data?.kind || 'update'))}</p>
 ${!notification.read_at ? `<span class="w-2 h-2 rounded-full bg-teal-400 shrink-0 shadow-[0_0_8px_rgba(45,212,191,0.6)]"></span>` : ''}
 </div>
 <p class="mt-1 text-sm ${notification.read_at ? 'text-slate-600' : 'text-slate-700'}">${h(notification.data?.preview || 'You have a new workspace update.')}</p>
 </button>`
 ).join('') || `<p class="text-sm text-slate-600">No notifications yet.</p>`}
 </div>
 </section>`;
}

function invoicePanel() {
 const printUrl = `/api/v1/contracts/${state.currentContract.id}/invoice/print?token=${encodeURIComponent(state.token)}`;
 

 return `<section class="soft-panel p-5"><p class="eyebrow">Billing</p><h2 class="mt-2 text-base md:text-xl font-black">Invoice</h2>${state.invoice ? `<div class="mt-5 rounded-2xl neu-raised p-4"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 gap-3"><span class="text-sm text-slate-600">${h(state.invoice.number)}</span><span class="status-pill status-open">${h(state.invoice.status)}</span></div><p class="mt-4 text-2xl font-black">${money(state.invoice.subtotal, state.invoice.currency)}</p><p class="mt-2 text-sm text-slate-600">Freelancer payout: ${money(state.invoice.freelancer_amount, state.invoice.currency)}</p><a href="${printUrl}"target="_blank"class="btn-primary inline-block text-center mt-4 w-full">Print Invoice / PDF</a></div>` : `<p class="mt-4 text-sm text-slate-600">An invoice is available after all milestones settle.</p>${state.currentContract.status === 'completed' ? `<button class="btn-primary mt-5 w-full"data-issue-invoice>Issue invoice</button>` : ''}`}</section>`;
}

function reviewPanel(contract) {
 

 return `<section class="soft-panel p-4 md:p-6"><p class="eyebrow">Closeout</p><h2 class="mt-2 text-base md:text-xl font-black">Review your experience</h2><form id="review-form"data-contract-id="${contract.id}"class="mt-5 grid gap-4">
 <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
 <label class="block text-sm font-semibold">Quality
 <select class="input-control mt-1"name="quality_rating"required>
 <option value="">Rate</option><option value="5">5 - Excellent</option><option value="4">4 - Good</option><option value="3">3 - Average</option><option value="2">2 - Poor</option><option value="1">1 - Terrible</option>
 </select>
 </label>
 <label class="block text-sm font-semibold">Communication
 <select class="input-control mt-1"name="communication_rating"required>
 <option value="">Rate</option><option value="5">5 - Excellent</option><option value="4">4 - Good</option><option value="3">3 - Average</option><option value="2">2 - Poor</option><option value="1">1 - Terrible</option>
 </select>
 </label>
 <label class="block text-sm font-semibold">Expertise
 <select class="input-control mt-1"name="expertise_rating"required>
 <option value="">Rate</option><option value="5">5 - Excellent</option><option value="4">4 - Good</option><option value="3">3 - Average</option><option value="2">2 - Poor</option><option value="1">1 - Terrible</option>
 </select>
 </label>
 <label class="block text-sm font-semibold">Professionalism
 <select class="input-control mt-1"name="professionalism_rating"required>
 <option value="">Rate</option><option value="5">5 - Excellent</option><option value="4">4 - Good</option><option value="3">3 - Average</option><option value="2">2 - Poor</option><option value="1">1 - Terrible</option>
 </select>
 </label>
 </div>
 <div class="grid gap-4 sm:grid-cols-[1fr_auto]">
 <input class="input-control mt-0"name="comment"placeholder="Share a short review"maxlength="5000">
 <button class="btn-primary"type="submit">Submit review</button>
 </div>
</form></section>`;
}

window.typewriterEffect = async (element, text, speed = 10) => {
 element.innerHTML = '';
 // Basic Markdown formatting helper for bold, lists, and Action buttons
 const formatMd = (txt) => {
 let html = h(txt);
 // Bold
 html = html.replace(/\*\*(.*?)\*\*/g, '<strong class="text-white font-bold">$1</strong>');
 // Italic
 html = html.replace(/\*(.*?)\*/g, '<em class="text-indigo-200">$1</em>');
 // Action Buttons: [ACTION:command:Label]
 html = html.replace(/\[ACTION:([^:]+):([^\]]+)\]/g, '<button onclick="document.getElementById(\'ai-prompt-input\').value=\'$1\'; document.getElementById(\'ai-form\').dispatchEvent(new Event(\'submit\'))"class="mt-2 block w-max px-3 py-1.5 rounded-lg bg-indigo-500 text-white text-xs font-bold shadow-[0_0_10px_rgba(99,102,241,0.5)] hover:bg-indigo-400 hover:scale-105 transition-all active:scale-95 border-indigo-400">$2</button>');
 // Lists
 html = html.replace(/^- (.*)$/gm, '<div class="ml-4 flex gap-2"><span class="text-indigo-500">•</span> <span>$1</span></div>');
 // Headers
 html = html.replace(/^### (.*)$/gm, '<div class="text-white font-bold text-base mt-2 mb-1">$1</div>');
 return html;
 };
 
 // For simplicity, we just fade in the formatted HTML
 const htmlContent = formatMd(text);
 element.style.opacity = 0;
 element.innerHTML = htmlContent;
 let op = 0;
 const timer = setInterval(() => {
 if (op >= 1) clearInterval(timer);
 element.style.opacity = op;
 op += 0.1;
 }, 20);
};

window.sendAdminAiCommand = async (e) => {
 e.preventDefault();
 const input = document.getElementById('ai-prompt-input') || e.target.elements.prompt;
 const prompt = input.value.trim();
 if (!prompt) return;

 const chatContainer = document.getElementById('ai-chat-history');
 
 // Add user message
 chatContainer.innerHTML += `
 <div class="flex gap-2 text-indigo-300">
 <span class="text-indigo-500">USR></span> 
 <span>${h(prompt)}</span>
 </div>
 `;
 input.value = '';
 chatContainer.scrollTop = chatContainer.scrollHeight;

 // Add loading state
 const loadingId = 'loading-' + Date.now();
 chatContainer.innerHTML += `
 <div id="${loadingId}"class="flex gap-2 text-indigo-400/80 animate-pulse">
 <span class="text-indigo-500">SYS></span> 
 <span>Processing<span class="animate-[ping_1s_infinite]">...</span></span>
 </div>
 `;
 chatContainer.scrollTop = chatContainer.scrollHeight;

 try {
 const res = await request('/admin/ai-command', {
 method: 'POST',
 body: JSON.stringify({ prompt })
 });
 
 document.getElementById(loadingId)?.remove();
 
 const msgId = 'msg-' + Date.now();
 chatContainer.innerHTML += `
 <div class="flex gap-2 text-emerald-400/90">
 <span class="text-emerald-700 mt-1">AI></span> 
 <div id="${msgId}"class="flex-1 font-sans leading-relaxed tracking-wide"></div>
 </div>
 <div class="h-4"></div>
 `;
 
 await window.typewriterEffect(document.getElementById(msgId), res.result);
 
 } catch (err) {
 document.getElementById(loadingId)?.remove();
 chatContainer.innerHTML += `
 <div class="flex gap-2 text-rose-400">
 <span class="text-rose-700">ERR></span> 
 <span>${h(err.message)}</span>
 </div>
 <div class="h-4"></div>
 `;
 }
 setTimeout(() => {
 chatContainer.scrollTop = chatContainer.scrollHeight;
 }, 100);
};

// =========================================================================
// RENDERERS (Admin Dashboard)
// =========================================================================


function adminLedgerPage() {
 const payload = state.adminLedger?.data || {};
 const transactionsPage = payload.transactions || { data: [], current_page: 1, last_page: 1, total: 0 };
 const transactions = transactionsPage.data || [];
 const metrics = payload.metrics || { total_deposits: 0, total_withdrawals: 0, total_commissions: 0, total_transactions: 0 };
 
 let html = `
 <div class="mx-auto max-w-7xl space-y-6 pb-20">
 <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
 <div>
 <p class="eyebrow">Financials</p>
 <h1 class="text-xl md:text-3xl font-black mt-2">Master Ledger</h1>
 <p class="text-sm text-slate-600 mt-2">Complete history of all platform transactions.</p>
 </div>
 <div class="flex gap-2">
 <button onclick="exportLedger()"class="btn-primary text-sm">${icon('download', 'w-3 h-3 md:w-4 md:h-4')} Export CSV</button>
 </div>
 </div>
 
 <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:grid-cols-4 gap-4">
 ${metric('Total Deposits', money(metrics.total_deposits || 0), 'Incoming')}
 ${metric('Total Withdrawals', money(metrics.total_withdrawals || 0), 'Outgoing')}
 ${metric('Platform Revenue', money(metrics.total_commissions || 0), 'Fees')}
 ${metric('Transactions', metrics.total_transactions || 0, 'Total')}
 </div>

 <section class="glass-panel p-4 md:p-6 rounded-3xl relative overflow-hidden neu-raised/80">
 <div class="overflow-x-auto max-h-96 overflow-y-auto">
 <table class="w-full text-left border-collapse">
 <thead>
 <tr class="text-xs font-semibold text-slate-600 uppercase tracking-wider">
 <th class="px-4 py-3">Date</th>
 <th class="px-4 py-3">Transaction ID</th>
 <th class="px-4 py-3">User</th>
 <th class="px-4 py-3">Type</th>
 <th class="px-4 py-3">Amount</th>
 <th class="px-4 py-3">Status</th>
 </tr>
 </thead>
 <tbody class="divide-y divide-slate-100">
 ${transactions.length ? transactions.map(t => `
 <tr class="hover:neu-raised/50 transition-colors text-sm">
 <td class="px-4 py-4 text-slate-600 whitespace-nowrap">${new Date(t.created_at).toLocaleString()}</td>
 <td class="px-4 py-4 font-mono text-xs text-slate-400">${h(t.id).substring(0, 8)}...</td>
 <td class="px-4 py-4 font-medium text-slate-900">${h(t.user?.name || 'System')}</td>
 <td class="px-4 py-4">
 <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-900 capitalize">
 ${h(t.type).replace('_', ' ')}
 </span>
 </td>
 <td class="px-4 py-4 font-bold ${t.type === 'fee' || t.type === 'deposit' || t.amount > 0 ? 'text-emerald-700' : 'text-slate-900'}">
 ${t.amount > 0 ? '+' : ''}${money(t.amount, t.currency)}
 </td>
 <td class="px-4 py-4">
 <span class="status-pill ${t.status === 'completed' ? 'status-open' : (t.status === 'pending' ? 'status-warn' : 'status-danger')} capitalize">${h(t.status)}</span>
 </td>
 </tr>
 `).join('') : `
 <tr>
 <td colspan="6"class="px-4 py-12 text-center text-slate-600">
 ${icon('document', 'w-12 h-12 mx-auto text-slate-300 mb-3')}
 <p>No transactions found.</p>
 </td>
 </tr>
 `}
 </tbody>
 </table>
 </div>
 </section>
 </div>
 `;

 if (!window.exportLedger) {
 window.exportLedger = function() {
 window.open(`${apiBase}/admin/ledger/export?token=` + localStorage.getItem('token'), '_blank');
 };
 }

 return html;
}

function adminPaymentsPage() {
 const withdrawalsHtml = (state.adminWithdrawals || []).map(w => `
 <tr class="hover:neu-raised/[0.01] transition-colors text-sm">
 <td class="px-4 py-3">
 <p class="font-semibold text-slate-900">${h(w.user?.name || 'User')}</p>
 <p class="text-xs text-slate-600">Balance: <span class="font-bold text-blue-700">${money(w.user?.balance ?? 0)}</span></p>
 </td>
 <td class="px-4 py-3 text-blue-700 font-bold">${money(w.amount, w.currency)}</td>
 <td class="px-4 py-3 text-slate-600 text-xs">${h(w.payout_method?.toUpperCase())} — ${h(w.payout_details)}</td>
 <td class="px-4 py-3"><span class="status-pill ${w.status === 'pending' ? 'status-warn' : w.status === 'approved' ? 'status-open' : 'status-danger'} capitalize">${h(w.status)}</span></td>
 <td class="px-4 py-3 text-right">
 ${w.status === 'pending' ? `<div class="flex items-center justify-end gap-2">
 <button class="btn-primary px-3 py-1 text-xs"data-approve-withdrawal="${w.id}">Approve</button>
 <button class="btn-ghost px-3 py-1 text-xs text-rose-700"data-reject-withdrawal="${w.id}">Reject</button>
 </div>` : '—'}
 </td>
 </tr>
 `).join('');

 const depositsHtml = (state.adminDeposits || []).map(d => `
 <tr class="hover:neu-raised/[0.01] transition-colors text-sm">
 <td class="px-4 py-3 font-semibold text-slate-900">${h(d.user?.name || 'User')}</td>
 <td class="px-4 py-3 text-blue-700 font-bold">${money(d.amount, d.currency)}</td>
 <td class="px-4 py-3 text-slate-600 text-xs font-mono">${h(d.gateway_reference || 'N/A')}</td>
 <td class="px-4 py-3"><span class="status-pill ${d.status === 'pending' ? 'status-warn' : d.status === 'completed' ? 'status-open' : 'status-danger'} capitalize">${h(d.status)}</span></td>
 <td class="px-4 py-3 text-right">
 ${d.status === 'pending' ? `<div class="flex items-center justify-end gap-2">
 <button class="btn-primary px-3 py-1 text-xs"data-approve-deposit="${d.id}">Approve</button>
 <button class="btn-ghost px-3 py-1 text-xs text-rose-700"data-reject-deposit="${d.id}">Reject</button>
 </div>` : '—'}
 </td>
 </tr>
 `).join('');

 const depositsTable = `
 <section class="soft-panel p-5 col-span-full">
 <p class="eyebrow">Manual UPI</p>
 <h2 class="mt-2 text-base md:text-xl font-black mb-4">Deposit Requests</h2>
 <div class="overflow-x-auto">
 <table class="w-full text-left border-collapse">
 <thead>
 <tr class="text-xs font-semibold text-slate-600 uppercase tracking-wider">
 <th class="px-4 py-3">User</th>
 <th class="px-4 py-3">Amount</th>
 <th class="px-4 py-3">UTR Number</th>
 <th class="px-4 py-3">Status</th>
 <th class="px-4 py-3 text-right">Actions</th>
 </tr>
 </thead>
 <tbody>
 ${depositsHtml || `<tr><td colspan="5"class="p-4 text-center text-slate-600">No deposit requests.</td></tr>`}
 </tbody>
 </table>
 </div>
 </section>
 `;

 const withdrawalsTable = `
 <section class="soft-panel p-5 col-span-full">
 <p class="eyebrow">Payouts</p>
 <h2 class="mt-2 text-base md:text-xl font-black mb-4">Withdrawal Requests</h2>
 <div class="overflow-x-auto">
 <table class="w-full text-left border-collapse">
 <thead>
 <tr class="text-xs font-semibold text-slate-600 uppercase tracking-wider">
 <th class="px-4 py-3">User</th>
 <th class="px-4 py-3">Amount</th>
 <th class="px-4 py-3">Payout Details</th>
 <th class="px-4 py-3">Status</th>
 <th class="px-4 py-3 text-right">Actions</th>
 </tr>
 </thead>
 <tbody>
 ${withdrawalsHtml || `<tr><td colspan="5"class="p-4 text-center text-slate-600">No withdrawal requests.</td></tr>`}
 </tbody>
 </table>
 </div>
 </section>
 `;

 return `<div class="space-y-6">
 ${depositsTable}
 ${withdrawalsTable}
 </div>`;
}

window.fetchSsmAiStats = async (silent = false) => {
 try {
 const res = await request('/admin/ssm-ai/stats');
 state.ssmAi = res;
 if (!silent) render();
 else if (state.currentRoute === 'admin-ai-core' && state.ssmAiTab === 'overview') render();
 } catch (e) {
 if (!silent) notify('Failed to load AI stats', 'error');
 }
};

window.setSsmAiTab = (tab) => {
 state.ssmAiTab = tab;
 if (tab === 'brain') window.fetchSsmAiLogs();
 render();
};

window.fetchSsmAiLogs = async () => {
 try {
 const res = await request('/admin/ssm-ai/logs');
 state.ssmAiLogs = res.data;
 render();
 } catch (e) {
 notify('Failed to load logs', 'error');
 }
};

window.updateBrainLog = async (id) => {
 const textarea = document.getElementById('brain-log-' + id);
 try {
 const parsed = JSON.parse(textarea.value);
 await request(`/admin/ssm-ai/logs/${id}`, {
 method: 'PUT',
 body: JSON.stringify({ response: parsed })
 });
 notify('Brain Memory Updated!', 'success');
 window.fetchSsmAiLogs();
 } catch (e) {
 notify('Invalid JSON or Error', 'error');
 }
};

window.exportSsmAiDataset = () => {
 notify('Preparing dataset...', 'info');
 
 if (!state.ssmAiLogs || state.ssmAiLogs.length === 0) {
 notify('No data to export. Please wait for logs to load.', 'error');
 return;
 }

 try {
 let jsonlContent ="";
 state.ssmAiLogs.forEach(log => {
 const line = {
 messages: [
 { role:"system", content:"You are SSM AI, an advanced intelligent system running SmartSiteMaker."},
 { role:"user", content: log.prompt },
 { role:"assistant", content: log.response }
 ]
 };
 jsonlContent += JSON.stringify(line) +"\n";
 });

 const blob = new Blob([jsonlContent], { type: 'application/x-ndjson' });
 const url = URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url;
 a.download = `ssm_ai_dataset_${new Date().toISOString().split('T')[0]}.jsonl`;
 document.body.appendChild(a);
 a.click();
 document.body.removeChild(a);
 setTimeout(() => URL.revokeObjectURL(url), 2000);
 
 notify('Dataset Exported successfully!', 'success');
 } catch (e) {
 console.error('Export error:', e);
 notify('Error generating export', 'error');
 }
};

window.saveAiPersona = async (e) => {
 e.preventDefault();
 const mode = document.getElementById('persona_mode').value;
 try {
 await request('/admin/ai-settings', {
 method: 'POST',
 body: JSON.stringify({ mode })
 });
 notify('Persona Saved!', 'success');
 } catch (e) {
 notify('Error saving persona', 'error');
 }
};

window.toggleAutoTrainer = async () => {
 const btn = document.getElementById('auto-train-btn');
 const isActive = localStorage.getItem('ssm_auto_train_active') === '1';
 
 if (isActive) {
 localStorage.setItem('ssm_auto_train_active', '0');
 btn.innerHTML = `<svg class="w-4 h-4 text-purple-300"fill="none"viewBox="0 0 24 24"stroke="currentColor"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg> Initialize Deep Scan & Auto-Train`;
 btn.className ="px-6 py-2 bg-gradient-to-r from-indigo-900/80 to-purple-900/80 hover:from-indigo-800 hover:to-purple-800 border-indigo-500/50 hover:border-purple-400 text-indigo-100 uppercase tracking-widest text-xs font-bold transition-all rounded shadow-[0_0_20px_rgba(168,85,247,0.4)] flex items-center gap-2";
 notify('Auto-Trainer Stopped', 'info');
 } else {
 localStorage.setItem('ssm_auto_train_active', '1');
 btn.innerHTML = `<span class="animate-pulse text-emerald-300 flex items-center gap-2"><div class="w-2 h-2 bg-emerald-400 rounded-full animate-ping"></div> Live Training Active (Click to Stop)</span>`;
 btn.className ="px-6 py-2 bg-emerald-900/80 border-emerald-500 text-emerald-100 uppercase tracking-widest text-xs font-bold transition-all rounded shadow-[0_0_20px_rgba(16,185,129,0.4)] flex items-center gap-2";
 notify('Auto-Trainer Started', 'success');
 startAutoTrainLoop();
 }
};

async function startAutoTrainLoop() {
 if (window.ssmAiTrainLoopActive) return;
 window.ssmAiTrainLoopActive = true;
 
 while (localStorage.getItem('ssm_auto_train_active') === '1') {
 try {
 await request('/admin/ssm-ai/auto-train', { method: 'POST' });
 if (state.currentRoute === 'admin-ai-core' && state.ssmAiTab === 'overview') {
 await window.fetchSsmAiStats(true);
 }
 } catch (e) {
 console.error('Auto-train tick failed', e);
 // Auto-stop on API exhaustion or error
 localStorage.setItem('ssm_auto_train_active', '0');
 notify('API Limit Exhausted. Training Paused.', 'error');
 const btn = document.getElementById('auto-train-btn');
 if (btn) {
 btn.innerHTML = `<svg class="w-4 h-4 text-purple-300"fill="none"viewBox="0 0 24 24"stroke="currentColor"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg> Initialize Deep Scan & Auto-Train`;
 btn.className ="px-6 py-2 bg-gradient-to-r from-indigo-900/80 to-purple-900/80 hover:from-indigo-800 hover:to-purple-800 border-indigo-500/50 hover:border-purple-400 text-indigo-100 uppercase tracking-widest text-xs font-bold transition-all rounded shadow-[0_0_20px_rgba(168,85,247,0.4)] flex items-center gap-2";
 }
 break;
 }
 await new Promise(r => setTimeout(r, 2000));
 }
 
 window.ssmAiTrainLoopActive = false;
}

window.importSsmAiDataset = async (e) => {
 const file = e.target.files[0];
 if (!file) return;
 
 notify('Uploading brain data...', 'info');
 const formData = new FormData();
 formData.append('dataset', file);
 
 try {
 await request('/admin/ssm-ai/import', {
 method: 'POST',
 body: formData,
 isFormData: true
 });
 notify('Brain Data Imported Successfully!', 'success');
 if (state.ssmAiTab === 'brain') window.fetchSsmAiLogs();
 if (state.ssmAiTab === 'overview') window.fetchSsmAiStats();
 } catch (err) {
 notify('Failed to import dataset', 'error');
 }
 // Reset file input
 e.target.value = '';
};

function ssmAiDashboard() {
 if (!state.ssmAi) {
 window.fetchSsmAiStats();
 return skeletonScreen();
 }

 if (!window.ssmAiLiveInterval) {
 window.ssmAiLiveInterval = setInterval(() => {
 if (state.currentRoute === 'admin-ai-core' && state.ssmAiTab === 'overview' && localStorage.getItem('ssm_auto_train_active') !== '1') {
 window.fetchSsmAiStats(true); // Silent reload if not already handled by train loop
 } else if (state.currentRoute !== 'admin-ai-core') {
 clearInterval(window.ssmAiLiveInterval);
 window.ssmAiLiveInterval = null;
 }
 }, 3000);
 }
 
 // Resume train loop on dashboard load if active
 if (localStorage.getItem('ssm_auto_train_active') === '1') {
 startAutoTrainLoop();
 }

 const ai = state.ssmAi;
 state.ssmAiTab = state.ssmAiTab || 'overview';
 const tab = state.ssmAiTab;
 
 // Tab Navigation
 const tabsHtml = `
 <div class="flex gap-4 border-cyan-900/50 pb-4 mb-8 justify-between items-center">
 <div class="flex gap-4">
 <button onclick="setSsmAiTab('overview')"class="px-6 py-2 uppercase tracking-widest text-xs font-bold transition-all rounded ${tab === 'overview' ? 'bg-cyan-900/50 text-cyan-300 border-cyan-500/50 shadow-[0_0_15px_rgba(6,182,212,0.3)]' : 'text-cyan-600 hover:text-cyan-400'}">Overview</button>
 <button onclick="setSsmAiTab('brain')"class="px-6 py-2 uppercase tracking-widest text-xs font-bold transition-all rounded ${tab === 'brain' ? 'bg-indigo-900/50 text-indigo-300 border-indigo-500/50 shadow-[0_0_15px_rgba(99,102,241,0.3)]' : 'text-indigo-600 hover:text-indigo-400'}">Brain Editor</button>
 <button onclick="setSsmAiTab('persona')"class="px-6 py-2 uppercase tracking-widest text-xs font-bold transition-all rounded ${tab === 'persona' ? 'bg-emerald-900/50 text-emerald-300 border-emerald-500/50 shadow-[0_0_15px_rgba(16,185,129,0.3)]' : 'text-emerald-700 hover:text-emerald-400'}">Persona Settings</button>
 <button onclick="setSsmAiTab('sandbox')"class="px-6 py-2 uppercase tracking-widest text-xs font-bold transition-all rounded ${tab === 'sandbox' ? 'bg-purple-900/50 text-purple-300 border-purple-500/50 shadow-[0_0_15px_rgba(168,85,247,0.3)]' : 'text-purple-600 hover:text-purple-400'}">Sandbox Terminal</button>
 </div>
 
 <div class="flex gap-4 items-center">
 <label class="px-6 py-2 bg-gradient-to-r from-emerald-900/50 to-teal-900/50 hover:from-emerald-800 hover:to-teal-800 border-emerald-500/50 text-emerald-100 uppercase tracking-widest text-xs font-bold transition-all rounded shadow-[0_0_15px_rgba(16,185,129,0.3)] cursor-pointer flex items-center gap-2">
 <svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path></svg>
 Import Brain
 <input type="file"class="hidden"accept=".jsonl"onchange="window.importSsmAiDataset(event)">
 </label>
 <button onclick="window.exportSsmAiDataset()"class="px-6 py-2 bg-gradient-to-r from-indigo-900/50 to-purple-900/50 hover:from-indigo-800 hover:to-purple-800 border-indigo-500/50 text-indigo-100 uppercase tracking-widest text-xs font-bold transition-all rounded shadow-[0_0_15px_rgba(99,102,241,0.3)] flex items-center gap-2">
 <svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
 Export Brain
 </button>
 
 ${tab === 'overview' ? `
 <button id="auto-train-btn"onclick="window.toggleAutoTrainer()"class="${localStorage.getItem('ssm_auto_train_active') === '1' ? 'px-6 py-2 bg-emerald-900/80 border-emerald-500 text-emerald-100 uppercase tracking-widest text-xs font-bold transition-all rounded shadow-[0_0_20px_rgba(16,185,129,0.4)] flex items-center gap-2' : 'px-6 py-2 bg-gradient-to-r from-indigo-900/80 to-purple-900/80 hover:from-indigo-800 hover:to-purple-800 border-indigo-500/50 hover:border-purple-400 text-indigo-100 uppercase tracking-widest text-xs font-bold transition-all rounded shadow-[0_0_20px_rgba(168,85,247,0.4)] flex items-center gap-2'}">
 ${localStorage.getItem('ssm_auto_train_active') === '1' ? `<span class="animate-pulse text-emerald-300 flex items-center gap-2"><div class="w-2 h-2 bg-emerald-400 rounded-full animate-ping"></div> Live Training Active (Click to Stop)</span>` : `<svg class="w-4 h-4 text-purple-300"fill="none"viewBox="0 0 24 24"stroke="currentColor"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg> Initialize Deep Scan & Auto-Train`}
 </button>
 ` : ''}
 </div>
 </div>
 `;

 // Overview Tab
 const overviewHtml = `
 <!-- Stats Grid -->
 <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-10">
 <!-- Status Orb -->
 <div class="col-span-1 bg-black/40 border-cyan-900/40 rounded-xl p-4 md:p-6 relative overflow-hidden backdrop-blur-md flex flex-col items-center justify-center">
 <div class="absolute inset-0 bg-gradient-to-b from-cyan-500/5 to-transparent pointer-events-none"></div>
 <div class="relative w-32 h-32 flex items-center justify-center mb-4">
 <div class="absolute inset-0 rounded-full border-cyan-500/20 animate-[spin_10s_linear_infinite]"></div>
 <div class="absolute inset-2 rounded-full border-indigo-500/30 animate-[spin_7s_linear_infinite_reverse]"></div>
 <div class="w-7 h-7 md:w-10 md:h-10 md:w-16 md:h-16 bg-cyan-400 rounded-full shadow-[0_0_40px_rgba(34,211,238,0.8)] animate-pulse flex items-center justify-center">
 <div class="w-8 h-8 md:w-12 md:h-12 neu-raised rounded-full blur-md"></div>
 </div>
 </div>
 <p class="text-2xl font-black text-white tracking-widest uppercase drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]">${ai.status}</p>
 <p class="text-[10px] text-cyan-500 mt-2 uppercase tracking-widest">System Operational</p>
 </div>

 <!-- Digital Age -->
 <div class="col-span-1 bg-black/40 border-cyan-900/40 rounded-xl p-4 md:p-6 relative overflow-hidden backdrop-blur-md">
 <p class="text-xs text-cyan-600 uppercase tracking-widest font-bold mb-4">Digital Age</p>
 <p class="text-3xl md:text-5xl font-black text-cyan-300 drop-shadow-[0_0_15px_rgba(103,232,249,0.5)] mb-2">${ai.digital_age}</p>
 <p class="text-xs text-cyan-500 uppercase tracking-wider">Years of Learning</p>
 <div class="mt-4 pt-4 border-cyan-900/50">
 <p class="text-[10px] text-cyan-600 uppercase tracking-widest mb-1">Online Since</p>
 <p class="text-sm font-bold text-cyan-200">${ai.birth_date}</p>
 </div>
 </div>

 <!-- Autonomy Prediction -->
 <div class="col-span-2 bg-black/40 border-cyan-900/40 rounded-xl p-4 md:p-6 relative overflow-hidden backdrop-blur-md">
 <p class="text-xs text-indigo-400 uppercase tracking-widest font-bold mb-4">Path to Absolute Autonomy</p>
 <div class="flex items-end gap-4 mb-4">
 <p class="text-2xl md:text-4xl md:text-6xl font-black text-indigo-300 drop-shadow-[0_0_20px_rgba(165,180,252,0.6)]">${ai.autonomy_progress_percent}%</p>
 <div class="pb-2">
 <p class="text-sm font-bold text-indigo-200">Independent Ops</p>
 <p class="text-[10px] text-indigo-400 uppercase tracking-widest">ETA: ${ai.estimated_days_to_autonomy} Days</p>
 </div>
 </div>
 
 <!-- Progress Bar -->
 <div class="w-full h-3 bg-slate-900 rounded-full overflow-hidden border-indigo-900/50 -inner mt-6">
 <div class="h-full bg-gradient-to-r from-cyan-500 to-indigo-500 shadow-[0_0_10px_rgba(99,102,241,0.8)] relative"style="width: ${ai.autonomy_progress_percent}%"></div>
 </div>
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 mt-2">
 <span class="text-[9px] text-indigo-500 uppercase tracking-widest">0% (Dependent)</span>
 <span class="text-[9px] text-indigo-500 uppercase tracking-widest">100% (Sentient)</span>
 </div>
 </div>
 </div>

 <!-- Metrics & Live Stream -->
 <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
 <div class="col-span-1 space-y-6">
 <div class="bg-black/40 border-emerald-900/40 rounded-xl p-4 md:p-6 backdrop-blur-md shadow-[0_0_15px_rgba(16,185,129,0.1)]">
 <h3 class="text-xs text-emerald-700 uppercase tracking-widest font-bold mb-5 border-emerald-900/50 pb-2 flex items-center justify-between">
 Value Metrics
 <svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
 </h3>
 <div class="space-y-4">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <span class="text-sm text-emerald-200">Admin Hours Saved</span>
 <span class="text-base md:text-xl font-bold text-emerald-400">${ai.metrics.hours_saved} hr</span>
 </div>
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <span class="text-sm text-emerald-200">Value Generated</span>
 <span class="text-base md:text-xl font-bold text-emerald-400">$${ai.metrics.cost_saved_usd}</span>
 </div>
 </div>
 </div>
 
 <div class="bg-black/40 border-cyan-900/40 rounded-xl p-4 md:p-6 backdrop-blur-md">
 <h3 class="text-xs text-cyan-600 uppercase tracking-widest font-bold mb-5 border-cyan-900/50 pb-2">Interaction Volume</h3>
 <div class="space-y-4">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <span class="text-sm text-cyan-200">Total Processed</span>
 <span class="text-base md:text-xl font-bold text-cyan-400">${ai.total_interactions}</span>
 </div>
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <span class="text-sm text-cyan-200">Successful</span>
 <span class="text-base md:text-xl font-bold text-emerald-400">${ai.metrics.success}</span>
 </div>
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <span class="text-sm text-cyan-200">Local Fallbacks</span>
 <span class="text-base md:text-xl font-bold text-amber-400">${ai.metrics.fallback}</span>
 </div>
 </div>
 </div>
 </div>

 <!-- Live Stream -->
 <div class="col-span-2 bg-black/40 border-cyan-900/40 rounded-xl backdrop-blur-md flex flex-col h-[400px]">
 <div class="p-4 border-cyan-900/40 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center bg-cyan-950/20 rounded-t-xl">
 <h3 class="text-xs text-cyan-400 uppercase tracking-widest font-bold flex items-center gap-2">
 <span class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse shadow-[0_0_5px_#10b981]"></span>
 Live Neural Telemetry
 </h3>
 </div>
 <div class="flex-1 overflow-y-auto p-4 space-y-3 custom-scrollbar">
 ${ai.recent_stream.map(log => `
 <div class="border-cyan-900/30 bg-black/50 p-3 rounded-lg flex items-center justify-between">
 <div>
 <p class="text-sm font-bold text-cyan-200">${log.context}</p>
 <p class="text-[10px] text-cyan-600 mt-0.5">${log.model} • ${log.human_time}</p>
 </div>
 <div class="text-right">
 <span class="text-[9px] uppercase tracking-widest px-2 py-0.5 rounded ${log.status === 'success' ? 'border-emerald-500/30 text-emerald-400 bg-emerald-500/10' : 'border-amber-500/30 text-amber-400 bg-amber-500/10'}">${log.status}</span>
 </div>
 </div>
 `).join('')}
 </div>
 </div>
 </div>
 `;

 // Brain Editor Tab
 const logs = state.ssmAiLogs || [];
 const brainHtml = `
 <div class="mb-6 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <div>
 <h3 class="text-base md:text-xl font-black text-indigo-100">Neural Pathway Editor</h3>
 <p class="text-xs text-indigo-400 mt-1 uppercase tracking-widest">Manually inspect and rewrite AI memories</p>
 </div>
 <div class="flex gap-4">
 <label class="px-6 py-2 bg-gradient-to-r from-emerald-900/50 to-teal-900/50 hover:from-emerald-800 hover:to-teal-800 border-emerald-500/50 text-emerald-100 uppercase tracking-widest text-xs font-bold transition-all rounded shadow-[0_0_15px_rgba(16,185,129,0.3)] cursor-pointer flex items-center gap-2">
 <svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path></svg>
 Import Brain
 <input type="file"class="hidden"accept=".jsonl"onchange="window.importSsmAiDataset(event)">
 </label>
 <button onclick="window.exportSsmAiDataset()"class="px-6 py-2 bg-gradient-to-r from-indigo-900/50 to-purple-900/50 hover:from-indigo-800 hover:to-purple-800 border-indigo-500/50 text-indigo-100 uppercase tracking-widest text-xs font-bold transition-all rounded shadow-[0_0_15px_rgba(99,102,241,0.3)] flex items-center gap-2">
 <svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
 Export Brain
 </button>
 </div>
 </div>
 <div class="space-y-6">
 ${logs.length === 0 ? '<p class="text-indigo-400">Loading logs...</p>' : logs.map(log => `
 <div class="border-indigo-900/30 bg-black/60 rounded-lg p-4">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 text-[10px] uppercase text-indigo-500 font-bold mb-3">
 <span>ID: ${log.id} | Context: ${log.context}</span>
 <span>${new Date(log.created_at).toLocaleString()}</span>
 </div>
 <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
 <div>
 <p class="text-xs text-indigo-300 uppercase mb-2">Prompt (Input)</p>
 <pre class="text-xs text-indigo-100 bg-indigo-950/30 p-3 rounded custom-scrollbar overflow-x-auto max-h-40">${h(JSON.stringify(log.prompt, null, 2))}</pre>
 </div>
 <div>
 <p class="text-xs text-indigo-300 uppercase mb-2">Response (Output)</p>
 <textarea id="brain-log-${log.id}"class="w-full h-40 bg-indigo-950/30 text-indigo-100 border-indigo-900/50 rounded p-3 text-xs font-mono custom-scrollbar focus:border-indigo-500 focus:outline-none transition-colors">${h(JSON.stringify(log.response, null, 2))}</textarea>
 <div class="text-right mt-2">
 <button onclick="updateBrainLog(${log.id})"class="px-4 py-1.5 bg-emerald-600/20 text-emerald-400 border-emerald-500/50 hover:bg-emerald-600/40 transition-colors rounded text-xs font-bold uppercase">Save Correction</button>
 </div>
 </div>
 </div>
 </div>
 `).join('')}
 </div>
 </div>
 `;

 // Persona Tab
 const personaHtml = `
 <div class="bg-black/40 border-emerald-900/40 rounded-xl p-4 md:p-6 backdrop-blur-md max-w-2xl">
 <h2 class="text-lg font-bold text-emerald-300 mb-2">AI Persona Control</h2>
 <p class="text-sm text-emerald-200 mb-6">Change how the SSM AI behaves across the platform. (Coming Soon - Hooks into .env)</p>
 <form onsubmit="saveAiPersona(event)"class="space-y-6">
 <div>
 <label class="block text-xs uppercase tracking-widest text-emerald-400 font-bold mb-2">Active Persona Mode</label>
 <select id="persona_mode"class="w-full bg-black border-emerald-900/50 rounded-lg p-3 text-emerald-100 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none">
 <option value="balanced">Balanced (Default) - Helpful and professional</option>
 <option value="strict">Strict - Enforces rules rigidly</option>
 <option value="creative">Creative - Writes vibrant and engaging text</option>
 <option value="professional">Professional - Formal business tone</option>
 </select>
 </div>
 <button type="submit"class="w-full py-3 bg-emerald-600/20 text-emerald-400 border-emerald-500/50 hover:bg-emerald-600/40 transition-colors rounded-lg font-bold uppercase tracking-widest">
 Update Persona
 </button>
 </form>
 </div>
 `;

 // Sandbox Tab
 const sandboxHtml = `
 <div class="bg-black/40 border-purple-900/40 rounded-xl backdrop-blur-md flex flex-col h-[600px] overflow-hidden">
 <div class="p-4 border-purple-900/40 bg-purple-950/20">
 <h2 class="text-lg font-bold text-purple-300">Sandbox Terminal</h2>
 <p class="text-xs text-purple-200">Direct interface to the local AI Nexus for testing prompts.</p>
 </div>
 <div id="ai-chat-history"class="flex-1 p-4 md:p-6 overflow-y-auto space-y-4 custom-scrollbar bg-black/60 font-sans">
 <!-- Sandbox chat messages go here via window.sendAdminAiCommand -->
 <div class="text-purple-400 italic text-sm">System ready. Enter your prompt below.</div>
 </div>
 <form onsubmit="window.sendAdminAiCommand(event)"class="p-4 border-purple-900/40 bg-purple-950/20 flex gap-4">
 <input type="text"id="ai-prompt-input"name="prompt"placeholder="Test a prompt..."class="flex-1 bg-black/50 border-purple-900/50 rounded-lg px-4 py-2 text-purple-100 focus:border-purple-500 focus:outline-none">
 <button type="submit"class="px-6 py-2 bg-purple-600 hover:bg-purple-500 text-white rounded-lg font-bold uppercase tracking-widest text-xs shadow-[0_0_15px_rgba(168,85,247,0.4)]">
 Send
 </button>
 </form>
 </div>
 `;

 // Futuristic Dashboard HTML
 return `
 <div class="bg-[#050510] rounded-3xl border-cyan-900/50 shadow-[0_0_50px_rgba(6,182,212,0.15)] overflow-hidden relative font-mono text-cyan-50 min-h-[85vh] mb-10">
 <div class="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20 pointer-events-none"></div>
 <div class="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-cyan-500 to-transparent shadow-[0_0_20px_rgba(6,182,212,0.8)]"></div>
 
 <!-- Header -->
 <div class="max-w-7xl mx-auto px-6 py-10 relative z-10">
 <div class="flex items-center justify-between mb-8 border-cyan-900/50 pb-6">
 <div>
 <h1 class="text-3xl md:text-5xl font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-indigo-500 drop-shadow-[0_0_15px_rgba(6,182,212,0.4)]">
 SSM AI <span class="text-cyan-100 font-light tracking-widest">NEXUS</span>
 </h1>
 <p class="text-cyan-600 uppercase tracking-widest text-xs mt-2 font-bold">Local Brain Telemetry & Learning Center</p>
 </div>
 <div class="flex items-center gap-6">
 <div class="text-right">
 <p class="text-[10px] text-cyan-600 uppercase tracking-widest mb-1">Core Temp</p>
 <p class="text-base md:text-xl font-bold text-rose-400 drop-shadow-[0_0_8px_rgba(251,113,133,0.5)]">${ai.core_temperature}</p>
 </div>
 <div class="text-right">
 <p class="text-[10px] text-cyan-600 uppercase tracking-widest mb-1">Efficiency</p>
 <p class="text-base md:text-xl font-bold text-emerald-400 drop-shadow-[0_0_8px_rgba(52,211,153,0.5)]">${ai.neural_efficiency}</p>
 </div>
 </div>
 </div>

 ${tabsHtml}

 ${tab === 'overview' ? overviewHtml : ''}
 ${tab === 'brain' ? brainHtml : ''}
 ${tab === 'persona' ? personaHtml : ''}
 ${tab === 'sandbox' ? sandboxHtml : ''}
 
 </div>
 
 <style>
 @keyframes slide {
 0% { background-position: 0 0; }
 100% { background-position: 40px 0; }
 }
 .custom-scrollbar::-webkit-scrollbar { width: 6px; }
 .custom-scrollbar::-webkit-scrollbar-track { background: rgba(0,0,0,0.3); border-radius: 4px; }
 .custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(99,102,241,0.5); border-radius: 4px; }
 .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: rgba(99,102,241,0.8); }
 </style>
 </div>`;
}

function adminPage() {
 const pendingKyc = state.kycDocuments.filter((document) => document.status === 'pending');
 const openDisputes = state.disputes.filter((dispute) => dispute.status === 'open');
 const pendingPayments = state.pendingPayments || [];
 const metrics = state.analytics || {};

 const liveAnalyticsHtml = `
 <section class="soft-panel p-5 col-span-full mb-6">
 <div class="flex items-center justify-between mb-4">
 <div>
 <p class="eyebrow flex items-center gap-2">
 <span class="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
 Live Telemetry
 </p>
 <h2 class="mt-1 text-base md:text-xl font-black">Platform Pulse</h2>
 </div>
 <div>
 <button type="button"onclick="generateAiReport()"class="btn-ai flex items-center gap-2">
 <svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
 Generate AI Report
 </button>
 </div>
 </div>
 
 <div class="grid lg:grid-cols-3 gap-6 mb-6">
 <div class="rounded-2xl neu-raised p-4 relative overflow-hidden">
 <div class="absolute -right-4 -top-4 w-24 h-24 bg-teal-500/10 rounded-full blur-2xl"></div>
 <p class="text-xs font-bold text-slate-600 uppercase tracking-wider">Live Visitors</p>
 <p class="text-2xl md:text-4xl font-black mt-2 text-slate-900"id="live-visitors-count">--</p>
 <p class="text-xs text-teal-700 font-semibold mt-1">Active right now</p>
 </div>
 
 <div class="rounded-2xl neu-raised p-4 relative overflow-hidden">
 <div class="absolute -right-4 -top-4 w-24 h-24 bg-blue-500/10 rounded-full blur-2xl"></div>
 <p class="text-xs font-bold text-slate-600 uppercase tracking-wider">Today's Escrow Volume</p>
 <p class="text-2xl md:text-4xl font-black mt-2 text-slate-900"id="live-today-funded">--</p>
 <p class="text-xs text-slate-600 font-semibold mt-1">Week: <span id="live-week-funded"class="text-slate-700">--</span></p>
 </div>
 
 <div class="rounded-2xl neu-raised p-4 relative overflow-hidden">
 <div class="absolute -right-4 -top-4 w-24 h-24 bg-purple-500/10 rounded-full blur-2xl"></div>
 <p class="text-xs font-bold text-slate-600 uppercase tracking-wider">Today's Commission</p>
 <p class="text-2xl md:text-4xl font-black mt-2 text-purple-700"id="live-today-commission">--</p>
 <p class="text-xs text-slate-600 font-semibold mt-1">Week: <span id="live-week-commission"class="text-slate-700">--</span></p>
 </div>
 </div>

 <!-- System Tools -->
 <div class="mt-6 pt-6">
 <p class="eyebrow text-slate-600 mb-3">System Actions</p>
 <div class="flex flex-wrap gap-4">
 <button onclick="window.toggleMaintenance(true)"class="btn-secondary text-amber-800 bg-amber-50 border-amber-200 hover:bg-amber-100">🚧 Enable Maintenance</button>
 <button onclick="window.toggleMaintenance(false)"class="btn-secondary text-emerald-700 bg-emerald-50 border-emerald-200 hover:bg-emerald-100">✅ Disable Maintenance</button>
 <button onclick="window.clearServerCache()"class="btn-secondary text-blue-700 bg-blue-50 border-blue-200 hover:bg-blue-100">🧹 Clear Server Cache</button>
 </div>
 </div>

 <div class="grid lg:grid-cols-2 gap-6 mt-6">
 <div class="rounded-2xl neu-raised p-4">
 <p class="text-xs font-bold text-slate-600 uppercase tracking-wider mb-4">Traffic Fluctuations (Last 10 Ticks)</p>
 <div class="relative w-full h-48">
 <canvas id="liveVisitorsChart"></canvas>
 </div>
 </div>
 <div class="rounded-2xl neu-raised p-4">
 <p class="text-xs font-bold text-slate-600 uppercase tracking-wider mb-4">12-Hour Income Trend (Commission + Escrow)</p>
 <div class="relative w-full h-48">
 <canvas id="liveIncomeChart"></canvas>
 </div>
 </div>
 </div>
 </section>
 `;

 const usersHtml = (state.adminUsers || []).slice(0, 100).map(user => `
 <tr class="hover:neu-raised/[0.01] transition-colors text-sm">
 <td class="px-4 py-3 font-semibold text-slate-900">${h(user.name)}</td>
 <td class="px-4 py-3 text-slate-600">${h(user.email)}</td>
 <td class="px-4 py-3">
 <span class="status-pill status-open capitalize">${h(user.role)}</span>
 </td>
 <td class="px-4 py-3 font-bold text-slate-700">
 ${money(user.balance ?? 0)}
 </td>
 <td class="px-4 py-3">
 <span class="status-pill ${user.kyc_status === 'approved' ? 'status-open' : user.kyc_status === 'pending' ? 'status-warn' : 'status-danger'} capitalize">${h(user.kyc_status || 'pending')}</span>
 </td>
 <td class="px-4 py-3 text-right">
 <div class="flex items-center justify-end gap-2">
 <button class="btn-secondary px-3 py-1 text-xs"data-toggle-kyc="${user.id}"data-current="${user.kyc_status}">
 ${user.kyc_status === 'approved' ? 'Reject KYC' : 'Approve KYC'}
 </button>
 <select class="input-control mt-0 py-1 text-xs max-w-24"data-change-role="${user.id}">
 <option value="freelancer"${user.role === 'freelancer' ? 'selected' : ''}>Freelancer</option>
 <option value="client"${user.role === 'client' ? 'selected' : ''}>Client</option>
 <option value="admin"${user.role === 'admin' ? 'selected' : ''}>Admin</option>
 </select>
 <button class="btn-ghost px-3 py-1 text-xs text-rose-700"onclick="window.adminForcePasswordChange(${user.id})">Password</button>
 ${user.role !== 'admin' ? `<button class="btn-primary px-3 py-1 text-xs"onclick="window.startImpersonation(${user.id})">Impersonate</button>` : ''}
 ${user.role !== 'admin' ? `<button class="btn-ghost px-3 py-1 text-xs text-rose-400 bg-rose-500/10 hover:bg-rose-500/20"onclick="window.adminDeleteUser(${user.id}, '${h(user.name)}')">Delete</button>` : ''}
 </div>
 </td>
 </tr>
 `).join('');

 const usersTable = `
 <section class="soft-panel p-5 col-span-full">
 <div class="flex items-center justify-between mb-4">
 <div>
 <p class="eyebrow">Platform Users</p>
 <h2 class="mt-1 text-base md:text-xl font-black">User Management Directory</h2>
 </div>
 <input type="text"id="admin-user-search"class="input-control w-full sm:w-64 m-0"placeholder="Search users..."oninput="window.filterAdminUsers()">
 </div>
 <div class="overflow-x-auto max-h-[500px] overflow-y-auto rounded-lg">
 <table class="w-full text-left border-collapse relative">
 <thead class="sticky top-0 neu-raised/90 backdrop-blur-md z-10">
 <tr class="text-xs font-semibold text-slate-600 uppercase tracking-wider">
 <th class="px-4 py-3">Name</th>
 <th class="px-4 py-3">Email</th>
 <th class="px-4 py-3">Role</th>
 <th class="px-4 py-3">Wallet Balance</th>
 <th class="px-4 py-3">KYC Status</th>
 <th class="px-4 py-3 text-right">Actions</th>
 </tr>
 </thead>
 <tbody id="admin-users-tbody">
 ${usersHtml || `<tr><td colspan="6"class="p-4 text-center text-slate-600">No users found.</td></tr>`}
 </tbody>
 </table>
 </div>
 </section>
 `;

 const contractsHtml = (state.adminContracts || []).slice(0, 100).map(c => `
 <tr class="hover:neu-raised/[0.01] transition-colors text-sm">
 <td class="px-4 py-3 font-semibold text-slate-900">#${c.id}</td>
 <td class="px-4 py-3 text-slate-600">${h(c.client?.name || 'Client')}</td>
 <td class="px-4 py-3 text-slate-600">${h(c.freelancer?.name || 'Freelancer')}</td>
 <td class="px-4 py-3 font-bold text-blue-700">${money(c.total_amount, c.currency)}</td>
 <td class="px-4 py-3">
 <span class="status-pill ${c.status === 'completed' ? 'status-open' : c.status === 'disputed' ? 'status-danger' : 'status-warn'} capitalize">${h(c.status)}</span>
 </td>
 <td class="px-4 py-3 text-right">
 <a href="#contracts/${c.id}"class="btn-secondary px-3 py-1 text-xs inline-block">Workspace</a>
 </td>
 </tr>
 `).join('');

 const contractsTable = `
 <section class="soft-panel p-5 col-span-full">
 <p class="eyebrow">Escrow Audits</p>
 <h2 class="mt-2 text-base md:text-xl font-black mb-4">Global Contracts Audit</h2>
 <div class="overflow-x-auto">
 <table class="w-full text-left border-collapse">
 <thead>
 <tr class="text-xs font-semibold text-slate-600 uppercase tracking-wider">
 <th class="px-4 py-3">Contract ID</th>
 <th class="px-4 py-3">Client</th>
 <th class="px-4 py-3">Freelancer</th>
 <th class="px-4 py-3">Amount</th>
 <th class="px-4 py-3">Status</th>
 <th class="px-4 py-3 text-right">Action</th>
 </tr>
 </thead>
 <tbody>
 ${contractsHtml || `<tr><td colspan="6"class="p-4 text-center text-slate-600">No active contracts found.</td></tr>`}
 </tbody>
 </table>
 </div>
 </section>
 `;

 const jobsHtml = (state.adminJobs || []).slice(0, 100).map(job => `
 <div class="admin-job-item flex items-center justify-between gap-4 p-4 rounded-2xl neu-raised hover:-translate-y-1 transition-all"data-client-name="${h(job.client?.name || `Client`)}">
 <div>
 <h3 class="font-bold text-slate-900">${h(job.title)}</h3>
 <p class="text-xs text-slate-600 mt-1">Client: ${h(job.client?.name || `Client`)} · Budget: <span class="text-blue-700 font-bold">${money(job.budget_min, job.currency)} - ${money(job.budget_max, job.currency)}</span></p>
 <p class="text-sm text-slate-600 mt-2 line-clamp-1">${h(job.description)}</p>
 </div>
 <button class="btn-ghost text-rose-400 hover:bg-rose-50/20 px-3 py-2 rounded-xl text-xs flex items-center gap-1"data-admin-delete-job="${job.id}">
 ${icon('trash')} Delete
 </button>
 </div>
 `).join(``);

 const jobsModerator = `
 <section class="soft-panel p-5 col-span-full">
 <p class="eyebrow">Listing Moderation</p>
 <div class="flex flex-col sm:flex-row sm:items-center justify-between mb-4 mt-2 gap-2">
 <h2 class="text-base md:text-xl font-black">Marketplace Jobs Moderator</h2>
 <input type="text"placeholder="Search by client name..."class="input-control sm:w-64 mt-0  text-base py-1.5"oninput="window.filterAdminJobs(this.value)">
 </div>
 <div class="space-y-3 max-h-[500px] overflow-y-auto pr-2 pb-2">
 ${jobsHtml || empty('No open marketplace jobs found for moderation.')}
 </div>
 </section>
 `;

 const withdrawalsHtml = (state.adminWithdrawals || []).map(w => `
 <tr class="hover:neu-raised/[0.01] transition-colors text-sm">
 <td class="px-4 py-3">
 <p class="font-semibold text-slate-900">${h(w.user?.name || 'User')}</p>
 <p class="text-xs text-slate-600">Balance: <span class="font-bold text-blue-700">${money(w.user?.balance ?? 0)}</span></p>
 </td>
 <td class="px-4 py-3 text-blue-700 font-bold">${money(w.amount, w.currency)}</td>
 <td class="px-4 py-3 text-slate-600 text-xs">${h(w.payout_method?.toUpperCase())} — ${h(w.payout_details)}</td>
 <td class="px-4 py-3"><span class="status-pill ${w.status === 'pending' ? 'status-warn' : w.status === 'approved' ? 'status-open' : 'status-danger'} capitalize">${h(w.status)}</span></td>
 <td class="px-4 py-3 text-right">
 ${w.status === 'pending' ? `<div class="flex items-center justify-end gap-2">
 <button class="btn-primary px-3 py-1 text-xs"data-approve-withdrawal="${w.id}">Approve</button>
 <button class="btn-ghost px-3 py-1 text-xs text-rose-700"data-reject-withdrawal="${w.id}">Reject</button>
 </div>` : '—'}
 </td>
 </tr>
 `).join('');

 const depositsHtml = (state.adminDeposits || []).map(d => `
 <tr class="hover:neu-raised/[0.01] transition-colors text-sm">
 <td class="px-4 py-3 font-semibold text-slate-900">${h(d.user?.name || 'User')}</td>
 <td class="px-4 py-3 text-blue-700 font-bold">${money(d.amount, d.currency)}</td>
 <td class="px-4 py-3 text-slate-600 text-xs font-mono">${h(d.gateway_reference || 'N/A')}</td>
 <td class="px-4 py-3"><span class="status-pill ${d.status === 'pending' ? 'status-warn' : d.status === 'completed' ? 'status-open' : 'status-danger'} capitalize">${h(d.status)}</span></td>
 <td class="px-4 py-3 text-right">
 ${d.status === 'pending' ? `<div class="flex items-center justify-end gap-2">
 <button class="btn-primary px-3 py-1 text-xs"data-approve-deposit="${d.id}">Approve</button>
 <button class="btn-ghost px-3 py-1 text-xs text-rose-700"data-reject-deposit="${d.id}">Reject</button>
 </div>` : '—'}
 </td>
 </tr>
 `).join('');

 const depositsTable = `
 <section class="soft-panel p-5 col-span-full">
 <p class="eyebrow">Manual UPI</p>
 <h2 class="mt-2 text-base md:text-xl font-black mb-4">Deposit Requests</h2>
 <div class="overflow-x-auto">
 <table class="w-full text-left border-collapse">
 <thead>
 <tr class="text-xs font-semibold text-slate-600 uppercase tracking-wider">
 <th class="px-4 py-3">User</th>
 <th class="px-4 py-3">Amount</th>
 <th class="px-4 py-3">UTR Number</th>
 <th class="px-4 py-3">Status</th>
 <th class="px-4 py-3 text-right">Actions</th>
 </tr>
 </thead>
 <tbody>
 ${depositsHtml || `<tr><td colspan="5"class="p-4 text-center text-slate-600">No deposit requests.</td></tr>`}
 </tbody>
 </table>
 </div>
 </section>
 `;

 const withdrawalsTable = `
 <section class="soft-panel p-5 col-span-full">
 <p class="eyebrow">Payouts</p>
 <h2 class="mt-2 text-base md:text-xl font-black mb-4">Withdrawal Requests</h2>
 <div class="overflow-x-auto">
 <table class="w-full text-left border-collapse">
 <thead>
 <tr class="text-xs font-semibold text-slate-600 uppercase tracking-wider">
 <th class="px-4 py-3">User</th>
 <th class="px-4 py-3">Amount</th>
 <th class="px-4 py-3">Payout Details</th>
 <th class="px-4 py-3">Status</th>
 <th class="px-4 py-3 text-right">Actions</th>
 </tr>
 </thead>
 <tbody>
 ${withdrawalsHtml || `<tr><td colspan="5"class="p-4 text-center text-slate-600">No withdrawal requests.</td></tr>`}
 </tbody>
 </table>
 </div>
 </section>
 `;

 const categoriesHtml = (state.adminCategories || []).map(cat => `
 <tr class="hover:neu-raised/[0.01] transition-colors text-sm">
 <td class="px-4 py-3 font-semibold text-slate-900">${h(cat.name)}</td>
 <td class="px-4 py-3 text-slate-600">${h(cat.description || '—')}</td>
 <td class="px-4 py-3 text-slate-600 text-center">${cat.jobs_count || 0}</td>
 <td class="px-4 py-3 text-right">
 <div class="flex items-center justify-end gap-2">
 <button class="btn-ghost px-3 py-1 text-xs text-blue-300"onclick="window.adminEditCategory(${cat.id})">Edit</button>
 <button class="btn-ghost px-3 py-1 text-xs text-rose-700"onclick="window.adminDeleteCategory(${cat.id})">Delete</button>
 </div>
 </td>
 </tr>
 `).join('');

 const categoriesTable = `
 <section class="soft-panel p-5 col-span-full">
 <div class="flex items-center justify-between mb-4">
 <div>
 <p class="eyebrow">Work Types</p>
 <h2 class="mt-2 text-base md:text-xl font-black">Work Categories</h2>
 </div>
 <button class="btn-primary"onclick="window.adminAddCategory()">Add Category</button>
 </div>
 <div class="overflow-x-auto">
 <table class="w-full text-left border-collapse">
 <thead>
 <tr class="text-xs font-semibold text-slate-600 uppercase tracking-wider">
 <th class="px-4 py-3">Name</th>
 <th class="px-4 py-3">Description</th>
 <th class="px-4 py-3 text-center">Jobs</th>
 <th class="px-4 py-3 text-right">Actions</th>
 </tr>
 </thead>
 <tbody>
 ${categoriesHtml || `<tr><td colspan="4"class="p-4 text-center text-slate-600">No categories found.</td></tr>`}
 </tbody>
 </table>
 </div>
 </section>
 `;

 const membershipsHtml = (state.adminMembershipPlans || []).map(plan => `
 <tr class="hover:neu-raised/[0.01] transition-colors text-sm">
 <td class="px-4 py-3 font-semibold text-slate-900">${h(plan.name)}</td>
 <td class="px-4 py-3 text-slate-600">${h(plan.slug)}</td>
 <td class="px-4 py-3 text-blue-700">${money(plan.price_monthly)}/mo</td>
 <td class="px-4 py-3 text-right">
 <div class="flex items-center justify-end gap-2">
 <button class="btn-ghost px-3 py-1 text-xs text-blue-300"onclick="window.adminEditMembershipPlan(${plan.id})">Edit</button>
 <button class="btn-ghost px-3 py-1 text-xs text-rose-700"onclick="window.adminDeleteMembershipPlan(${plan.id})">Delete</button>
 </div>
 </td>
 </tr>
 `).join('');

 const membershipPlansTable = `
 <section class="soft-panel p-5 col-span-full">
 <div class="flex items-center justify-between mb-4">
 <div>
 <p class="eyebrow">Subscriptions</p>
 <h2 class="mt-2 text-base md:text-xl font-black">Membership Plans</h2>
 </div>
 <button class="btn-primary"onclick="window.adminAddMembershipPlan()">Add Plan</button>
 </div>
 <div class="overflow-x-auto">
 <table class="w-full text-left border-collapse">
 <thead>
 <tr class="text-xs font-semibold text-slate-600 uppercase tracking-wider">
 <th class="px-4 py-3">Name</th>
 <th class="px-4 py-3">Slug</th>
 <th class="px-4 py-3">Price</th>
 <th class="px-4 py-3 text-right">Actions</th>
 </tr>
 </thead>
 <tbody>
 ${membershipsHtml || `<tr><td colspan="4"class="p-4 text-center text-slate-600">No membership plans found.</td></tr>`}
 </tbody>
 </table>
 </div>
 </section>
 `;

 // Default tab
 const currentTab = state.adminTab || 'overview';
 
 const tabs = [
 { id: 'overview', label: 'Overview', icon: 'dashboard' },
 { id: 'users', label: 'Users & KYC', icon: 'users' },
 { id: 'financials', label: 'Financials', icon: 'currency-dollar' },
 { id: 'escrow', label: 'Escrow & Audits', icon: 'briefcase' },
 { id: 'settings', label: 'Settings', icon: 'cog' },
 { id: 'ai-tracker', label: 'AI Usage Tracker', icon: 'sparkles' }
 ];

 const tabNav = `
 <div class="flex space-x-1 rounded-xl neu-raised/50 p-1 mb-6 overflow-x-auto hide-scrollbar">
 ${tabs.map(t => `
 <button 
 onclick="window.setAdminTab('${t.id}')"
 class="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-all whitespace-nowrap ${currentTab === t.id ? 'bg-blue-50 text-blue-700 ' : 'text-slate-600 hover:text-slate-700 hover:neu-raised'}"
 >
 ${t.label}
 </button>
 `).join('')}
 </div>
 `;
 const compactAiDashboard = `
 <section class="glass-panel p-4 md:p-6 rounded-3xl relative overflow-hidden bg-gradient-to-br from-slate-900 via-indigo-950 to-slate-900 border-indigo-500/20 mb-6 shadow-2xl shadow-indigo-900/20">
 <div class="absolute inset-0 bg-grid-indigo-500/[0.05] bg-[length:32px_32px]"></div>
 <div class="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent pointer-events-none"></div>
 
 <div class="relative z-10 flex flex-col xl:flex-row gap-6 h-full">
 <!-- Left side: Welcome & Input -->
 <div class="flex-1 flex flex-col justify-between space-y-6 xl: border-indigo-500/20 xl:pr-6">
 <div>
 <div class="flex items-center gap-3 mb-2">
 <div class="w-7 h-7 md:w-10 md:h-10 rounded-2xl bg-indigo-500/20 flex items-center justify-center border-indigo-500/30 shadow-[0_0_15px_rgba(99,102,241,0.2)]">
 ${icon('sparkles', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 text-indigo-400')}
 </div>
 <h2 class="text-2xl font-black text-white tracking-tight">Admin Co-Pilot</h2>
 <span class="px-2 py-0.5 rounded-full bg-indigo-500/20 text-indigo-300 text-[10px] font-bold border-indigo-500/30 uppercase tracking-widest animate-pulse">Online</span>
 </div>
 <p class="text-sm text-indigo-200/70 max-w-xl leading-relaxed">Your advanced AI assistant. I can analyze platform health, detect chat sentiment, ban users, or execute commands directly.</p>
 
 <!-- Suggestion Chips -->
 <div class="flex flex-wrap gap-2 mt-4">
 <button onclick="document.getElementById('ai-prompt-input').value='check_platform_health'; document.getElementById('ai-form').dispatchEvent(new Event('submit'))"class="text-xs px-3 py-1.5 rounded-full bg-indigo-500/10 hover:bg-indigo-500/20 border-indigo-500/20 text-indigo-300 transition-all hover:scale-105 active:scale-95 flex items-center gap-1.5">
 ${icon('heart', 'w-3 h-3')} Platform Health
 </button>
 <button onclick="document.getElementById('ai-prompt-input').value='analyze_chat_sentiment'; document.getElementById('ai-form').dispatchEvent(new Event('submit'))"class="text-xs px-3 py-1.5 rounded-full bg-indigo-500/10 hover:bg-indigo-500/20 border-indigo-500/20 text-indigo-300 transition-all hover:scale-105 active:scale-95 flex items-center gap-1.5">
 ${icon('chat-bubble-left-ellipsis', 'w-3 h-3')} Chat Sentiment
 </button>
 <button onclick="document.getElementById('ai-prompt-input').value='get_platform_stats'; document.getElementById('ai-form').dispatchEvent(new Event('submit'))"class="text-xs px-3 py-1.5 rounded-full bg-indigo-500/10 hover:bg-indigo-500/20 border-indigo-500/20 text-indigo-300 transition-all hover:scale-105 active:scale-95 flex items-center gap-1.5">
 ${icon('chart-bar', 'w-3 h-3')} Live Stats
 </button>
 </div>
 </div>
 
 <form id="ai-form"onsubmit="sendAdminAiCommand(event)"class="relative flex items-center max-w-xl group">
 <div class="absolute -inset-1 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
 <input id="ai-prompt-input"type="text"name="prompt"class="relative w-full bg-slate-900/90 border-indigo-500/30 text-indigo-100 placeholder-indigo-300/30 rounded-2xl py-3 pl-4 pr-12 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 -inner"placeholder="Ask me anything..."required autocomplete="off">
 <button type="submit"class="absolute right-2 p-2 text-indigo-400 hover:text-white transition-colors bg-indigo-500/10 rounded-xl hover:bg-indigo-500/40 border-transparent hover:border-indigo-400/50 group-focus-within:text-indigo-300">
 <svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 24 24"fill="currentColor"class="w-4 h-4"><path d="M3.478 2.404a.75.75 0 00-.926.941l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.404z"/></svg>
 </button>
 </form>
 </div>
 
 <!-- Right side: Mini Terminal Output -->
 <div class="flex-1 bg-[#0a0f1d] border-indigo-500/20 rounded-2xl p-4 flex flex-col h-64 xl:max-w-xl -[inset_0_0_20px_rgba(0,0,0,0.5)] relative overflow-hidden group">
 <div class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-indigo-500/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
 <div class="text-[10px] font-bold text-indigo-500/50 uppercase tracking-widest mb-3 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center border-indigo-500/10 pb-2">
 <span class="flex items-center gap-1.5">${icon('command-line', 'w-3 h-3')} System Terminal</span>
 <div class="flex gap-1.5">
 <div class="w-2.5 h-2.5 rounded-full bg-slate-800 border-rose-500/30"></div>
 <div class="w-2.5 h-2.5 rounded-full bg-slate-800 border-amber-500/30"></div>
 <div class="w-2.5 h-2.5 rounded-full bg-slate-800 border-emerald-500/50"></div>
 </div>
 </div>
 <div id="ai-chat-history"class="flex-1 overflow-y-auto text-sm space-y-3 font-mono text-emerald-400/90 hide-scrollbar break-words">
 <div class="opacity-70 flex gap-2">
 <span class="text-indigo-500">SYS></span> 
 <span>Connected to AdminAI v2.0...</span>
 </div>
 </div>
 </div>
 </div>
 </section>
 `;

 const overviewContent = `
 ${liveAnalyticsHtml}
 ${compactAiDashboard}
 <section class="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">${metric('Users', metrics.users ?? 0, 'Registered accounts')}${metric('Open jobs', metrics.open_jobs ?? 0, 'Marketplace demand')}${metric('Open disputes', metrics.open_disputes ?? openDisputes.length, 'Need resolution')}${metric('Gross funded', money(metrics.gross_funded), 'Escrow volume')}</section>
 
 <!-- System Tools -->
 <div class="mt-6 pt-6">
 <p class="eyebrow text-slate-600 mb-3">System Actions</p>
 <div class="flex flex-wrap gap-4">
 <button onclick="window.toggleMaintenance(true)"class="btn-secondary text-amber-800 bg-amber-50 border-amber-200 hover:bg-amber-100">🚧 Enable Maintenance</button>
 <button onclick="window.toggleMaintenance(false)"class="btn-secondary text-emerald-700 bg-emerald-50 border-emerald-200 hover:bg-emerald-100">✅ Disable Maintenance</button>
 <button onclick="window.clearServerCache()"class="btn-secondary text-blue-700 bg-blue-50 border-blue-200 hover:bg-blue-100">🧹 Clear Server Cache</button>
 </div>
 </div>

 <div class="grid gap-6 xl:grid-cols-2 mt-6">
 <section class="soft-panel p-5"><div class="flex items-center justify-between"><div><p class="eyebrow">Identity queue</p><h2 class="mt-2 text-base md:text-xl font-black">KYC reviews</h2></div><span class="status-pill ${pendingKyc.length ? 'status-warn' : 'status-open'}">${pendingKyc.length} pending</span></div><div class="mt-5 space-y-3">${pendingKyc.map(kycCard).join('') || empty('No pending KYC records.')}</div></section>
 <section class="soft-panel p-5"><div class="flex items-center justify-between"><div><p class="eyebrow">Trust & safety</p><h2 class="mt-2 text-base md:text-xl font-black">Disputes</h2></div><span class="status-pill ${openDisputes.length ? 'status-danger' : 'status-open'}">${openDisputes.length} open</span></div><div class="mt-5 space-y-3">${state.disputes.map(disputeCard).join('') || empty('No disputes found.')}</div></section>
 <section class="soft-panel p-5 col-span-full"><div class="flex items-center justify-between"><div><p class="eyebrow">Manual Payments Queue</p><h2 class="mt-2 text-base md:text-xl font-black">UPI QR Verification Requests</h2></div><span class="status-pill ${pendingPayments.length ? 'status-warn' : 'status-open'}">${pendingPayments.length} pending</span></div><div class="mt-5 space-y-3">${pendingPayments.map(paymentCard).join('') || empty('No pending UPI manual payments for review.')}</div></section>
 ${adminRevenueCharts()}
 ${adminSearchResultsSection()}
 <section class="soft-panel p-5 col-span-full"><div class="flex items-center justify-between"><p class="eyebrow">Admin search</p></div><input id="admin-search-input"class="input-control mt-3 w-full"placeholder="Search users, jobs, contracts..."></section>
 </div>
 `;

 const usersContent = `
 <div class="space-y-6">
 ${usersTable}
 </div>
 `;

 const financialsContent = `
 <div class="space-y-6">
 ${depositsTable}
 ${withdrawalsTable}
 </div>
 `;

 const escrowContent = `
 <div class="space-y-6">
 ${contractsTable}
 ${jobsModerator}
 </div>
 `;

 const settingsForm = `
 <section class="soft-panel p-5 col-span-full">
 <div class="flex items-center justify-between"><div><p class="eyebrow">Financial control</p><h2 class="mt-2 text-base md:text-xl font-black">Settings & Credentials</h2></div></div>
 <form id="admin-settings-form"class="mt-5 grid gap-4 sm:grid-cols-3">
 <label class="block text-sm font-semibold text-slate-600">Web Commission (%)<input class="input-control"name="commission_rate_web"type="number"step="0.1"min="0"max="100"value="${state.settings?.commission_rate_web || 15}"></label>
 <label class="block text-sm font-semibold text-slate-600">Mobile Commission (%)<input class="input-control"name="commission_rate_mobile"type="number"step="0.1"min="0"max="100"value="${state.settings?.commission_rate_mobile || 10}"></label>
 <label class="block text-sm font-semibold text-slate-600">Design Commission (%)<input class="input-control"name="commission_rate_design"type="number"step="0.1"min="0"max="100"value="${state.settings?.commission_rate_design || 12}"></label>
 <label class="block text-sm font-semibold text-slate-600">Manual UPI ID<input class="input-control"name="manual_upi_id"type="text"placeholder="payto@ssm"value="${state.settings?.manual_upi_id || ''}"></label>
 <label class="block text-sm font-semibold text-slate-600 sm:col-span-2">Manual UPI QR Image
 <div class="flex gap-2 items-center mt-1">
 <input class="input-control flex-1 mt-0"id="manual_upi_qr_url_input"name="manual_upi_qr_url"type="text"placeholder="https://example.com/qr.png"value="${state.settings?.manual_upi_qr_url || ''}">
 <input type="file"id="qr-upload-input"class="hidden"accept="image/*"onchange="window.uploadAdminQr(this)">
 <button type="button"class="btn-secondary whitespace-nowrap"onclick="document.getElementById('qr-upload-input').click()">Upload Image</button>
 </div>
 </label>
 <label class="block text-sm font-semibold text-slate-600 sm:col-span-3">Stripe Secret Key<input class="input-control"name="stripe_secret"type="password"placeholder="sk_test_..."value="${state.settings?.stripe_secret || ''}"></label>
 <label class="block text-sm font-semibold text-slate-600">Razorpay Key ID<input class="input-control"name="razorpay_key_id"type="text"placeholder="rzp_test_..."value="${state.settings?.razorpay_key_id || ''}"></label>
 <label class="block text-sm font-semibold text-slate-600 sm:col-span-2">Razorpay Key Secret<input class="input-control"name="razorpay_key_secret"type="password"placeholder="Key Secret Value"value="${state.settings?.razorpay_key_secret || ''}"></label>
 <label class="block text-sm font-semibold text-slate-600">Cashfree App ID<input class="input-control"name="cashfree_app_id"type="text"placeholder="CF App ID"value="${state.settings?.cashfree_app_id || ''}"></label>
 <label class="block text-sm font-semibold text-slate-600">Cashfree Secret Key<input class="input-control"name="cashfree_secret_key"type="password"placeholder="Secret Key Value"value="${state.settings?.cashfree_secret_key || ''}"></label>
 <label class="block text-sm font-semibold text-slate-600">Cashfree Mode<select class="input-control mt-0"name="cashfree_sandbox"><option value="1"${state.settings?.cashfree_sandbox === '1' ? 'selected' : ''}>Sandbox (Testing)</option><option value="0"${state.settings?.cashfree_sandbox === '0' ? 'selected' : ''}>Production (Live)</option></select></label>
 <button class="btn-primary sm:col-span-3 mt-4"type="submit">Save Dynamic Settings & Gateways</button>
 </form>
 </section>
 `;

 const ghostProfileManager = `
 <section class="soft-panel p-5">
 <div class="flex items-start justify-between">
 <div>
 <p class="eyebrow">Data Seeding</p>
 <h2 class="mt-2 text-base md:text-xl font-black mb-1">Ghost Profiles Management</h2>
 <p class="text-sm text-slate-600">Import or completely remove the 2,200 ghost freelancer profiles used for platform population.</p>
 </div>
 </div>
 <div class="mt-6 flex flex-wrap gap-4">
 <button class="btn-primary flex items-center gap-2 px-5 py-2.5 -teal-500/20 hover:-teal-500/30"onclick="window.importGhostProfiles()">
 ${icon('cloud_upload')}
 <span>Import Ghost Profiles</span>
 </button>
 <button class="btn-secondary flex items-center gap-2 px-5 py-2.5 text-rose-700 hover:text-rose-700 border-rose-200 hover:border-rose-500/40 hover:bg-rose-500/10"onclick="window.removeGhostProfiles()">
 ${icon('trash')}
 <span>Remove All Ghost Profiles</span>
 </button>
 </div>
 <div id="ghost-profile-status"class="mt-4 text-sm font-medium"></div>
 </section>
 `;



 const settingsContent = `
 <div class="space-y-6">
 ${ghostProfileManager}
 ${categoriesTable}
 ${membershipPlansTable}
 ${settingsForm}
 </div>
 `;

 const aiTrackerContent = `
 <section class="soft-panel p-5">
    <div class="flex items-center justify-between mb-5">
        <div>
            <p class="eyebrow">API Observability</p>
            <h2 class="mt-1 text-lg font-black">AI Key Usage Tracker</h2>
            <p class="text-xs text-slate-600">Live monitoring of API key rotations between Gemini and Groq.</p>
        </div>
        <div class="flex items-center gap-2">
            <button onclick="window.clearAiTrackerLogs()" class="btn-ghost px-3 py-1.5 text-xs flex items-center gap-2 text-rose-500 hover:text-rose-700">
                ${icon('trash', 'w-3 h-3')} Clear Logs
            </button>
            <button onclick="window.loadAiTrackerStats()" class="btn-secondary px-3 py-1.5 text-xs flex items-center gap-2">
                ${icon('refresh', 'w-3 h-3')} Refresh
            </button>
        </div>
    </div>
    <div id="ai-tracker-container" class="animate-pulse p-10 text-center text-slate-400 font-medium">
        Loading AI usage statistics...
    </div>
 </section>
 `;

 let activeContent = '';
 switch (currentTab) {
 case 'overview': activeContent = overviewContent; break;
 case 'users': activeContent = usersContent; break;
 case 'financials': activeContent = financialsContent; break;
 case 'escrow': activeContent = escrowContent; break;
 case 'settings': activeContent = settingsContent; break;
 case 'ai-tracker': activeContent = aiTrackerContent; break;
 }

 return `
 <div class="space-y-4">
 <section>
 <p class="eyebrow">Operations</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Admin command center</h1>
 <p class="mt-2 text-sm text-slate-600">Review identity, resolve escalations, and monitor platform health.</p>
 </section>
 
 ${tabNav}
 
 <div class="animate-in fade-in slide-in-from-bottom-2 duration-300">
 ${activeContent}
 </div>
 </div>
 `;
}

function paymentCard(payment) {
 const clientName = payment.milestone?.contract?.client?.name || 'Client';
 

 return `<article class="rounded-2xl neu-raised p-4"><div class="flex items-start justify-between gap-3"><div><p class="font-bold">Manual UPI Claim by ${h(clientName)}</p><p class="mt-1 text-xs text-slate-600">UTR: <span class="font-bold text-blue-700">${h(payment.gateway_reference)}</span> · Amount: <span class="font-bold">${money(payment.amount, payment.currency)}</span></p><p class="mt-1 text-xs text-slate-600">Milestone: ${h(payment.milestone?.title || 'Unknown')}</p></div><span class="status-pill status-warn">${h(payment.status)}</span></div><div class="mt-4 flex gap-2"><button class="btn-primary px-3 py-2 text-xs"data-review-payment="${payment.milestone_id}"data-contract-id="${payment.contract_id}"data-status="approved">Approve Payout</button><button class="btn-ghost px-3 py-2 text-xs text-rose-700"data-review-payment="${payment.milestone_id}"data-contract-id="${payment.contract_id}"data-status="rejected">Reject</button></div></article>`;
}

function kycCard(document) {
 if (!document) return '';
 return `<article class="neu-raised rounded-2xl p-5 relative hover:border-blue-200 hover:-translate-y-1 transition-all group overflow-hidden">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-start mb-4">
 <div>
 <span class="text-[10px] font-black uppercase tracking-widest text-slate-400 bg-slate-100 px-2 py-1 rounded-md">ID #${document.id}</span>
 <h3 class="font-bold text-slate-900 mt-2 capitalize">${h(document.document_type || 'Document')}</h3>
 <p class="text-xs text-slate-600 mt-1">Submitted: ${new Date(document.created_at).toLocaleDateString()}</p>
 ${document.user ? `<p class="text-xs font-semibold text-blue-700 mt-1 cursor-pointer"onclick="navigate('freelancers/${document.user.id}')">By: ${h(document.user.name)}</p>` : ''}
 </div>
 <span class="status-pill ${document.status === 'approved' ? 'status-open' : document.status === 'pending' ? 'status-warn' : 'status-danger'} capitalize">
 ${document.status === 'pending' ? '<span class="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse mr-1"></span>' : ''}
 ${h(document.status)}
 </span>
 </div>
 <div class="rounded-xl overflow-hidden neu-raised relative group cursor-pointer">
 <a href="${apiBase}/files/kyc/${document.id}?token=${localStorage.getItem('ssm_token') || ''}"target="_blank"class="block group relative">
 ${(document.file_path || '').toLowerCase().endsWith('.pdf') ? 
 `<div class="p-5 md:p-8 text-center bg-slate-100 text-slate-600 font-bold flex flex-col items-center justify-center h-40"><span>📄</span><span>PDF Document</span></div>` :
 `<img src="${apiBase}/files/kyc/${document.id}?token=${localStorage.getItem('ssm_token') || ''}"alt="KYC Document"class="w-full h-40 object-cover group-hover:opacity-80 transition-opacity">`
 }
 <div class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 bg-slate-900/40 transition-opacity">
 <span class="text-white text-xs font-bold bg-slate-900/80 px-3 py-1.5 rounded-lg backdrop-blur-sm">🔍 View Full Document</span>
 </div>
 </a>
 </div>
 ${document.status === 'pending' ? `<div class="mt-4 flex gap-2"><button class="btn-primary px-3 py-2 text-xs"data-review-kyc="${document.id}"data-status="approved">Approve</button><button class="btn-ghost px-3 py-2 text-xs text-rose-700"data-review-kyc="${document.id}"data-status="rejected">Reject</button></div>` : ''}</article>`;
}

function disputeCard(dispute) {
 

 return `<article class="rounded-2xl neu-raised p-4 relative">
 <div class="flex items-start justify-between gap-3">
 <div>
 <p class="font-bold">${h(dispute.reason)}</p>
 <p class="mt-1 text-xs text-slate-600">Contract #${dispute.contract_id} · Milestone #${dispute.milestone_id}</p>
 </div>
 <span class="status-pill ${dispute.status === 'open' ? 'status-danger' : 'status-muted'}">${h(dispute.status)}</span>
 </div>
 <p class="mt-3 text-sm leading-6 text-slate-600">${h(dispute.description)}</p>
 
 <div id="ai-verdict-${dispute.id}"class="hidden mt-4 p-4 bg-indigo-950/30 border-indigo-500/20 rounded-xl">
 <div class="flex items-center gap-2 mb-2 text-indigo-400">
 <svg class="w-4 h-4 animate-spin hidden spinner"xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"><circle class="opacity-25"cx="12"cy="12"r="10"stroke="currentColor"stroke-width="4"></circle><path class="opacity-75"fill="currentColor"d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
 <span class="text-sm font-bold verdict-title">AI Dispute Analysis</span>
 </div>
 <div class="text-sm text-slate-600 whitespace-pre-wrap verdict-content leading-relaxed"></div>
 </div>

 ${dispute.status === 'open' ? `<div class="mt-4 flex flex-wrap gap-2">
 <button class="btn-primary px-3 py-2 text-xs"data-resolve-dispute="${dispute.id}"data-resolution="release_freelancer">Release to freelancer</button>
 <button class="btn-ghost px-3 py-2 text-xs text-amber-800"data-resolve-dispute="${dispute.id}"data-resolution="refund_client">Refund client</button>
 <button class="btn-secondary px-3 py-2 text-xs border-indigo-500/30 text-indigo-400 hover:bg-indigo-500/10 transition-colors"onclick="window.generateAiVerdict(${dispute.id}, this)">✨ Generate AI Verdict</button>
 </div>` : `<p class="mt-3 text-xs text-slate-600">Resolution: ${h(dispute.resolution || 'Recorded')}</p>`}
 </article>`;
}

function emailSettingsSection() {
 return `<section class="soft-panel p-4 md:p-6 mt-6">
 <p class="eyebrow">Contact Details</p>
 <h2 class="mt-2 text-base md:text-xl font-black">Email Address</h2>
 <div class="mt-2 text-sm text-slate-600 mb-5">
 Current Email: <strong class="text-slate-900">${h(state.user.email)}</strong>
 ${state.user.pending_email ? `<br><span class="text-amber-800 text-xs font-bold mt-1 inline-block">Pending change to: ${h(state.user.pending_email)}</span>` : ''}
 </div>
 <form onsubmit="window.submitEmailChange(event)"class="grid gap-4 sm:grid-cols-2">
 <label class="block text-sm font-semibold text-slate-600">New Email Address<input class="input-control"type="email"name="new_email"required placeholder="new@example.com"></label>
 <div class="hidden sm:block"></div>
 <button class="btn-secondary sm:col-span-2"type="submit">Request Email Change</button>
 </form>
 </section>`;
}

window.submitEmailChange = async function(e) {
 e.preventDefault();
 const form = e.currentTarget;
 const formData = new FormData(form);
 
 const submitBtn = form.querySelector('button[type="submit"]');
 const ogText = submitBtn.innerHTML;
 submitBtn.innerHTML = 'Sending OTP...';
 submitBtn.disabled = true;

 try {
 await request('/auth/request-email-change', {
 method: 'POST',
 body: JSON.stringify({
 new_email: formData.get('new_email')
 })
 });
 alert('OTP sent to your new email. Please verify.');
 openModal('verify_email_change');
 } catch (err) {
 alert(err.message || 'Failed to request email change.');
 } finally {
 submitBtn.innerHTML = ogText;
 submitBtn.disabled = false;
 }
};

window.verifyEmailChange = async function(e) {
 e.preventDefault();
 const form = e.currentTarget;
 const formData = new FormData(form);
 
 const submitBtn = form.querySelector('button[type="submit"]');
 const ogText = submitBtn.innerHTML;
 submitBtn.innerHTML = 'Verifying...';
 submitBtn.disabled = true;

 try {
 const res = await request('/auth/verify-email-change', {
 method: 'POST',
 body: JSON.stringify({
 otp_code: formData.get('otp_code')
 })
 });
 state.user = res.user;
 localStorage.setItem('ssm_user', JSON.stringify(state.user));
 closeModal();
 alert('Email changed successfully!');
 render(); // Re-render profile page
 } catch (err) {
 alert(err.message || 'Failed to verify email change.');
 } finally {
 submitBtn.innerHTML = ogText;
 submitBtn.disabled = false;
 }
};

function passwordSettingsSection() {
 return `<section class="soft-panel p-4 md:p-6 mt-6">
 <p class="eyebrow">Security</p>
 <h2 class="mt-2 text-base md:text-xl font-black">Change password</h2>
 <form onsubmit="window.submitPasswordChange(event)"class="mt-5 grid gap-4 sm:grid-cols-2">
 <label class="block text-sm font-semibold text-slate-600">Current Password<input class="input-control"type="password"name="current_password"required></label>
 <div class="hidden sm:block"></div>
 <label class="block text-sm font-semibold text-slate-600">New Password<input class="input-control"type="password"name="new_password"required minlength="8"></label>
 <label class="block text-sm font-semibold text-slate-600">Confirm New Password<input class="input-control"type="password"name="new_password_confirmation"required minlength="8"></label>
 <button class="btn-primary sm:col-span-2"type="submit">Update password</button>
 </form>
 </section>`;
}

window.submitPasswordChange = async function(e) {
 e.preventDefault();
 const form = e.currentTarget;
 const formData = new FormData(form);
 
 if (formData.get('new_password') !== formData.get('new_password_confirmation')) {
 alert('New passwords do not match!');
 return;
 }
 
 const submitBtn = form.querySelector('button[type="submit"]');
 const ogText = submitBtn.innerHTML;
 submitBtn.innerHTML = 'Updating...';
 submitBtn.disabled = true;

 try {
 await request('/profile/password', {
 method: 'PUT',
 body: JSON.stringify({
 current_password: formData.get('current_password'),
 new_password: formData.get('new_password')
 })
 });
 form.reset();
 alert('Password updated successfully!');
 } catch (err) {
 alert(err.message || 'Failed to update password.');
 } finally {
 submitBtn.innerHTML = ogText;
 submitBtn.disabled = false;
 }
};

function profilePage() {
 const role = state.user.role;
 const freelancer = role === 'freelancer';
 const isClient = role === 'client';
 const isAdmin = role === 'admin';

 if (isAdmin) {
 return `<div class="mx-auto max-w-3xl space-y-6">
 <section>
 <p class="eyebrow">System account</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Admin account settings</h1>
 <p class="mt-2 text-sm text-slate-600">Manage your admin identity. Payment, membership and portfolio features are user-facing only.</p>
 </section>
 <section class="soft-panel p-6 sm:p-8">
 <div class="flex flex-col gap-5 sm:flex-row sm:items-center">
 ${avatar(state.user, 'h-16 w-16 text-2xl rounded-2xl')}
 <div>
 <h2 class="text-base md:text-xl font-black">${h(state.user.name)}</h2>
 <p class="text-sm text-slate-600">${h(state.user.email)}</p>
 <span class="status-pill status-open mt-2">administrator</span>
 </div>
 </div>
 <div class="mt-6 grid gap-3 sm:grid-cols-3">
 <div class="rounded-2xl neu-raised p-4"><p class="text-xs text-slate-600">Role</p><p class="mt-1 font-bold text-blue-700">Admin (God mode)</p></div>
 <div class="rounded-2xl neu-raised p-4"><p class="text-xs text-slate-600">Last login</p><p class="mt-1 font-bold">${new Date().toLocaleDateString()}</p></div>
 <div class="rounded-2xl neu-raised p-4"><p class="text-xs text-slate-600">Permissions</p><p class="mt-1 font-bold">All access</p></div>
 </div>
 </section>
 <section class="soft-panel p-4 md:p-6">
 <p class="eyebrow">Personal Details</p>
 <h2 class="mt-2 text-base md:text-xl font-black">Account settings</h2>
 <form id="user-profile-form"class="mt-5 grid gap-4 sm:grid-cols-2">
 <label class="block text-sm font-semibold text-slate-600">Name<input class="input-control"name="name"value="${h(state.user.name || '')}"required></label>
 <label class="block text-sm font-semibold text-slate-600">Phone Number<input class="input-control"name="phone"value="${h(state.user.phone || '')}"placeholder="+1 (555) 000-0000"></label>
 <label class="sm:col-span-2 block text-sm font-semibold text-slate-600">Avatar URL<input class="input-control"name="avatar_url"type="url"value="${h(state.user.avatar_url || '')}"placeholder="https://example.com/avatar.png"></label>
 <button class="btn-primary sm:col-span-2"type="submit">Save account details</button>
 </form>
 </section>
 ${passwordSettingsSection()}
 ${emailSettingsSection()}
 <div class="rounded-2xl border-amber-400/20 bg-amber-950/20 p-5 mt-6">
 <p class="font-bold flex items-center gap-1.5 text-amber-800">${icon('warning', 'w-3 h-3 md:w-4 md:h-4')} Admin note</p>
 <p class="mt-2 text-sm text-slate-600">Wallet, membership plans, referrals, portfolio and client profile are <strong>user-facing features only</strong>. To manage those, go to <a href="#admin"class="text-blue-700 hover:underline">Admin center</a>.</p>
 </div>
 </div>`;
 }

 const profile = state.freelancerProfile || {};
 const reviews = state.freelancerReviews || {};
 const reviewRows = reviews.reviews?.data || [];
 const documents = state.kycDocuments || [];
 
 const agenciesHtml = freelancer ? `
 <section class="soft-panel p-6 sm:p-8 mt-6">
 <div class="flex items-center justify-between">
 <div>
 <p class="eyebrow">Agencies</p>
 <h2 class="mt-1 text-base md:text-xl font-black">My Agencies</h2>
 </div>
 <button class="btn-primary px-3 py-1.5 text-xs"data-open-modal="create_agency">Create Agency</button>
 </div>
 <div class="mt-5 grid gap-4 sm:grid-cols-2">
 ${state.agencies && state.agencies.length > 0 ? state.agencies.map(agency => `
 <div class="rounded-2xl neu-raised p-5 relative border border-transparent hover:border-blue-300 transition-colors">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-start">
 <h3 class="font-bold text-lg">${h(agency.name)}</h3>
 <span class="status-pill ${agency.owner_id === state.user.id ? 'status-open' : 'status-muted'}">${agency.owner_id === state.user.id ? 'Owner' : 'Member'}</span>
 </div>
 <p class="mt-2 text-sm text-slate-600 line-clamp-2">${h(agency.description || 'No description.')}</p>
 <button class="btn-primary w-full text-xs py-2 mt-4" onclick="window.manageAgency(${agency.id})">Manage / View Agency</button>
 ${agency.owner_id === state.user.id ? `<div class="grid grid-cols-2 gap-2 mt-4"><button class="btn-secondary w-full text-xs py-2"data-open-modal="invite_agency_member"data-agency-id="${agency.id}">Invite Member</button><button class="btn-secondary border-rose-200 text-rose-700 hover:bg-rose-50 w-full text-xs py-2"onclick="window.deleteAgency(${agency.id})">Delete Agency</button></div>` : ''}
 </div>
 `).join('') : '<p class="text-sm text-slate-600 col-span-2">You are not part of any agencies.</p>'}
 </div>
 </section>
 ` : '';

 return `<div class="mx-auto max-w-5xl space-y-6"><section><p class="eyebrow">Identity & reputation</p><h1 class="mt-2 text-xl md:text-3xl font-black">Profile & settings</h1><p class="mt-2 text-sm text-slate-600">Keep your professional profile current and build trust with every completed project.</p></section><section class="soft-panel p-6 sm:p-8"><div class="flex flex-col gap-5 sm:flex-row sm:items-center">${avatar(state.user, 'h-16 w-16 text-2xl rounded-2xl')}<div><h2 class="text-base md:text-xl font-black">${h(state.user.name)}</h2><p class="text-sm text-slate-600">${h(state.user.email)}</p><span class="status-pill status-open mt-2">${h(state.user.role)}</span></div></div><dl class="mt-8 grid gap-4 sm:grid-cols-2 ${freelancer ? 'lg:grid-cols-4' : ''}"><div class="rounded-2xl neu-raised p-4"><dt class="text-xs text-slate-600">KYC status</dt><dd class="mt-1 font-bold">${titleCase(state.user.kyc_status || 'pending')}</dd></div><div class="rounded-2xl neu-raised p-4"><dt class="text-xs text-slate-600">Verification</dt><dd class="mt-1 font-bold">${state.user.verified_badge ? 'Verified badge active' : 'Not yet verified'}</dd></div>${freelancer ? `<div class="rounded-2xl neu-raised p-4"><dt class="text-xs text-slate-600">Rating</dt><dd class="mt-1 font-bold">${Number(reviews.average_rating || 0).toFixed(1)} / 5</dd></div><div class="rounded-2xl neu-raised p-4"><dt class="text-xs text-slate-600">Reviews</dt><dd class="mt-1 font-bold">${reviews.review_count || 0}</dd></div>` : ''}</dl>${!state.user.kyc_status || state.user.kyc_status === 'rejected' ? `<button class="btn-primary mt-6"data-open-modal="kyc">Submit KYC details</button>` : ''}</section><section class="soft-panel p-4 md:p-6"><p class="eyebrow">Personal Details</p><h2 class="mt-2 text-base md:text-xl font-black">Account settings</h2><form id="user-profile-form"class="mt-5 grid gap-4 sm:grid-cols-2"><label class="block text-sm font-semibold text-slate-600">Name<input class="input-control"name="name"value="${h(state.user.name || '')}"required></label><label class="block text-sm font-semibold text-slate-600"><div class="flex items-center justify-between mb-1"><span>Phone Number</span><span class="text-[9px] font-black text-rose-500 uppercase tracking-widest bg-rose-50 px-2 py-0.5 rounded-full animate-pulse border-rose-200">⚠️ Required for verification</span></div><input class="input-control"name="phone"value="${h(state.user.phone || '')}"placeholder="+91 XXXXXXXXXX"></label><label class="sm:col-span-2 block text-sm font-semibold text-slate-600">Avatar URL<input class="input-control"name="avatar_url"type="url"value="${h(state.user.avatar_url || '')}"placeholder="https://example.com/avatar.png"></label><button class="btn-primary sm:col-span-2"type="submit">Save personal details</button></form></section>
${passwordSettingsSection()}
${emailSettingsSection()}
${freelancer ? `${agenciesHtml}
${portfolioSection()}
<section class="grid gap-6 lg:grid-cols-[1.1fr_.9fr]">
<section class="soft-panel p-4 md:p-6">
<div class="flex items-center justify-between"><div><p class="eyebrow">Portfolio</p><h2 class="mt-2 text-base md:text-xl font-black">Professional profile</h2></div><span class="status-pill status-muted">${profile.skills?.length || 0} skills</span></div><form id="freelancer-profile-form"class="mt-5 grid gap-4"><label class="block text-sm font-semibold">Headline<input class="input-control"name="headline"value="${h(profile.headline || '')}"maxlength="180"placeholder="Full-stack Laravel developer"></label><label class="block text-sm font-semibold"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center mb-1"><span>Bio</span><button type="button"class="btn-ai"onclick="window.optimizeProfileBio(this)">✨ Optimize with AI</button></div><textarea class="input-control min-h-28"name="bio"id="profile-bio-input"maxlength="5000"placeholder="Tell clients what you build best.">${h(profile.bio || '')}</textarea></label><label class="block text-sm font-semibold">Skills <span class="text-slate-600">(comma separated)</span><input class="input-control"name="skills"id="profile-skills-input"value="${h((profile.skills || []).join(', '))}"placeholder="Laravel, Vue, Product design"></label><div class="grid gap-4 sm:grid-cols-2"><label class="block text-sm font-semibold">Hourly rate<input class="input-control"name="hourly_rate"type="number"min="0"value="${h(profile.hourly_rate || '')}"></label><label class="block text-sm font-semibold">Currency<input class="input-control"name="currency"value="${h(profile.currency || 'INR')}"maxlength="3"></label></div><div class="grid gap-4 sm:grid-cols-2"><label class="block text-sm font-semibold">Razorpay Account ID<input class="input-control"name="razorpay_account_id"value="${h(profile.razorpay_account_id || '')}"placeholder="acc_12345"></label><label class="block text-sm font-semibold">Stripe Account ID<input class="input-control"name="stripe_account_id"value="${h(profile.stripe_account_id || '')}"placeholder="acct_12345"></label></div><label class="block text-sm font-semibold">GitHub URL<input class="input-control"name="github_url"type="url"value="${h(profile.github_url || '')}"placeholder="https://github.com/..."></label><label class="block text-sm font-semibold">Behance URL<input class="input-control"name="behance_url"type="url"value="${h(profile.behance_url || '')}"placeholder="https://behance.net/..."></label><label class="block text-sm font-semibold">Play Store URL<input class="input-control"name="play_store_url"type="url"value="${h(profile.play_store_url || '')}"placeholder="https://play.google.com/..."></label><button class="btn-primary"type="submit">Save professional profile</button></form></section><div class="space-y-6"><section class="soft-panel p-4 md:p-6"><p class="eyebrow">Earnings</p><h2 class="mt-2 text-base md:text-xl font-black">Payout overview</h2><div class="mt-5 grid gap-3"><div class="rounded-2xl neu-raised p-4"><p class="text-xs text-slate-600">Gross payout</p><p class="mt-1 text-2xl font-black">${money(state.analytics?.gross_payout)}</p></div><div class="rounded-2xl neu-raised p-4"><p class="text-xs text-slate-600">Platform commission</p><p class="mt-1 text-base md:text-xl font-bold">${money(state.analytics?.platform_commission)}</p></div></div>${earningsSvgChart()}<div class="mt-4 rounded-2xl border-blue-200 bg-blue-50 p-4">${profile.spotlight_until && new Date(profile.spotlight_until) > new Date() ? `<p class="text-sm font-bold text-blue-700">✦ Spotlighted until ${new Date(profile.spotlight_until).toLocaleDateString()}</p><p class="text-xs text-slate-600 mt-1">Your profile is boosted to the top of the directory!</p>` : `<p class="text-sm font-bold text-blue-700">✦ Get Spotlighted</p><p class="text-xs text-slate-600 mt-1 mb-3">Appear at the top of the Freelancer Directory for 7 days.</p><button onclick="window.spotlightMe()"class="btn-secondary text-xs text-blue-700 border-blue-200 hover:bg-teal-400/10">✦ Spotlight Me — ₹499</button>`}</div></section><section class="soft-panel p-4 md:p-6"><p class="eyebrow">Verification history</p><h2 class="mt-2 text-base md:text-xl font-black">KYC documents</h2><div class="mt-5 space-y-3">${documents.map((document) => `<div class="flex items-center justify-between gap-3 rounded-xl neu-raised p-3"><div><p class="font-semibold">${h(titleCase(document.type))}</p><p class="text-xs text-slate-600">${h(document.document_number || 'No document number')}</p></div><span class="status-pill ${document.status === 'approved' ? 'status-open' : document.status === 'pending' ? 'status-warn' : 'status-danger'}">${h(document.status)}</span></div>`).join('') || `<p class="text-sm text-slate-600">No KYC documents submitted yet.</p>`}</div></section></div></section>
${notificationPrefsSection()}
<section class="soft-panel p-4 md:p-6"><div class="flex items-center justify-between"><div><p class="eyebrow">Client feedback</p><h2 class="mt-2 text-base md:text-xl font-black">Reviews</h2></div><span class="status-pill status-open">${Number(reviews.average_rating || 0).toFixed(1)} average</span></div><div class="mt-5 grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">${reviewRows.map((review) => `<article class="rounded-2xl neu-raised p-4">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 gap-3">
 <p class="font-bold">${h(review.reviewer?.name || 'Client')}</p>
 <span class="text-amber-800">${icon('star', 'w-3 h-3 inline-block text-amber-800').repeat(Number(review.rating || 0))}</span>
 </div>
 <div class="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 text-[10px] text-slate-600">
 ${review.quality_rating ? `<div>Quality: ${review.quality_rating}/5</div>` : ''}
 ${review.communication_rating ? `<div>Communication: ${review.communication_rating}/5</div>` : ''}
 ${review.expertise_rating ? `<div>Expertise: ${review.expertise_rating}/5</div>` : ''}
 ${review.professionalism_rating ? `<div>Professionalism: ${review.professionalism_rating}/5</div>` : ''}
 </div>
 <p class="mt-3 text-sm leading-6 text-slate-600">${h(review.comment || 'No written comment.')}</p>
</article>`).join('') || empty('No reviews yet. Complete a contract to build your reputation.')}</div></section></div>` : `${clientProfileSection()}${notificationPrefsSection()}</div>`}`;
}


function empty(message) { 

 return `<div class="col-span-full rounded-2xl border-dashed p-5 md:p-8 text-center text-sm text-slate-600">${h(message)}</div>`; }

function modalView() {
 if (!state.modal) return '';
 const close = `<button class="btn-ghost"data-close-modal aria-label="Close dialog">${icon('close')}</button>`;
 
 if (typeof state.modal === 'object') {
 return `<div class="fixed inset-0 z-50 grid place-items-center overflow-y-auto neu-raised/80 p-4 backdrop-blur-sm"><section role="dialog"aria-modal="true"class="glass-panel my-8 w-full max-w-xl rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0"><h2 class="text-2xl font-black">${h(state.modal.title)}</h2>${close}</div><div class="mt-6">${state.modal.content}</div></section></div>`;
 }
 
 if (state.modal === 'verify_email_change') {
 return `<div class="fixed inset-0 z-50 grid place-items-center overflow-y-auto neu-raised/80 p-4 backdrop-blur-sm"><section role="dialog"aria-modal="true"class="glass-panel w-full max-w-md rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center mb-6"><h2 class="text-base md:text-xl font-black">Verify Email Change</h2>${close}</div><form onsubmit="window.verifyEmailChange(event)"class="grid gap-4"><p class="text-sm text-slate-600 mb-2">We sent a 6-digit OTP to your new email address.</p><label class="text-sm font-semibold">OTP Code<input class="input-control text-center text-2xl tracking-widest font-mono"name="otp_code"type="text"required maxlength="6"pattern="\\d{6}"placeholder="------"></label><div class="flex justify-end mt-2"><button type="submit"class="btn-primary w-full py-3">Verify & Update Email</button></div></form></section></div>`;
 }

 if (state.modal === 'create_task') {
 return `<div class="fixed inset-0 z-50 grid place-items-center overflow-y-auto neu-raised/80 p-4 backdrop-blur-sm"><section role="dialog"aria-modal="true"class="glass-panel w-full max-w-md rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center mb-6"><h2 class="text-base md:text-xl font-black">Add New Task</h2>${close}</div><form onsubmit="window.createTask(event)"class="grid gap-4"><label class="text-sm font-semibold">Task Title<input class="input-control"name="title"required maxlength="255"></label><label class="text-sm font-semibold">Description<textarea class="input-control min-h-24"name="description"></textarea></label><div class="flex justify-end mt-2"><button type="submit"class="btn-primary">Create Task</button></div></form></section></div>`;
 }

 if (state.modal === 'job')

 return `<div class="fixed inset-0 z-50 grid place-items-center overflow-y-auto neu-raised/80 p-4 backdrop-blur-sm"><section role="dialog"aria-modal="true"class="glass-panel my-8 w-full max-w-2xl rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0"><div><p class="eyebrow">Client brief</p><h2 class="mt-2 text-2xl font-black">Post a new job</h2></div>${close}</div><form id="job-form"class="mt-6 grid gap-4 sm:grid-cols-2"><label class="sm:col-span-2 text-sm font-semibold">Title<input class="input-control"name="title"required maxlength="180"></label><label class="sm:col-span-2 text-sm font-semibold"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center mb-1"><span>Description</span><button type="button"class="btn-ai"onclick="window.enhanceJobDescription(this)">✨ Enhance with AI</button></div><textarea class="input-control min-h-32"name="description"id="job-description-input"required></textarea></label><label class="text-sm font-semibold">Category<select class="input-control"name="category"><option value="web">Web</option><option value="mobile">Mobile</option><option value="design">Design</option></select></label><label class="text-sm font-semibold">Deadline<input class="input-control"name="deadline"type="date"></label>
 <label class="text-sm font-semibold">Payment Type
 <select class="input-control"name="payment_type"onchange="document.getElementById('weekly_limit_container').classList.toggle('hidden', this.value !== 'hourly')">
 <option value="fixed">Fixed Price</option>
 <option value="hourly">Hourly Rate</option>
 </select>
 </label>
 <label id="weekly_limit_container"class="text-sm font-semibold hidden">Weekly Limit (Hours)
 <input class="input-control"name="weekly_limit"type="number"min="1"max="168"placeholder="e.g. 40">
 </label>
 <label class="text-sm font-semibold">Minimum budget/rate
 <input class="input-control"name="budget_min"type="number"min="0"required>
 </label>
 <label class="text-sm font-semibold">Maximum budget/rate
 <input class="input-control"name="budget_max"type="number"min="0"required>
 </label>
<label class="sm:col-span-2 text-sm font-semibold">Skills <span class="text-slate-600">(comma separated)</span><input class="input-control"name="skills"placeholder="Laravel, Tailwind, UX"></label><div class="sm:col-span-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-2">
 <label class="group relative flex cursor-pointer flex-col gap-3 rounded-2xl neu-raised p-4 transition-all hover:bg-slate-50 has-[:checked]:ring-2 has-[:checked]:ring-amber-500 has-[:checked]:bg-amber-50/30">
 <div class="flex items-start justify-between">
 <div class="flex flex-col">
 <span class="text-sm font-black tracking-tight text-slate-900">⭐ Featured</span>
 <span class="mt-1.5 w-fit rounded bg-amber-100/80 px-2 py-0.5 text-[10px] font-black uppercase tracking-widest text-amber-800">49 COINS</span>
 </div>
 <input type="checkbox" name="is_featured" value="1" class="peer sr-only">
 <div class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-slate-300 bg-white transition-all peer-checked:border-amber-500 peer-checked:bg-amber-500">
 <svg class="h-3 w-3 text-white opacity-0 transition-opacity peer-checked:opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
 </div>
 </div>
 <p class="text-[11px] text-slate-600 font-medium leading-snug">Get more views and proposals by pinning your job.</p>
 </label>
 <label class="group relative flex cursor-pointer flex-col gap-3 rounded-2xl neu-raised p-4 transition-all hover:bg-slate-50 has-[:checked]:ring-2 has-[:checked]:ring-rose-500 has-[:checked]:bg-rose-50/30">
 <div class="flex items-start justify-between">
 <div class="flex flex-col">
 <span class="text-sm font-black tracking-tight text-slate-900">⚡ Urgent</span>
 <span class="mt-1.5 w-fit rounded bg-rose-100/80 px-2 py-0.5 text-[10px] font-black uppercase tracking-widest text-rose-700">29 COINS</span>
 </div>
 <input type="checkbox" name="is_urgent" value="1" class="peer sr-only">
 <div class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-slate-300 bg-white transition-all peer-checked:border-rose-500 peer-checked:bg-rose-500">
 <svg class="h-3 w-3 text-white opacity-0 transition-opacity peer-checked:opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
 </div>
 </div>
 <p class="text-[11px] text-slate-600 font-medium leading-snug">Mark as urgent to attract freelancers faster.</p>
 </label>
 <label class="group relative flex cursor-pointer flex-col gap-3 rounded-2xl neu-raised p-4 transition-all hover:bg-slate-50 has-[:checked]:ring-2 has-[:checked]:ring-teal-500 has-[:checked]:bg-teal-50/30">
 <div class="flex items-start justify-between">
 <div class="flex flex-col">
 <span class="text-sm font-black tracking-tight text-slate-900">🛡️ Private</span>
 <span class="mt-1.5 w-fit rounded bg-teal-100/80 px-2 py-0.5 text-[10px] font-black uppercase tracking-widest text-teal-700">79 COINS</span>
 </div>
 <input type="checkbox" name="is_private" value="1" class="peer sr-only">
 <div class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-slate-300 bg-white transition-all peer-checked:border-teal-500 peer-checked:bg-teal-500">
 <svg class="h-3 w-3 text-white opacity-0 transition-opacity peer-checked:opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
 </div>
 </div>
 <p class="text-[11px] text-slate-600 font-medium leading-snug">Hide your job details from search engines and non-users.</p>
 </label>
 <label class="group relative flex cursor-pointer flex-col gap-3 rounded-2xl neu-raised p-4 transition-all hover:bg-slate-50 has-[:checked]:ring-2 has-[:checked]:ring-slate-500 has-[:checked]:bg-slate-100/50">
 <div class="flex items-start justify-between">
 <div class="flex flex-col">
 <span class="text-sm font-black tracking-tight text-slate-900">🔒 Sealed</span>
 <span class="mt-1.5 w-fit rounded bg-slate-200/80 px-2 py-0.5 text-[10px] font-black uppercase tracking-widest text-slate-700">15 COINS</span>
 </div>
 <input type="checkbox" name="is_sealed" value="1" class="peer sr-only">
 <div class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-slate-300 bg-white transition-all peer-checked:border-slate-500 peer-checked:bg-slate-500">
 <svg class="h-3 w-3 text-white opacity-0 transition-opacity peer-checked:opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
 </div>
 </div>
 <p class="text-[11px] text-slate-600 font-medium leading-snug">Keep all freelancer bids hidden from each other.</p>
 </label>
</div>
<div class="sm:col-span-2 text-xs text-slate-600 mt-1 bg-blue-50 p-4 rounded-xl border border-blue-100 leading-relaxed">
    <p>Standard jobs cost <strong class="text-slate-900">0 coins</strong>. We only charge you coins if you choose to upgrade your job post's design, ranking, urgency, or privacy.</p>
    <p class="mt-2 text-sm">💰 You currently have <strong class="text-amber-800 font-black">${state.user?.balance || 0} Coins</strong>. <br> <span class="text-teal-700 font-bold">Pro Tip:</span> Select all 4 premium features to unlock the Ultimate Bundle for exactly 99 Coins!</p>
</div>
<button class="btn-primary sm:col-span-2"type="submit">Publish job</button></form></section></div>`;
 
 if (state.modal === 'create_agency') {
 return `<div class="fixed inset-0 z-50 grid place-items-center neu-raised/80 p-4"><section class="glass-panel w-full max-w-sm rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0"><h2>Create Agency</h2>${close}</div><form id="create-agency-form"class="mt-4 space-y-4">
 <label class="block text-sm">Agency Name<input class="input-control"type="text"name="name"required maxlength="100"></label>
 <label class="block text-sm">Description<textarea class="input-control"name="description"></textarea></label>
 <button class="btn-primary w-full"type="submit">Create Agency</button>
 </form></section></div>`;
 }
 if (state.modal === 'manage_agency') {
  const agency = state.agencies.find(a => a.id == state.manageAgencyId);
  if (!agency) return '';
  const isOwner = agency.owner_id === state.user.id;
  
  return `<div class="fixed inset-0 z-50 grid place-items-center neu-raised/80 p-4"><section class="glass-panel w-full max-w-md rounded-3xl p-4 md:p-6 max-h-[90vh] overflow-y-auto"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center mb-6"><h2>Manage Agency</h2>${close}</div>
  
  ${isOwner ? `
  <form id="update-agency-form" class="space-y-4 mb-8">
    <input type="hidden" name="agency_id" value="${agency.id}">
    <label class="block text-sm font-semibold">Logo URL<input class="input-control mt-1" type="url" name="logo_url" value="${h(agency.logo_url || '')}"></label>
    <label class="block text-sm font-semibold">Description<textarea class="input-control mt-1" name="description">${h(agency.description || '')}</textarea></label>
    <button class="btn-primary w-full" type="submit">Update Agency Info</button>
  </form>
  ` : `
  <div class="mb-8">
    <p class="font-bold">Description</p>
    <p class="text-sm text-slate-600">${h(agency.description || 'No description.')}</p>
  </div>
  `}
  
  <h3 class="font-bold text-lg mb-3 border-b pb-2">Team Members (${agency.members ? agency.members.length : 1})</h3>
  <div class="space-y-3">
    ${agency.owner ? `
    <div class="flex items-center justify-between p-3 bg-slate-50 rounded-xl">
      <div>
        <p class="font-bold text-sm">${h(agency.owner.name)}</p>
        <p class="text-xs text-slate-600">Owner</p>
      </div>
    </div>
    ` : ''}
    
    ${agency.members ? agency.members.filter(m => m.pivot.status === 'active' && m.id !== agency.owner_id).map(member => `
    <div class="flex items-center justify-between p-3 bg-slate-50 rounded-xl">
      <div>
        <p class="font-bold text-sm">${h(member.name)}</p>
        <p class="text-xs text-slate-600">Member</p>
      </div>
      ${isOwner ? `<button class="text-xs text-rose-500 hover:text-rose-700" onclick="window.removeAgencyMember(${agency.id}, ${member.id})">Remove</button>` : ''}
    </div>
    `).join('') : ''}
    
    ${agency.members && isOwner ? agency.members.filter(m => m.pivot.status === 'pending').map(member => `
    <div class="flex items-center justify-between p-3 bg-amber-50 rounded-xl opacity-75">
      <div>
        <p class="font-bold text-sm">${h(member.name)}</p>
        <p class="text-[10px] text-amber-800 font-bold uppercase tracking-widest mt-1">Pending Invite</p>
      </div>
      <button class="text-xs text-rose-500 hover:text-rose-700" onclick="window.removeAgencyMember(${agency.id}, ${member.id})">Cancel Invite</button>
    </div>
    `).join('') : ''}
  </div>
  
  </section></div>`;
  }
 if (state.modal === 'invite_agency_member') {
 return `<div class="fixed inset-0 z-50 grid place-items-center neu-raised/80 p-4"><section class="glass-panel w-full max-w-sm rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0"><h2>Invite Member</h2>${close}</div><form id="invite-agency-form"class="mt-4 space-y-4">
 <input type="hidden"name="agency_id"value="${state.inviteAgencyId || ''}">
 <label class="block text-sm">User Email<input class="input-control"type="email"name="email"required></label>
 <button class="btn-primary w-full"type="submit">Send Invite</button>
 </form></section></div>`;
 }

 if (state.modal === 'log_time') {
 

 return `<div class="fixed inset-0 z-50 grid place-items-center neu-raised/80 p-4"><section class="glass-panel w-full max-w-sm rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0"><h2>Log Time</h2>${close}</div><form id="log-time-form"class="mt-4 space-y-4">
 <label class="block text-sm">Date<input class="input-control"type="date"name="logged_date"required></label>
 <label class="block text-sm">Hours (0.1 - 24)<input class="input-control"type="number"step="0.1"min="0.1"max="24"name="hours"required></label>
 <label class="block text-sm">Memo<textarea class="input-control"name="memo"></textarea></label>
 <button class="btn-primary w-full"type="submit">Submit Hours</button>
 </form></section></div>`;
 }
 if (state.modal === 'proposal') {
 const isHourly = state.currentJob?.payment_type === 'hourly';
 const bidLabel = isHourly ? 'Hourly Rate (₹)' : 'Bid amount';
 

 return `<div class="fixed inset-0 z-50 grid place-items-center overflow-y-auto neu-raised/80 p-4 backdrop-blur-sm"><section role="dialog"aria-modal="true"class="glass-panel my-8 w-full max-w-xl rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0"><div><p class="eyebrow">Your offer</p><h2 class="mt-2 text-2xl font-black">Submit proposal</h2></div>${close}</div><form id="proposal-form"class="mt-6 space-y-4">
 <input type="hidden"name="payment_type"value="${isHourly ? 'hourly' : 'fixed'}">
 ${state.agencies && state.agencies.length > 0 ? `
 <label class="block text-sm font-semibold">Bid as<select class="input-control"name="agency_id">
 <option value="">Individual</option>
 ${state.agencies.map(a => `<option value="${a.id}">${h(a.name)} (Agency)</option>`).join('')}
 </select></label>` : ''}

 <label class="block text-sm font-semibold">${bidLabel}<input class="input-control"name="bid_amount"type="number"min="1"required></label>
 <label class="block text-sm font-semibold">Delivery days<input class="input-control"name="delivery_days"type="number"min="1"required></label>
 <label class="block text-sm font-semibold mb-1">
 <div class="flex justify-between items-end mb-2">
 <span>Cover letter</span>
 <button type="button" onclick="window.getAiProposalDraft(${state.currentJob?.id}, this)" class="text-[10px] bg-amber-100/80 text-amber-800 px-2 py-1 rounded font-black uppercase tracking-widest hover:bg-amber-200/80 transition-colors">✨ AI Draft</button>
 </div>
 <textarea id="proposal-cover-letter"class="input-control min-h-36"name="cover_letter"minlength="20"required></textarea>
 </label>
<div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-2">
 <label class="group relative flex cursor-pointer flex-col gap-3 rounded-2xl neu-raised p-4 transition-all hover:bg-slate-50 has-[:checked]:ring-2 has-[:checked]:ring-amber-500 has-[:checked]:bg-amber-50/30">
 <div class="flex items-start justify-between">
 <div class="flex flex-col">
 <span class="text-sm font-black tracking-tight text-slate-900">⭐ Sponsored</span>
 <span class="mt-1.5 w-fit rounded bg-amber-100/80 px-2 py-0.5 text-[10px] font-black uppercase tracking-widest text-amber-800">20 COINS</span>
 </div>
 <input type="checkbox" name="is_sponsored" value="1" class="peer sr-only">
 <div class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-slate-300 bg-white transition-all peer-checked:border-amber-500 peer-checked:bg-amber-500">
 <svg class="h-3 w-3 text-white opacity-0 transition-opacity peer-checked:opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
 </div>
 </div>
 <p class="text-[11px] text-slate-600 font-medium leading-snug">Pin your proposal at the very top of the list.</p>
 </label>
 <label class="group relative flex cursor-pointer flex-col gap-3 rounded-2xl neu-raised p-4 transition-all hover:bg-slate-50 has-[:checked]:ring-2 has-[:checked]:ring-indigo-500 has-[:checked]:bg-indigo-50/30">
 <div class="flex items-start justify-between">
 <div class="flex flex-col">
 <span class="text-sm font-black tracking-tight text-slate-900">✨ Highlighted</span>
 <span class="mt-1.5 w-fit rounded bg-indigo-100/80 px-2 py-0.5 text-[10px] font-black uppercase tracking-widest text-indigo-700">10 COINS</span>
 </div>
 <input type="checkbox" name="is_highlighted" value="1" class="peer sr-only">
 <div class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-slate-300 bg-white transition-all peer-checked:border-indigo-500 peer-checked:bg-indigo-500">
 <svg class="h-3 w-3 text-white opacity-0 transition-opacity peer-checked:opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
 </div>
 </div>
 <p class="text-[11px] text-slate-600 font-medium leading-snug">Make your proposal stand out visually.</p>
 </label>
 <label class="group relative flex cursor-pointer flex-col gap-3 rounded-2xl neu-raised p-4 transition-all hover:bg-slate-50 has-[:checked]:ring-2 has-[:checked]:ring-slate-500 has-[:checked]:bg-slate-100/50">
 <div class="flex items-start justify-between">
 <div class="flex flex-col">
 <span class="text-sm font-black tracking-tight text-slate-900">🔒 Sealed Bid</span>
 <span class="mt-1.5 w-fit rounded bg-slate-200/80 px-2 py-0.5 text-[10px] font-black uppercase tracking-widest text-slate-700">5 COINS</span>
 </div>
 <input type="checkbox" name="is_sealed" value="1" class="peer sr-only">
 <div class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 border-slate-300 bg-white transition-all peer-checked:border-slate-500 peer-checked:bg-slate-500">
 <svg class="h-3 w-3 text-white opacity-0 transition-opacity peer-checked:opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
 </div>
 </div>
 <p class="text-[11px] text-slate-600 font-medium leading-snug">Hide your bid amount and details from competitors.</p>
 </label>
</div>
 
 <div class="mt-4 p-4 rounded-xl bg-blue-50/50 border-blue-100 text-sm leading-relaxed text-slate-600">
 <p class="font-bold text-blue-900 mb-1 flex items-center gap-1.5">${icon('check-circle', 'w-3 h-3 md:w-4 md:h-4 text-blue-700')} Bidding is completely FREE</p>
 <p>Standard proposals cost <strong class="text-slate-900">0 coins</strong>. We only charge you coins if you choose to upgrade your proposal's design, ranking, highlighting, or if you want to hide your bidding amount from other freelancers.</p>
 </div>

 <button class="btn-primary mt-6 w-full"type="submit">Submit proposal</button>
 </form></section></div>`;
 }
 if (state.modal === 'kyc') 

 return `<div class="fixed inset-0 z-50 grid place-items-center overflow-y-auto neu-raised/80 p-4 backdrop-blur-sm"><section role="dialog"aria-modal="true"class="glass-panel my-8 w-full max-w-xl rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0"><div><p class="eyebrow">Verification</p><h2 class="mt-2 text-2xl font-black">Submit KYC record</h2></div>${close}</div><form id="kyc-form"class="mt-6 space-y-4"><label class="block text-sm font-semibold">Document type<select class="input-control"name="type"required><option value="aadhar">Aadhar</option><option value="pan">PAN</option><option value="passport">Passport</option><option value="portfolio">Portfolio</option></select></label><label class="block text-sm font-semibold">Document number<input class="input-control"name="document_number"maxlength="100"></label><label class="block text-sm font-semibold">Identity document<input class="input-control"name="file"type="file"required accept=".pdf,.jpg,.jpeg,.png"></label><button class="btn-primary w-full"type="submit">Submit for review</button></form></section></div>`;
 if (state.modal.startsWith('deliverable:')) 

 return `<div class="fixed inset-0 z-50 grid place-items-center overflow-y-auto neu-raised/80 p-4 backdrop-blur-sm"><section role="dialog"aria-modal="true"class="glass-panel my-8 w-full max-w-xl rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0"><div><p class="eyebrow">Milestone delivery</p><h2 class="mt-2 text-2xl font-black">Submit deliverable</h2></div>${close}</div><form id="deliverable-form"class="mt-6 space-y-4"><label class="block text-sm font-semibold">Title<input class="input-control"name="title"required maxlength="180"></label><label class="block text-sm font-semibold">Description<textarea class="input-control min-h-28"name="description"maxlength="10000"></textarea></label><label class="block text-sm font-semibold">External URL<input class="input-control"name="external_url"type="url"placeholder="https://..."></label><label class="block text-sm font-semibold">Deliverable file<input class="input-control"name="file"type="file"accept=".pdf,.zip,.jpg,.jpeg,.png,.webp,.txt,.csv,.doc,.docx,.xls,.xlsx"></label><label class="block text-sm font-semibold">Version<input class="input-control"name="version"value="1.0"maxlength="40"></label><button class="btn-primary w-full"type="submit">Submit deliverable</button></form></section></div>`;
 if (state.modal.startsWith('dispute:')) 

 return `<div class="fixed inset-0 z-50 grid place-items-center overflow-y-auto neu-raised/80 p-4 backdrop-blur-sm"><section role="dialog"aria-modal="true"class="glass-panel my-8 w-full max-w-xl rounded-3xl p-4 md:p-6"><div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0"><div><p class="eyebrow">Escalation</p><h2 class="mt-2 text-2xl font-black">Open a dispute</h2></div>${close}</div><form id="dispute-form"class="mt-6 space-y-4"><label class="block text-sm font-semibold">Reason<input class="input-control"name="reason"required maxlength="255"placeholder="Delivery does not match the brief"></label><label class="block text-sm font-semibold">Description<textarea class="input-control min-h-36"name="description"required maxlength="5000"></textarea></label><button class="btn-primary w-full"type="submit">Open dispute</button></form></section></div>`;
 return '';
}


function aboutUsPage() {
 return `
 <main class="min-h-screen neu-raised text-slate-900 selection:bg-blue-600 selection:text-white flex flex-col font-sans transition-all duration-75 overflow-x-hidden">
 <!-- Header -->
 <header class="bg-[#e9eef5]/80 backdrop-blur-xl border-b border-white/50 shadow-[0_4px_30px_rgba(0,0,0,0.05)] sticky top-0 z-50">
 <div class="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
 <a href="#dashboard"class="hover:opacity-80 transition-opacity flex items-center gap-2">
 ${icon('logo', 'text-slate-900')}
 </a>
 <div class="flex items-center gap-4 shrink-0">
 <a href="#dashboard"class="text-xs sm:text-sm font-semibold text-slate-600 hover:text-slate-900 whitespace-nowrap">&larr; Back to Home</a>
 </div>
 </div>
 </header>

 <!-- Content -->
 <div class="flex-grow flex items-center justify-center py-10 md:py-16 px-4 relative overflow-hidden">
 <!-- Decorative Subtle Glows -->
 <div class="absolute top-0 right-0 w-[200px] h-[200px] sm:w-[500px] sm:h-[500px] bg-blue-50/50 rounded-full blur-[80px] pointer-events-none"></div>
 <div class="absolute bottom-0 left-0 w-[200px] h-[200px] sm:w-[600px] sm:h-[600px] bg-teal-50/50 rounded-full blur-[100px] pointer-events-none"></div>

 <div class="max-w-3xl w-full neu-raised/70 backdrop-blur-xl rounded-[2rem] shadow-[0_8px_40px_rgb(0,0,0,0.06)] relative z-10 p-8 sm:p-12 lg:p-16 text-center">
 
 <h1 class="text-2xl sm:text-4xl lg:text-5xl font-black mb-6 sm:mb-8 text-slate-900 leading-tight tracking-tight">SmartSiteMaker<br><span class="text-blue-700">Freelancing Hub</span></h1>
 
 <div class="space-y-6 text-slate-600 leading-relaxed text-lg sm:text-xl font-medium mx-auto text-left">
 <p>
 <strong class="text-slate-900">SmartSiteMaker</strong> is a premier freelancing hub designed to bridge the gap between global technical talent and enterprise demands. 
 We provide an elite gig economy platform where quality, security, and smart contracts form the core foundation of every project.
 </p>
 
 <p>
 Operating from our headquarters in <strong class="text-slate-900">Delhi & Ghaziabad</strong>, our mandate is strict: zero-compromise on quality and an intuitive UI/UX that sets a new industry standard for freelancers and clients alike.
 </p>
 </div>
 
 <div class="mt-12 pt-8 flex flex-col items-center">
 <p class="text-xs sm:text-sm font-bold text-slate-600 uppercase tracking-widest mb-4">Contact Us</p>
 <a href="mailto:smartsitemaker@gmail.com"class="inline-flex items-center gap-3 bg-blue-50 hover:bg-blue-100 text-blue-700 px-6 py-3 rounded-full font-bold transition-all border-blue-100 group">
 <svg class="w-5 h-5 text-blue-500 group-hover:text-blue-700 transition-colors"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
 <span>smartsitemaker@gmail.com</span>
 </a>
 </div>
 </div>
 </div>
 
 <!-- Footer -->
 <footer class="neu-raised mt-auto relative z-10">
 <div class="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
 <p class="text-slate-600 text-sm font-medium">&copy; 2024 SmartSiteMaker. All rights reserved.</p>
 <div class="flex flex-col md:flex-row gap-4 md:gap-6">
 <a href="#about"class="text-sm font-semibold text-slate-600 hover:text-slate-900 transition-colors">About Us</a>
 <a href="#policy-terms"class="text-sm font-semibold text-slate-600 hover:text-slate-900 transition-colors">Terms of Service</a>
 </div>
 </div>
 </footer>
 </main>
 `;
}

function pricingPage() {
 return `
 <main class="min-h-screen neu-raised text-slate-900 pb-24 selection:bg-blue-600 selection:text-white overflow-x-hidden">
 <header class="neu-raised py-6 px-6">
 <div class="max-w-7xl mx-auto flex items-center justify-between">
 <a href="#dashboard"class="hover:opacity-80 transition-opacity">${icon('logo', 'text-slate-900')}</a>
 <a href="#register"class="btn-primary">Get Started</a>
 </div>
 </header>
 <div class="max-w-4xl mx-auto px-6 mt-16 text-center">
 <h1 class="text-2xl sm:text-4xl lg:text-5xl font-black mb-6 tracking-tight">Simple, transparent pricing</h1>
 <p class="text-lg sm:text-xl text-slate-600 mb-16">No hidden fees, no agency markups. Just pure value.</p>
 
 <div class="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 text-left">
 <div class="neu-raised p-5 md:p-8 rounded-3xl shadow-xl">
 <h3 class="text-2xl font-bold mb-2">Freelancers</h3>
 <p class="text-slate-600 mb-6">Keep more of what you earn.</p>
 <div class="text-3xl md:text-5xl font-black mb-6">5% <span class="text-lg text-slate-600 font-normal">/ payout</span></div>
 <ul class="space-y-4 mb-8 font-medium">
 <li class="flex gap-2 text-slate-700">✓ Free profile</li>
 <li class="flex gap-2 text-slate-700">✓ AI Dispute resolution</li>
 <li class="flex gap-2 text-slate-700">✓ Same-day bank transfers</li>
 </ul>
 <a href="#register"class="btn-secondary w-full text-center block py-4 text-lg">Join as Talent</a>
 </div>
 
 <div class="bg-slate-900 text-white p-5 md:p-8 rounded-3xl border-slate-800 shadow-xl relative overflow-hidden">
 <div class="absolute top-0 right-0 w-32 h-32 bg-blue-500/20 rounded-full blur-3xl"></div>
 <h3 class="text-2xl font-bold mb-2">Enterprise</h3>
 <p class="text-slate-400 mb-6">Hire elite talent seamlessly.</p>
 <div class="text-3xl md:text-5xl font-black mb-6">3% <span class="text-lg text-slate-400 font-normal">/ transaction</span></div>
 <ul class="space-y-4 mb-8 font-medium">
 <li class="flex gap-2 text-slate-300">✓ Zero onboarding fees</li>
 <li class="flex gap-2 text-slate-300">✓ RBI-compliant Escrow</li>
 <li class="flex gap-2 text-slate-300">✓ Dedicated AI Manager</li>
 </ul>
 <a href="#register" class="bg-blue-600 text-white rounded-xl hover:bg-blue-500 transition-colors w-full text-center block py-4 text-lg font-bold">Hire Now</a>
 </div>
 </div>
 </div>
 </main>
 `;
}

function docsPage() {
 return `
 <main class="min-h-screen neu-raised text-slate-900 font-sans selection:bg-blue-600 selection:text-white flex flex-col md:flex-row relative overflow-x-hidden">
 <!-- Mobile Header (Visible only on small screens) -->
 <header class="md:hidden flex items-center justify-between p-4 neu-raised sticky top-0 z-50">
 <a href="#dashboard"class="flex items-center gap-2">
 ${icon('logo', 'text-blue-700')}
 </a>
 <a href="#dashboard"class="text-sm font-bold text-slate-600 hover:text-slate-900">
 Back to App
 </a>
 </header>

 <!-- Sidebar Navigation (Hidden on mobile) -->
 <aside class="hidden md:flex w-64 neu-raised flex-shrink-0 flex-col h-screen sticky top-0 z-40 overflow-y-auto">
 <div class="p-4 md:p-6 neu-raised">
 <a href="#dashboard"class="hover:opacity-80 transition-opacity flex items-center gap-2">
 ${icon('logo', 'text-blue-700')}
 </a>
 </div>
 <nav class="p-4 space-y-8 pb-20">
 <div>
 <h3 class="text-xs font-black text-slate-600 uppercase tracking-widest mb-3 px-2">Getting Started</h3>
 <ul class="space-y-1">
 <li><a href="#docs-intro"class="block px-3 py-2 text-sm font-semibold text-slate-900 bg-blue-50 text-blue-700 rounded-lg">Introduction</a></li>
 <li><a href="#docs-auth"class="block px-3 py-2 text-sm font-semibold text-slate-600 hover:text-slate-900 hover:bg-slate-200/50 rounded-lg transition-colors">Authentication</a></li>
 <li><a href="#docs-auth"class="block px-3 py-2 text-sm font-semibold text-slate-600 hover:text-slate-900 hover:bg-slate-200/50 rounded-lg transition-colors">Errors</a></li>
 <li><a href="#docs-auth"class="block px-3 py-2 text-sm font-semibold text-slate-600 hover:text-slate-900 hover:bg-slate-200/50 rounded-lg transition-colors">Pagination</a></li>
 </ul>
 </div>
 <div>
 <h3 class="text-xs font-black text-slate-600 uppercase tracking-widest mb-3 px-2">Core Resources</h3>
 <ul class="space-y-1">
 <li><a href="#docs-users"class="block px-3 py-2 text-sm font-semibold text-slate-600 hover:text-slate-900 hover:bg-slate-200/50 rounded-lg transition-colors">Users</a></li>
 <li><a href="#docs-escrow"class="block px-3 py-2 text-sm font-semibold text-slate-600 hover:text-slate-900 hover:bg-slate-200/50 rounded-lg transition-colors">Escrow</a></li>
 <li><a href="#docs-escrow"class="block px-3 py-2 text-sm font-semibold text-slate-600 hover:text-slate-900 hover:bg-slate-200/50 rounded-lg transition-colors">Jobs</a></li>
 <li><a href="#docs-escrow"class="block px-3 py-2 text-sm font-semibold text-slate-600 hover:text-slate-900 hover:bg-slate-200/50 rounded-lg transition-colors">Webhooks</a></li>
 </ul>
 </div>
 </nav>
 <div class="mt-auto p-4 neu-raised">
 <a href="#dashboard"class="flex items-center gap-2 text-sm font-bold text-slate-600 hover:text-slate-900 transition-colors">
 <svg class="w-4 h-4"fill="none"viewBox="0 0 24 24"stroke="currentColor"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
 Back to App
 </a>
 </div>
 </aside>

 <!-- Main Content Area -->
 <div class="flex-grow flex flex-col neu-raised min-w-0 h-full">
 <div class="flex-grow max-w-7xl w-full mx-auto p-6 md:p-12 lg:p-16 space-y-24"id="docs-content">
 
 <!-- Section: Introduction -->
 <section id="docs-intro"class="grid grid-cols-1 xl:grid-cols-2 gap-6 md:gap-12 xl:gap-16 items-start">
 <div class="prose prose-slate max-w-none">
 <h1 class="text-2xl md:text-4xl font-black mb-4 tracking-tight">API Reference</h1>
 <p class="text-lg text-slate-600 leading-relaxed">The SmartSiteMaker API is organized around REST. Our API has predictable resource-oriented URLs, accepts form-encoded request bodies, returns JSON-encoded responses, and uses standard HTTP response codes, authentication, and verbs.</p>
 <p class="text-lg text-slate-600 leading-relaxed mt-4">You can use the SmartSiteMaker API in test mode, which does not affect your live data or interact with the banking networks. The API key you use to authenticate the request determines whether the request is live mode or test mode.</p>
 
 <h3 class="text-base md:text-xl font-bold mt-10 mb-4 pb-2">Base URL</h3>
 <p class="mb-4">All production requests must be made over HTTPS. Calls made over plain HTTP will fail.</p>
 <code class="bg-slate-100 text-pink-600 px-3 py-2 rounded-lg font-mono text-sm block mb-4 font-medium">https://api.smartsitemaker.com/v4</code>
 </div>
 <div class="bg-slate-900 rounded-2xl p-4 md:p-6 shadow-xl xl:sticky top-12 border-slate-800">
 <div class="flex items-center justify-between mb-4 border-slate-800 pb-3">
 <span class="text-xs font-bold text-slate-600 uppercase tracking-widest">Base API URL</span>
 </div>
 <pre class="text-sm text-green-400 font-mono overflow-x-auto whitespace-pre-wrap word-break"><code>https://api.smartsitemaker.com/v4</code></pre>
 </div>
 </section>

 <!-- Section: Authentication -->
 <section id="docs-auth"class="grid grid-cols-1 xl:grid-cols-2 gap-6 md:gap-12 xl:gap-16 items-start pt-16">
 <div class="prose prose-slate max-w-none">
 <h2 class="text-xl md:text-3xl font-black mb-4 tracking-tight">Authentication</h2>
 <p class="text-slate-600 leading-relaxed mb-4">Authenticate your account when using the API by including your secret API key in the request. You can manage your API keys in the Dashboard.</p>
 <p class="text-slate-600 leading-relaxed mb-6">Authentication to the API is performed via HTTP Bearer Auth. Provide your API key as the bearer token value.</p>
 
 <div class="bg-amber-50 border-amber-200 rounded-xl p-5 my-8 flex gap-4">
 <div class="text-amber-800 mt-1 shrink-0">
 <svg class="w-6 h-6"fill="none"viewBox="0 0 24 24"stroke="currentColor"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
 </div>
 <div>
 <p class="font-bold text-amber-900 m-0">Keep your keys safe</p>
 <p class="text-amber-800 text-sm m-0 mt-2 leading-relaxed">Your API keys carry many privileges, so be sure to keep them secure! Do not share your secret API keys in publicly accessible areas such as GitHub, client-side code, and so forth.</p>
 </div>
 </div>
 </div>
 <div class="bg-slate-900 rounded-2xl p-4 md:p-6 shadow-xl xl:sticky top-12 border-slate-800">
 <div class="flex items-center gap-6 mb-4 border-slate-800 pb-3">
 <button class="text-xs font-bold text-blue-400 uppercase tracking-widest -2 border-blue-400 pb-3 -mb-[14px]">cURL</button>
 <button class="text-xs font-bold text-slate-600 hover:text-slate-300 uppercase tracking-widest pb-3 -mb-[14px] transition-colors">Node.js</button>
 <button class="text-xs font-bold text-slate-600 hover:text-slate-300 uppercase tracking-widest pb-3 -mb-[14px] transition-colors">Python</button>
 </div>
 <pre class="text-sm font-mono overflow-x-auto text-slate-300 leading-relaxed mt-4"><code><span class="text-pink-400">curl</span> https://api.smartsitemaker.com/v4/users/me \\
 <span class="text-blue-400">-H</span> <span class="text-green-300">"Authorization: Bearer ssm_live_secret_key"</span></code></pre>
 </div>
 </section>

 <!-- Section: Users -->
 <section id="docs-users"class="grid grid-cols-1 xl:grid-cols-2 gap-6 md:gap-12 xl:gap-16 items-start pt-16">
 <div class="prose prose-slate max-w-none">
 <h2 class="text-xl md:text-3xl font-black mb-4 tracking-tight">Users</h2>
 <p class="text-slate-600 leading-relaxed mb-8">The User object represents your account on the SmartSiteMaker platform. You can retrieve it to check your balance, role, and verification status programmatically.</p>
 
 <div class="mb-8">
 <h3 class="text-base md:text-xl font-bold flex items-center gap-3 mb-3">
 Retrieve current user
 <span class="bg-blue-100 text-blue-700 px-2 py-0.5 rounded text-[10px] uppercase tracking-widest font-black">GET</span>
 </h3>
 <code class="neu-raised text-slate-900 px-3 py-2 rounded-lg font-mono text-sm block">/v4/users/me</code>
 </div>
 
 <p class="font-bold pb-2 mb-4 text-slate-900">Returns</p>
 <p class="text-sm text-slate-600 mb-6">Returns a User object if the call succeeded.</p>
 <div class="overflow-x-auto">
 <table class="w-full text-left text-sm border-collapse">
 <tbody class="divide-y divide-slate-100">
 <tr>
 <td class="py-4 font-mono text-pink-600 font-semibold w-1/3 align-top">id</td>
 <td class="py-4 text-slate-600 align-top">string<br><span class="text-xs text-slate-400 mt-1 block">Unique identifier for the user.</span></td>
 </tr>
 <tr>
 <td class="py-4 font-mono text-pink-600 font-semibold align-top">email</td>
 <td class="py-4 text-slate-600 align-top">string<br><span class="text-xs text-slate-400 mt-1 block">The user's email address.</span></td>
 </tr>
 <tr>
 <td class="py-4 font-mono text-pink-600 font-semibold align-top">balance</td>
 <td class="py-4 text-slate-600 align-top">integer<br><span class="text-xs text-slate-400 mt-1 block">Current wallet balance in USD cents.</span></td>
 </tr>
 </tbody>
 </table>
 </div>
 </div>
 <div class="bg-slate-900 rounded-2xl shadow-xl xl:sticky top-12 border-slate-800 flex flex-col overflow-hidden">
 <div class="p-4 md:p-6 border-slate-800/60 bg-slate-900/50">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center mb-3">
 <span class="text-[10px] font-black text-slate-600 uppercase tracking-widest">Example Request</span>
 </div>
 <pre class="text-sm font-mono overflow-x-auto text-slate-300 leading-relaxed"><code><span class="text-pink-400">curl</span> https://api.smartsitemaker.com/v4/users/me \\
 <span class="text-blue-400">-H</span> <span class="text-green-300">"Authorization: Bearer ssm_live_secret_key"</span></code></pre>
 </div>
 
 <div class="p-4 md:p-6 bg-slate-950/50">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center mb-3">
 <span class="text-[10px] font-black text-slate-600 uppercase tracking-widest">Example Response</span>
 </div>
 <pre class="text-sm font-mono overflow-x-auto text-slate-300 leading-relaxed"><code>{
 <span class="text-pink-300">"id"</span>: <span class="text-green-300">"usr_9812739"</span>,
 <span class="text-pink-300">"object"</span>: <span class="text-green-300">"user"</span>,
 <span class="text-pink-300">"name"</span>: <span class="text-green-300">"Tech Solutions LLC"</span>,
 <span class="text-pink-300">"email"</span>: <span class="text-green-300">"admin@techsolutions.com"</span>,
 <span class="text-pink-300">"role"</span>: <span class="text-green-300">"client"</span>,
 <span class="text-pink-300">"balance"</span>: <span class="text-blue-300">5400000</span>,
 <span class="text-pink-300">"created"</span>: <span class="text-blue-300">1672531200</span>
}</code></pre>
 </div>
 </div>
 </section>
 
 <!-- Section: Escrow -->
 <section id="docs-escrow"class="grid grid-cols-1 xl:grid-cols-2 gap-6 md:gap-12 xl:gap-16 items-start pt-16">
 <div class="prose prose-slate max-w-none">
 <h2 class="text-xl md:text-3xl font-black mb-4 tracking-tight">Escrow Contracts</h2>
 <p class="text-slate-600 leading-relaxed mb-8">Create and manage secure escrow contracts programmatically. When you create an escrow, funds are immediately reserved from your wallet balance and held securely on-chain.</p>
 
 <div class="mb-8">
 <h3 class="text-base md:text-xl font-bold flex items-center gap-3 mb-3">
 Create an Escrow
 <span class="bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded text-[10px] uppercase tracking-widest font-black">POST</span>
 </h3>
 <code class="neu-raised text-slate-900 px-3 py-2 rounded-lg font-mono text-sm block">/v4/escrow</code>
 </div>
 
 <p class="font-bold pb-2 mb-4 text-slate-900">Body Parameters</p>
 <div class="overflow-x-auto">
 <table class="w-full text-left text-sm border-collapse mb-8">
 <tbody class="divide-y divide-slate-100">
 <tr>
 <td class="py-4 font-mono text-pink-600 font-semibold w-1/3 align-top">amount <div class="mt-1"><span class="text-[9px] bg-red-100 text-red-700 px-1.5 py-0.5 rounded-sm font-sans uppercase font-bold tracking-wider">Required</span></div></td>
 <td class="py-4 text-slate-600 align-top">integer<br><span class="text-xs text-slate-400 mt-1 block">Amount intended to be collected by this escrow, in the smallest currency unit (e.g., 100 cents to charge $1.00).</span></td>
 </tr>
 <tr>
 <td class="py-4 font-mono text-pink-600 font-semibold align-top">currency <div class="mt-1"><span class="text-[9px] bg-red-100 text-red-700 px-1.5 py-0.5 rounded-sm font-sans uppercase font-bold tracking-wider">Required</span></div></td>
 <td class="py-4 text-slate-600 align-top">string<br><span class="text-xs text-slate-400 mt-1 block">Three-letter ISO currency code, in lowercase. Must be a supported currency.</span></td>
 </tr>
 <tr>
 <td class="py-4 font-mono text-pink-600 font-semibold align-top">freelancer_id <div class="mt-1"><span class="text-[9px] bg-red-100 text-red-700 px-1.5 py-0.5 rounded-sm font-sans uppercase font-bold tracking-wider">Required</span></div></td>
 <td class="py-4 text-slate-600 align-top">string<br><span class="text-xs text-slate-400 mt-1 block">The ID of the user receiving the funds upon completion.</span></td>
 </tr>
 </tbody>
 </table>
 </div>
 </div>
 <div class="bg-slate-900 rounded-2xl shadow-xl xl:sticky top-12 border-slate-800 flex flex-col overflow-hidden">
 <div class="p-4 md:p-6 border-slate-800/60 bg-slate-900/50">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center mb-3">
 <span class="text-[10px] font-black text-slate-600 uppercase tracking-widest">Example Request</span>
 </div>
 <pre class="text-sm font-mono overflow-x-auto text-slate-300 leading-relaxed"><code><span class="text-pink-400">curl</span> https://api.smartsitemaker.com/v4/escrow \\
 <span class="text-blue-400">-X</span> POST \\
 <span class="text-blue-400">-H</span> <span class="text-green-300">"Authorization: Bearer ssm_live_secret_key"</span> \\
 <span class="text-blue-400">-H</span> <span class="text-green-300">"Content-Type: application/json"</span> \\
 <span class="text-blue-400">-d</span> <span class="text-amber-300">'{
"amount": 500000,
"currency":"usd",
"freelancer_id":"usr_7384912"
 }'</span></code></pre>
 </div>
 
 <div class="p-4 md:p-6 bg-slate-950/50">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center mb-3">
 <span class="text-[10px] font-black text-slate-600 uppercase tracking-widest">Example Response</span>
 </div>
 <pre class="text-sm font-mono overflow-x-auto text-slate-300 leading-relaxed"><code>{
 <span class="text-pink-300">"id"</span>: <span class="text-green-300">"esc_8b2j49f"</span>,
 <span class="text-pink-300">"object"</span>: <span class="text-green-300">"escrow"</span>,
 <span class="text-pink-300">"amount"</span>: <span class="text-blue-300">500000</span>,
 <span class="text-pink-300">"currency"</span>: <span class="text-green-300">"usd"</span>,
 <span class="text-pink-300">"status"</span>: <span class="text-green-300">"funded"</span>,
 <span class="text-pink-300">"client"</span>: <span class="text-green-300">"usr_9812739"</span>,
 <span class="text-pink-300">"freelancer"</span>: <span class="text-green-300">"usr_7384912"</span>,
 <span class="text-pink-300">"created"</span>: <span class="text-blue-300">1672610500</span>
}</code></pre>
 </div>
 </div>
 </section>
 
 <!-- Spacer for scrolling -->
 <div class="h-48"></div>
 </div>
 </div>
 </main>
 `;
}

function statusPage() {
 return `
 <main class="min-h-screen neu-raised text-slate-900 pb-24 selection:bg-blue-600 selection:text-white overflow-x-hidden">
 <header class="neu-raised py-6 px-6">
 <div class="max-w-7xl mx-auto flex items-center justify-between">
 <a href="#dashboard"class="hover:opacity-80 transition-opacity">${icon('logo', 'text-slate-900')}</a>
 <a href="#dashboard"class="text-slate-600 font-bold hover:text-blue-700 transition-colors">Home</a>
 </div>
 </header>
 <div class="max-w-3xl mx-auto px-6 mt-16">
 <h1 class="text-2xl sm:text-4xl font-black mb-8 tracking-tight">System Status</h1>
 
 <div class="bg-emerald-50 border-emerald-200 rounded-2xl p-6 sm:p-8 mb-8 flex flex-col sm:flex-row items-center sm:items-start gap-4 text-center sm:text-left">
 <div class="w-7 h-7 md:w-10 md:h-10 md:w-16 md:h-16 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-700 flex-shrink-0">
 <svg class="w-8 h-8"fill="none"viewBox="0 0 24 24"stroke="currentColor"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="3"d="M5 13l4 4L19 7"></path></svg>
 </div>
 <div>
 <h2 class="text-2xl font-black text-emerald-900">All Systems Operational</h2>
 <p class="text-emerald-700 font-medium mt-1">Last updated: Just now</p>
 </div>
 </div>
 
 <div class="neu-raised rounded-2xl overflow-hidden">
 <div class="p-5 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <span class="font-bold text-slate-700">API Gateway</span>
 <span class="text-emerald-700 font-bold text-xs uppercase tracking-widest bg-emerald-50 px-3 py-1.5 rounded-full">Operational</span>
 </div>
 <div class="p-5 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <span class="font-bold text-slate-700">Escrow Engine (Smart Contracts)</span>
 <span class="text-emerald-700 font-bold text-xs uppercase tracking-widest bg-emerald-50 px-3 py-1.5 rounded-full">Operational</span>
 </div>
 <div class="p-5 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <span class="font-bold text-slate-700">AI Matching Algorithm</span>
 <span class="text-emerald-700 font-bold text-xs uppercase tracking-widest bg-emerald-50 px-3 py-1.5 rounded-full">Operational</span>
 </div>
 <div class="p-5 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <span class="font-bold text-slate-700">Web Application</span>
 <span class="text-emerald-700 font-bold text-xs uppercase tracking-widest bg-emerald-50 px-3 py-1.5 rounded-full">Operational</span>
 </div>
 </div>
 </div>
 </main>
 `;
}
window.releaseMilestoneFunds = async function(milestoneId) {
 if(!confirm("Are you sure you want to release funds for this milestone? This action cannot be reversed on the ledger.")) return;
 try {
 await request(`/contracts/${state.currentContract.id}/milestones/${milestoneId}/release`, { method: 'POST' });
 notify('Smart Contract Executed: Funds have been securely released.', 'success');
 await loadRouteData();
 } catch (e) {
 notify(e.message, 'error');
 }
};

window.requestRevision = async function(deliverableId) {
 if(!confirm("Are you sure you want to request a revision for this deliverable?")) return;
 try {
 await request(`/deliverables/${deliverableId}/request-revision`, { method: 'POST' });
 notify('Revision request sent to the freelancer.', 'success');
 await loadRouteData();
 } catch (e) {
 notify(e.message, 'error');
 }
};

window.raiseDispute = async function(milestoneId) {
 const reason = prompt("Please provide a short reason for raising a dispute on this milestone:");
 if(!reason) return;
 const description = prompt("Please provide a detailed description of the issue:");
 if(!description) return;
 try {
 await request(`/contracts/${state.currentContract.id}/milestones/${milestoneId}/disputes`, { method: 'POST', body: JSON.stringify({ reason, description }) });
 notify('Dispute raised. Our legal team will review the contract hash.', 'error');
 await loadRouteData();
 } catch (e) {
 notify(e.message, 'error');
 }
};

window.resolveDispute = async function(disputeId, resolution) {
 if(!confirm(`Are you sure you want to ${resolution === 'refund_client' ? 'refund the client' : 'release funds to the freelancer'}? This action is final.`)) return;
 try {
 await request(`/disputes/${disputeId}/resolve`, { method: 'PATCH', body: JSON.stringify({ resolution, resolution_notes: 'Resolved by Admin.' }) });
 notify('Dispute successfully resolved.', 'success');
 await loadRouteData();
 } catch (e) {
 notify(e.message, 'error');
 }
};window.downloadSecureFile = async function(url, filename) {
 try {
 const btn = event?.currentTarget;
 if(btn) { btn.style.opacity = '0.5'; btn.style.pointerEvents = 'none'; }
 const response = await fetch(url, { headers: { 'Authorization': `Bearer ${state.token}` } });
 if (!response.ok) throw new Error('Download failed');
 const blob = await response.blob();
 const objectUrl = window.URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = objectUrl;
 a.download = filename || 'download';
 document.body.appendChild(a);
 a.click();
 window.URL.revokeObjectURL(objectUrl);
 a.remove();
 if(btn) { btn.style.opacity = '1'; btn.style.pointerEvents = 'auto'; }
 } catch (e) {
 alertPopup('Download Error', 'Could not download the file securely. Please try again.');
 }
};

window.deleteWorkspaceFile = async function(deliverableId) {
 if (!confirm('Are you sure you want to delete this file?')) return;
 notify('Deleting file...', 'info');
 try {
 await request(`/deliverables/${deliverableId}`, {
 method: 'DELETE',
 });
 notify('File deleted successfully!', 'success');
 await loadRouteData();
 } catch (e) {
 notify('Deletion failed: ' + e.message, 'error');
 }
};

window.uploadWorkspaceFile = async function(event, defaultMilestoneId) {
 const file = event.target.files[0];
 if (!file) return;

 if (!defaultMilestoneId && state.currentContract?.milestones?.length) {
 defaultMilestoneId = state.currentContract.milestones[0].id;
 }

 if (!defaultMilestoneId) {
 notify('No milestone exists to attach this file to.', 'error');
 return;
 }

 const formData = new FormData();
 formData.append('file', file);
 formData.append('title', file.name);

 notify('Uploading file...', 'info');
 try {
 await request(`/milestones/${defaultMilestoneId}/deliverables`, {
 method: 'POST',
 body: formData,
 }, true);
 notify('File uploaded successfully!', 'success');
 await loadRouteData();
 } catch (e) {
 notify('File upload failed: ' + e.message, 'error');
 }
};

window.submitContractMessage = async function(event) {
 event.preventDefault();
 const input = document.getElementById('contractMessageInput');
 const content = input.value;
 if(!content.trim()) return;
 try {
 await request(`/contracts/${state.currentContract.id}/messages`, { method: 'POST', body: JSON.stringify({ body: content }) });
 input.value = '';
 
 // Fetch only messages to update the chat feed without full page reload
 const res = await request(`/contracts/${state.currentContract.id}/messages?after_id=${state.messageCursor || 0}`);
 const freshMessages = res.data?.data || res.data || [];
 
 if (freshMessages.length) {
 state.messages = [...state.messages, ...freshMessages];
 state.messageCursor = res.meta?.next_after_id || state.messageCursor;
 await request(`/contracts/${state.currentContract.id}/messages/read`, { method: 'POST' });
 }
 
 // Smoothly update the chat feed DOM
 const chatFeed = document.getElementById('contract-chat-feed');
 if (chatFeed) {
 chatFeed.innerHTML = renderChatMessagesHTML(state.messages, state.currentContract);
 chatFeed.scrollTop = chatFeed.scrollHeight;
 } else {
 await loadRouteData(); // fallback
 }
 } catch(e) {
 notify(e.message, 'error');
 }
};

function renderChatMessagesHTML(messages, contract) {
 if (!messages || !messages.length) {
 return '<p class="text-xs text-slate-400 text-center py-4">No messages yet. Send a message to start!</p>';
 }
 const sortedMessages = [...messages].sort((a, b) => a.id - b.id);
 return sortedMessages.map(msg => {
 const isSystem = msg.is_system; 
 if (isSystem) {
 return `
 <div class="flex items-start gap-3">
 <div class="w-8 h-8 rounded-full bg-slate-200 text-slate-600 flex items-center justify-center shrink-0">
 ${icon('alert')}
 </div>
 <div class="bg-slate-100 rounded-2xl rounded-tl-sm px-4 py-3 max-w-[85%]">
 <p class="text-slate-600"><span class="font-semibold text-slate-900">System:</span> ${h(msg.body || msg.content)}</p>
 <p class="text-[10px] text-slate-400 mt-0.5">${new Date(msg.created_at).toLocaleString()}</p>
 </div>
 </div>`;
 }

 let senderName = h(msg.sender?.name || 'User');
 let isAdmin = msg.sender?.id != contract.client_id && msg.sender?.id != contract.freelancer_id;
 let senderRole = isAdmin ? 'Admin' : (msg.sender?.id == contract.client_id ? 'Client' : 'Freelancer');
 
 if (isAdmin) senderName = 'Admin';
 
 const isMe = msg.sender?.id === state.user?.id;

 if (isMe) {
 return `
 <div class="flex items-start gap-3 flex-row-reverse w-full">
 <div class="w-8 h-8 rounded-full ${isAdmin ? 'bg-rose-100 text-rose-700 border-rose-200' : 'bg-indigo-100 text-indigo-600 border-indigo-200'} font-bold flex items-center justify-center shrink-0 text-xs">
 ${isAdmin ? icon('shield') : h(senderName[0])}
 </div>
 <div class="${isAdmin ? 'bg-rose-600' : 'bg-indigo-600'} rounded-2xl rounded-tr-sm px-4 py-3 max-w-[85%] text-white">
 <div class="flex flex-row-reverse items-baseline gap-2 mb-1">
 <span class="font-bold text-white/90 text-xs">${senderName} <span class="opacity-75 font-normal">(${senderRole})</span></span>
 </div>
 <p class="whitespace-pre-wrap text-left">${h(msg.body || msg.content)}</p>
 <p class="text-[10px] text-white/70 mt-1 text-right">${new Date(msg.created_at).toLocaleString()}</p>
 </div>
 </div>`;
 } else {
 return `
 <div class="flex items-start gap-3 w-full">
 <div class="w-8 h-8 rounded-full ${isAdmin ? 'bg-rose-100 text-rose-700 border-rose-200' : 'bg-slate-200 text-slate-600 '} font-bold flex items-center justify-center shrink-0 text-xs">
 ${isAdmin ? icon('shield') : h(senderName[0])}
 </div>
 <div class="${isAdmin ? 'bg-rose-50 border-rose-100' : 'neu-raised '} rounded-2xl rounded-tl-sm px-4 py-3 max-w-[85%]">
 <div class="flex items-baseline gap-2 mb-1">
 <span class="font-bold ${isAdmin ? 'text-rose-900' : 'text-slate-900'} text-xs">${senderName}</span>
 <span class="text-[10px] ${isAdmin ? 'text-rose-500' : 'text-slate-600'} neu-raised px-1.5 py-0.5 rounded-sm ${isAdmin ? 'border-rose-100' : ''} uppercase font-bold tracking-wider">${senderRole}</span>
 </div>
 <p class="${isAdmin ? 'text-rose-900 font-medium' : 'text-slate-700'} whitespace-pre-wrap text-left">${h(msg.body || msg.content)}</p>
 <p class="text-[10px] ${isAdmin ? 'text-rose-400' : 'text-slate-400'} mt-1 text-right">${new Date(msg.created_at).toLocaleString()}</p>
 </div>
 </div>`;
 }
 }).join('');
}

function contractDetailPage() {
 const contract = state.currentContract;
 if (!contract) return skeletonScreen();
 
 const messages = state.messages || [];
 
 const totalAmount = contract.milestones?.reduce((sum, m) => sum + (parseFloat(m.amount) || 0), 0) || 0;
 const fundedAmount = contract.milestones?.filter(m => m.status === 'funded' || m.status === 'released').reduce((sum, m) => sum + (parseFloat(m.amount) || 0), 0) || 0;
 const releasedAmount = contract.milestones?.filter(m => m.status === 'released').reduce((sum, m) => sum + (parseFloat(m.amount) || 0), 0) || 0;
 const remainingAmount = totalAmount - releasedAmount;

 const milestonesHtml = contract.milestones?.length ? contract.milestones.map((m, i) => {
 let statusIcon = '<svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>';
 let statusClass = ' bg-slate-100 text-slate-400';
 let cardClass = 'neu-raised opacity-60 ';
 let statusText = 'Awaiting funding to unlock this milestone.';
 
 if (m.status === 'released') {
 statusIcon = '<svg class="w-5 h-5"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M5 13l4 4L19 7"></path></svg>';
 statusClass = 'border-white bg-emerald-100 text-emerald-700';
 cardClass = 'neu-raised ';
 statusText = 'Funds released.';
 } else if (m.status === 'funded' || m.status === 'submitted') {
 statusIcon = '<svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>';
 statusClass = 'border-4 border-white bg-blue-500 text-white ring-4 ring-blue-500/20';
 cardClass = 'bg-blue-50/50 border-blue-200';
 statusText = m.status === 'submitted' ? 'Work submitted for review.' : 'In progress. Escrow funded and locked.';
 } else if (m.status === 'disputed') {
 statusIcon = '<svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>';
 statusClass = 'border-white bg-rose-100 text-rose-700';
 cardClass = 'bg-rose-50 border-rose-200';
 statusText = 'Milestone is currently disputed.';
 }

 return `
 <div class="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group ${m.status !== 'pending' ? 'is-active' : ''}">
 <div class="flex items-center justify-center w-7 h-7 md:w-10 md:h-10 rounded-full shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 ${statusClass}">
 ${statusIcon}
 </div>
 <div class="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl ${cardClass}">
 <div class="flex items-center justify-between space-x-2 mb-1">
 <div class="font-bold text-slate-900">${h(m.title)}</div>
 <time class="font-mono text-xs ${m.status==='released' ? 'text-emerald-700' : (m.status==='funded'?'text-blue-700':'text-slate-600')}">${money(m.amount, contract.currency)}</time>
 </div>
 <div class="text-sm text-slate-600">${h(m.description)}</div>
 <div class="text-xs font-semibold mt-2">${statusText}</div>
 
 ${m.deliverables && m.deliverables.length > 0 ? `
 <div class="mt-4 space-y-2 pt-3">
 <p class="text-[10px] uppercase font-bold text-slate-400 tracking-wider">Submitted Work</p>
 ${m.deliverables.map(f => `
 <div class="flex items-center justify-between neu-raised/60 p-2 rounded">
 <div class="flex items-center gap-2 overflow-hidden">
 <div class="w-6 h-6 bg-blue-50 text-blue-700 rounded flex items-center justify-center shrink-0">
 <svg class="w-3 h-3"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path></svg>
 </div>
 <div class="overflow-hidden">
 <p class="text-[11px] font-semibold text-slate-700 truncate"title="${h(f.title || f.file_path)}">${h(f.title || f.file_path?.split('/').pop() || 'Uploaded File')}</p>
 <p class="text-[9px] text-slate-400">${new Date(String(f.submitted_at || f.created_at).replace(' ', 'T')).toLocaleString()}</p>
 </div>
 </div>
 <div class="flex items-center gap-1 shrink-0">
 ${f.file_path ? `<button onclick="window.downloadSecureFile('/api/v1/files/deliverables/${f.id}', '${f.file_path?.split('/').pop() || 'download'}')"class="text-blue-700 hover:text-blue-800 p-1.5 bg-blue-50 hover:bg-blue-100 rounded transition-colors"title="Download">
 <svg class="w-3 h-3"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
 </button>` : ''}
 ${(state.user?.id === f.submitter_id && m.status !== 'released') ? `
 <button onclick="window.deleteWorkspaceFile(${f.id})"class="text-rose-700 hover:text-rose-800 p-1.5 bg-rose-50 hover:bg-rose-100 rounded transition-colors"title="Delete">
 <svg class="w-3 h-3"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
 </button>
 ` : ''}
 ${(state.user?.role === 'client' && m.status === 'submitted') ? `
 <button onclick="window.requestRevision(${f.id})"class="text-amber-800 hover:text-amber-800 p-1.5 bg-amber-50 hover:bg-amber-100 rounded transition-colors"title="Request Revision">
 <svg class="w-3 h-3"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
 </button>
 ` : ''}
 </div>
 </div>
 `).join('')}
 </div>
 ` : ''}

 ${(m.status === 'funded' || m.status === 'submitted') ? `
 ${state.user?.role === 'client' && m.status === 'submitted' ? `
 <div class="mt-4 mb-3 p-3 bg-rose-50 border-rose-200 rounded-xl">
 <p class="text-xs text-rose-700 font-bold mb-1">⚠️ IMPORTANT: DOWNLOAD BEFORE RELEASING</p>
 <p class="text-[10px] text-rose-700 leading-snug font-medium">Please download and review all submitted files. Once funds are released, the files will be permanently deleted from our servers. This process is irreversible.</p>
 </div>` : ''}
 <div class="mt-3 flex flex-wrap gap-2">
 ${state.user?.role === 'client' ? `<button class="btn-primary text-[10px] px-3 py-1.5"onclick="window.releaseMilestoneFunds(${m.id})">Review & Release Funds</button>` : ''}
 ${(state.user?.role === 'freelancer' && (m.status === 'funded' || m.status === 'submitted')) ? `
 <div class="flex flex-col gap-1">
 <label class="cursor-pointer btn-primary text-[10px] px-3 py-1.5 inline-block m-0 text-center">
 Submit Work (ZIP Only)
 <input type="file"accept=".zip,application/zip"class="hidden"onchange="window.uploadWorkspaceFile(event, ${m.id})">
 </label>
 <span class="text-[9px] text-slate-400">Please compress your files into a single .zip before uploading.</span>
 </div>
 ` : ''}
 <button class="btn-secondary text-[10px] px-3 py-1.5 border-rose-200 text-rose-700 hover:bg-rose-50"onclick="window.raiseDispute(${m.id})">Raise Dispute</button>
 </div>` : ''}
 ${(m.status === 'pending' && state.user?.role === 'client') ? `
 <div class="mt-3 flex flex-wrap gap-2">
 ${m.has_pending_verification ? `<span class="status-pill status-warn px-3 py-2 text-[10px]">Verification Pending (UTR: ${h(m.pending_utr)})</span>` : `<button class="btn-primary text-[10px] px-3 py-1.5"data-fund="${m.id}">Fund Milestone</button>`}
 </div>` : ''}
 </div>
 </div>
 `;
 }).join('') : `<p class="text-slate-600 text-sm">No milestones found.</p>`;

 const messagesHtml = renderChatMessagesHTML(messages, contract);

 const contractHash = '0x' + Array.from({length: 40}, () => Math.floor(Math.random()*16).toString(16)).join('');

 return `
 <div class="min-h-screen neu-raised flex flex-col font-sans text-slate-900 pb-20 lg:pb-0">
 <!-- Header -->
 <header class="neu-raised sticky top-0 z-40">
 <div class="max-w-7xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
 <div class="flex items-center gap-4">
 <a href="#contracts"class="w-7 h-7 md:w-10 md:h-10 rounded-full hover:bg-slate-100 flex items-center justify-center text-slate-600 transition-colors">
 &larr;
 </a>
 <div>
 <h1 class="text-base md:text-xl font-bold text-slate-900 flex items-center gap-3">
 Smart Contract Workspace
 <span class="bg-emerald-100 text-emerald-700 text-[10px] uppercase tracking-widest font-bold px-2 py-1 rounded-full flex items-center gap-1">
 <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span> ${h(contract.status || 'Active')}
 </span>
 </h1>
 <p class="text-xs text-slate-600 font-mono">Contract ID: #SSM-CTR-${contract.id}</p>
 </div>
 </div>
 </div>
 </header>

 <div class="max-w-7xl mx-auto w-full p-4 sm:p-6 lg:p-8 flex-1 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-8">
 
 <!-- Left Column: Main Activity & Milestones -->
 <div class="lg:col-span-2 space-y-8">
 
 <!-- Escrow & Financials -->
 <div class="neu-raised rounded-2xl overflow-hidden relative">
 <div class="absolute top-0 right-0 w-32 h-32 md:w-64 md:h-64 bg-emerald-400/5 rounded-full blur-3xl pointer-events-none"></div>
 <div class="p-4 md:p-6 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-start">
 <div>
 <h2 class="text-lg font-bold">Escrow Vault</h2>
 <p class="text-sm text-slate-600">Funds are secured on the SmartSiteMaker ledger.</p>
 </div>
 <div class="text-right">
 <p class="text-sm text-slate-600 mb-1">Total Contract Value</p>
 <p class="text-xl md:text-3xl font-black text-slate-900">${money(totalAmount, contract.currency)}</p>
 </div>
 </div>
 <div class="neu-raised p-4 md:p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:grid-cols-4 gap-4">
 <div>
 <p class="text-xs text-slate-600 font-semibold uppercase tracking-wider mb-1">Funded</p>
 <p class="text-lg font-bold text-emerald-700">${money(fundedAmount, contract.currency)}</p>
 </div>
 <div>
 <p class="text-xs text-slate-600 font-semibold uppercase tracking-wider mb-1">Released</p>
 <p class="text-lg font-bold text-blue-700">${money(releasedAmount, contract.currency)}</p>
 </div>
 <div>
 <p class="text-xs text-slate-600 font-semibold uppercase tracking-wider mb-1">Remaining</p>
 <p class="text-lg font-bold text-slate-700">${money(remainingAmount, contract.currency)}</p>
 </div>
 <div>
 <p class="text-xs text-slate-600 font-semibold uppercase tracking-wider mb-1">Smart Hash</p>
 <p class="text-sm font-mono text-slate-600 truncate"title="${contractHash}">${contractHash.substring(0,6)}...${contractHash.substring(36)}</p>
 </div>
 </div>
 </div>

 ${(state.user?.role === 'admin' && contract.status === 'disputed') ? `
 <!-- Admin Mediation Panel -->
 <div class="bg-rose-50 rounded-2xl border-rose-200 p-4 md:p-6">
 <h2 class="text-lg font-bold text-rose-900 mb-2 flex items-center gap-2">
 <svg class="w-5 h-5 text-rose-700"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
 Super Admin Mediation Panel
 </h2>
 <p class="text-sm text-rose-700 mb-6">This contract is currently in dispute. As the administrator, you can review the workspace activity and make a final ruling.</p>
 <div class="flex flex-wrap gap-4">
 ${contract.milestones?.filter(m => m.status === 'disputed').map(m => `
 <div class="w-full neu-raised p-4 rounded-xl border-rose-100 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center">
 <div>
 <p class="font-bold text-slate-900">${h(m.title)}</p>
 <p class="text-sm text-slate-600">Disputed Amount: ${money(m.amount, contract.currency)}</p>
 </div>
 <div class="flex gap-2">
 <button class="btn-secondary border-rose-200 text-rose-700 hover:bg-rose-50"onclick="window.resolveDispute(${m.dispute?.id || 1}, 'refund_client')">Refund Client</button>
 <button class="btn-primary bg-emerald-600 hover:bg-emerald-700 border-emerald-600 shadow-emerald-500/30"onclick="window.resolveDispute(${m.dispute?.id || 1}, 'release_freelancer')">Release to Freelancer</button>
 </div>
 </div>
 `).join('')}
 </div>
 </div>
 ` : ''}

 <!-- Milestone Tracker -->
 <div class="neu-raised rounded-2xl p-4 md:p-6">
 <h2 class="text-lg font-bold mb-6">Project Milestones</h2>
 <div class="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-200 before:to-transparent">
 ${milestonesHtml}
 </div>
 </div>

 </div>

 <!-- Right Column: Sidebar (Files, Chat) -->
 <div class="space-y-8">
 
 <!-- Deliverables & Files -->
 <div class="neu-raised rounded-2xl overflow-hidden">
 <div class="p-5 flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-center neu-raised">
 <h3 class="font-bold text-slate-900">Deliverables & Assets</h3>
 <label class="cursor-pointer text-blue-700 hover:text-blue-800 p-1 bg-blue-50 rounded text-xs font-semibold px-2">
 Upload
 <input type="file"class="hidden"onchange="window.uploadWorkspaceFile(event, ${contract.milestones?.[0]?.id})">
 </label>
 </div>
 <div class="p-5 space-y-3">
 ${(() => {
 const allFiles = contract.milestones?.flatMap(m => m.deliverables || []) || [];
 if (allFiles.length === 0) return '<p class="text-xs text-slate-400 text-center">Uploads will appear here when submitted.</p>';
 return allFiles.map(f => `
 <div class="flex items-center justify-between p-3 neu-raised rounded-lg">
 <div class="flex items-center gap-3">
 <div class="w-8 h-8 bg-blue-100 text-blue-700 rounded flex items-center justify-center shrink-0">
 <svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path></svg>
 </div>
 <div class="overflow-hidden">
 <p class="text-sm font-semibold text-slate-700 truncate"title="${h(f.title || f.file_path)}">${h(f.title || f.file_path?.split('/').pop() || 'Uploaded File')}</p>
 <p class="text-xs text-slate-400">By ${h(f.submitter?.name || 'User')} • ${new Date(String(f.submitted_at || f.created_at).replace(' ', 'T')).toLocaleDateString()}</p>
 </div>
 </div>
 <button onclick="window.downloadSecureFile('/api/v1/files/deliverables/${f.id}', '${f.file_path?.split('/').pop() || 'download'}')"class="text-blue-700 hover:text-blue-800 p-2 neu-raised rounded shrink-0"title="Download">
 <svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
 </button>
 </div>
 `).join('');
 })()}
 </div>
 </div>

 <!-- Activity Feed -->
 <div class="neu-raised rounded-2xl overflow-hidden flex flex-col h-96">
 <div class="p-5 neu-raised">
 <h3 class="font-bold text-slate-900 flex items-center gap-2">
 <div class="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
 Live Feed
 </h3>
 </div>
 <div id="contract-chat-feed"class="flex-1 p-5 overflow-y-auto space-y-4 text-sm flex flex-col">
 ${messagesHtml}
 </div>
 <div class="p-3 neu-raised">
 <form class="relative"onsubmit="window.submitContractMessage(event)">
 <input type="text"id="contractMessageInput"class="w-full neu-raised rounded-full pl-4 pr-12 py-2 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all"placeholder="Type a message..."required>
 <button type="submit"class="absolute right-1 top-1 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
 <svg class="w-4 h-4"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path></svg>
 </button>
 </form>
 </div>
 </div>

 </div>
 </div>
 
 <!-- Mobile Bottom Nav Spacer -->
 <div class="h-16 lg:hidden"></div>
 </div>
 `;
}

function currentPage() {
 const path = route();
 
 // Public & Landing Pages
 if (path === 'pricing') return pricingPage();
 if (path === 'docs') return docsPage();
 if (path === 'status') return statusPage();
 if (path === 'blog') return blogPage();
 if (path.startsWith('blog/')) return blogPostPage();
 
 // Core Platform Pages
 if (path === 'marketplace') return marketplacePage();
 if (/^jobs\/\d+$/.test(path)) return jobPage();
 
 // Freelancer & Community Pages
 if (path === 'freelancers') return freelancerDirectoryPage();
 if (/^freelancers\/\d+$/.test(path)) return freelancerPublicProfilePage();
 if (path === 'saved-freelancers') return savedFreelancersPage();
 if (path === 'leaderboard') return leaderboardPage();
 if (path === 'forum') return forumPage();
 if (path === 'skill-tests') return skillTestsPage();
 if (path === 'membership') return membershipPage();
 if (path === 'referrals') return referralsPage();
 
 // Dashboard & Admin Pages
 if (path === 'manage-jobs') return manageJobsPage();
 if (path === 'contracts') return contractsPage();
 if (/^contracts\/\d+$/.test(path)) return contractDetailPage();
 if (path === 'profile') return profilePage();
 if (path === 'settings') return settingsPage();
 if (path === 'escalation') return escalationPage();
 
 // Dedicated Admin Pages
 if (path === 'admin') return adminPage();
 if (path === 'admin-payments') return adminPaymentsPage();
 if (path === 'admin-reports') return adminReportsPage();
 if (path === 'admin-announcements') return adminAnnouncementsPage();
 if (path === 'admin-featured') return adminFeaturedPage();
 if (path === 'admin/blog') return adminBlogPage();
 if (path === 'admin-seo') return adminSeoPage();
 if (path === 'admin-ledger') return typeof adminLedgerPage === 'function' ? adminLedgerPage() : adminPage(); // Fallback if adminLedgerPage missing
 
 // Default fallback
 return dashboardPage();
}


function mobileBottomNav() {
 const path = route();
 const active = (key) => path === key || (key !== 'dashboard' && path.startsWith(`${key}/`)) 
 ? 'text-teal-300 font-bold' 
 : 'text-slate-400';

 return `
 <nav class="fixed bottom-0 inset-x-0 bg-slate-900/95 backdrop-blur-md border-t border-slate-800 flex items-center justify-around pt-1 pb-2 px-1 lg:hidden z-40">
 <a href="#dashboard"class="flex flex-col items-center gap-0.5 py-1 px-3 ${active('dashboard')}">
 ${icon('dashboard', 'w-5 h-5 md:w-6 md:h-6')}
 <span class="text-[10px] font-semibold">Dash</span>
 </a>
 <a href="#marketplace"class="flex flex-col items-center gap-0.5 py-1 px-3 ${active('marketplace')}">
 ${icon('search', 'w-5 h-5 md:w-6 md:h-6')}
 <span class="text-[10px] font-semibold">Find</span>
 </a>
 <a href="#contracts"class="flex flex-col items-center gap-0.5 py-1 px-3 ${active('contracts')}">
 ${icon('document', 'w-5 h-5 md:w-6 md:h-6')}
 <span class="text-[10px] font-semibold">Jobs</span>
 </a>
 </nav>
 `;
}

function impersonationBanner() {
 return '';
}

function announcementBanner() {
 return '';
}

function shell() {
 return `<div class="h-screen overflow-hidden flex flex-col">${impersonationBanner()}${announcementBanner()}<div class="flex-1 overflow-hidden lg:flex relative"><div id="scrim"class="fixed inset-0 z-[60] hidden bg-slate-900/40 backdrop-blur-sm"></div>${sidebar()}<main class="min-w-0 flex-1 flex flex-col h-full pb-16 lg:pb-0">${pageHeader()}<div class="flex-1 overflow-y-auto relative z-0"><div class="mx-auto max-w-7xl p-5 sm:p-8">${state.loading ? skeletonScreen() : currentPage()}</div></div></main>${state.modal === 'notifications' ? notificationPanel() : ''}${modalView()}${mobileBottomNav()}</div></div>`;
}

function skeletonScreen() {
 return `
 <div class="animate-pulse space-y-8">
 <div class="flex gap-4">
 <div class="h-16 w-16 neu-raised rounded-full"></div>
 <div class="flex-1 space-y-3 py-2">
 <div class="h-4 neu-raised rounded w-1/4"></div>
 <div class="h-3 neu-raised rounded w-1/3"></div>
 </div>
 </div>
 <div class="h-48 neu-raised rounded-2xl w-full"></div>
 <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
 <div class="h-32 neu-raised rounded-2xl"></div>
 <div class="h-32 neu-raised rounded-2xl"></div>
 <div class="h-32 neu-raised rounded-2xl"></div>
 </div>
 </div>
 <div class="h-64 neu-raised rounded-2xl w-full"></div>
 </div>
 `;
}

function policyView(policy) {
 const tocHTML = policy.toc ? policy.toc.map(item => `
 <li>
 <a href="javascript:void(0)"onclick="document.getElementById('${item.id}').scrollIntoView({behavior: 'smooth'})"class="text-sm text-slate-600 hover:text-blue-700 hover:font-medium transition-colors block py-1">${item.text}</a>
 </li>
 `).join('') : '';

 return `
 <main class="min-h-screen neu-raised text-slate-900 selection:bg-blue-600 selection:text-white flex flex-col">
 <!-- Header -->
 <header class="neu-raised sticky top-0 z-50">
 <div class="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
 <a href="#dashboard"class="hover:opacity-80 transition-opacity">
 ${icon('logo', 'text-slate-900')}
 </a>
 <div class="flex items-center gap-4 shrink-0">
 <a href="#dashboard"class="text-xs sm:text-sm font-semibold text-slate-600 hover:text-slate-900 whitespace-nowrap">&larr; Back to Home</a>
 </div>
 </div>
 </header>

 <!-- Content Area -->
 <div class="flex-1 max-w-7xl mx-auto w-full px-6 py-12 flex flex-col lg:flex-row gap-6 md:gap-12 items-start">
 
 <!-- Sidebar Navigation -->
 <div class="w-full lg:w-72 flex-shrink-0 lg:sticky top-28 neu-raised p-4 md:p-6 rounded-2xl hidden md:block">
 <h3 class="text-xs font-black text-slate-600 uppercase tracking-widest mb-4">Table of Contents</h3>
 <ul class="space-y-1">
 ${tocHTML}
 </ul>
 <div class="mt-8 pt-6">
 <p class="text-xs text-slate-600 mb-2">Need help understanding these terms?</p>
 <a href="mailto:smartsitemaker@gmail.com"class="text-sm font-bold text-blue-700 hover:text-blue-700 flex items-center gap-2">
 ${icon('mail', 'w-3 h-3 md:w-4 md:h-4')} Contact Legal
 </a>
 </div>
 </div>

 <!-- Main Document -->
 <div class="flex-1 neu-raised rounded-3xl p-8 md:p-14 min-w-0">
 <div class="pb-8 mb-10">
 <span class="inline-block py-1.5 px-4 rounded-full bg-slate-900 text-white text-xs font-bold uppercase tracking-widest mb-4">Legal Policy</span>
 <h1 class="text-2xl md:text-4xl md:text-5xl font-black tracking-tight text-slate-900">${policy.title}</h1>
 <p class="text-slate-600 mt-4 font-medium">Effective Date: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
 </div>
 <div class="prose prose-slate max-w-none prose-headings:font-black prose-headings:text-slate-900 prose-p:text-slate-600 prose-p:leading-relaxed prose-a:text-blue-700 hover:prose-a:text-blue-500 prose-li:text-slate-600">
 ${policy.content}
 </div>
 </div>
 </div>
 
 <!-- Footer -->
 <footer class="bg-slate-900 text-slate-400 py-8 border-slate-800 text-center mt-12 relative z-10">
 <p class="text-sm font-medium">© ${new Date().getFullYear()} SmartSiteMaker Inc. All rights reserved.</p>
 </footer>
 </main>
 `;
}

function render() {
 const app = document.querySelector('#app');
 if (!app) return;
 
 let sidebarScroll = 0;
 const sidebarNav = document.querySelector('#sidebar nav');
 if (sidebarNav) {
 sidebarScroll = sidebarNav.scrollTop;
 }
 
 const hash = window.location.hash;
 
 if (hash.startsWith('#docs')) {
 if (!document.getElementById('docs-container')) {
 app.innerHTML = docsPage();
 }
 setTimeout(() => {
 if (hash !== '#docs') {
 const el = document.getElementById(hash.replace('#', ''));
 if (el) el.scrollIntoView({ behavior: 'smooth' });
 }
 }, 100);
    } else if (hash.startsWith('#reset-password')) {
        if (state.user) {
            state.user = null;
            state.token = null;
            localStorage.removeItem('ssm_state');
        }
        app.innerHTML = resetPasswordView();
    } else if (state.user) {
        app.innerHTML = shell();
    } else {
        if (hash === '#login' || hash === '#register') {
            app.innerHTML = authView();
        } else if (hash === '#verify-email') {
            app.innerHTML = verifyEmailView();
        } else if (hash === '#forgot-password') {
            app.innerHTML = forgotPasswordView();
        } else if (hash === '#about') {
 app.innerHTML = aboutUsPage();
 } else if (hash === '#pricing') {
 } else if (hash.startsWith('#policy-')) {
 const key = hash.replace('#policy-', '');
 if (policies[key]) {
 app.innerHTML = policyView(policies[key]);
 } else {
 app.innerHTML = landingPage();
 }
 } else {
 app.innerHTML = landingPage();
 }
 }
 bindEvents();
 
 if (sidebarScroll > 0) {
 const newSidebarNav = document.querySelector('#sidebar nav');
 if (newSidebarNav) {
 newSidebarNav.scrollTop = sidebarScroll;
 }
 }

 // Init live admin graphs whenever the chart canvas is present in DOM
 if (window.initLiveAdminGraphs && document.getElementById('liveVisitorsChart')) {
 setTimeout(() => window.initLiveAdminGraphs(), 150);
 }
 
 // Auto-scroll chat feed to bottom when rendering
 setTimeout(() => {
 const chatFeed = document.getElementById('contract-chat-feed');
 if (chatFeed) {
 chatFeed.scrollTop = chatFeed.scrollHeight;
 }
 }, 50);
}

function openModal(name) { state.modal = name; render(); }
function closeModal() { state.modal = null; render(); }
function closeMenu() { document.querySelector('#sidebar')?.classList.add('-translate-x-full'); document.querySelector('#scrim')?.classList.add('hidden'); }

async function logout(callApi = true) {
 if (state.eventSource) {
 try { state.eventSource.close(); } catch(_) {}
 state.eventSource = null;
 }
 if (callApi) try { await request('/auth/logout', { method: 'POST' }); } catch (_) { /* token may already be invalid */ }
 localStorage.removeItem('ssm_token'); localStorage.removeItem('ssm_user');
 state.token = null; state.user = null; state.analytics = null; state.contracts = []; state.currentContract = null; state.messages = []; state.invoice = null; state.kycDocuments = []; state.freelancerProfile = null; state.freelancerReviews = null; state.disputes = [];
 render();
}

async function startImpersonation(userId) {
 if (state.user?.role !== 'admin') return;
 try {
 const res = await request(`/admin/impersonate/${userId}`, { method: 'POST' });
 // Save current admin token and user
 state.originalAdminToken = state.token;
 state.originalAdminUser = state.user;
 localStorage.setItem('ssm_orig_token', state.originalAdminToken);
 localStorage.setItem('ssm_orig_user', JSON.stringify(state.originalAdminUser));
 
 // Swap to the impersonated user
 state.token = res.token;
 state.user = res.user;
 localStorage.setItem('ssm_token', state.token);
 localStorage.setItem('ssm_user', JSON.stringify(state.user));
 
 notify(res.message, 'success');
 
 // Reset app state and reload data
 state.notifications = [];
 state.notificationCursor = null;
 if (state.eventSource) {
 try { state.eventSource.close(); } catch(_) {}
 state.eventSource = null;
 }
 
 location.hash = 'dashboard';
 loadRouteData();
 } catch (e) {
 notify('Failed to impersonate: ' + e.message, 'error');
 }
}

async function stopImpersonation() {
 if (!state.originalAdminToken) return;
 
 // Restore admin token and user
 state.token = state.originalAdminToken;
 state.user = state.originalAdminUser;
 localStorage.setItem('ssm_token', state.token);
 localStorage.setItem('ssm_user', JSON.stringify(state.user));
 
 // Clear impersonation state
 state.originalAdminToken = null;
 state.originalAdminUser = null;
 localStorage.removeItem('ssm_orig_token');
 localStorage.removeItem('ssm_orig_user');
 
 notify('Returned to admin dashboard', 'success');
 
 // Reset app state and reload data
 state.notifications = [];
 state.notificationCursor = null;
 if (state.eventSource) {
 try { state.eventSource.close(); } catch(_) {}
 state.eventSource = null;
 }
 
 // Instead of loadRouteData, completely re-initialize the app to fetch all fresh admin data
 // including deposits, withdrawals, and notifications.
 window.location.hash = 'admin';
 await loadCore();
}

window.startImpersonation = startImpersonation;
window.navigate = navigate;
window.stopImpersonation = stopImpersonation;
window.setAdminTab = function(tab) {
 state.adminTab = tab;
 render();
 // Re-init live graphs when switching to overview tab
 if (tab === 'overview' && window.initLiveAdminGraphs) {
 setTimeout(() => window.initLiveAdminGraphs(), 200);
 }
 if (tab === 'ai-tracker' && window.loadAiTrackerStats) {
 setTimeout(() => window.loadAiTrackerStats(), 50);
 }
}

window.loadAiTrackerStats = async function() {
 const container = document.getElementById('ai-tracker-container');
 if (!container) return;
 
 container.innerHTML = '<div class="p-10 text-center text-slate-400 animate-pulse font-medium">Fetching live AI metrics...</div>';
 
 try {
    const res = await request('/admin/ai-tracker');
    
    if (res.length === 0) {
        container.innerHTML = '<div class="p-8 text-center text-slate-600 bg-slate-50 rounded-2xl">No API key usage logged yet. Generate some content first!</div>';
        return;
    }
    
    let rows = res.map(stat => {
        const successRate = stat.total > 0 ? Math.round((stat.success / stat.total) * 100) : 0;
        const pillClass = stat.provider === 'Gemini' ? 'bg-blue-100 text-blue-700 border-blue-200' : 'bg-orange-100 text-orange-700 border-orange-200';
        const rateColor = successRate > 90 ? 'text-emerald-700' : (successRate > 50 ? 'text-amber-800' : 'text-rose-700');
        
        return `
        <tr class="border-b border-slate-100 last:border-0 hover:bg-slate-50/50 transition-colors">
            <td class="p-4 py-3">
                <div class="flex items-center gap-2">
                    <span class="font-mono text-sm font-semibold text-slate-700 bg-slate-100 px-2.5 py-1 rounded-md border border-slate-200">${stat.key}</span>
                </div>
            </td>
            <td class="p-4 py-3">
                <span class="px-2.5 py-1 rounded-full text-xs font-black border ${pillClass}">
                    ${stat.provider}
                </span>
            </td>
            <td class="p-4 py-3 text-right font-black text-slate-900">${stat.total.toLocaleString()}</td>
            <td class="p-4 py-3 text-right font-bold text-emerald-700">${stat.success.toLocaleString()}</td>
            <td class="p-4 py-3 text-right font-bold text-rose-500">${stat.failed.toLocaleString()}</td>
            <td class="p-4 py-3 text-right font-black ${rateColor}">${successRate}%</td>
        </tr>
        `;
    }).join('');
    
    container.innerHTML = `
    <div class="overflow-y-auto max-h-96 rounded-2xl border border-slate-200">
        <table class="w-full text-left text-sm">
            <thead class="bg-slate-50 sticky top-0 shadow-sm text-slate-600 uppercase text-[10px] font-black tracking-wider border-b border-slate-200 z-10">
                <tr>
                    <th class="p-4">Masked Key</th>
                    <th class="p-4">Provider</th>
                    <th class="p-4 text-right">Total Reqs</th>
                    <th class="p-4 text-right">Success</th>
                    <th class="p-4 text-right">Failed</th>
                    <th class="p-4 text-right">Health</th>
                </tr>
            </thead>
            <tbody class="bg-white">
                ${rows}
            </tbody>
        </table>
    </div>
    `;
 } catch (err) {
    container.innerHTML = `<div class="p-6 bg-rose-50 text-rose-700 rounded-2xl border border-rose-100 font-medium">Failed to load tracker: ${err.message}</div>`;
 }
}

window.clearAiTrackerLogs = async function() {
 if (!confirm("Are you sure you want to clear all AI Tracker logs? This cannot be undone.")) return;
 try {
    const res = await request('/admin/ai-tracker/clear', { method: 'DELETE' });
    notify(res.message, 'success');
    window.loadAiTrackerStats();
 } catch (err) {
    notify(err.message, 'error');
 }
}

window.filterLedger = (e) => {
 e.preventDefault();
 const formData = new FormData(e.target);
 const params = new URLSearchParams();
 if (formData.get('start_date')) params.set('start_date', formData.get('start_date'));
 if (formData.get('end_date')) params.set('end_date', formData.get('end_date'));
 
 location.hash = `admin-ledger?${params.toString()}`;
 loadRouteData(); // Reload data with new parameters
};

window.exportLedger = () => {
 const query = new URLSearchParams(window.location.hash.split('?')[1] || '');
 const url = new URL(`${apiBase}/admin/ledger/export`);
 if (query.get('start_date')) url.searchParams.append('start_date', query.get('start_date'));
 if (query.get('end_date')) url.searchParams.append('end_date', query.get('end_date'));
 
 // Using fetch to pass auth token, then trigger download
 fetch(url.toString(), {
 headers: { 'Authorization': `Bearer ${state.token}` }
 })
 .then(res => {
 if (!res.ok) throw new Error('Failed to export ledger');
 return res.blob();
 })
 .then(blob => {
 const a = document.createElement('a');
 a.href = URL.createObjectURL(blob);
 a.download = `ledger_export_${new Date().toISOString().split('T')[0]}.csv`;
 document.body.appendChild(a);
 a.click();
 document.body.removeChild(a);
 })
 .catch(e => notify(e.message, 'error'));
};

window.importGhostProfiles = async () => {
 const statusEl = document.getElementById('ghost-profile-status');
 if (!confirm('This will seed 2,200 ghost profiles into the database. Are you sure?')) return;
 try {
 if (statusEl) { statusEl.className = 'mt-4 text-sm font-medium text-amber-800'; statusEl.textContent = 'Importing ghost profiles... This may take a minute or two.'; }
 const res = await request('/admin/ghost-profiles/import', { method: 'POST' });
 notify(res.message);
 if (statusEl) { statusEl.className = 'mt-4 text-sm font-medium text-emerald-400'; statusEl.textContent = res.message; }
 await loadCore();
 } catch (e) {
 notify(e.message, 'error');
 if (statusEl) { statusEl.className = 'mt-4 text-sm font-medium text-rose-400'; statusEl.textContent = 'Failed to import: ' + e.message; }
 }
};

window.removeGhostProfiles = async () => {
 const statusEl = document.getElementById('ghost-profile-status');
 if (!confirm('Are you absolutely sure you want to remove all ghost profiles? This cannot be undone.')) return;
 try {
 if (statusEl) { statusEl.className = 'mt-4 text-sm font-medium text-amber-800'; statusEl.textContent = 'Removing ghost profiles...'; }
 const res = await request('/admin/ghost-profiles/remove', { method: 'DELETE' });
 notify(res.message);
 if (statusEl) { statusEl.className = 'mt-4 text-sm font-medium text-emerald-400'; statusEl.textContent = res.message; }
 await loadCore();
 } catch (e) {
 notify(e.message, 'error');
 if (statusEl) { statusEl.className = 'mt-4 text-sm font-medium text-rose-400'; statusEl.textContent = 'Failed to remove: ' + e.message; }
 }
};

window.uploadAdminQr = async (input) => {
 if (!input.files || !input.files[0]) return;
 const file = input.files[0];
 const formData = new FormData();
 formData.append('qr_image', file);
 
 const btn = input.nextElementSibling;
 const oldText = btn.textContent;
 btn.textContent = 'Uploading...';
 btn.disabled = true;
 
 try {
 const res = await fetch(`${apiBase}/admin/settings/upload-qr`, {
 method: 'POST',
 headers: {
 'Authorization': `Bearer ${state.token}`,
 'Accept': 'application/json'
 },
 body: formData
 });
 const data = await res.json();
 if (!res.ok) throw new Error(data.message || 'Upload failed');
 
 document.getElementById('manual_upi_qr_url_input').value = data.url;
 notify('QR Code uploaded! Make sure to click Save Dynamic Settings.');
 } catch (e) {
 notify(e.message, 'error');
 } finally {
 btn.textContent = oldText;
 btn.disabled = false;
 input.value = ''; // reset file input
 }
};

function bindEvents() {
    if (window.liveActivityInterval) { clearInterval(window.liveActivityInterval); window.liveActivityInterval = null; }
    if (window.liveTickerInterval) { clearInterval(window.liveTickerInterval); window.liveTickerInterval = null; }

    if (!window._hasGlobalTouchListener) {
        document.addEventListener('touchstart', (e) => {
            if (!e.target.closest('.group, a, button, input, textarea, select')) {
                if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
            }
            if (state.modal === 'notifications') {
                const p = document.getElementById('notification-panel');
                const b = document.getElementById('notifications-button');
                if (p && b && !p.contains(e.target) && !b.contains(e.target)) closeModal();
            }
        });
        window._hasGlobalTouchListener = true;
    }


 const liveFeed = document.querySelector('#live-activity-feed');
 if (liveFeed) {
 const getAmt = () => (Math.floor(Math.random() * 21) + 10) + ',000';
 const actions = [
 () => `Smart AI <span class="text-teal-400">approved a milestone</span> for ₹${getAmt()}.`,
 () => `Enterprise Client <span class="text-blue-400">funded escrow</span> with ₹${getAmt()}.`,
 () => `Freelancer <span class="text-emerald-400">completed task</span> and received ₹${getAmt()}.`,
 () => `New contract started for <span class="text-rose-400">${['React Native App', 'UI/UX Redesign', 'Backend API', 'Cloud Migration', 'E-commerce Setup'][Math.floor(Math.random()*5)]}</span>.`
 ];
 let history = [
 { time: 'Just now', text: actions[0]() },
 { time: '2 mins ago', text: actions[1]() },
 { time: '5 mins ago', text: actions[3]() }
 ];
 const renderFeed = () => {
 liveFeed.innerHTML = history.map(h => `
 <div class="bg-slate-800/50 p-3 rounded-xl border-slate-700/50 transition-all">
 <p class="text-xs text-slate-400">${h.time}</p>
 <p class="text-sm text-white font-medium">${h.text}</p>
 </div>
 `).join('');
 };
 renderFeed();
 window.liveActivityInterval = setInterval(() => {
 history.unshift({ time: 'Just now', text: actions[Math.floor(Math.random() * actions.length)]() });
 history = history.slice(0, 3);
 history.forEach((h, i) => {
 if (i === 1) h.time = Math.floor(Math.random() * 2 + 1) + ' mins ago';
 if (i === 2) h.time = Math.floor(Math.random() * 4 + 3) + ' mins ago';
 });
 renderFeed();
 }, 8000);
 }

 const ticker = document.querySelector('#live-projects-ticker');
 if (ticker) {
 const generateTickerItems = () => {
 let html = '';
 for(let i=0; i<15; i++) {
 const title = ['React Native Dev', 'Fullstack Engineer', 'UI/UX Designer', 'Laravel Expert', 'Python Scripting', 'SEO Specialist', 'Content Writer'][Math.floor(Math.random()*7)];
 const amt = (Math.floor(Math.random() * 150) + 10) + ',000';
 const time = Math.floor(Math.random() * 59) + 1;
 html += `<span class="flex items-center gap-2">🔥 <span class="font-bold">${title}</span> <span class="text-slate-400">| Budget: ₹${amt} |</span> <span class="text-slate-600">${time}m ago</span></span>`;
 }
 return html;
 };
 // Generate a very wide string and duplicate for seamless marquee
 const content = generateTickerItems();
 ticker.innerHTML = content + content;
 
 // Every 30 seconds, regenerate to keep it fresh
 window.liveTickerInterval = setInterval(() => {
 const content = generateTickerItems();
 ticker.innerHTML = content + content;
 }, 30000);
 }
 const aiBtn = document.querySelector('#ai-demo-btn');
 const aiTerminal = document.querySelector('#ai-demo-terminal');
 if (aiBtn && aiTerminal) {
 aiBtn.addEventListener('click', () => {
 if(aiBtn.disabled) return;
 aiBtn.disabled = true;
 aiBtn.innerHTML = '<span class="animate-spin inline-block mr-2">⚙️</span> Analyzing...';
 aiTerminal.innerHTML = '';
 
 const steps = [
 { text: '▶ System.Analyze(milestone_4.zip)', color: 'text-blue-400', delay: 200 },
 { text: 'Scanning 422 files... Code coverage: 94%', color: 'text-slate-400', delay: 800 },
 { text: '▶ AI.EvaluateRequirements(contract_id: 8942)', color: 'text-teal-400 mt-4', delay: 1500 },
 { text: 'Result: 100% Match. All criteria satisfied.', color: 'text-emerald-400', delay: 2200 },
 { text: '▶ Action.ExecuteEscrowTransfer()', color: 'text-rose-400 mt-4', delay: 2800 },
 { text: '₹150,000 released to Freelancer wallet.', color: 'text-white font-bold bg-slate-900 p-2 rounded border-slate-700 inline-block', delay: 3200 }
 ];
 
 steps.forEach((step, index) => {
 setTimeout(() => {
 const el = document.createElement('div');
 el.className = `opacity-0 transform translate-y-2 transition-all duration-300 ${step.color}`;
 el.innerText = step.text;
 aiTerminal.appendChild(el);
 
 void el.offsetWidth;
 el.classList.remove('opacity-0', 'translate-y-2');
 aiTerminal.scrollTop = aiTerminal.scrollHeight;
 
 if(index === steps.length - 1) {
 aiBtn.innerHTML = 'Analysis Complete ✓';
 aiBtn.classList.replace('text-teal-400', 'text-emerald-400');
 aiBtn.classList.replace('hover:bg-teal-500/30', 'bg-emerald-500/20');
 setTimeout(() => {
 aiBtn.disabled = false;
 aiBtn.innerHTML = 'Run Analysis Again';
 aiBtn.classList.replace('text-emerald-400', 'text-teal-400');
 aiBtn.classList.replace('bg-emerald-500/20', 'bg-teal-500/20');
 }, 3000);
 }
 }, step.delay);
 });
 });
 }

 const slider = document.querySelector('#budget-slider');
 if (slider) {
 const agencyCostEl = document.querySelector('#calc-agency');
 const platformCostEl = document.querySelector('#calc-platform');
 const savingsEl = document.querySelector('#calc-savings');
 const budgetDisplay = document.querySelector('#budget-display');
 
 slider.addEventListener('input', (e) => {
 const val = parseInt(e.target.value);
 const agencyCost = val * 1.6;
 const savings = agencyCost - val;
 
 budgetDisplay.textContent = '₹' + val.toLocaleString();
 agencyCostEl.textContent = '₹' + agencyCost.toLocaleString();
 platformCostEl.textContent = '₹' + val.toLocaleString();
 savingsEl.textContent = '₹' + savings.toLocaleString();
 });
 }

 const faqItems = document.querySelectorAll('.faq-item');
 faqItems.forEach(item => {
 item.addEventListener('click', () => {
 const content = item.querySelector('.faq-content');
 const icon = item.querySelector('.faq-icon');
 const isOpen = !content.classList.contains('hidden');
 
 document.querySelectorAll('.faq-content').forEach(el => el.classList.add('hidden'));
 document.querySelectorAll('.faq-icon').forEach(el => el.textContent = '+');
 
 if (!isOpen) {
 content.classList.remove('hidden');
 icon.textContent = '−';
 }
 });
 });

 const mobileMenuBtn = document.querySelector('#mobile-menu-btn');
 const mobileMenu = document.querySelector('#mobile-menu');
 if (mobileMenuBtn && mobileMenu) {
 mobileMenuBtn.addEventListener('click', () => {
 mobileMenu.classList.toggle('hidden');
 });
 
 // Close mobile menu when a link is clicked
 const mobileLinks = mobileMenu.querySelectorAll('.mobile-link, .btn-primary');
 mobileLinks.forEach(link => {
 link.addEventListener('click', () => {
 mobileMenu.classList.add('hidden');
 });
 });
 }

 if (!state.user) {
 document.querySelectorAll('a[href^="#"]').forEach(link => {
 link.addEventListener('click', (e) => {
 const targetId = link.getAttribute('href').substring(1);
 if (['login', 'register', 'dashboard'].includes(targetId) || targetId.startsWith('policy-')) return;
 
 const targetEl = document.getElementById(targetId);
 if (targetEl) {
 e.preventDefault();
 targetEl.scrollIntoView({ behavior: 'smooth' });
 window.history.pushState(null, null, `#${targetId}`);
 }
 });
 });
 }

 document.querySelector('#toggle-auth')?.addEventListener('click', () => {
 const fields = document.querySelectorAll('.reg-field');
 fields.forEach(f => f.classList.toggle('hidden'));
 const register = !fields[0].classList.contains('hidden');
 document.querySelector('#auth-submit').textContent = register ? 'Create account' : 'Sign in';
 document.querySelector('#toggle-auth').textContent = register ? 'Already have an account? Sign in' : 'Need an account? Create one';
 
 const verifyBtn = document.querySelector('#btn-verify-email');
 const editBtn = document.querySelector('#btn-edit-email');
 if (register && !document.querySelector('#auth-email').readOnly) {
 verifyBtn.classList.remove('hidden');
 } else {
 verifyBtn.classList.add('hidden');
 editBtn.classList.add('hidden');
 }
 
 ['#auth-phone', '#auth-name', '#auth-confirm', '#auth-role'].forEach(selector => {
 const el = document.querySelector(selector);
 if (el) el.required = register;
 });
 if (!register) document.querySelector('#auth-otp').required = false;
 });

 document.querySelector('#btn-verify-email')?.addEventListener('click', async (event) => {
 const emailInput = document.querySelector('#auth-email');
 if (!emailInput.value || !emailInput.checkValidity()) {
 notify('Please enter a valid email address first.', 'error'); return;
 }
 const btn = event.currentTarget;
 btn.innerHTML = 'Sending...'; btn.disabled = true;
 try {
 await request('/auth/send-register-otp', { method: 'POST', body: JSON.stringify({ email: emailInput.value }) });
 notify('OTP sent! Please check your email inbox.');
 emailInput.readOnly = true;
 emailInput.classList.add('neu-raised', 'text-slate-600');
 btn.classList.add('hidden');
 document.querySelector('#btn-edit-email').classList.remove('hidden');
 
 // Show OTP field
 const otpField = document.querySelector('#register-otp');
 otpField.style.display = 'block';
 document.querySelector('#auth-otp').required = true;
 document.querySelector('#auth-otp').focus();
 } catch (e) {
 notify(e.message, 'error');
 } finally {
 btn.innerHTML = 'Verify'; btn.disabled = false;
 }
 });

 document.querySelector('#btn-edit-email')?.addEventListener('click', (event) => {
 const emailInput = document.querySelector('#auth-email');
 emailInput.readOnly = false;
 emailInput.classList.remove('neu-raised', 'text-slate-600');
 event.currentTarget.classList.add('hidden');
 document.querySelector('#btn-verify-email').classList.remove('hidden');
 document.querySelector('#register-otp').style.display = 'none';
 document.querySelector('#auth-otp').required = false;
 });

 document.querySelector('#auth-form')?.addEventListener('submit', async (event) => {
 event.preventDefault();
 const register = !document.querySelector('.reg-field').classList.contains('hidden');
 
 if (register && !document.querySelector('#auth-email').readOnly) {
 notify('Please click"Verify"next to your email address first.', 'error');
 return;
 }

 try {
 const result = await request(register ? '/auth/register' : '/auth/login', { method: 'POST', body: JSON.stringify(formObject(event.currentTarget)) });
 state.token = result.token; state.user = result.user;
 localStorage.setItem('ssm_token', state.token); localStorage.setItem('ssm_user', JSON.stringify(state.user));
 location.hash = 'dashboard'; await loadCore(); notify(`Welcome, ${state.user.name.split(' ')[0]}.`);
 } catch (error) { notify(error.message, 'error'); }
 });
 
 document.querySelector('#verify-email-form')?.addEventListener('submit', async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const btn = form.querySelector('button[type="submit"]');
        const og = btn.innerHTML; 
        try {
            btn.innerHTML = 'Verifying...'; btn.disabled = true;
            
            const otp = form.querySelector('#verify-email-otp').value;
            const oldToken = state.token;
            state.token = state.tempAuthToken; 
            const result = await request('/auth/verify-email', { method: 'POST', body: JSON.stringify({ email: state.user.email, otp }) });
            
            state.token = result.token || state.tempAuthToken; 
            state.user.email_verified_at = new Date().toISOString();
            localStorage.setItem('ssm_token', state.token);
            localStorage.setItem('ssm_user', JSON.stringify(state.user));
            location.hash = 'dashboard'; await loadCore(); notify('Email verified successfully!', 'success');
        } catch (error) {
            state.token = state.tempAuthToken; // Restoring tempAuthToken properly
            notify(error.message, 'error'); 
            btn.innerHTML = 'Verify & Continue';
            btn.disabled = false;
        }
    });

 const verifyEmailForm = document.querySelector('#verify-email-form');
 if (verifyEmailForm) {
 let timeLeft = 60;
 const timerText = document.querySelector('#otp-timer-text');
 const timerSpan = document.querySelector('#otp-timer');
 const resendBtn = document.querySelector('#resend-otp-btn');
 
 if (window.otpTimerInterval) clearInterval(window.otpTimerInterval);
 const updateTimer = () => {
 if (timeLeft <= 0) {
 if (timerText) timerText.classList.add('hidden');
 if (resendBtn) resendBtn.classList.remove('hidden');
 clearInterval(window.otpTimerInterval);
 return;
 }
 if (timerSpan) timerSpan.textContent = timeLeft;
 timeLeft--;
 };
 updateTimer();
 window.otpTimerInterval = setInterval(updateTimer, 1000);
 
 if (resendBtn) {
 resendBtn.addEventListener('click', async () => {
 try {
 resendBtn.textContent = 'Sending...';
 resendBtn.disabled = true;
 await request('/auth/resend-otp', { 
 method: 'POST', 
 body: JSON.stringify({ token: state.tempAuthToken })
 });
 notify('OTP has been resent to your email.', 'success');
 timeLeft = 60;
 resendBtn.classList.add('hidden');
 timerText.classList.remove('hidden');
 resendBtn.textContent = 'Resend OTP';
 resendBtn.disabled = false;
 updateTimer();
 window.otpTimerInterval = setInterval(updateTimer, 1000);
 } catch (error) {
 notify(error.message, 'error');
 resendBtn.textContent = 'Resend OTP';
 resendBtn.disabled = false;
 }
 });
 }
 }

 document.querySelector('#forgot-password-form')?.addEventListener('submit', async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const btn = form.querySelector('button[type="submit"]');
        const og = btn.innerHTML; 
        try {
            btn.innerHTML = 'Sending...'; btn.disabled = true;
            await request('/auth/forgot-password', { method: 'POST', body: JSON.stringify(formObject(form)) });
            notify('Reset link sent to your email! (Check backend logs for the simulated email)', 'success');
            btn.innerHTML = og; btn.disabled = false;
        } catch (error) { 
            notify(error.message, 'error');
            btn.innerHTML = 'Send Reset Link';
            btn.disabled = false;
        }
    });

 document.querySelector('#reset-password-form')?.addEventListener('submit', async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const btn = form.querySelector('button[type="submit"]');
        const data = formObject(form);
        if (data.password !== data.password_confirmation) {
            return notify('Passwords do not match', 'error');
        }
        const og = btn.innerHTML; 
        try {
            btn.innerHTML = 'Resetting...'; btn.disabled = true;
            await request('/auth/reset-password', { method: 'POST', body: JSON.stringify(data) });
            notify('Password has been reset successfully. You can now login.', 'success');
            location.hash = 'login';
        } catch (error) {
            notify(error.message, 'error');
            btn.innerHTML = 'Reset Password';
            btn.disabled = false;
        }
    });
 document.querySelector('#logout')?.addEventListener('click', () => logout());
 document.querySelector('#header-logout')?.addEventListener('click', () => logout());

 document.querySelector('#newsletter-btn')?.addEventListener('click', async () => {
 const emailInput = document.querySelector('#newsletter-email');
 const email = emailInput.value.trim();
 if (!email) return notify('Please enter your email address.', 'error');
 
 const btn = document.querySelector('#newsletter-btn');
 btn.textContent = 'Subscribing...';
 btn.disabled = true;
 
 try {
 await request('/newsletter/subscribe', { method: 'POST', body: JSON.stringify({ email }) });
 notify('Subscribed successfully! You will receive our updates.');
 emailInput.value = '';
 btn.textContent = 'Subscribed!';
 btn.classList.replace('bg-blue-600', 'bg-emerald-600');
 btn.classList.replace('hover:bg-blue-500', 'hover:bg-emerald-500');
 } catch (error) {
 notify(error.message, 'error');
 btn.textContent = 'Subscribe';
 btn.disabled = false;
 }
 });
 const notifBtn = document.querySelector('#notifications-button');
 if (notifBtn) {
 notifBtn.addEventListener('mouseenter', async () => {
 clearTimeout(window.notificationHideTimer);
 if (state.modal !== 'notifications') {
 await loadNotifications();
 openModal('notifications');
 }
 });
 notifBtn.addEventListener('mouseleave', () => {
 window.notificationHideTimer = setTimeout(() => {
 if (state.modal === 'notifications') closeModal();
 }, 300);
 });
 notifBtn.addEventListener('click', async () => {
 if (state.modal === 'notifications') {
 closeModal();
 } else {
 await loadNotifications();
 openModal('notifications');
 }
 });
 }

 const notifPanel = document.querySelector('#notifications-panel');
 if (notifPanel) {
 notifPanel.addEventListener('mouseenter', () => {
 clearTimeout(window.notificationHideTimer);
 });
 notifPanel.addEventListener('mouseleave', () => {
 window.notificationHideTimer = setTimeout(() => {
 if (state.modal === 'notifications') closeModal();
 }, 300);
 });
 }
 document.querySelector('[data-clear-all]')?.addEventListener('click', async () => {
 // Optimistic UI update
 state.unreadNotifications = 0;
 state.notifications = [];
 render();
 await request('/notifications/clear', { method: 'DELETE' });
 });
 document.querySelectorAll('[data-notification-route]').forEach((button) => button.addEventListener('click', async () => {
 const id = button.dataset.notificationId;
 const route = button.dataset.notificationRoute;
 
 // Optimistic UI update
 const notif = state.notifications.find(n => n.id === id);
 if (notif && !notif.read_at) {
 notif.read_at = new Date().toISOString();
 if (state.unreadNotifications > 0) state.unreadNotifications--;
 }
 
 if (route.startsWith('modal:')) {
 openModal(route.split(':')[1]);
 } else {
 await navigate(route);
 }
 
 // Fire request in background
 request(`/notifications/${id}/read`, { method: 'PATCH' }).catch(console.error);
 }));
 document.querySelector('#open-menu')?.addEventListener('click', () => { document.querySelector('#sidebar').classList.remove('-translate-x-full'); document.querySelector('#scrim').classList.remove('hidden'); });
 document.querySelector('#close-menu')?.addEventListener('click', closeMenu);
 document.querySelector('#scrim')?.addEventListener('click', closeMenu);
 document.querySelectorAll('[data-open-modal]').forEach((button) => button.addEventListener('click', () => openModal(button.dataset.openModal)));
 document.querySelectorAll('[data-close-modal]').forEach((button) => button.addEventListener('click', closeModal));
 document.querySelector('#job-search')?.addEventListener('input', filterJobs);
 document.querySelector('#job-category')?.addEventListener('change', filterJobs);
 document.querySelector('#job-payment-type')?.addEventListener('change', filterJobs);
 document.querySelector('#job-min-budget')?.addEventListener('input', filterJobs);
 document.querySelector('#job-max-budget')?.addEventListener('input', filterJobs);
 document.querySelector('#job-smart-feed')?.addEventListener('change', filterJobs);
 document.querySelector('#job-form')?.addEventListener('submit', submitJob);
 document.querySelector('#log-time-form')?.addEventListener('submit', logTime);

 document.querySelector('#create-agency-form')?.addEventListener('submit', createAgency);
 document.querySelector('#update-agency-form')?.addEventListener('submit', handleAgencyUpdate);
 document.querySelector('#invite-agency-form')?.addEventListener('submit', inviteAgencyMember);

 document.querySelector('#proposal-form')?.addEventListener('submit', submitProposal);
 document.querySelector('#kyc-form')?.addEventListener('submit', submitKyc);
 document.querySelector('#freelancer-profile-form')?.addEventListener('submit', submitFreelancerProfile);
 document.querySelector('#user-profile-form')?.addEventListener('submit', submitUserProfile);
 document.querySelectorAll('[data-accept-proposal]').forEach((button) => button.addEventListener('click', () => acceptProposal(button.dataset.acceptProposal)));
 document.querySelectorAll('[data-contract]').forEach((button) => button.addEventListener('click', () => navigate(`contracts/${button.dataset.contract}`)));
 document.querySelectorAll('[data-delete-contract]').forEach((button) => button.addEventListener('click', () => deleteContract(button.dataset.deleteContract)));
 document.querySelectorAll('[data-fund]').forEach((button) => button.addEventListener('click', () => mutateMilestone(button.dataset.fund, 'fund')));
 document.querySelectorAll('[data-release]').forEach((button) => button.addEventListener('click', () => mutateMilestone(button.dataset.release, 'release')));
 document.querySelectorAll('[data-open-deliverable]').forEach((button) => button.addEventListener('click', () => openModal(`deliverable:${button.dataset.openDeliverable}`)));
 document.querySelectorAll('[data-open-dispute]').forEach((button) => button.addEventListener('click', () => openModal(`dispute:${button.dataset.openDispute}`)));
 document.querySelector('#message-form')?.addEventListener('submit', sendMessage);

 // Auto-scroll chat to bottom when workspace loads
 requestAnimationFrame(() => {
 const chatList = document.querySelector('#chat-messages-list');
 if (chatList) chatList.scrollTop = chatList.scrollHeight;
 });

 // Enter to send (Shift+Enter for newline)
 document.querySelector('#message-form [name="body"]')?.addEventListener('keydown', (e) => {
 if (e.key === 'Enter' && !e.shiftKey) {
 e.preventDefault();
 document.querySelector('#message-form')?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
 }
 });

 document.querySelector('#deliverable-form')?.addEventListener('submit', submitDeliverable);
 document.querySelector('#dispute-form')?.addEventListener('submit', submitDispute);
 document.querySelector('#review-form')?.addEventListener('submit', submitReview);
 document.querySelector('[data-issue-invoice]')?.addEventListener('click', issueInvoice);
 document.querySelectorAll('[data-review-kyc]').forEach((button) => button.addEventListener('click', () => reviewKyc(button.dataset.reviewKyc, button.dataset.status)));
 document.querySelectorAll('[data-resolve-dispute]').forEach((button) => button.addEventListener('click', () => resolveDispute(button.dataset.resolveDispute, button.dataset.resolution)));
 document.querySelectorAll('[data-review-payment]').forEach((button) => button.addEventListener('click', () => reviewManualPayment(button.dataset.contractId, button.dataset.reviewPayment, button.dataset.status)));
 document.querySelectorAll('[data-toggle-kyc]').forEach(btn => btn.addEventListener('click', () => toggleKycStatus(btn.dataset.toggleKyc, btn.dataset.current)));
 document.querySelectorAll('[data-change-role]').forEach(select => select.addEventListener('change', () => changeUserRole(select.dataset.changeRole, select.value)));
 document.querySelectorAll('[data-admin-delete-job]').forEach(btn => btn.addEventListener('click', () => adminDeleteJob(btn.dataset.adminDeleteJob)));
 document.querySelector('#admin-settings-form')?.addEventListener('submit', submitAdminSettings);
 document.querySelector('#wallet-balance-btn')?.addEventListener('click', showWalletModal);
 document.querySelectorAll('[data-approve-withdrawal]').forEach(btn => btn.addEventListener('click', () => adminWithdrawal(btn.dataset.approveWithdrawal, 'approve')));
 document.querySelectorAll('[data-reject-withdrawal]').forEach(btn => btn.addEventListener('click', () => adminWithdrawal(btn.dataset.rejectWithdrawal, 'reject')));
 document.querySelectorAll('[data-approve-deposit]').forEach(btn => btn.addEventListener('click', () => adminDeposit(btn.dataset.approveDeposit, 'approve')));
 document.querySelectorAll('[data-reject-deposit]').forEach(btn => btn.addEventListener('click', () => adminDeposit(btn.dataset.rejectDeposit, 'reject')));
 // Phase 2 bindings
 document.querySelectorAll('[data-view-freelancer]').forEach(btn => btn.addEventListener('click', () => navigate(`freelancers/${btn.dataset.viewFreelancer}`)));
 document.querySelectorAll('[data-take-test]').forEach(btn => btn.addEventListener('click', () => openSkillTest(btn.dataset.takeTest)));
 document.querySelectorAll('[data-subscribe-plan]').forEach(btn => btn.addEventListener('click', () => subscribeMembership(btn.dataset.subscribePlan)));
 document.querySelector('#copy-referral-link')?.addEventListener('click', copyReferralLink);
 document.querySelector('#claim-referral-btn')?.addEventListener('click', claimReferral);
 document.querySelector('#notification-prefs-form')?.addEventListener('submit', saveNotificationPrefs);
 document.querySelector('#portfolio-form')?.addEventListener('submit', addPortfolioItem);
 document.querySelectorAll('[data-delete-portfolio]').forEach(btn => btn.addEventListener('click', () => deletePortfolioItem(btn.dataset.deletePortfolio)));
 document.querySelector('#client-profile-form')?.addEventListener('submit', saveClientProfile);
 document.querySelector('#admin-search-input')?.addEventListener('input', adminSearch);
 document.querySelectorAll('[data-delete-skill-test]').forEach(btn => btn.addEventListener('click', () => deleteSkillTest(btn.dataset.deleteSkillTest)));
 document.querySelector('#create-skill-test-form')?.addEventListener('submit', createSkillTest);
}


async function submitAdminSettings(event) {
 event.preventDefault();
 try {
 const result = await request('/admin/settings', {
 method: 'PATCH',
 body: JSON.stringify(formObject(event.currentTarget))
 });
 state.settings = result.data || {};
 notify(`Commission settings saved successfully.`);
 render();
 } catch (error) {
 notify(error.message, 'error');
 }
}

window.saveAiSettings = async (event) => {
 event.preventDefault();
 try {
 const result = await request('/admin/ai-settings', {
 method: 'POST',
 body: JSON.stringify(formObject(event.currentTarget))
 });
 notify(result.message || 'AI settings saved!', 'success');
 await window.dispatchEvent(new Event('hashchange')); // Reload state
 } catch (error) {
 notify(error.message, 'error');
 }
};

window.showWalletModal = async function() {
 let qrUrl = '/media_1787271444063.jpg';
 try {
 const res = await request('/settings/public');
 if (res.data && res.data.manual_upi_qr_url) {
 qrUrl = res.data.manual_upi_qr_url;
 }
 } catch (e) { console.error('Failed to load QR setting'); }

 const modalDiv = document.createElement('div');
 modalDiv.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm animate-in fade-in duration-200 overflow-y-auto';
    modalDiv.innerHTML = `
    <div class="soft-panel w-full max-w-md p-0 my-8 relative overflow-hidden flex flex-col shadow-2xl">
        <div class="flex flex-col neu-raised relative">
            <button id="wallet-close" class="absolute top-4 right-4 text-slate-600 hover:text-slate-900 transition neu-raised hover:bg-slate-100 rounded-full w-8 h-8 flex items-center justify-center text-lg z-10">&times;</button>
            <div class="p-4 md:p-6 text-center pb-6 pt-6 bg-gradient-to-br from-teal-950/40 to-slate-900/40">
                <p class="text-[11px] font-bold text-blue-700/80 uppercase tracking-widest mb-1.5">Available Balance</p>
                <p id="wallet-balance-display" class="text-3xl md:text-5xl font-black text-slate-900 tracking-tight">${money(state.user?.balance ?? 0)}</p>
            </div>
            <div class="flex">
                <button id="tab-deposit" class="flex-1 py-3 text-sm font-bold neu-raised/5 text-slate-900 -2 border-teal-400 transition">Deposit</button>
                <button id="tab-withdraw" class="flex-1 py-3 text-sm font-bold text-slate-600 -2 border-transparent hover:text-slate-900 hover:neu-raised transition">Withdraw</button>
            </div>
        </div>
        
        <div id="content-deposit" class="p-4 md:p-6 space-y-5 animate-in slide-in-from-left-4 duration-300">
            <div class="flex flex-col sm:flex-row gap-5">
                <div class="p-3 neu-raised rounded-2xl flex flex-col items-center justify-center shrink-0 w-full sm:w-56">
                    <img src="${qrUrl}" alt="Payment QR Code" class="w-44 h-44 sm:w-48 sm:h-48 rounded-xl neu-raised p-2 object-contain mb-2">
                    <div class="text-center text-[11px] font-medium text-slate-600 leading-tight">Scan with any UPI App</div>
                </div>
                <div class="bg-blue-50 border border-blue-100 p-4 rounded-xl text-xs text-blue-700 leading-relaxed flex-1 flex flex-col justify-center">
                    <strong class="text-[13px] mb-1.5 block">How to Deposit:</strong>
                    <span class="block mb-1">1. Scan the QR code and pay the exact amount.</span>
                    <span class="block mb-2">2. Note the <strong>12-digit UTR/Reference number</strong> from the success screen.</span>
                    <span class="text-slate-900 block opacity-90 mt-auto">⏱ Funds credited in <strong>max 1-2 hours</strong>.</span>
                </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <label class="block text-xs font-semibold text-slate-600">Deposit Amount (₹)
                    <input id="deposit-amount" class="input-control mt-1" type="number" min="1" step="1" placeholder="e.g. 5000">
                </label>
                <label class="block text-xs font-semibold text-slate-600">12-Digit UTR Number
                    <input id="deposit-utr" class="input-control mt-1" type="text" placeholder="e.g. 312345678901">
                </label>
            </div>
            <button id="deposit-btn" class="btn-primary w-full py-3 -teal-500/20">Submit for Verification</button>
        </div>
        
        <div id="content-withdraw" class="p-4 md:p-6 space-y-4 hidden animate-in slide-in-from-right-4 duration-300">
            <div class="bg-rose-50/50 border border-rose-100 p-4 rounded-xl text-[12px] text-slate-700 mb-2 leading-relaxed">
                <span class="text-rose-700 font-bold block mb-1">Important:</span>
                Withdrawals are processed manually and will be credited to your account in <strong>max 1-2 hours</strong>.
            </div>
            <label class="block text-xs font-semibold text-slate-600">Withdrawal Amount (₹)
                <input id="withdraw-amount" class="input-control mt-1" type="number" min="100" step="1" placeholder="Minimum ₹100" max="${state.user?.balance ?? 0}">
            </label>
            <label class="block text-xs font-semibold text-slate-600">Payout Method
                <select id="withdraw-method" class="input-control mt-1">
                    <option value="upi">UPI Transfer</option>
                    <option value="bank">Bank Transfer</option>
                </select>
            </label>
            <label class="block text-xs font-semibold text-slate-600">Account Details
                <textarea id="withdraw-details" class="input-control mt-1" rows="2" placeholder="UPI ID or Bank Account / IFSC"></textarea>
            </label>
            <button id="withdraw-btn" class="btn-secondary w-full py-3 text-rose-700 border-rose-200 hover:bg-rose-50 hover:text-rose-700 mt-2">Request Withdrawal</button>
        </div>
    </div>
    `;
 document.body.appendChild(modalDiv);
 
 const tabDeposit = modalDiv.querySelector('#tab-deposit');
 const tabWithdraw = modalDiv.querySelector('#tab-withdraw');
 const contentDeposit = modalDiv.querySelector('#content-deposit');
 const contentWithdraw = modalDiv.querySelector('#content-withdraw');
 
 tabDeposit.addEventListener('click', () => {
 tabDeposit.className = 'flex-1 py-3 text-sm font-bold neu-raised/5 text-slate-900 -2 border-teal-400 transition';
 tabWithdraw.className = 'flex-1 py-3 text-sm font-bold text-slate-600 -2 border-transparent hover:text-slate-900 hover:neu-raised transition';
 contentDeposit.classList.remove('hidden');
 contentWithdraw.classList.add('hidden');
 });
 
 tabWithdraw.addEventListener('click', () => {
 tabWithdraw.className = 'flex-1 py-3 text-sm font-bold neu-raised/5 text-slate-900 -2 border-teal-400 transition';
 tabDeposit.className = 'flex-1 py-3 text-sm font-bold text-slate-600 -2 border-transparent hover:text-slate-900 hover:neu-raised transition';
 contentWithdraw.classList.remove('hidden');
 contentDeposit.classList.add('hidden');
 });
 modalDiv.querySelector('#wallet-close').addEventListener('click', () => modalDiv.remove());
 modalDiv.addEventListener('click', (e) => { if (e.target === modalDiv) modalDiv.remove(); });
 modalDiv.querySelector('#deposit-btn').addEventListener('click', async () => {
 const amount = parseFloat(modalDiv.querySelector('#deposit-amount').value);
 const utr = modalDiv.querySelector('#deposit-utr').value.trim();
 const gateway = 'manual_upi';

 if (!amount || amount <= 0) return notify('Please enter a valid amount', 'error');
 if (!utr) return notify('Please enter the 12-digit UTR number', 'error');
 try {
 const result = await request('/wallet/deposit', { method: 'POST', body: JSON.stringify({ amount, gateway, utr }) });
 notify(result.message || 'Deposit request submitted successfully.', 'success');
 modalDiv.remove();
 } catch (error) { notify(error.message, 'error'); }
 });
 modalDiv.querySelector('#withdraw-btn').addEventListener('click', async () => {
 const amount = parseFloat(modalDiv.querySelector('#withdraw-amount').value);
 const method = modalDiv.querySelector('#withdraw-method').value;
 const details = modalDiv.querySelector('#withdraw-details').value;
 if (!amount || amount < 100) { notify('Minimum withdrawal is ₹100.', 'error'); return; }
 if (!details.trim()) { notify('Enter your payout details.', 'error'); return; }
 try {
 const result = await request('/wallet/withdraw', { method: 'POST', body: JSON.stringify({ amount, payout_method: method, payout_details: details }) });
 notify(`Withdrawal request submitted. New balance: ${money(result.balance)}`);
 state.user.balance = result.balance;
 localStorage.setItem('ssm_user', JSON.stringify(state.user));
 modalDiv.remove();
 render();
 } catch (error) { notify(error.message, 'error'); }
 });
}

async function adminWithdrawal(id, action) {
 const confirmed = await confirmPopup(`${action === 'approve' ? 'Approve' : 'Reject'} this withdrawal request?`);
 if (!confirmed) return;
 try {
 await request(`/admin/withdrawals/${id}/${action}`, { method: 'POST' });
 notify(`Withdrawal ${action}d successfully.`);
 state.adminWithdrawals = state.adminWithdrawals.map(w => w.id == id ? { ...w, status: action === 'approve' ? 'approved' : 'rejected' } : w);
 render();
 } catch (error) { notify(error.message, 'error'); }
}

async function adminDeposit(id, action) {
 const confirmed = await confirmPopup(`${action === 'approve' ? 'Approve' : 'Reject'} this deposit request?`);
 if (!confirmed) return;
 try {
 await request(`/admin/deposits/${id}/${action}`, { method: 'POST' });
 notify(`Deposit ${action}d successfully.`);
 state.adminDeposits = state.adminDeposits.map(d => d.id == id ? { ...d, status: action === 'approve' ? 'completed' : 'rejected' } : d);
 render();
 } catch (error) { notify(error.message, 'error'); }
}

function filterJobs() {
 const term = document.querySelector('#job-search').value.toLowerCase();
 const category = document.querySelector('#job-category').value;
 const paymentType = document.querySelector('#job-payment-type')?.value;
 const minBudget = parseInt(document.querySelector('#job-min-budget')?.value || 0, 10);
 const maxBudget = parseInt(document.querySelector('#job-max-budget')?.value || 0, 10);
 const smartCheck = document.querySelector('#job-smart-feed');
 const smartFeedEnabled = smartCheck ? smartCheck.checked : false;

 const mySkills = (state.freelancerProfile?.skills || []).map(s => s.toLowerCase());

 const filtered = state.jobs.filter((job) => {
 if (category && job.category !== category) return false;
 if (paymentType && job.payment_type !== paymentType) return false;
 
 const budget = job.payment_type === 'hourly' ? job.hourly_rate : job.budget;
 if (minBudget && budget < minBudget) return false;
 if (maxBudget && budget > maxBudget) return false;
 
 if (smartFeedEnabled) {
 const hasMatch = (job.skills || []).some(s => mySkills.includes(s.toLowerCase()));
 if (!hasMatch) return false;
 }

 return [job.title, job.description, ...(job.skills || [])].join(' ').toLowerCase().includes(term);
 });
 
 document.querySelector('#job-grid').innerHTML = filtered.map(jobCard).join('') || empty(smartFeedEnabled && !mySkills.length ? 'Add skills to your professional profile to populate your Smart Feed matching results.' : 'No matching jobs are open.');
}

async function submitJob(event) {
 event.preventDefault();
 const form = event.currentTarget;
 const btn = form.querySelector('button[type="submit"]');
 const originalText = btn.innerHTML;
 
 // Cool loading state
 btn.innerHTML = `<svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block"xmlns="http://www.w3.org/2000/svg"fill="none"viewBox="0 0 24 24"><circle class="opacity-25"cx="12"cy="12"r="10"stroke="currentColor"stroke-width="4"></circle><path class="opacity-75"fill="currentColor"d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> Publishing Your Job...`;
 btn.disabled = true;
 form.classList.add('opacity-50', 'pointer-events-none');
 
 const data = formObject(form);
 data.skills = data.skills ? data.skills.split(',').map((skill) => skill.trim()).filter(Boolean) : [];
 data.currency = 'INR';
 if (!data.deadline) delete data.deadline;
 
 try {
 const created = await request('/jobs', { method: 'POST', body: JSON.stringify(data) });
 if (state.jobs) {
 state.jobs.unshift(created.data);
 }
 
 // Energetic Success Animation & Countdown
 const modalEl = document.querySelector('section[role="dialog"]');
 if (modalEl) {
 modalEl.innerHTML = `
 <div class="text-center p-6 md:p-10 flex flex-col items-center justify-center animate-[fade-in_0.5s_ease-out]">
 <div class="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6 -inner animate-[bounce_1s_infinite]">
 <svg class="w-8 h-8 md:w-12 md:h-12 text-green-500"fill="none"stroke="currentColor"viewBox="0 0 24 24"stroke-width="3">
 <path stroke-linecap="round"stroke-linejoin="round"d="M5 13l4 4L19 7"></path>
 </svg>
 </div>
 <h2 class="text-2xl md:text-4xl font-black text-slate-900 mb-3 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-teal-500 to-emerald-600">Boom! 🚀 Job Published!</h2>
 <p class="text-slate-600 mb-8 max-w-md mx-auto text-lg">Your job is now live! Get ready to receive awesome proposals from top freelancers.</p>
 
 <div class="w-full max-w-xs mx-auto">
 <p class="text-sm font-bold text-slate-400 mb-2 uppercase tracking-widest">Redirecting in <span id="success-countdown"class="text-emerald-500 text-lg">3</span></p>
 <div class="w-full bg-slate-100 rounded-full h-2 mb-8 overflow-hidden -inner">
 <div class="bg-gradient-to-r from-teal-400 to-emerald-500 h-2 rounded-full"style="animation: progress 3s linear forwards;"></div>
 </div>
 </div>
 
 <button class="btn-primary w-full max-w-xs shadow-emerald-500/30"onclick="closeModal(); navigate('jobs/${created.data.id}')">Take me there now</button>
 
 <style>
 @keyframes progress { from { width: 0%; } to { width: 100%; } }
 </style>
 </div>
 `;
 
 let timeLeft = 3;
 const timer = setInterval(() => {
 timeLeft--;
 const counter = document.getElementById('success-countdown');
 if (counter) counter.innerText = timeLeft;
 if (timeLeft <= 0) {
 clearInterval(timer);
 closeModal();
 navigate(`jobs/${created.data.id}`);
 }
 }, 1000);
 } else {
 closeModal();
 navigate(`jobs/${created.data.id}`);
 }
 } catch (error) { 
 notify(error.message, 'error'); 
 form.classList.remove('opacity-50', 'pointer-events-none');
 btn.innerHTML = originalText;
 btn.disabled = false;
 }
}

async function submitProposal(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const btn = form.querySelector('button[type="submit"]');
    let originalText = '';
    if (btn) {
        originalText = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = '<span class="loader border-4 border-white/30 border-t-white rounded-full w-5 h-5 inline-block animate-spin align-middle mr-2"></span> Submitting...';
    }
    try {
        await request(`/jobs/${state.currentJob.id}/proposals`, { method: 'POST', body: JSON.stringify(formObject(form)) });
        
        const modalEl = document.querySelector('section[role="dialog"]');
        if (modalEl) {
            modalEl.innerHTML = `
            <div class="text-center p-6 md:p-10 flex flex-col items-center justify-center animate-[fade-in_0.5s_ease-out]">
                <div class="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6 -inner animate-[bounce_1s_infinite]">
                    <svg class="w-8 h-8 md:w-12 md:h-12 text-green-500"fill="none"stroke="currentColor"viewBox="0 0 24 24"stroke-width="3">
                        <path stroke-linecap="round"stroke-linejoin="round"d="M5 13l4 4L19 7"></path>
                    </svg>
                </div>
                <h2 class="text-2xl md:text-4xl font-black text-slate-900 mb-3 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-teal-500 to-emerald-600">Awesome! 🚀 Proposal Sent!</h2>
                <p class="text-slate-600 mb-8 max-w-md mx-auto text-lg">Your proposal has been submitted successfully to the client. Good luck!</p>
                
                <div class="w-full max-w-xs mx-auto">
                    <p class="text-sm font-bold text-slate-400 mb-2 uppercase tracking-widest">Closing in <span id="success-countdown-prop"class="text-emerald-500 text-lg">3</span></p>
                    <div class="w-full bg-slate-100 rounded-full h-2 mb-8 overflow-hidden -inner">
                        <div class="bg-gradient-to-r from-teal-400 to-emerald-500 h-2 rounded-full"style="animation: progress 3s linear forwards;"></div>
                    </div>
                </div>
                
                <button class="btn-primary w-full max-w-xs shadow-emerald-500/30"onclick="closeModal();">Close Now</button>
                
                <style>
                    @keyframes progress { from { width: 0%; } to { width: 100%; } }
                </style>
            </div>
            `;
            
            let timeLeft = 3;
            const timer = setInterval(() => {
                timeLeft--;
                const counter = document.getElementById('success-countdown-prop');
                if (counter) counter.innerText = timeLeft;
                if (timeLeft <= 0) {
                    clearInterval(timer);
                    closeModal();
                }
            }, 1000);
        } else {
            closeModal(); 
            notify(`Proposal submitted successfully.`);
        }
    } catch (error) { 
        if (btn) {
            btn.disabled = false;
            btn.innerHTML = originalText;
        }
        notify(error.message, 'error'); 
    }
}

async function deleteContract(id) {
 if (!confirm('Are you sure you want to delete this contract? This will remove all associated milestones, deliverables, and messages. This action cannot be undone.')) return;
 
 try {
 const data = await request(`/contracts/${id}`, { method: 'DELETE' });
 notify(data.message || 'Contract deleted', 'success');
 window.location.reload(); // Reload state
 } catch (err) {
 notify(err.message || 'Error deleting contract', 'error');
 }
}

async function acceptProposal(id) {
 const ok = await confirmPopup('Accept Proposal', 'Accept this proposal and create the contract milestones?');
 if (!ok) return;
 try {
 await request(`/jobs/${state.currentJob.id}/proposals/${id}/accept`, { method: 'POST', body: JSON.stringify({}) });
 if (window.confetti) window.confetti({ particleCount: 150, spread: 80, origin: { y: 0.6 } });
 notify(`Proposal accepted and contract created.`); await navigate('contracts');
 } catch (error) { notify(error.message, 'error'); }
}

async function mutateMilestone(id, action) {
 if (action === 'fund') {
 const val = await selectPopup(
 'Milestone Funding',
 'Choose payment provider:',
 [
 { value: 'wallet', label: 'Wallet' },
 { value: 'razorpay', label: 'Razorpay' },
 { value: 'stripe', label: 'Stripe' },
 { value: 'cashfree', label: 'Cashfree' },
 { value: 'manual_upi', label: 'Manual UPI' }
 ],
 'wallet'
 );
 if (!val) return;
 const provider = val.trim().toLowerCase();
 if (!provider) return;

 try {
 if (provider === 'wallet') {
 await request(`/contracts/${state.currentContract.id}/milestones/${id}/fund-from-wallet`, { method: 'POST' });
 if (window.confetti) window.confetti({ particleCount: 150, spread: 80, origin: { y: 0.6 } });
 notify(`Milestone funded successfully from your wallet.`);
 await navigate(`contracts/${state.currentContract.id}`);
 return;
 }

 const checkout = (await request(
 `/contracts/${state.currentContract.id}/milestones/${id}/checkout`,
 { method: 'POST', body: JSON.stringify({ provider }) }
 )).data;

 if (provider === 'manual_upi') {
 showManualUpiPopup(id, checkout);
 return;
 }

 notify(`${titleCase(checkout.provider)} checkout ${checkout.reference} created. Complete payment in the provider checkout; escrow updates after webhook confirmation.`);
 return;
 } catch (error) { notify(error.message, 'error'); return; }
 }

 const ok = await confirmPopup('Release Milestone', 'Release this milestone after reviewing the submitted deliverable?');
 if (!ok) return;
 try {
 await request(`/contracts/${state.currentContract.id}/milestones/${id}/release`, {
 method: 'POST',
 body: JSON.stringify({}),
 });
 if (window.confetti) window.confetti({ particleCount: 200, spread: 100, origin: { y: 0.6 } });
 notify(`Milestone released successfully.`);
 await navigate(`contracts/${state.currentContract.id}`);
 } catch (error) { notify(error.message, 'error'); }
}

async function sendMessage(event) {
 event.preventDefault();
 const form = event.currentTarget;
 const contractId = form.dataset.contractId;
 const input = form.querySelector('[name="body"]');
 const body = input?.value?.trim();
 if (!body) return;

 // Clear input immediately before async — avoids reset-on-null
 input.value = '';
 input.focus();

 try {
 const res = await request(`/contracts/${contractId}/messages`, {
 method: 'POST',
 body: JSON.stringify({ body })
 });

 const msg = res.data;
 if (msg) {
 // Push to state
 state.messages = [...(state.messages || []), msg];
 if (msg.id) state.messageCursor = Math.max(state.messageCursor || 0, msg.id);

 // Surgically append to chat list — NO full render(), so page doesn't jump
 const chatList = document.querySelector('#chat-messages-list');
 if (chatList) {
 const div = document.createElement('div');
 div.className = 'rounded-2xl neu-raised p-3 group relative';
 div.innerHTML = `
 <div class="flex items-center justify-between gap-2">
 <p class="text-xs font-semibold text-blue-700">${h(msg.sender?.name || state.user?.name || 'You')}</p>
 </div>
 <p class="mt-1 whitespace-pre-wrap text-sm text-slate-600">${h(msg.body || '')}</p>
 `;
 chatList.appendChild(div);
 // Scroll the chat container to the very bottom
 chatList.scrollTop = chatList.scrollHeight;
 } else {
 // Fallback: re-render if chat list not found
 render();
 // After render, scroll chat to bottom
 requestAnimationFrame(() => {
 const cl = document.querySelector('#chat-messages-list');
 if (cl) cl.scrollTop = cl.scrollHeight;
 });
 }
 }
 } catch (error) {
 // Restore typed text on failure
 if (input) input.value = body;
 
 if (error.message.includes('prohibited')) {
 const overlay = document.createElement('div');
 overlay.className = 'fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4';
 overlay.innerHTML = `
 <div class="neu-raised rounded-2xl shadow-2xl max-w-md w-full p-4 md:p-6 text-center transform transition-all scale-100">
 <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
 <svg class="h-10 w-10 text-red-600"fill="none"viewBox="0 0 24 24"stroke="currentColor">
 <path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
 </svg>
 </div>
 <h3 class="text-base md:text-xl font-bold text-slate-900 mb-2">Message Blocked</h3>
 <p class="text-sm text-slate-600 mb-6 font-medium leading-relaxed">
 ${error.message}
 </p>
 <button class="w-full inline-flex justify-center rounded-xl border-transparent bg-red-600 px-4 py-3 text-base font-bold text-white hover:bg-red-700 transition-colors"onclick="this.closest('.fixed').remove()">
 I Understand
 </button>
 </div>
 `;
 document.body.appendChild(overlay);
 } else {
 notify(error.message, 'error');
 }
 }
}



async function submitDeliverable(event) {
 event.preventDefault();
 const milestoneId = state.modal.split(':')[1];
 try { await request(`/milestones/${milestoneId}/deliverables`, { method: 'POST', body: new FormData(event.currentTarget) }); closeModal(); notify(`Deliverable submitted.`); await navigate(`contracts/${state.currentContract.id}`); }
 catch (error) { notify(error.message, 'error'); }
}

async function submitDispute(event) {
 event.preventDefault();
 const milestoneId = state.modal.split(':')[1];
 try { await request(`/contracts/${state.currentContract.id}/milestones/${milestoneId}/disputes`, { method: 'POST', body: JSON.stringify(formObject(event.currentTarget)) }); closeModal(); notify(`Dispute opened for review.`); await navigate(`contracts/${state.currentContract.id}`); }
 catch (error) { notify(error.message, 'error'); }
}

async function submitReview(event) {
    event.preventDefault();
    const form = event.currentTarget;
    try { await request(`/contracts/${form.dataset.contractId}/reviews`, { method: 'POST', body: JSON.stringify(formObject(form)) }); form.reset(); notify(`Review submitted.`); }
    catch (error) { notify(error.message, 'error'); }
}

async function issueInvoice() {
 try { state.invoice = (await request(`/contracts/${state.currentContract.id}/invoice`, { method: 'POST', body: JSON.stringify({}) })).data; notify(`Invoice issued.`); render(); }
 catch (error) { notify(error.message, 'error'); }
}

async function reviewKyc(id, status) {
 const notesVal = await promptPopup('KYC Review Decision', `Optional notes for this ${status} decision:`);
 const notes = notesVal ? notesVal.trim() : '';
 try { await request(`/kyc/documents/${id}`, { method: 'PATCH', body: JSON.stringify({ status, review_notes: notes }) }); notify(`KYC document ${status}.`); await navigate('admin'); }
 catch (error) { notify(error.message, 'error'); }
}

async function resolveDispute(id, resolution) {
 const notes = await promptPopup('Resolve Dispute Escalation', 'Resolution notes details:');
 if (!notes) return;
 try { await request(`/disputes/${id}/resolve`, { method: 'PATCH', body: JSON.stringify({ resolution, resolution_notes: notes }) }); notify(`Dispute resolved.`); await navigate('admin'); }
 catch (error) { notify(error.message, 'error'); }
}

window.generateAiVerdict = async function(id, btn) {
 const container = document.getElementById(`ai-verdict-${id}`);
 const content = container.querySelector('.verdict-content');
 const spinner = container.querySelector('.spinner');
 
 container.classList.remove('hidden');
 content.innerHTML = 'Analyzing contract terms and message history...';
 spinner.classList.remove('hidden');
 btn.disabled = true;

 try {
 const res = await request(`/admin/disputes/${id}/ai-resolve`, { method: 'POST' });
 content.innerHTML = res.verdict.replace(/\\n/g, '<br>');
 } catch (error) {
 content.innerHTML = `<span class="text-rose-400">Failed to generate verdict: ${error.message}</span>`;
 } finally {
 spinner.classList.add('hidden');
 btn.disabled = false;
 }
};

async function reviewManualPayment(contractId, milestoneId, status) {
 const ok = await confirmPopup('Review Manual Payment', `Are you sure you want to ${status} this manual payment?`);
 if (!ok) return;

 try {
 await request(`/contracts/${contractId}/milestones/${milestoneId}/manual-payment/verify`, {
 method: 'POST',
 body: JSON.stringify({ status })
 });
 notify(`Manual payment successfully ${status === 'approved' ? 'approved' : 'rejected'}.`);
 await navigate('admin');
 } catch (error) {
 notify(error.message, 'error');
 }
}

async function toggleKycStatus(userId, currentStatus) {
 const nextStatus = currentStatus === 'approved' ? 'rejected' : 'approved';
 const ok = await confirmPopup('Update Verification Status', `Are you sure you want to change this user's KYC status to ${nextStatus}?`);
 if (!ok) return;

 try {
 await request(`/admin/users/${userId}/kyc-status`, {
 method: 'POST',
 body: JSON.stringify({ kyc_status: nextStatus })
 });
 notify(`User verification status updated to ${nextStatus}.`);
 await navigate('admin');
 } catch (error) {
 notify(error.message, 'error');
 }
}

async function changeUserRole(userId, newRole) {
 const ok = await confirmPopup('Change User Role', `Are you sure you want to change this user's role to ${newRole}?`);
 if (!ok) return;

 try {
 await request(`/admin/users/${userId}/role`, {
 method: 'POST',
 body: JSON.stringify({ role: newRole })
 });
 notify(`User role successfully changed to ${newRole}.`);
 await navigate('admin');
 } catch (error) {
 notify(error.message, 'error');
 }
}

async function adminDeleteJob(jobId) {
 const ok = await confirmPopup('Moderate Listing', 'Are you sure you want to delete and remove this job listing from the marketplace?');
 if (!ok) return;

 try {
 await request(`/jobs/${jobId}`, {
 method: 'DELETE'
 });
 notify(`Job listing deleted successfully.`);
 await navigate('admin');
 } catch (error) {
 notify(error.message, 'error');
 }
}

async function showManualUpiPopup(id, checkout) {
 const modalDiv = document.createElement('div');
 modalDiv.className = `fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm animate-in fade-in duration-200`;
 
 modalDiv.innerHTML = `
 <div class="glass-panel w-full max-w-md rounded-3xl p-4 md:p-6 shadow-2xl neu-raised animate-in fade-in zoom-in duration-200">
 <div class="flex items-center gap-3">
 <span class="text-2xl">${icon('mobile')}</span>
 <h3 class="text-base md:text-xl font-black text-slate-900">Manual UPI Payment</h3>
 </div>
 <p class="mt-4 text-sm text-slate-600 leading-6">
 Scan the QR code below using GPay, PhonePe, or Paytm to pay <strong>${money(checkout.amount, checkout.currency)}</strong>.
 </p>
 <div class="mt-5 text-center">
 <img class="mx-auto rounded-2xl p-2 neu-raised"src="${checkout.qr_code_url}"style="max-height: 200px; max-width: 200px;"/>
 <p class="mt-3 text-sm font-semibold text-slate-700">UPI ID: <span class="text-blue-700 select-all">${h(checkout.upi_id)}</span></p>
 </div>
 <div class="mt-5">
 <label class="block text-sm font-semibold text-slate-600 mb-1">Enter Transaction UTR (12 digits)</label>
 <input class="input-control mt-0 w-full"id="manual-utr-input"type="text"placeholder="e.g. 123456789012"required>
 </div>
 <div class="mt-6 flex justify-end gap-3">
 <button class="btn-secondary px-4 py-2 text-sm"id="cancel-manual-payment">Cancel</button>
 <button class="btn-primary px-4 py-2 text-sm"id="submit-manual-payment">Submit Reference</button>
 </div>
 </div>
 `;

 document.body.appendChild(modalDiv);

 modalDiv.querySelector('#cancel-manual-payment').addEventListener('click', () => {
 modalDiv.remove();
 });

 modalDiv.querySelector('#submit-manual-payment').addEventListener('click', async () => {
 const utrInput = modalDiv.querySelector('#manual-utr-input').value.trim();
 if (!utrInput || utrInput.length < 8) {
 notify('Please enter a valid Transaction UTR (min 8 characters).', 'error');
 return;
 }

 try {
 await request(`/contracts/${state.currentContract.id}/milestones/${id}/manual-payment`, {
 method: 'POST',
 body: JSON.stringify({ utr: utrInput })
 });
 notify(`Manual payment details submitted. Admin will verify shortly.`);
 modalDiv.remove();
 await navigate(`contracts/${state.currentContract.id}`);
 } catch (error) {
 notify(error.message, 'error');
 }
 });
}

async function submitFreelancerProfile(event) {
 event.preventDefault();
 const data = formObject(event.currentTarget);
 data.skills = data.skills ? data.skills.split(',').map((skill) => skill.trim()).filter(Boolean) : [];
 data.currency = (data.currency || 'INR').toUpperCase();
 try {
 state.freelancerProfile = (await request('/freelancer-profile', { method: 'PUT', body: JSON.stringify(data) })).data;
 notify(`Professional profile saved.`);
 render();
 } catch (error) { notify(error.message, 'error'); }
}

async function submitUserProfile(event) {
 event.preventDefault();
 const data = formObject(event.currentTarget);
 try {
 const result = await request('/user/profile', { method: 'PUT', body: JSON.stringify(data) });
 state.user = result.user;
 localStorage.setItem('ssm_user', JSON.stringify(state.user));
 notify(`Account details saved successfully.`);
 render();
 } catch (error) { notify(error.message, 'error'); }
}

async function submitKyc(event) {
 event.preventDefault();
 try {
 await request('/kyc/documents', { method: 'POST', body: new FormData(event.currentTarget) });
 closeModal(); notify(`KYC record submitted for review.`);
 } catch (error) { notify(error.message, 'error'); }
}

let syncTimer = null;

async function syncLiveWorkspace() {
 if (!state.user || document.visibilityState === 'hidden' || state.loading) return;

 try {
 const notificationQuery = state.notificationCursor
 ? `?after=${encodeURIComponent(state.notificationCursor)}`
 : '';
 const notifications = await request(`/notifications${notificationQuery}`);
 const freshNotifications = notifications.data || [];
 if (freshNotifications.length > 0) {
 nativeNotify('New Notification', freshNotifications[0].data?.preview || 'You have new updates.');
 }
 state.notifications = [...freshNotifications, ...state.notifications]
 .filter((notification, index, all) => all.findIndex((item) => item.id === notification.id) === index)
 .slice(0, 50);
 state.unreadNotifications = notifications.meta?.unread_count || state.unreadNotifications;
 state.notificationCursor = notifications.meta?.server_time || state.notificationCursor;
 
 if (notifications.meta?.balance !== undefined && state.user) {
 state.user.balance = notifications.meta.balance;
 localStorage.setItem('ssm_user', JSON.stringify(state.user));
 const display = document.querySelector('#wallet-balance-display');
 if (display) display.innerHTML = money(state.user.balance);
 const headerBtn = document.querySelector('#wallet-balance-btn');
 if (headerBtn) headerBtn.innerHTML = `${money(state.user.balance)} <span class="text-teal-500">${icon('money')}</span>`;
 }

 const contractMatch = route().match(/^contracts\/(\d+)$/);
 if (contractMatch && state.currentContract) {
 const messages = await request(`/contracts/${contractMatch[1]}/messages?after_id=${state.messageCursor || 0}`);
 const freshMessages = messages.data?.data || messages.data || [];
 if (freshMessages.length) {
 nativeNotify('New Message', freshMessages[freshMessages.length - 1].body || 'You received a new message.');
 state.messages = [...state.messages, ...freshMessages];
 state.messageCursor = messages.meta?.next_after_id || state.messageCursor;
 await request(`/contracts/${contractMatch[1]}/messages/read`, { method: 'POST' });
 
 const chatFeed = document.getElementById('chat-messages-list');
 if (chatFeed) {
 chatFeed.innerHTML = renderChatMessagesHTML(state.messages, state.currentContract);
 chatFeed.scrollTop = chatFeed.scrollHeight;
 } else {
 render();
 }
 }
 }
 } catch (_) {
 // Background synchronization must not interrupt the active workspace.
 }
}

function startLiveSync() {
 if (state.eventSource) {
 try { state.eventSource.close(); } catch(_) {}
 state.eventSource = null;
 }
 clearInterval(syncTimer);

 if (!state.user || !state.token) return;

 // Use standard REST polling instead of Server-Sent Events (SSE)
 // SSE blocks the single-threaded PHP built-in server (php artisan serve),
 // causing all other API requests to hang and timeout.
 syncLiveWorkspace();
 syncTimer = setInterval(syncLiveWorkspace, 10000);
}

window.addEventListener('hashchange', () => {
 state.messageCursor = null;
 closeMenu();
 loadRouteData();
});
document.addEventListener('visibilitychange', () => {
 if (document.visibilityState === 'visible') syncLiveWorkspace();
});

render();
if (state.user && state.token) {
 loadCore();
 startLiveSync();
}
// Removed duplicate hashchange listener
window.addEventListener('beforeinstallprompt', (event) => { event.preventDefault(); window.__installPrompt = event; });

// ===== PHASE 2 PAGE FUNCTIONS =====

function renderStars(avg) {
 const full = Math.round(avg || 0);
 return Array.from({length: 5}, (_, i) =>
 `<svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 24 24"fill="${i < full ? '#f59e0b' : 'none'}"stroke="#f59e0b"stroke-width="1.5"class="w-3.5 h-3.5 inline-block"><path stroke-linecap="round"stroke-linejoin="round"d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.562.562 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.562.562 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"/></svg>`
 ).join('');
}

function renderFreelancerCard(fp) {
 const u = fp.user || {};
 const skills = Array.isArray(fp.skills) ? fp.skills.slice(0, 4) : [];
 // Use cached avg_rating from freelancer_profiles, fallback to average_rating from API
 const avgRating = parseFloat(fp.avg_rating || fp.average_rating || 0);
 const reviewCount = fp.review_count || 0;
 const completedCount = fp.completed_contracts_count || 0;
 const isSpotlight = fp.is_spotlight;
 const isClient = state.user?.role === 'client';
 const isSaved = (state.savedFreelancers || []).includes(u.id);

 const spotlightCardClass = isSpotlight ? 'bg-gradient-to-br from-amber-50/50 via-white to-orange-50/50 border-amber-200 shadow-[0_0_15px_rgba(245,158,11,0.15)] ring-1 ring-amber-300' : 'soft-panel';
 const spotlightBadge = isSpotlight ? `<div class="absolute -top-3 -right-3 text-[11px] font-black uppercase tracking-widest text-white bg-gradient-to-r from-amber-500 to-orange-500 rounded-full px-4 py-1.5 shadow-[0_0_15px_rgba(245,158,11,0.5)] animate-pulse flex items-center gap-1.5 z-10 border-2 border-white">&#9733; PREMIUM SPOTLIGHT</div>` : '';

 return `<article class="${spotlightCardClass} group relative flex flex-col justify-between gap-5 p-4 md:p-6 cursor-pointer transition-all duration-300 ${isSpotlight ? 'hover:scale-[1.01]' : ''}"onclick="navigate('freelancers/${u.id}')">
 ${spotlightBadge}
 <div class="flex flex-col gap-4 sm:flex-row sm:items-start">
 <div class="flex-shrink-0">
 ${avatar(u, 'h-[72px] w-[72px] text-2xl font-bold rounded-full bg-blue-100 text-blue-700')}
 </div>
 <div class="flex-1 min-w-0">
 <div class="flex flex-col sm:flex-row sm:items-start justify-between gap-3">
 <div class="flex-1">
 <div class="flex flex-wrap items-center gap-2">
 <h3 class="text-base md:text-xl font-extrabold text-slate-900 group-hover:text-blue-700 transition-colors">${h(u.name || 'Freelancer')}</h3>
 ${u.kyc_status === 'approved' ? `<span title="Verified User"class="inline-flex items-center justify-center gap-1 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 px-2.5 py-0.5 text-[10px] font-black uppercase tracking-wider text-white border-blue-400 ml-1 hover:shadow-blue-500/50 transition-"><svg class="w-3 h-3 text-white"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="3"d="M5 13l4 4L19 7"></path></svg> Verified</span>` : ''}
 ${state.user?.role === 'admin' ? `<button onclick="event.stopPropagation(); window.startImpersonation(${u.id})"class="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-rose-700 border-rose-200 hover:bg-rose-100">Impersonate</button>` : ''}
 </div>
 <p class="mt-1 text-base text-slate-600 font-medium line-clamp-1">${h(fp.headline || 'Professional Freelancer')}</p>
 ${u.agencies && u.agencies.length > 0 ? `<div class="mt-2 flex flex-wrap gap-1.5">${u.agencies.map(a => `<span class="inline-flex items-center rounded-md bg-blue-50 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-widest text-blue-700 ring-1 ring-inset ring-blue-700/10"><svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path></svg>${h(a.name)}</span>`).join('')}</div>` : ''}
 </div>
 ${isClient ? `<button onclick="event.stopPropagation(); toggleSaveFreelancer(${u.id}, this)"class="flex-shrink-0 p-1.5 rounded-lg transition-colors ${isSaved ? 'text-rose-400 bg-rose-400/10' : 'text-slate-600 hover:text-rose-400 hover:bg-rose-400/10'}"title="${isSaved ? 'Remove bookmark' : 'Save freelancer'}">
 <svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 24 24"fill="${isSaved ? 'currentColor' : 'none'}"stroke="currentColor"stroke-width="2"class="w-5 h-5"><path stroke-linecap="round"stroke-linejoin="round"d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"/></svg>
 </button>` : ''}
 </div>

 <div class="mt-4 flex flex-wrap gap-2">
 ${skills.map(s => `<span class="rounded-full neu-raised/80 px-3 py-1 text-[13px] font-medium text-slate-600">${h(s)}</span>`).join('')}
 ${(fp.skills?.length || 0) > 4 ? `<span class="rounded-full neu-raised/50 px-3 py-1 text-[13px] font-medium text-slate-600">+${fp.skills.length - 4}</span>` : ''}
 </div>
 </div>
 </div>

 <div class="mt-2 flex items-center justify-between pt-2">
 <div class="flex flex-wrap items-center gap-3 text-sm">
 <div class="flex items-center gap-1">
 <span class="flex">${renderStars(avgRating)}</span>
 <span class="ml-1 text-amber-800 font-semibold text-xs">${avgRating > 0 ? avgRating.toFixed(1) : 'New'}</span>
 ${reviewCount > 0 ? `<span class="text-slate-600 text-xs">(${reviewCount})</span>` : ''}
 </div>
 ${completedCount > 0 ? `<span class="text-slate-600 text-xs">${completedCount} jobs done</span>` : ''}
 </div>
 <div class="text-right">
 ${fp.hourly_rate ? `<p class="text-[17px] font-bold text-emerald-400">${money(fp.hourly_rate)}<span class="text-sm font-medium text-emerald-400/70">/hr</span></p>` : `<span class="text-slate-600 text-xs font-semibold uppercase tracking-wider">Rate open</span>`}
 </div>
 </div>
 </article>`;
}

function freelancerDirectoryPage() {
 const freelancers = state.freelancers || [];
 
 return `<div class="space-y-6 relative">
 <section>
 <p class="eyebrow">Talent marketplace</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Browse Freelancers</h1>
 <p class="mt-2 text-sm text-slate-600 flex items-center gap-1.5">Find skilled professionals for your next project. <span id="freelancers-count">${state.freelancersMeta?.total ? `<span class="text-emerald-400 font-bold ml-2">${state.freelancersMeta.total.toLocaleString()} freelancers available</span>` : ''}</span><span class="text-slate-700 mx-2 text-lg">|</span><span class="online-freelancers-count text-amber-800 font-bold flex items-center"><span class="w-2 h-2 rounded-full bg-amber-400 animate-pulse mr-1.5 inline-block"></span>${window.onlineCount} online now</span></p>
 </section>
 <div class="flex flex-col gap-4 sm:flex-row sticky top-0 z-10 neu-raised/90 backdrop-blur-xl p-4 -mx-4 rounded-xl">
 <input id="freelancer-search"class="input-control flex-1"placeholder="Search by skill or name..."value="${h(state._freelancerSearchTerm || '')}"oninput="window.debouncedFilterFreelancers()">
 <select id="freelancer-skill-filter"class="input-control sm:w-48 mt-0"onchange="filterFreelancers()">
 <option value="">All skills</option>
 <option>Laravel</option><option>React</option><option>Vue</option>
 <option>Flutter</option><option>Android</option><option>iOS</option>
 <option>Figma</option><option>Python</option><option>Node.js</option>
 </select>
 <select id="freelancer-sort"class="input-control sm:w-44 mt-0"onchange="filterFreelancers()">
 <option value="newest">Newest</option>
 <option value="rate_asc">Rate: Low → High</option>
 <option value="rate_desc">Rate: High → Low</option>
 </select>
 </div>
 <div id="freelancer-results">
 <div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3"id="freelancer-grid">
 ${freelancers.map(renderFreelancerCard).join('') || empty('No freelancers found. Try different filters.')}
 </div>
 <div id="freelancer-load-more-container"class="mt-8 flex justify-center">
 ${state.freelancersMeta && state.freelancersMeta.current_page < state.freelancersMeta.last_page ? `<button onclick="loadMoreFreelancers()"class="btn-secondary">Load More</button>` : ''}
 </div>
 </div>
 </div>`;
}

window.debouncedFilterFreelancers = () => {
 clearTimeout(window._searchTimeout);
 window._searchTimeout = setTimeout(filterFreelancers, 300);
};

window.loadMoreFreelancers = async () => {
 try {
 const page = (state.freelancersMeta?.current_page || 1) + 1;
 const term = state._freelancerSearchTerm || '';
 const skill = document.querySelector('#freelancer-skill-filter')?.value || '';
 const sort = document.querySelector('#freelancer-sort')?.value || 'newest';
 
 const params = new URLSearchParams({ page });
 if (term) params.set('q', term);
 if (skill) params.set('skill', skill);
 if (sort) params.set('sort', sort);
 
 const res = await request(`/freelancers?${params}`);
 const newFreelancers = res.data || [];
 state.freelancers = [...(state.freelancers || []), ...newFreelancers];
 state.freelancersMeta = res.meta || null;
 
 const grid = document.querySelector('#freelancer-grid');
 if (grid) grid.insertAdjacentHTML('beforeend', newFreelancers.map(renderFreelancerCard).join(''));
 
 const lm = document.querySelector('#freelancer-load-more-container');
 if (lm) lm.innerHTML = (state.freelancersMeta && state.freelancersMeta.current_page < state.freelancersMeta.last_page) ? `<button onclick="loadMoreFreelancers()"class="btn-secondary">Load More</button>` : '';
 } catch (e) { notify(e.message, 'error'); }
};

function freelancerPublicProfilePage() {
 const d = state.currentFreelancer;
 if (!d) {
 return `<div class="space-y-4"><a class="btn-ghost"href="#freelancers">← Back</a>${empty('Freelancer not found.')}</div>`;
 }
 const { user, profile, average_rating, review_count, reviews, skill_badges, completed_contracts, agencies } = d;
 const isSpotlight = profile?.is_spotlight;
 const portfolioItems = profile?.portfolio_items || [];
 const stars = Array.from({length: 5}, (_, i) => i < Math.round(average_rating) ? icon('star', 'w-3 h-3 md:w-4 md:h-4 inline-block') : icon('star_outline', 'w-3 h-3 md:w-4 md:h-4 inline-block')).join('');
 

 return `<div class="space-y-8">
 <a class="btn-ghost -ml-3 group flex items-center gap-2 text-slate-600 hover:text-slate-700"href="#freelancers">
 <span class="transition-transform group-hover:-translate-x-1">&larr;</span> Back to Freelancers
 </a>
 
 <!-- Header Section -->
 <section class="rounded-2xl ${isSpotlight ? 'border-amber-300 shadow-[0_0_20px_rgba(245,158,11,0.15)] ring-1 ring-amber-300' : ''} neu-raised/50 overflow-hidden relative">
 ${isSpotlight ? `<div class="absolute top-4 right-4 z-20 text-[11px] font-black uppercase tracking-widest text-white bg-gradient-to-r from-amber-500 to-orange-500 rounded-full px-4 py-1.5 shadow-[0_0_15px_rgba(245,158,11,0.5)] animate-pulse flex items-center gap-1.5 border-2 border-white">&#9733; SPOTLIGHT</div>` : ''}
 <!-- Cover Banner -->
 <div class="h-40 w-full ${isSpotlight ? 'bg-gradient-to-r from-amber-500 via-orange-400 to-amber-500' : 'neu-raised'} relative">
 ${!isSpotlight ? `<div class="absolute inset-0 bg-gradient-to-r from-slate-800 via-slate-800/80 to-slate-900"></div>` : ''}
 <div class="absolute inset-0 opacity-10"style="background-image: radial-gradient(circle at 2px 2px, white 1px, transparent 0); background-size: 24px 24px;"></div>
 <div class="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
 </div>
 
 <div class="p-8 sm:p-10 relative">
 <div class="flex flex-col gap-6 sm:flex-row sm:items-start -mt-20 sm:-mt-24">
 <div class="flex-shrink-0 relative z-10">
 ${avatar(user, 'h-28 w-28 text-3xl rounded-full border-4 border-slate-950 neu-raised shadow-xl')}
 </div>
 
 <div class="flex-1 min-w-0 mt-2 sm:mt-16">
 <div class="flex flex-col sm:flex-row sm:items-start justify-between gap-6">
 <div>
 <div class="flex items-center gap-3">
 <h1 class="text-xl md:text-3xl font-bold tracking-tight text-slate-900">${h(user?.name)}</h1>
 ${user?.kyc_status === 'approved' ? `<span title="Verified User"class="inline-flex items-center justify-center gap-1 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 px-3 py-1 text-[11px] font-black uppercase tracking-wider text-white shadow-[0_0_10px_rgba(59,130,246,0.3)] border-blue-400 ml-2 hover:shadow-blue-500/50 transition-"><svg class="w-3.5 h-3.5 text-white"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="3"d="M5 13l4 4L19 7"></path></svg> Verified</span>` : ''}
 </div>
 <p class="mt-2 text-lg font-medium text-slate-600">${h(profile?.headline || `Professional Freelancer`)}</p>
 ${agencies && agencies.length > 0 ? `<div class="mt-3 flex flex-wrap gap-2">${agencies.map(a => `<span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-bold uppercase tracking-widest text-blue-700 ring-1 ring-inset ring-blue-700/20"><svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path></svg>${h(a.name)}</span>`).join('')}</div>` : ''}
 
 <div class="mt-4 flex flex-wrap gap-4 text-sm font-medium text-slate-600">
 <div class="flex items-center gap-1.5">
 <span class="flex text-blue-400">${stars}</span>
 <span class="text-slate-700">${Number(average_rating).toFixed(1)} <span class="text-slate-600">(${review_count} reviews)</span></span>
 </div>
 <div class="flex items-center gap-1.5 border-l pl-4">
 <span class="text-slate-600">${icon('briefcase', 'w-3 h-3 md:w-4 md:h-4')}</span>
 <span class="text-slate-700">${completed_contracts} <span class="text-slate-600">jobs</span></span>
 </div>
 <div class="flex items-center gap-1.5 border-l pl-4">
 <span class="text-slate-600">${icon('calendar', 'w-3 h-3 md:w-4 md:h-4')}</span>
 <span class="text-slate-600">Member since ${h(user?.member_since || ``)}</span>
 </div>
 </div>
 </div>
 
 <div class="flex flex-col items-start sm:items-end gap-4 min-w-[140px]">
 ${profile?.hourly_rate ? `<div class="text-left sm:text-right">
 <p class="text-xs font-semibold uppercase tracking-wider text-slate-600">Hourly Rate</p>
 <p class="mt-1 text-2xl font-bold text-slate-900">${money(profile.hourly_rate)}<span class="text-base font-normal text-slate-600">/hr</span></p>
 </div>` : ''}
 ${state.user?.role === 'client' ? `<button class="btn-primary w-full"onclick="navigate('marketplace'); notify('Post a job to receive proposals from this freelancer.');"><span>Post Job to Hire</span></button>` : ''}
 ${state.user?.role === 'client' ? `<button onclick="window.toggleSaveFreelancer(${user?.id}, this)"class="w-full flex items-center justify-center gap-2 btn-secondary text-sm ${(state.savedFreelancers||[]).includes(user?.id) ? 'text-rose-400 border-rose-200' : ''}"><svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 24 24"fill="${(state.savedFreelancers||[]).includes(user?.id) ? 'currentColor' : 'none'}"stroke="currentColor"stroke-width="2"class="w-4 h-4"><path d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"/></svg> ${(state.savedFreelancers||[]).includes(user?.id) ? 'Saved' : 'Save'}</button>` : ''}
 ${state.user?.id !== user?.id ? `<button onclick="window.reportUser(${user?.id}, '${h(user?.name)}')"class="w-full btn-secondary text-xs text-slate-600 hover:text-rose-400 hover:border-rose-200 transition-colors">🚩 Report User</button>` : ''}
 ${state.user?.role === 'admin' ? `<button class="btn-primary w-full bg-rose-500 hover:bg-rose-600 text-slate-900 border-none"onclick="window.startImpersonation(${user.id})">Impersonate Profile</button>` : ''}
 </div>
 </div>
 </div>
 </div>
 
 ${profile?.bio ? `
 <div class="mt-10 pt-8">
 <h3 class="text-lg font-bold text-slate-700 mb-4">About</h3>
 <p class="text-base leading-relaxed text-slate-600 whitespace-pre-wrap max-w-4xl">${h(profile.bio)}</p>
 </div>` : ''}
 
 <div class="mt-8 pt-8">
 <h3 class="text-lg font-bold text-slate-700 mb-4">Skills</h3>
 <div class="flex flex-wrap gap-2">
 ${(profile?.skills || []).map(s => `<span class="rounded neu-raised px-3 py-1.5 text-sm font-medium text-slate-600 hover:bg-slate-700 hover:text-slate-700 transition-colors cursor-default">${h(s)}</span>`).join('')}
 </div>
 </div>
 </section>
 ${skill_badges?.length ? `<section class="rounded-2xl neu-raised/50 p-5 md:p-8">
 <h3 class="text-lg font-bold text-slate-700 mb-4">Certifications & Badges</h3>
 <div class="flex flex-wrap gap-3">
 ${skill_badges.map(b => `<span class="flex items-center gap-2 rounded neu-raised px-3 py-1.5 text-sm font-medium text-slate-700">${icon('trophy', 'w-3 h-3 md:w-4 md:h-4 text-amber-800')} ${h(b.skill_test?.title)}</span>`).join('')}
 </div>
 </section>` : ``}
 ${portfolioItems.length ? `<section class="rounded-2xl neu-raised/50 p-5 md:p-8">
 <h3 class="text-lg font-bold text-slate-700 mb-6">Portfolio</h3>
 <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
 ${portfolioItems.map(item => `<div class="group rounded-xl neu-raised/20 overflow-hidden hover:text-blue-700 transition-colors">
 ${item.image_url ? `<img src="${h(item.image_url)}"alt="${h(item.title)}"class="w-full h-48 object-cover">` : `<div class="h-48 neu-raised flex items-center justify-center text-slate-600">${icon('image', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 md:w-6 md:h-6 md:w-8 md:h-8')}</div>`}
 <div class="p-5">
 <p class="font-bold text-slate-700 group-hover:text-blue-400 transition-colors">${h(item.title)}</p>
 ${item.description ? `<p class="mt-2 text-sm text-slate-600 line-clamp-2">${h(item.description)}</p>` : ``}
 ${item.link_url ? `<a href="${h(item.link_url)}"target="_blank"rel="noopener noreferrer"class="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-blue-400 hover:text-blue-300">View Project &rarr;</a>` : ``}
 </div>
 </div>`).join('')}
 </div>
 </section>` : ``}
 ${reviews?.length ? `<section class="rounded-2xl neu-raised/50 p-5 md:p-8">
 <h3 class="text-lg font-bold text-slate-700 mb-6">Client Feedback</h3>
 <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
 ${reviews.map(r => `<article class="rounded-xl neu-raised/30 p-5">
 <div class="flex flex-col md:flex-row md:justify-between gap-4 md:gap-0 items-start gap-3">
 <div class="flex items-center gap-3">
 <div class="h-10 w-10 rounded-full bg-slate-700 flex items-center justify-center text-slate-600 font-bold">${h((r.reviewer?.name || 'Client')[0].toUpperCase())}</div>
 <div>
 <p class="font-bold text-slate-700">${h(r.reviewer?.name || `Client`)}</p>
 <div class="flex items-center gap-1 mt-0.5">
 <span class="flex text-amber-800">${icon('star', 'w-3 h-3').repeat(Number(r.rating || 0))}</span>
 <span class="text-xs font-semibold text-slate-600 ml-1">${Number(r.rating || 0).toFixed(1)}</span>
 </div>
 </div>
 </div>
 </div>
 <p class="mt-4 text-sm leading-relaxed text-slate-600 italic">"${h(r.comment || '')}"</p>
 </article>`).join('')}
 </div>
 </section>` : ''}
 </div>`;
}

window.filterFreelancers = async () => {
 const term = document.querySelector('#freelancer-search')?.value || '';
 const skill = document.querySelector('#freelancer-skill-filter')?.value || '';
 const sort = document.querySelector('#freelancer-sort')?.value || 'newest';
 state._freelancerSearchTerm = term;
 try {
 const params = new URLSearchParams();
 if (term) params.set('q', term);
 if (skill) params.set('skill', skill);
 if (sort) params.set('sort', sort);
 const res = await fetch(`${apiBase}/freelancers?${params}`, { headers: { Accept: 'application/json' } });
 const data = await res.json();
 state.freelancers = data.data || [];
 state.freelancersMeta = data.meta || null;
 
 const grid = document.querySelector('#freelancer-grid');
 if (grid) grid.innerHTML = state.freelancers.map(renderFreelancerCard).join('') || empty('No freelancers found. Try different filters.');
 
 const count = document.querySelector('#freelancers-count');
 if (count) count.innerHTML = state.freelancersMeta?.total ? `<span class="text-emerald-400 font-bold ml-2">${state.freelancersMeta.total.toLocaleString()} freelancers available</span>` : '';
 
 const lm = document.querySelector('#freelancer-load-more-container');
 if (lm) lm.innerHTML = (state.freelancersMeta && state.freelancersMeta.current_page < state.freelancersMeta.last_page) ? `<button onclick="loadMoreFreelancers()"class="btn-secondary">Load More</button>` : '';
 } catch (e) { notify(e.message, 'error'); }
};

function skillTestsPage() {
 const tests = state.skillTests || [];
 

 return `<div class="space-y-6">
 <section>
 <p class="eyebrow">Certifications</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Skill Tests</h1>
 <p class="mt-2 text-sm text-slate-600">Pass a test to earn a badge displayed on your profile. One attempt per test.</p>
 </section>
 ${state.user?.role === 'admin' ? adminCreateSkillTestForm() : ``}
 <div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
 ${tests.map(test => {
 const attempted = test.attempted;
 

 return `<div class="soft-panel p-5 flex flex-col">
 <div class="flex items-start justify-between gap-3">
 <div>
 <span class="eyebrow">${h(test.category)}</span>
 <h3 class="mt-2 text-lg font-black line-clamp-2">${h(test.title)}</h3>
 </div>
 <span class="text-xl md:text-3xl">${icon('trophy', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 inline-block')}</span>
 </div>
 <div class="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 text-sm text-slate-600">
 <div><p class="text-xs text-slate-600">Questions</p><p class="font-bold">${test.questions_count || '?'}</p></div>
 <div><p class="text-xs text-slate-600">Time limit</p><p class="font-bold">${Math.round((test.time_limit_seconds || 600) / 60)} min</p></div>
 <div><p class="text-xs text-slate-600">Pass score</p><p class="font-bold">${test.pass_score || 70}%</p></div>
 </div>
 <div class="mt-auto pt-5 flex gap-2">
 ${state.user?.role === 'freelancer' ? `<button class="btn-primary flex-1 py-2 text-sm"data-take-test="${test.id}">Take test</button>` : ''}
 ${state.user?.role === 'admin' ? `<button class="btn-ghost px-3 py-2 text-sm text-rose-700"data-delete-skill-test="${test.id}">Delete</button>` : ''}
 </div>
 </div>`;
 }).join('') || empty('No skill tests available yet.')}
 </div>
 </div>`;
}

function adminCreateSkillTestForm() {
 return `<section class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-6">
 <!-- Manual Creation -->
 <div class="soft-panel p-5">
 <p class="eyebrow">Admin</p><h2 class="mt-2 text-base md:text-xl font-black">Manual Skill Test</h2>
 <form id="create-skill-test-form"class="mt-4 space-y-3">
 <div class="grid gap-3 sm:grid-cols-2">
 <input class="input-control"name="title"placeholder="Test title"required>
 <input class="input-control"name="category"placeholder="Category (e.g. web)"required>
 </div>
 <div class="grid gap-3 sm:grid-cols-2">
 <input class="input-control"name="time_limit_seconds"type="number"placeholder="Time limit (seconds)"value="600">
 <input class="input-control"name="pass_score"type="number"placeholder="Pass score %"value="70">
 </div>
 <p class="text-xs text-slate-600">Add questions as JSON: <code>[{"question":"...","options":["a","b"],"correct_index":0}]</code></p>
 <textarea class="input-control min-h-28"name="questions_json"placeholder='[{"question":"What is Laravel?","options":["Framework","Database","OS","Language"],"correct_index":0}]' required></textarea>
 <button class="btn-primary w-full"type="submit">Create Manually</button>
 </form>
 </div>

 <!-- AI Generation -->
 <div class="soft-panel p-5 border-2 border-teal-500/20 bg-teal-50/10">
 <p class="eyebrow text-teal-700">Automated</p><h2 class="mt-2 text-base md:text-xl font-black text-teal-700">✨ Generate via AI</h2>
 <form id="ai-skill-test-form"onsubmit="window.generateAiSkillTest(event)"class="mt-4 space-y-3">
 <div class="grid gap-3 sm:grid-cols-2">
 <input class="input-control"name="title"placeholder="Topic (e.g. ReactJS)"required>
 <input class="input-control"name="category"placeholder="Category (e.g. web)"required>
 </div>
 <div>
 <label class="block text-sm font-semibold mb-1 text-slate-700">Number of Questions</label>
 <input class="input-control"name="num"type="number"placeholder="10"value="10"min="1"max="20"required>
 </div>
 <p class="text-xs text-slate-600 mb-2">Our AI will automatically generate the questions, distractors, and correct answers based on the topic.</p>
 <button class="btn-ai w-full"type="submit">✨ Generate AI Test</button>
 </form>
 </div>
 </section>`;
}

window.generateAiSkillTest = async function(event) {
 event.preventDefault();
 const btn = event.submitter;
 const oldText = btn.innerHTML;
 btn.innerHTML = `<span class="animate-pulse">✨ Generating...</span>`;
 btn.disabled = true;
 try {
 const data = formObject(event.target);
 await request('/admin/skill-tests/generate', { method: 'POST', body: JSON.stringify(data) });
 notify('AI Skill Test generated successfully!');
 const res = await request('/skill-tests');
 state.skillTests = res.data || [];
 render();
 } catch (e) { notify(e.message, 'error'); }
 finally {
 btn.innerHTML = oldText;
 btn.disabled = false;
 }
};

async function createSkillTest(event) {
 event.preventDefault();
 try {
 const data = formObject(event.currentTarget);
 data.questions = JSON.parse(data.questions_json);
 delete data.questions_json;
 await request('/skill-tests', { method: 'POST', body: JSON.stringify(data) });
 notify('Skill test created!');
 const res = await request('/skill-tests');
 state.skillTests = res.data || [];
 render();
 } catch (e) { notify(e.message, 'error'); }
}

async function deleteSkillTest(id) {
 if (!await confirmPopup('Delete this skill test?')) return;
 try {
 await request(`/skill-tests/${id}`, { method: 'DELETE' });
 state.skillTests = state.skillTests.filter(t => t.id != id);
 notify(`Skill test deleted.`);
 render();
 } catch (e) { notify(e.message, 'error'); }
}

async function openSkillTest(testId) {
 try {
 const res = await request(`/skill-tests/${testId}`);
 const { test, questions, attempt } = res.data;
 if (attempt?.passed) { await alertPopup('Already passed!', `You scored ${attempt.score}% and earned this badge already.`); return; }
 state._activeTest = { test, questions, answers: {}, started: Date.now() };
 showSkillTestModal();
 } catch (e) { notify(e.message, 'error'); }
}

function showSkillTestModal() {
 const { test, questions, answers } = state._activeTest;
 const elapsed = Math.round((Date.now() - state._activeTest.started) / 1000);
 const remaining = Math.max(0, (test.time_limit_seconds || 600) - elapsed);
 const mm = String(Math.floor(remaining / 60)).padStart(2, '0');
 const ss = String(remaining % 60).padStart(2, '0');
 const progress = Object.keys(answers).length;
 const existing = document.querySelector('#skill-test-modal');
 if (existing) existing.remove();
 const modal = document.createElement('div');
 modal.id = 'skill-test-modal';
 modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm';
 modal.innerHTML = `<div class="soft-panel w-full max-w-2xl max-h-[90vh] overflow-y-auto p-4 md:p-6 space-y-4">
 <div class="flex items-center justify-between">
 <h2 class="text-base md:text-xl font-black">${h(test.title)}</h2>
 <span class="font-mono text-blue-700 text-lg font-bold">${mm}:${ss}</span>
 </div>
 <p class="text-sm text-slate-600"><span class="progress-text">${progress}/${questions.length} answered</span> · Pass with ${test.pass_score}%</p>
 <div class="space-y-5">
 ${questions.map((q, idx) => `<div class="rounded-2xl neu-raised p-4">
 <p class="font-semibold mb-3">${idx + 1}. ${h(q.question)}</p>
 <div class="space-y-2">
 ${(q.options || []).map((opt, oi) => `<label class="flex items-center gap-3 cursor-pointer rounded-xl p-2 hover:neu-raised/5 ${answers[idx] === oi ? 'bg-teal-950/60 border-blue-200' : ''}">
 <input type="radio"name="q_${idx}"value="${oi}"class="accent-teal-400"${answers[idx] === oi ? 'checked' : ''} data-qidx="${idx}"data-oidx="${oi}">
 <span class="text-sm">${h(opt)}</span>
 </label>`).join('')}
 </div>
 </div>`).join('')}
 </div>
 <div class="flex gap-3 pt-2">
 <button class="btn-primary flex-1"id="submit-test-btn">Submit Test (${progress}/${questions.length})</button>
 <button class="btn-ghost"id="cancel-test-btn">Cancel</button>
 </div>
 </div>`;
 
 // Allow clicking the backdrop to close it too
 modal.addEventListener('click', (e) => {
 if (e.target === modal) {
 modal.remove();
 state._activeTest = null;
 }
 });

 document.body.appendChild(modal);
 // Bind radio changes without full re-render
 modal.querySelectorAll('input[type=radio]').forEach(radio => {
 radio.addEventListener('change', () => {
 const qidx = Number(radio.dataset.qidx);
 state._activeTest.answers[qidx] = Number(radio.dataset.oidx);
 
 const newProgress = Object.keys(state._activeTest.answers).length;
 modal.querySelector('.progress-text').innerText = `${newProgress}/${questions.length} answered`;
 modal.querySelector('#submit-test-btn').innerText = `Submit Test (${newProgress}/${questions.length})`;

 // Update styling
 modal.querySelectorAll(`input[name="q_${qidx}"]`).forEach(r => {
 r.closest('label').className = 'flex items-center gap-3 cursor-pointer rounded-xl p-2 hover:neu-raised/5';
 });
 radio.closest('label').className = 'flex items-center gap-3 cursor-pointer rounded-xl p-2 hover:neu-raised/5 bg-teal-950/60 border-blue-200';
 });
 });
 modal.querySelector('#cancel-test-btn').addEventListener('click', () => { modal.remove(); state._activeTest = null; });
 modal.querySelector('#submit-test-btn').addEventListener('click', async () => {
 const { test: t, answers: ans } = state._activeTest;
 try {
 const payload = { answers: state._activeTest.questions.map((_, i) => ans[i] ?? -1) };
 const result = await request(`/skill-tests/${t.id}/submit`, { method: `POST`, body: JSON.stringify(payload) });
 modal.remove(); state._activeTest = null;
 await alertPopup(result.passed ? `${icon('trophy', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 inline-block')} You passed!` : `${icon('error')} Not quite`, result.message);
 const res = await request('/skill-tests');
 state.skillTests = res.data || [];
 render();
 } catch (e) { notify(e.message, 'error'); }
 });
 // Countdown timer
 if (state._testTimer) clearInterval(state._testTimer);
 state._testTimer = setInterval(() => {
 const el = modal.querySelector('span.font-mono');
 if (!el || !document.body.contains(modal)) { clearInterval(state._testTimer); return; }
 const elapsedNow = Math.round((Date.now() - state._activeTest.started) / 1000);
 const rem = Math.max(0, (test.time_limit_seconds || 600) - elapsedNow);
 const m = String(Math.floor(rem / 60)).padStart(2, '0');
 const s = String(rem % 60).padStart(2, '0');
 el.textContent = `${m}:${s}`;
 if (rem === 0) { clearInterval(state._testTimer); modal.querySelector('#submit-test-btn').click(); }
 }, 1000);
}

function membershipPage() {
 const plans = state.membershipPlans || [];
 const mine = state.myMembership;
 const planColors = { free: 'from-slate-700 to-slate-800', basic: 'from-teal-900 to-teal-800', professional: 'from-indigo-900 to-indigo-800', premium: `from-amber-900 to-amber-800` };
 const planIcons = { free: `${icon('free', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 md:w-6 md:h-6 md:w-8 md:h-8')}`, basic: `${icon('bolt', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 md:w-6 md:h-6 md:w-8 md:h-8')}`, professional: `${icon('rocket', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 md:w-6 md:h-6 md:w-8 md:h-8')}`, premium: `${icon('crown', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 md:w-6 md:h-6 md:w-8 md:h-8')}` };
 

 return `<div class="space-y-6">
 <section>
 <p class="eyebrow">Upgrade your account</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Membership Plans</h1>
 <p class="mt-2 text-sm text-slate-600">Unlock more bids, featured jobs, sealed bids, and more.</p>
 </section>
 ${mine ? `<div class="rounded-2xl border-blue-200 bg-teal-950/30 px-5 py-4 flex items-center gap-4">
 <span class="text-xl md:text-3xl">${icon('check', 'w-3 h-3 md:w-4 md:h-4 inline-block')}</span>
 <div><p class="font-bold text-blue-700">Active: ${h(mine.plan?.name)} Plan</p>
 <p class="text-xs text-slate-600">Expires ${mine.expires_at ? new Date(mine.expires_at).toLocaleDateString(`en-IN`) : 'Never'}</p></div>
 </div>` : ''}
 <div class="grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
 ${plans.map(plan => {
 const features = plan.features || {};
 const isCurrent = mine?.plan?.slug === plan.slug;
 

 return `<div class="rounded-2xl ${isCurrent ? 'border-teal-500 shadow-[0_0_30px_rgba(45,212,191,0.15)] ring-1 ring-teal-500' : ''} neu-raised p-5 md:p-8 flex flex-col relative transition-all duration-300 hover:neu-raised group">
 ${plan.slug === 'professional' ? `<div class="absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-indigo-500 to-transparent opacity-100"></div><div class="absolute right-6 top-0 -translate-y-1/2 rounded-full bg-indigo-500 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-slate-900 shadow-indigo-500/30">Most Popular</div>` : ''}
 
 <div class="flex items-center gap-4 mb-6">
 <div class="flex h-12 w-12 items-center justify-center rounded-xl neu-raised text-slate-900 -inner group-hover:scale-105 transition-transform">
 ${planIcons[plan.slug] || `${icon('star')}`}
 </div>
 <div>
 <h3 class="text-base md:text-xl font-bold text-slate-900">${h(plan.name)}</h3>
 <p class="text-xs font-semibold uppercase tracking-wider text-slate-600">${plan.slug === 'free' ? 'Starter' : plan.slug === 'professional' ? 'Recommended' : 'Premium'}</p>
 </div>
 </div>
 
 <div class="mb-6 flex items-baseline gap-1">
 <span class="text-2xl md:text-4xl font-black text-slate-900">${plan.price_monthly > 0 ? money(plan.price_monthly) : 'Free'}</span>
 <span class="text-sm font-medium text-slate-600">${plan.price_monthly > 0 ? '/month' : ''}</span>
 </div>
 
 <div class="mb-8"></div>
 
 <ul class="space-y-4 flex-1 text-[14px] text-slate-600">
 <li class="flex items-start gap-3">
 <span class="mt-0.5 text-blue-700">${icon('check', 'w-3 h-3 md:w-4 md:h-4')}</span>
 <span><strong class="text-slate-900">${features.max_bids_per_month || 8}</strong> bids per month</span>
 </li>
 ${features.can_feature_jobs ? `<li class="flex items-start gap-3"><span class="mt-0.5 text-blue-700">${icon('check', 'w-3 h-3 md:w-4 md:h-4')}</span> <span>Feature your jobs</span></li>` : ''}
 ${features.can_seal_bids ? `<li class="flex items-start gap-3"><span class="mt-0.5 text-blue-700">${icon('check', 'w-3 h-3 md:w-4 md:h-4')}</span> <span>Sealed bids</span></li>` : ''}
 ${features.profile_boost ? `<li class="flex items-start gap-3"><span class="mt-0.5 text-blue-700">${icon('check', 'w-3 h-3 md:w-4 md:h-4')}</span> <span>Profile boost</span></li>` : ''}
 ${features.nda_available ? `<li class="flex items-start gap-3"><span class="mt-0.5 text-blue-700">${icon('check', 'w-3 h-3 md:w-4 md:h-4')}</span> <span>NDA available</span></li>` : ''}
 </ul>
 
 <button class="mt-8 w-full rounded-xl py-3 text-sm font-bold transition-all ${isCurrent ? 'neu-raised text-slate-600 cursor-default ' : plan.slug === 'professional' ? 'bg-indigo-500 text-slate-900 hover:bg-indigo-400 shadow-[0_0_20px_rgba(99,102,241,0.2)]' : 'neu-raised text-slate-900 hover:bg-slate-700 '}"data-subscribe-plan="${plan.slug}"${isCurrent ? 'disabled' : ''}>
 ${isCurrent ? 'Current Plan' : plan.price_monthly > 0 ? `Subscribe to ${h(plan.name)}` : 'Get Started Free'}
 </button>
 </div>`;
 }).join('')}
 </div>
 </div>`;
}

async function subscribeMembership(planSlug) {
 if (!await confirmPopup(`Subscribe to ${planSlug} plan?`)) return;
 try {
 const res = await request('/memberships/subscribe', { method: 'POST', body: JSON.stringify({ plan_slug: planSlug }) });
 notify(res.message);
 state.myMembership = res.membership;
 if (res.balance !== undefined) { state.user.balance = res.balance; localStorage.setItem('ssm_user', JSON.stringify(state.user)); }
 render();
 } catch (e) { notify(e.message, 'error'); }
}

function referralsPage() {
 const d = state.referralData;
 if (!d) return empty('Loading referral data...');
 const link = d.referral_link || '';
 const referrals = d.referrals || [];
 

 return `<div class="space-y-6">
 <section>
 <p class="eyebrow">Earn rewards</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Refer &amp; Earn</h1>
 <p class="mt-2 text-sm text-slate-600">Invite friends and earn ₹200 wallet credit for each successful referral.</p>
 </section>
 <section class="soft-panel p-4 md:p-6">
 <p class="eyebrow">Your referral link</p>
 <h2 class="mt-2 text-base md:text-xl font-black">Share &amp; Earn ${money(d.bonus_per_referral || 200)}</h2>
 <p class="mt-2 text-sm text-slate-600">You and your friend both receive ₹200 wallet credit after they complete their first contract.</p>
 <div class="mt-5 flex gap-3">
 <input id="referral-link-input"class="input-control flex-1"value="${h(link)}"readonly>
 <button id="copy-referral-link"class="btn-primary px-5">Copy link</button>
 </div>
 <div class="mt-5 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 text-center">
 <div class="rounded-2xl neu-raised p-4"><p class="text-2xl font-black text-blue-700">${d.rewarded_count || 0}</p><p class="text-xs text-slate-600 mt-1">Rewarded</p></div>
 <div class="rounded-2xl neu-raised p-4"><p class="text-2xl font-black text-amber-800">${d.pending_count || 0}</p><p class="text-xs text-slate-600 mt-1">Pending</p></div>
 <div class="rounded-2xl neu-raised p-4"><p class="text-2xl font-black">${money((d.rewarded_count || 0) * (d.bonus_per_referral || 200))}</p><p class="text-xs text-slate-600 mt-1">Earned</p></div>
 </div>
 <button id="claim-referral-btn"class="btn-secondary mt-4 w-full">Claim pending bonus</button>
 </section>
 <section class="soft-panel p-5">
 <h2 class="text-base md:text-xl font-black">Your Referrals</h2>
 <div class="mt-4 space-y-3">
 ${referrals.map(r => `<div class="flex items-center justify-between gap-3 rounded-xl neu-raised p-3">
 <div><p class="font-semibold">${h(r.referee?.name || 'User')}</p><p class="text-xs text-slate-600">${new Date(r.created_at).toLocaleDateString('en-IN')}</p></div>
 <span class="status-pill ${r.status === 'rewarded' ? 'status-open' : 'status-warn'}">${h(r.status)}</span>
 </div>`).join('') || empty('No referrals yet. Share your link!')}
 </div>
 </section>
 </div>`;
}

function copyReferralLink() {
 const input = document.querySelector('#referral-link-input');
 if (!input) return;
 navigator.clipboard.writeText(input.value).then(() => notify('Referral link copied!')).catch(() => { input.select(); document.execCommand('copy'); notify('Referral link copied!'); });
}

async function claimReferral() {
 try {
 const res = await request('/referral/claim', { method: 'POST' });
 notify(res.message);
 state.user.balance = res.balance;
 localStorage.setItem('ssm_user', JSON.stringify(state.user));
 const ref = await request('/referral');
 state.referralData = ref.data;
 render();
 } catch (e) { notify(e.message, 'error'); }
}

function notificationPrefsSection() {
 const prefs = state.notificationPrefs || [];
 const labels = {
 new_proposal: 'New proposal on your job',
 message: 'New message',
 payment: 'Payment & escrow updates',
 kyc_update: 'KYC status change',
 dispute: 'Dispute opened/resolved',
 new_contract: 'New contract started',
 withdrawal: 'Withdrawal approved/rejected',
 referral: 'Referral bonus earned',
 };
 

 return `<section class="soft-panel p-4 md:p-6">
 <p class="eyebrow">Preferences</p>
 <h2 class="mt-2 text-base md:text-xl font-black">Notification Settings</h2>
 <p class="mt-2 text-sm text-slate-600">Control which events send you in-app and email notifications.</p>
 <form id="notification-prefs-form"class="mt-5">
 <div class="rounded-2xl border border-slate-100/50 overflow-hidden bg-white/30 backdrop-blur-sm">
 <div class="hidden md:grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 px-4 py-3 text-xs font-bold text-slate-600 uppercase tracking-wide border-b border-slate-100 bg-slate-50/50">
 <span>Event</span><span class="text-center">In-App</span><span class="text-center">Email</span>
 </div>
 ${prefs.map(p => `<div class="flex flex-col md:grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 px-4 py-4 md:py-3 border-b border-slate-100/50 last:border-0 md:items-center hover:bg-slate-50/30 transition-colors">
 <span class="text-sm font-bold text-slate-900 md:font-normal md:text-slate-900 mb-1 md:mb-0">${labels[p.event_type] || h(p.event_type)}</span>
 <label class="flex items-center justify-between md:justify-center cursor-pointer p-1 md:p-0">
 <span class="text-xs font-semibold text-slate-600 md:hidden uppercase tracking-wider">In-App</span>
 <div class="flex items-center"><input type="hidden"name="pref_${p.event_type}_in_app"value="0"><input type="checkbox"name="pref_${p.event_type}_in_app"value="1"class="accent-blue-600 w-5 h-5 md:w-4 md:h-4"${p.in_app ? 'checked' : ''}></div>
 </label>
 <label class="flex items-center justify-between md:justify-center cursor-pointer p-1 md:p-0">
 <span class="text-xs font-semibold text-slate-600 md:hidden uppercase tracking-wider">Email</span>
 <div class="flex items-center"><input type="hidden"name="pref_${p.event_type}_email"value="0"><input type="checkbox"name="pref_${p.event_type}_email"value="1"class="accent-blue-600 w-5 h-5 md:w-4 md:h-4"${p.email ? 'checked' : ''}></div>
 </label>
 </div>`).join('')}
 </div>
 <button class="btn-primary mt-4"type="submit">Save preferences</button>
 </form>
 </section>`;
}

async function saveNotificationPrefs(event) {
 event.preventDefault();
 const formData = new FormData(event.currentTarget);
 const events = ['new_proposal','message','payment','kyc_update','dispute','new_contract','withdrawal','referral'];
 const preferences = events.map(ev => ({
 event_type: ev,
 in_app: formData.get(`pref_${ev}_in_app`) === '1',
 email: formData.get(`pref_${ev}_email`) === '1',
 }));
 try {
 await request('/notification-preferences', { method: 'PUT', body: JSON.stringify({ preferences }) });
 notify(`Notification preferences saved.`);
 } catch (e) { notify(e.message, `error`); }
}

function portfolioSection() {
 const items = state.portfolio || [];
 

 return `<section class="soft-panel p-4 md:p-6">
 <div class="flex items-center justify-between">
 <div><p class="eyebrow">Work samples</p><h2 class="mt-2 text-base md:text-xl font-black">Portfolio</h2></div>
 <span class="status-pill status-muted">${items.length} items</span>
 </div>
 <div class="mt-5 grid gap-4 sm:grid-cols-2">
 ${items.map(item => `<div class="relative rounded-2xl neu-raised overflow-hidden">
 ${item.image_url ? `<img src="${h(item.image_url)}"alt="${h(item.title)}"class="w-full h-36 object-cover">` : `<div class="h-36 bg-gradient-to-br from-teal-900/30 to-indigo-900/30 flex items-center justify-center text-xl md:text-3xl">${icon('palette', 'w-3 h-3 md:w-4 md:h-4 md:w-5 md:h-5 md:w-6 md:h-6 md:w-8 md:h-8')}</div>`}
 <div class="p-4"><p class="font-bold">${h(item.title)}</p>
 ${item.description ? `<p class="mt-1 text-xs text-slate-600 line-clamp-2">${h(item.description)}</p>` : ``}
 ${item.external_url ? `<a href="${h(item.external_url)}"target="_blank"class="mt-2 inline-block text-xs text-blue-700 hover:underline">View →</a>` : ''}
 </div>
 <button class="absolute top-2 right-2 rounded-lg bg-rose-50/80 border-rose-400/20 px-2 py-1 text-xs text-rose-700 hover:bg-rose-900"data-delete-portfolio="${item.id}">${icon('close')}</button>
 </div>`).join(``)}
 </div>
 <form id="portfolio-form"class="mt-5 grid gap-4 sm:grid-cols-2 rounded-2xl border-dashed p-5">
 <p class="sm:col-span-2 text-sm font-bold text-slate-600">Add portfolio item</p>
 <input class="input-control"name="title"placeholder="Project title"required>
 <input class="input-control"name="image_url"type="url"placeholder="Image URL (optional)">
 <input class="input-control sm:col-span-2"name="external_url"type="url"placeholder="Project URL (optional)">
 <textarea class="input-control sm:col-span-2"name="description"placeholder="Brief description..."rows="2"></textarea>
 <button class="btn-primary sm:col-span-2"type="submit">Add to portfolio</button>
 </form>
 </section>`;
}

async function addPortfolioItem(event) {
 event.preventDefault();
 const form = event.currentTarget;
 try {
 const data = formObject(form);
 const res = await request('/portfolio', { method: 'POST', body: JSON.stringify(data) });
 state.portfolio.push(res.data);
 notify(`Portfolio item added.`);
 form.reset();
 render();
 } catch (e) { notify(e.message, 'error'); }
}

async function deletePortfolioItem(id) {
 if (!await confirmPopup('Remove this portfolio item?')) return;
 try {
 await request(`/portfolio/${id}`, { method: 'DELETE' });
 state.portfolio = state.portfolio.filter(p => p.id != id);
 notify(`Portfolio item removed.`);
 render();
 } catch (e) { notify(e.message, 'error'); }
}

function clientProfileSection() {
 const cp = state.clientProfile || {};
 

 return `<section class="soft-panel p-4 md:p-6">
 <p class="eyebrow">Company</p><h2 class="mt-2 text-base md:text-xl font-black">Client Profile</h2>
 <p class="mt-2 text-sm text-slate-600">Your public profile shown to freelancers on your job posts.</p>
 <form id="client-profile-form"class="mt-5 grid gap-4 sm:grid-cols-2">
 <label class="block text-sm font-semibold">Company Name<input class="input-control"name="company_name"value="${h(cp.company_name || '')}"placeholder="Acme Corp"></label>
 <label class="block text-sm font-semibold">Location<input class="input-control"name="location"value="${h(cp.location || '')}"placeholder="Mumbai, India"></label>
 <label class="block text-sm font-semibold sm:col-span-2">Company Website<input class="input-control"name="company_url"type="url"value="${h(cp.company_url || '')}"placeholder="https://acme.com"></label>
 <label class="block text-sm font-semibold sm:col-span-2">About your company<textarea class="input-control min-h-20"name="description">${h(cp.description || '')}</textarea></label>
 <button class="btn-primary sm:col-span-2"type="submit">Save client profile</button>
 </form>
 </section>`;
}

async function saveClientProfile(event) {
 event.preventDefault();
 try {
 const res = await request('/client-profile', { method: 'PUT', body: JSON.stringify(formObject(event.currentTarget)) });
 state.clientProfile = res.data;
 notify(`Client profile saved.`);
 render();
 } catch (e) { notify(e.message, 'error'); }
}

function adminRevenueCharts() {
 const revenue = state.adminRevenue;
 if (!revenue) return '';
 const monthly = revenue.monthly || [];
 const allTime = revenue.all_time || {};
 const maxCommission = Math.max(...monthly.map(m => m.commission), 1);
 const barChart = (data, key, color) => data.map((m, i) => {
 const pct = Math.max(2, Math.round((m[key] / maxCommission) * 100));
 

 return `<div class="flex flex-col items-center gap-1 flex-1"title="${m.month}: ${money(m[key])}">
 <div class="w-full rounded-t-md ${color}"style="height:${pct}px;min-height:2px"></div>
 <span class="text-[8px] text-slate-600 rotate-45 origin-left">${m.month.split(' ')[0]}</span>
 </div>`;
 }).join('');
 

 return `<section class="soft-panel p-5 col-span-full">
 <p class="eyebrow">Financial overview</p><h2 class="mt-2 text-base md:text-xl font-black">Revenue Dashboard (12 months)</h2>
 <div class="mt-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:grid-cols-4">
 ${[
 ['Total commission', money(allTime.total_commission), 'Platform earnings'],
 ['Total funded', money(allTime.total_funded), 'Escrow volume'],
 ['Total payouts', money(allTime.total_payouts), 'Paid to freelancers'],
 ['Memberships', money(allTime.total_memberships), 'Subscription revenue'],
 ].map(([label, val, sub]) => `<div class="rounded-2xl neu-raised p-4"><p class="text-xs text-slate-600">${label}</p><p class="mt-1 text-base md:text-xl font-black text-blue-700">${val}</p><p class="text-xs text-slate-600 mt-0.5">${sub}</p></div>`).join('')}
 </div>
 <div class="mt-6">
 <p class="text-xs text-slate-600 mb-3">Monthly Commission (last 12 months)</p>
 <div class="flex items-end gap-1"style="height:120px">
 ${barChart(monthly, 'commission', 'bg-teal-500')}
 </div>
 </div>
 <div class="mt-6">
 <p class="text-xs text-slate-600 mb-3">New users per month</p>
 <div class="flex items-end gap-1"style="height:80px">
 ${monthly.map(m => {
 const maxU = Math.max(...monthly.map(x => x.new_users), 1);
 const pct = Math.max(2, Math.round((m.new_users / maxU) * 80));
 

 return `<div class="flex-1 rounded-t-md bg-indigo-500"style="height:${pct}px"title="${m.month}: ${m.new_users} users"></div>`;
 }).join('')}
 </div>
 </div>
 </section>`;
}

let _adminSearchTimer;
async function adminSearch() {
 const q = document.querySelector('#admin-search-input')?.value || '';
 clearTimeout(_adminSearchTimer);
 if (q.length < 2) { state.searchResults = null; render(); return; }
 _adminSearchTimer = setTimeout(async () => {
 try {
 const res = await request(`/admin/search?q=${encodeURIComponent(q)}`);
 state.searchResults = res.data;
 render();
 } catch (e) { notify(e.message, 'error'); }
 }, 400);
}

function adminSearchResultsSection() {
 const r = state.searchResults;
 if (!r) return '';
 

 return `<section class="soft-panel p-5 col-span-full">
 <h2 class="text-base md:text-xl font-black">Search Results</h2>
 ${r.users?.length ? `<div class="mt-4"><p class="eyebrow">Users</p>
 <div class="mt-2 space-y-2">${r.users.map(u => `<div class="flex items-center gap-3 rounded-xl neu-raised p-3">
 ${avatar(u, 'h-8 w-8 text-xs')}
 <div class="flex-1"><p class="font-semibold">${h(u.name)}</p><p class="text-xs text-slate-600">${h(u.email)} · ${h(u.role)}</p></div>
 <span class="status-pill ${u.kyc_status === 'approved' ? 'status-open' : 'status-muted'}">${h(u.kyc_status)}</span>
 </div>`).join('')}</div>` : ''}
 ${r.jobs?.length ? `<div class="mt-4"><p class="eyebrow">Jobs</p>
 <div class="mt-2 space-y-2">${r.jobs.map(j => `<div class="flex items-center justify-between gap-3 rounded-xl neu-raised p-3">
 <p class="font-semibold">${h(j.title)}</p><span class="status-pill status-muted">${h(j.status)}</span>
 </div>`).join('')}</div>` : ''}
 ${r.contracts?.length ? `<div class="mt-4"><p class="eyebrow">Contracts</p>
 <div class="mt-2 space-y-2">${r.contracts.map(c => `<div class="flex items-center justify-between gap-3 rounded-xl neu-raised p-3">
 <div><p class="font-semibold">#${c.id} — ${h(c.client?.name)} ↔ ${h(c.freelancer?.name)}</p></div>
 <span class="font-bold text-blue-700">${money(c.total_amount)}</span>
 </div>`).join('')}</div>` : ''}
 </section>`;
}

async function logTime(event) {
 event.preventDefault();
 try {
 await request(`/contracts/${state.currentContract.id}/time-logs`, { method: 'POST', body: JSON.stringify(formObject(event.currentTarget)) });
 closeModal();
 notify('Time logged successfully.');
 await navigate(`contracts/${state.currentContract.id}`);
 } catch (e) {
 notify('Failed to log time.');
 }
}

window.manageAgency = async function(id) {
 state.manageAgencyId = id;
 openModal('manage_agency');
}

window.removeAgencyMember = async function(agencyId, userId) {
 if (!confirm('Remove this member?')) return;
 try {
 await request(`/agencies/${agencyId}/members/${userId}`, { method: 'DELETE' });
 notify('Member removed.');
 await navigate('profile');
 closeModal();
 } catch (e) {
 notify(e.message || 'Failed to remove member.', 'error');
 }
}

async function handleAgencyUpdate(event) {
 event.preventDefault();
 const data = formObject(event.currentTarget);
 try {
 await request(`/agencies/${data.agency_id}`, { method: 'PUT', body: JSON.stringify(data) });
 closeModal();
 notify('Agency info updated.');
 await navigate('profile');
 } catch (e) {
 notify(e.message || 'Failed to update agency.', 'error');
 }
}

async function createAgency(event) {
 event.preventDefault();
 const form = event.currentTarget;
 try {
 await request('/agencies', { method: 'POST', body: JSON.stringify(formObject(form)) });
 closeModal();
 notify('Agency created.');
 await navigate('profile');
 } catch (e) {
 notify('Failed to create agency.');
 }
}

window.deleteAgency = async function(id) {
 if (!confirm('Are you sure you want to delete this agency? This cannot be undone.')) return;
 try {
 await request(`/agencies/${id}`, { method: 'DELETE' });
 notify('Agency deleted successfully.');
 await navigate('profile');
 } catch (e) {
 notify(e.message || 'Failed to delete agency.', 'error');
 }
}
window.acceptAgencyInvite = async function(id) {
 try {
 await request(`/agencies/${id}/accept-invite`, { method: 'POST' });
 notify('Invite accepted.');
 await navigate('profile');
 } catch (e) {
 notify(e.message || 'Failed to accept invite.', 'error');
 }
}
window.declineAgencyInvite = async function(id) {
 if (!confirm('Decline this invitation?')) return;
 try {
 await request(`/agencies/${id}/decline-invite`, { method: 'POST' });
 notify('Invite declined.');
 await navigate('profile');
 } catch (e) {
 notify(e.message || 'Failed to decline invite.', 'error');
 }
}
async function inviteAgencyMember(event) {
 event.preventDefault();
 const data = formObject(event.currentTarget);
 try {
 await request(`/agencies/${data.agency_id}/members`, { method: 'POST', body: JSON.stringify({email: data.email}) });
 closeModal();
 notify('Invite sent.');
 } catch (e) {
 notify('Failed to send invite.');
 }
}

window.adminAddCategory = function() {
 state.modal = {
 title: 'Add Work Category',
 content: `
 <form onsubmit="window.submitAdminCategory(event)"class="space-y-4">
 <label class="block text-sm font-semibold text-slate-600">Category Name
 <input class="input-control"name="name"required placeholder="e.g. Mobile Apps">
 </label>
 <label class="block text-sm font-semibold text-slate-600">Description
 <textarea class="input-control"name="description"rows="3"placeholder="Short description of this category"></textarea>
 </label>
 <div class="mt-6 flex justify-end gap-3">
 <button type="button"class="btn-secondary"onclick="closeModal()">Cancel</button>
 <button type="submit"class="btn-primary">Save Category</button>
 </div>
 </form>
 `
 };
 render();
};

window.adminEditCategory = function(id) {
 const cat = state.adminCategories.find(c => c.id === id);
 if (!cat) return;
 state.modal = {
 title: 'Edit Work Category',
 content: `
 <form onsubmit="window.submitAdminCategory(event, ${id})"class="space-y-4">
 <label class="block text-sm font-semibold text-slate-600">Category Name
 <input class="input-control"name="name"required value="${h(cat.name)}">
 </label>
 <label class="block text-sm font-semibold text-slate-600">Description
 <textarea class="input-control"name="description"rows="3">${h(cat.description || '')}</textarea>
 </label>
 <div class="mt-6 flex justify-end gap-3">
 <button type="button"class="btn-secondary"onclick="closeModal()">Cancel</button>
 <button type="submit"class="btn-primary">Update Category</button>
 </div>
 </form>
 `
 };
 render();
};

window.submitAdminCategory = async function(event, id = null) {
 event.preventDefault();
 const data = formObject(event.target);
 const url = id ? `/admin/categories/${id}` : '/admin/categories';
 const method = id ? 'PUT' : 'POST';
 
 try {
 await request(url, { method, body: JSON.stringify(data) });
 notify('Category saved successfully.');
 closeModal();
 await loadRouteData(); // reload admin data
 } catch (e) {
 notify(e.message, 'error');
 }
};

window.adminDeleteCategory = async function(id) {
 if (!await confirmPopup('Are you sure you want to delete this category?')) return;
 try {
 await request(`/admin/categories/${id}`, { method: 'DELETE' });
 notify('Category deleted successfully.');
 await loadRouteData(); // reload admin data
 } catch (e) {
 notify(e.message, 'error');
 }
};

window.adminAddMembershipPlan = function() {
 state.modal = {
 title: 'Add Membership Plan',
 content: `
 <form onsubmit="window.submitAdminMembershipPlan(event)"class="space-y-4">
 <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
 <label class="block text-sm font-semibold text-slate-600">Name
 <input class="input-control"name="name"required placeholder="e.g. Pro">
 </label>
 <label class="block text-sm font-semibold text-slate-600">Slug
 <input class="input-control"name="slug"required placeholder="e.g. pro">
 </label>
 <label class="block text-sm font-semibold text-slate-600">Monthly Price (₹)
 <input class="input-control"type="number"step="0.01"name="price_monthly"required placeholder="e.g. 999">
 </label>
 <label class="block text-sm font-semibold text-slate-600">Sort Order
 <input class="input-control"type="number"name="sort_order"value="0">
 </label>
 </div>
 
 <p class="font-bold text-blue-700 mt-4 mb-2">Features</p>
 <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
 <label class="block text-sm font-semibold text-slate-600">Max Bids Per Month
 <input class="input-control"type="number"name="features[max_bids_per_month]"required value="0">
 </label>
 <div class="space-y-2 mt-4">
 <label class="flex items-center gap-2 text-sm text-slate-600">
 <input type="hidden"name="features[can_feature_jobs]"value="false">
 <input type="checkbox"name="features[can_feature_jobs]"value="true"class="accent-teal-400"> Feature jobs
 </label>
 <label class="flex items-center gap-2 text-sm text-slate-600">
 <input type="hidden"name="features[can_seal_bids]"value="false">
 <input type="checkbox"name="features[can_seal_bids]"value="true"class="accent-teal-400"> Seal bids
 </label>
 <label class="flex items-center gap-2 text-sm text-slate-600">
 <input type="hidden"name="features[profile_boost]"value="false">
 <input type="checkbox"name="features[profile_boost]"value="true"class="accent-teal-400"> Profile boost
 </label>
 <label class="flex items-center gap-2 text-sm text-slate-600">
 <input type="hidden"name="features[nda_available]"value="false">
 <input type="checkbox"name="features[nda_available]"value="true"class="accent-teal-400"> NDA available
 </label>
 </div>
 </div>

 <div class="mt-6 flex justify-end gap-3">
 <button type="button"class="btn-secondary"onclick="closeModal()">Cancel</button>
 <button type="submit"class="btn-primary">Save Plan</button>
 </div>
 </form>
 `
 };
 render();
};

window.adminEditMembershipPlan = function(id) {
 const plan = state.adminMembershipPlans.find(p => p.id === id);
 if (!plan) return;
 const f = plan.features || {};

 state.modal = {
 title: 'Edit Membership Plan',
 content: `
 <form onsubmit="window.submitAdminMembershipPlan(event, ${id})"class="space-y-4">
 <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
 <label class="block text-sm font-semibold text-slate-600">Name
 <input class="input-control"name="name"required value="${h(plan.name)}">
 </label>
 <label class="block text-sm font-semibold text-slate-600">Slug
 <input class="input-control"name="slug"required value="${h(plan.slug)}">
 </label>
 <label class="block text-sm font-semibold text-slate-600">Monthly Price (₹)
 <input class="input-control"type="number"step="0.01"name="price_monthly"required value="${plan.price_monthly}">
 </label>
 <label class="block text-sm font-semibold text-slate-600">Sort Order
 <input class="input-control"type="number"name="sort_order"value="${plan.sort_order || 0}">
 </label>
 </div>
 
 <p class="font-bold text-blue-700 mt-4 mb-2">Features</p>
 <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
 <label class="block text-sm font-semibold text-slate-600">Max Bids Per Month
 <input class="input-control"type="number"name="features[max_bids_per_month]"required value="${f.max_bids_per_month || 0}">
 </label>
 <div class="space-y-2 mt-4">
 <label class="flex items-center gap-2 text-sm text-slate-600">
 <input type="hidden"name="features[can_feature_jobs]"value="false">
 <input type="checkbox"name="features[can_feature_jobs]"value="true"class="accent-teal-400"${f.can_feature_jobs ? 'checked' : ''}> Feature jobs
 </label>
 <label class="flex items-center gap-2 text-sm text-slate-600">
 <input type="hidden"name="features[can_seal_bids]"value="false">
 <input type="checkbox"name="features[can_seal_bids]"value="true"class="accent-teal-400"${f.can_seal_bids ? 'checked' : ''}> Seal bids
 </label>
 <label class="flex items-center gap-2 text-sm text-slate-600">
 <input type="hidden"name="features[profile_boost]"value="false">
 <input type="checkbox"name="features[profile_boost]"value="true"class="accent-teal-400"${f.profile_boost ? 'checked' : ''}> Profile boost
 </label>
 <label class="flex items-center gap-2 text-sm text-slate-600">
 <input type="hidden"name="features[nda_available]"value="false">
 <input type="checkbox"name="features[nda_available]"value="true"class="accent-teal-400"${f.nda_available ? 'checked' : ''}> NDA available
 </label>
 </div>
 </div>

 <div class="mt-6 flex justify-end gap-3">
 <button type="button"class="btn-secondary"onclick="closeModal()">Cancel</button>
 <button type="submit"class="btn-primary">Update Plan</button>
 </div>
 </form>
 `
 };
 render();
};

window.submitAdminMembershipPlan = async function(event, id = null) {
 event.preventDefault();
 
 // Custom form data parsing because of array naming (features[xyz])
 const formData = new FormData(event.target);
 const data = {
 name: formData.get('name'),
 slug: formData.get('slug'),
 price_monthly: formData.get('price_monthly'),
 sort_order: formData.get('sort_order'),
 features: {
 max_bids_per_month: parseInt(formData.get('features[max_bids_per_month]') || 0),
 can_feature_jobs: formData.getAll('features[can_feature_jobs]').includes('true'),
 can_seal_bids: formData.getAll('features[can_seal_bids]').includes('true'),
 profile_boost: formData.getAll('features[profile_boost]').includes('true'),
 nda_available: formData.getAll('features[nda_available]').includes('true'),
 }
 };

 const url = id ? `/admin/memberships/${id}` : '/admin/memberships';
 const method = id ? 'PUT' : 'POST';
 
 try {
 await request(url, { method, body: JSON.stringify(data) });
 notify('Membership plan saved successfully.');
 closeModal();
 await loadRouteData(); // reload admin data
 } catch (e) {
 notify(e.message, 'error');
 }
};

window.adminDeleteUser = async function(id, name) {
 if (!confirm(`Are you sure you want to permanently delete user ${name}? This action cannot be undone.`)) {
 return;
 }
 
 try {
 await request(`/admin/users/${id}`, { method: 'DELETE' });
 notify('User deleted successfully.');
 state.adminUsers = state.adminUsers.filter(u => u.id !== id);
 render();
 } catch (e) {
 notify(e.message, 'error');
 }
};

let adminUserSearchTimeout = null;
window.filterAdminUsers = function() {
 if (adminUserSearchTimeout) clearTimeout(adminUserSearchTimeout);
 adminUserSearchTimeout = setTimeout(() => {
 const q = document.getElementById('admin-user-search')?.value.toLowerCase() || '';
 const rows = document.querySelectorAll('#admin-users-tbody tr');
 rows.forEach(row => {
 // textContent is 100x faster than innerText because it doesn't trigger layout reflows
 const text = row.textContent.toLowerCase();
 row.style.display = text.includes(q) ? '' : 'none';
 });
 }, 250);
};

window.adminForcePasswordChange = function(id) {
 const user = state.adminUsers.find(u => u.id === id);
 if (!user) return;
 
 state.modal = {
 title: `Change Password for ${user.name}`,
 content: `
 <form onsubmit="window.submitAdminForcePasswordChange(event, ${user.id})"class="space-y-4">
 <label class="block text-sm font-semibold">New Password
 <input class="input-control"type="password"name="new_password"required minlength="8">
 </label>
 <label class="block text-sm font-semibold">Confirm New Password
 <input class="input-control"type="password"name="new_password_confirmation"required minlength="8">
 </label>
 <div class="pt-4 flex gap-3">
 <button type="submit"class="btn-primary w-full">Update Password</button>
 <button type="button"class="btn-secondary w-full"data-close-modal>Cancel</button>
 </div>
 </form>
 `
 };
 render();
};

window.submitAdminForcePasswordChange = async function(event, id) {
 event.preventDefault();
 const form = event.currentTarget;
 const formData = new FormData(form);
 
 if (formData.get('new_password') !== formData.get('new_password_confirmation')) {
 alert('Passwords do not match!');
 return;
 }
 
 const submitBtn = form.querySelector('button[type="submit"]');
 const ogText = submitBtn.innerHTML;
 submitBtn.innerHTML = 'Updating...';
 submitBtn.disabled = true;

 try {
 await request(`/admin/users/${id}/password`, {
 method: 'PUT',
 body: JSON.stringify({
 new_password: formData.get('new_password')
 })
 });
 alert('Password updated successfully!');
 closeModal();
 } catch (err) {
 alert(err.message || 'Failed to update password.');
 } finally {
 submitBtn.innerHTML = ogText;
 submitBtn.disabled = false;
 }
};
window.adminDeleteMembershipPlan = async function(id) {
 if (!await confirmPopup('Are you sure you want to deactivate this membership plan?')) return;
 try {
 await request(`/admin/memberships/${id}`, { method: 'DELETE' });
 notify('Membership plan deactivated successfully.');
 await loadRouteData(); // reload admin data
 } catch (e) {
 notify(e.message, 'error');
 }
};

async function initAuth() {
 const token = localStorage.getItem('ssm_token');
 const userStr = localStorage.getItem('ssm_user');
 if (token && userStr) {
 state.token = token;
 try {
 state.user = JSON.parse(userStr);
 } catch (e) {
 state.token = null;
 state.user = null;
 localStorage.removeItem('ssm_token');
 localStorage.removeItem('ssm_user');
 }
 }
}

// =====================================================================
// PHASE 3 PAGE FUNCTIONS
// =====================================================================

function leaderboardPage() {
 const leaders = state.leaderboard || [];
 const tierColors = ['text-amber-800', 'text-slate-600', 'text-amber-800', 'text-blue-700'];
 const tierBg = ['bg-amber-400/10', 'bg-slate-400/10', 'bg-amber-700/10', 'bg-teal-400/10'];
 return `<div class="space-y-6">
 <section>
 <p class="eyebrow">Top Talent</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Leaderboard</h1>
 <p class="mt-2 text-sm text-slate-600">Top freelancers ranked by rating and completed projects</p>
 </section>
 <div class="space-y-3">
 ${leaders.length ? leaders.map((l, i) => `
 <div class="flex items-center gap-5 rounded-2xl neu-raised p-5 hover:-translate-y-1 transition-all cursor-pointer"onclick="navigate('freelancers/${l.user?.id}')">
 <div class="flex-shrink-0 w-10 text-center">
 <span class="text-2xl font-black ${i < 3 ? tierColors[i] : 'text-slate-600'}">${i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `#${l.rank}`}</span>
 </div>
 ${avatar(l.user, 'h-12 w-12 text-base font-bold rounded-full bg-gradient-to-br from-teal-400 to-blue-500 text-slate-950')}
 <div class="flex-1 min-w-0">
 <p class="font-bold text-slate-900">${h(l.user?.name)}</p>
 <p class="text-sm text-slate-600 truncate">${h(l.headline || '')}</p>
 </div>
 <div class="text-right flex-shrink-0 space-y-1">
 <div class="flex items-center justify-end gap-1">
 <span class="text-amber-800">${renderStars(l.avg_rating)}</span>
 <span class="text-amber-800 text-sm font-bold">${parseFloat(l.avg_rating || 0).toFixed(1)}</span>
 </div>
 <p class="text-xs text-slate-600">${l.review_count} reviews · ${l.completed_contracts_count} jobs</p>
 </div>
 </div>`).join('') : empty('Not enough data yet. Leaderboard populates as freelancers earn reviews.')}
 </div>
 </div>`;
}

function forumPage() {
 const posts = state.forumPosts || [];
 const cats = ['general', 'help', 'showcase', 'announcements'];
 const catColors = { general: 'bg-blue-500/15 text-blue-300', help: 'bg-amber-500/15 text-amber-800', showcase: 'bg-teal-500/15 text-blue-700', announcements: 'bg-rose-500/15 text-rose-700' };
 return `<div class="space-y-6">
 <section class="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
 <div>
 <p class="eyebrow">Community</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Community Forum</h1>
 <p class="mt-2 text-sm text-slate-600">Ask questions, share work, and connect with the community</p>
 </div>
 <button onclick="window.openNewPostModal()"class="btn-primary flex-shrink-0">+ New Post</button>
 </section>
 <div class="flex flex-wrap gap-2">
 ${cats.map(c => `<button onclick="window.filterForumCat('${c}')"class="rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-wider hover:border-teal-400 transition-colors ${catColors[c] || ''}">${c}</button>`).join('')}
 </div>
 <div class="space-y-3"id="forum-list">
 ${posts.length ? posts.map(p => `
 <article onclick="navigate('forum/${p.id}')"class="flex items-start gap-4 rounded-2xl neu-raised p-5 cursor-pointer hover:-translate-y-1 transition-all">
 ${avatar(p.author, 'h-10 w-10 text-sm flex-shrink-0 rounded-full bg-gradient-to-br from-purple-400 to-pink-500 text-slate-950')}
 <div class="flex-1 min-w-0">
 <div class="flex flex-wrap items-center gap-2 mb-1">
 ${p.is_pinned ? '<span class="text-[10px] font-bold text-amber-800 uppercase tracking-wider">📌 Pinned</span>' : ''}
 <span class="rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase ${catColors[p.category] || 'bg-slate-700 text-slate-600'}">${p.category}</span>
 </div>
 <h3 class="font-bold text-slate-900 line-clamp-1">${h(p.title)}</h3>
 <p class="text-sm text-slate-600 line-clamp-1 mt-0.5">${h(p.body)}</p>
 <p class="text-xs text-slate-600 mt-2">${h(p.author?.name)} · ${p.reply_count || 0} replies · ${p.view_count || 0} views</p>
 </div>
 </article>`).join('') : empty('No posts yet. Be the first to start a conversation!')}
 </div>
 <div id="forum-new-post-modal"class="hidden fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm">
 <div class="neu-raised rounded-2xl p-4 md:p-6 w-full max-w-xl mx-4 space-y-4">
 <h2 class="text-base md:text-xl font-bold">New Forum Post</h2>
 <input id="forum-post-title"class="input-control"placeholder="Post title (min 10 chars)">
 <select id="forum-post-cat"class="input-control mt-0">
 ${cats.map(c => `<option value="${c}">${titleCase(c)}</option>`).join('')}
 </select>
 <textarea id="forum-post-body"class="input-control mt-0 min-h-[140px]"placeholder="Share your thoughts, question, or showcase... (min 20 chars)"></textarea>
 <div class="flex gap-3 justify-end">
 <button onclick="document.querySelector('#forum-new-post-modal').classList.add('hidden')"class="btn-secondary">Cancel</button>
 <button onclick="window.submitForumPost()"class="btn-primary">Publish</button>
 </div>
 </div>
 </div>
 </div>`;
}

function forumPostPage() {
 const d = state.currentForumPost;
 if (!d) return `<div class="py-12 md:py-20 text-center text-slate-600">Loading post…</div>`;
 const post = d.data;
 const replies = d.replies || [];
 const catColors = { general: 'bg-blue-500/15 text-blue-300', help: 'bg-amber-500/15 text-amber-800', showcase: 'bg-teal-500/15 text-blue-700', announcements: 'bg-rose-500/15 text-rose-700' };
 return `<div class="space-y-6 max-w-3xl mx-auto">
 <button onclick="navigate('forum')"class="btn-ghost text-sm">← Back to Forum</button>
 <article class="rounded-2xl neu-raised p-4 md:p-6 space-y-4">
 <div class="flex flex-wrap items-center gap-2">
 <span class="rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase ${catColors[post.category] || 'bg-slate-700 text-slate-600'}">${post.category}</span>
 ${post.is_pinned ? '<span class="text-[11px] font-bold text-amber-800">📌 Pinned</span>' : ''}
 ${post.is_locked ? '<span class="text-[11px] font-bold text-rose-400">🔒 Locked</span>' : ''}
 </div>
 <h1 class="text-2xl font-black">${h(post.title)}</h1>
 <div class="flex items-center gap-3">
 ${avatar(post.author, 'h-8 w-8 text-xs rounded-full bg-gradient-to-br from-purple-400 to-pink-500 text-slate-950')}
 <span class="text-sm text-slate-600">${h(post.author?.name)} · ${post.view_count} views</span>
 </div>
 <div class="text-slate-600 whitespace-pre-wrap leading-relaxed">${h(post.body)}</div>
 ${state.user?.role === 'admin' ? `<div class="flex gap-2 pt-2">
 <button onclick="window.adminTogglePin(${post.id},${!post.is_pinned})"class="btn-secondary text-xs">${post.is_pinned ? 'Unpin' : '📌 Pin'}</button>
 <button onclick="window.adminToggleLock(${post.id},${!post.is_locked})"class="btn-secondary text-xs">${post.is_locked ? '🔓 Unlock' : '🔒 Lock'}</button>
 </div>` : ''}
 </article>
 <section class="space-y-3">
 <h2 class="text-lg font-bold text-slate-600">${replies.length} Replies</h2>
 ${replies.map(r => `
 <div class="flex gap-4 rounded-2xl ${r.is_solution ? 'border-emerald-500/40 bg-emerald-900/10' : ' neu-raised'} p-5">
 ${avatar(r.author, 'h-9 w-9 text-sm flex-shrink-0 rounded-full bg-gradient-to-br from-teal-400 to-blue-500 text-slate-950')}
 <div class="flex-1">
 <div class="flex items-center gap-2 mb-2">
 <span class="font-semibold text-slate-700 text-sm">${h(r.author?.name)}</span>
 ${r.is_solution ? '<span class="text-[11px] font-bold text-emerald-400 bg-emerald-400/10 px-2.5 py-0.5 rounded-full border-emerald-400/30">✓ Solution</span>' : ''}
 ${(state.user?.id === post.author_id || state.user?.role === 'admin') && !r.is_solution ? `<button onclick="window.markSolution(${post.id},${r.id})"class="text-[11px] text-slate-600 hover:text-emerald-400 transition-colors ml-auto">Mark as Solution</button>` : ''}
 </div>
 <p class="text-slate-600 text-sm whitespace-pre-wrap leading-relaxed">${h(r.body)}</p>
 </div>
 </div>`).join('') || empty('No replies yet. Be the first to respond!')}
 </section>
 ${!post.is_locked ? `<div class="rounded-2xl neu-raised p-5 space-y-3">
 <h3 class="font-bold text-slate-600">Post a Reply</h3>
 <textarea id="forum-reply-body"class="input-control min-h-[100px]"placeholder="Share your thoughts or answer…"></textarea>
 <button onclick="window.submitForumReply(${post.id})"class="btn-primary">Post Reply</button>
 </div>` : '<p class="text-center text-slate-600 text-sm py-4">🔒 This thread is locked.</p>'}
 </div>`;
}

function savedFreelancersPage() {
 const freelancers = state.savedFreelancersData || [];
 return `<div class="space-y-6">
 <section>
 <p class="eyebrow">Your Shortlist</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Saved Freelancers</h1>
 <p class="mt-2 text-sm text-slate-600">Your bookmarked talent, ready to invite</p>
 </section>
 <div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
 ${freelancers.length ? freelancers.map(u => {
 const fp = u.freelancer_profile || {};
 return `<div class="rounded-2xl neu-raised p-5 flex items-center gap-4 cursor-pointer hover:-translate-y-1 transition-all group"onclick="navigate('freelancers/${u.id}')">
 ${avatar(u, 'h-14 w-14 text-xl font-bold rounded-full bg-gradient-to-br from-teal-400 to-blue-500 text-slate-950')}
 <div class="flex-1 min-w-0">
 <p class="font-bold text-slate-900 group-hover:text-blue-700 transition-colors">${h(u.name)}</p>
 <p class="text-sm text-slate-600 line-clamp-1">${h(fp.headline || '')}</p>
 <div class="flex items-center gap-1 mt-1">
 <span>${renderStars(fp.avg_rating || 0)}</span>
 <span class="text-xs text-slate-600">${fp.review_count || 0} reviews</span>
 </div>
 </div>
 <button onclick="event.stopPropagation(); toggleSaveFreelancer(${u.id}, this)"class="flex-shrink-0 p-1.5 text-rose-400 bg-rose-400/10 rounded-lg hover:bg-rose-400/20 transition-colors"title="Remove bookmark">
 <svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 24 24"fill="currentColor"class="w-5 h-5"><path stroke-linecap="round"stroke-linejoin="round"d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"/></svg>
 </button>
 </div>`;
 }).join('') : empty('No saved freelancers yet. Browse the directory and click ❤️ to bookmark.')}
 </div>
 </div>`;
}

function adminReportsPage() {
 const reports = state.adminReports || [];
 const statusColors = { pending: 'text-amber-800 bg-amber-400/10', reviewed: 'text-blue-400 bg-blue-400/10', actioned: 'text-rose-400 bg-rose-400/10', dismissed: 'text-slate-600 bg-slate-400/10' };
 return `<div class="space-y-6">
 <section>
 <p class="eyebrow">Trust & Safety</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">User Reports</h1>
 <p class="mt-2 text-sm text-slate-600">${reports.filter(r => r.status === 'pending').length} pending review</p>
 </section>
 <div class="space-y-3">
 ${reports.length ? reports.map(r => `
 <div class="rounded-2xl neu-raised p-5 space-y-3">
 <div class="flex flex-wrap items-start justify-between gap-3">
 <div>
 <p class="font-bold text-slate-900">${h(r.reported?.name)} <span class="text-slate-600 font-normal text-sm">reported by ${h(r.reporter?.name)}</span></p>
 <p class="text-sm text-slate-600 mt-0.5"><strong>Reason:</strong> ${h(r.reason)}</p>
 ${r.description ? `<p class="text-sm text-slate-600 mt-1">${h(r.description)}</p>` : ''}
 </div>
 <span class="rounded-full px-3 py-1 text-xs font-bold uppercase ${statusColors[r.status] || ''}">${r.status}</span>
 </div>
 ${r.status === 'pending' ? `<div class="flex gap-2 flex-wrap">
 <button onclick="window.resolveReport(${r.id},'actioned')"class="btn-secondary text-xs text-rose-400 border-rose-200">Take Action</button>
 <button onclick="window.resolveReport(${r.id},'reviewed')"class="btn-secondary text-xs text-blue-400 border-blue-400/30">Mark Reviewed</button>
 <button onclick="window.resolveReport(${r.id},'dismissed')"class="btn-secondary text-xs">Dismiss</button>
 </div>` : `<p class="text-xs text-slate-600">Reviewed by ${h(r.reviewer?.name || 'Admin')} · ${r.admin_notes || ''}</p>`}
 </div>`).join('') : empty('No reports submitted yet.')}
 </div>
 </div>`;
}

function adminAnnouncementsPage() {
 const anns = state.adminAnnouncements || [];
 const typeColors = { info: 'bg-blue-400/10 text-blue-300', warning: 'bg-amber-400/10 text-amber-800', success: 'bg-emerald-400/10 text-emerald-300', danger: 'bg-rose-400/10 text-rose-700' };
 return `<div class="space-y-6">
 <section class="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
 <div>
 <p class="eyebrow">Platform</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Announcements</h1>
 <p class="mt-2 text-sm text-slate-600">Broadcast messages to all users or specific roles</p>
 </div>
 <button onclick="window.openAnnouncementModal()"class="btn-primary flex-shrink-0">+ New Announcement</button>
 </section>
 <div class="space-y-3">
 ${anns.length ? anns.map(a => `
 <div class="rounded-2xl neu-raised p-5 space-y-2">
 <div class="flex flex-wrap items-start justify-between gap-3">
 <div class="flex items-center gap-2 flex-wrap">
 <span class="rounded-full px-2.5 py-0.5 text-xs font-bold uppercase ${typeColors[a.type] || ''}">${a.type}</span>
 <h3 class="font-bold text-slate-900">${h(a.title)}</h3>
 ${!a.is_active ? '<span class="text-xs text-slate-600 neu-raised rounded-full px-2 py-0.5">Inactive</span>' : '<span class="text-xs text-emerald-400 bg-emerald-400/10 rounded-full px-2 py-0.5">Live</span>'}
 </div>
 <div class="flex gap-2">
 <button onclick="window.toggleAnnouncement(${a.id},${!a.is_active})"class="btn-secondary text-xs">${a.is_active ? 'Deactivate' : 'Activate'}</button>
 <button onclick="window.deleteAnnouncement(${a.id})"class="btn-secondary text-xs text-rose-400 border-rose-400/20">Delete</button>
 </div>
 </div>
 <p class="text-sm text-slate-600">${h(a.body)}</p>
 <p class="text-xs text-slate-600">Target: ${a.target_roles?.join(', ') || 'All users'} · By ${h(a.creator?.name || 'Admin')}</p>
 </div>`).join('') : empty('No announcements yet.')}
 </div>
 <div id="ann-modal"class="hidden fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm">
 <div class="neu-raised rounded-2xl p-4 md:p-6 w-full max-w-lg mx-4 space-y-4">
 <h2 class="text-base md:text-xl font-bold">New Announcement</h2>
 <input id="ann-title"class="input-control"placeholder="Title">
 <textarea id="ann-body"class="input-control mt-0 min-h-[100px]"placeholder="Message body…"></textarea>
 <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
 <select id="ann-type"class="input-control mt-0">
 <option value="info">ℹ️ Info</option>
 <option value="success">✅ Success</option>
 <option value="warning">⚠️ Warning</option>
 <option value="danger">🚨 Danger</option>
 </select>
 <select id="ann-roles"class="input-control mt-0">
 <option value="">All Users</option>
 <option value="client">Clients Only</option>
 <option value="freelancer">Freelancers Only</option>
 </select>
 </div>
 <div class="flex gap-3 justify-end">
 <button onclick="document.querySelector('#ann-modal').classList.add('hidden')"class="btn-secondary">Cancel</button>
 <button onclick="window.createAnnouncement()"class="btn-primary">Publish</button>
 </div>
 </div>
 </div>
 </div>`;
}

function adminFeaturedPage() {
 const d = state.adminFeatured || {};
 const jobs = d.featured_jobs || [];
 const spotlights = d.spotlighted_freelancers || [];
 return `<div class="space-y-8">
 <section class="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
 <div>
 <p class="eyebrow">Revenue</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Featured Items</h1>
 <p class="mt-2 text-sm text-slate-600">${jobs.length} featured jobs · ${spotlights.length} spotlighted freelancers</p>
 </div>
 <button onclick="window.expireFeatured()"class="btn-secondary text-sm">🧹 Expire Stale</button>
 </section>
 <div class="space-y-3">
 <h2 class="text-lg font-bold text-slate-600">Featured Jobs</h2>
 ${jobs.length ? jobs.map(j => `
 <div class="rounded-2xl border-amber-200 bg-amber-400/5 p-5 flex items-center gap-4">
 <div class="flex-1">
 <p class="font-bold text-slate-900">${h(j.title)}</p>
 <p class="text-sm text-slate-600">By ${h(j.client?.name)} · Until ${new Date(j.featured_until).toLocaleDateString()}</p>
 </div>
 <span class="text-amber-800 text-xs font-bold border-amber-200 rounded-full px-2.5 py-0.5">⭐ Priority ${j.featured_priority}</span>
 </div>`).join('') : empty('No featured jobs.')}
 </div>
 <div class="space-y-3">
 <h2 class="text-lg font-bold text-slate-600">Spotlighted Freelancers</h2>
 ${spotlights.length ? spotlights.map(fp => `
 <div class="rounded-2xl border-blue-200 bg-teal-400/5 p-5 flex items-center gap-4">
 ${avatar(fp.user, 'h-10 w-10 text-sm rounded-full bg-gradient-to-br from-teal-400 to-blue-500 text-slate-950')}
 <div class="flex-1">
 <p class="font-bold text-slate-900">${h(fp.user?.name)}</p>
 <p class="text-sm text-slate-600">Until ${new Date(fp.spotlight_until).toLocaleDateString()}</p>
 </div>
 <span class="text-blue-700 text-xs font-bold border-blue-200 rounded-full px-2.5 py-0.5">✦ Spotlight</span>
 </div>`).join('') : empty('No spotlighted freelancers.')}
 </div>
 </div>`;
}

// =====================================================================
// BLOG PAGES
// =====================================================================

function adminBlogPage() {
 const posts = state.adminBlogPosts || [];
 return `<div class="space-y-6">
 <section class="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
 <div>
 <p class="eyebrow">Content</p>
 <h1 class="mt-2 text-xl md:text-3xl font-black">Blog Management</h1>
 </div>
 <div class="flex gap-2">
 <button onclick="window.openBlogModal()"class="btn-primary flex-shrink-0">+ New Post</button>
 <button onclick="document.querySelector('#ai-blog-modal').classList.remove('hidden')"class="btn-ai flex-shrink-0">✨ Generate via AI</button>
 </div>
 </section>
 <div class="space-y-3">
 ${posts.length ? posts.map(p => `
 <div class="rounded-2xl neu-raised p-5 flex flex-wrap items-center justify-between gap-4">
 <div>
 <h3 class="font-bold text-slate-900">${h(p.title)}</h3>
 <p class="text-sm text-slate-600">/${h(p.slug)}</p>
 </div>
 <div class="flex items-center gap-3">
 <span class="rounded-full px-2.5 py-0.5 text-xs font-bold uppercase ${p.status === 'published' ? 'bg-emerald-400/10 text-emerald-300' : 'neu-raised text-slate-600'}">${p.status}</span>
 <button onclick='window.editBlogPost(${JSON.stringify(p).replace(/'/g,"&#39;")})' class="btn-secondary text-xs">Edit</button>
 <button onclick="window.deleteBlogPost(${p.id})"class="btn-secondary text-xs text-rose-400 border-rose-400/20">Delete</button>
 </div>
 </div>`).join('') : empty('No blog posts found.')}
 </div>
 
 <!-- Manual Blog Modal -->
 <div id="blog-modal"class="hidden fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4 overflow-y-auto">
 <div class="neu-raised rounded-2xl p-4 md:p-6 w-full max-w-3xl space-y-4 my-8">
 <h2 id="blog-modal-title"class="text-base md:text-xl font-bold">New Blog Post</h2>
 <input type="hidden"id="blog-id"value="">
 <div><label class="block text-sm font-semibold mb-1">Title</label><input type="text"id="blog-title"class="input-control mt-0"placeholder="Post Title"></div>
 <div><label class="block text-sm font-semibold mb-1">Status</label><select id="blog-status"class="input-control mt-0"><option value="draft">Draft</option><option value="published">Published</option></select></div>
 <div><label class="block text-sm font-semibold mb-1">Excerpt</label><textarea id="blog-excerpt"class="input-control mt-0 h-20"placeholder="Short description..."></textarea></div>
 <div><label class="block text-sm font-semibold mb-1">Content (HTML/Markdown supported)</label><textarea id="blog-content"class="input-control mt-0 h-64 font-mono  text-base"placeholder="<p>Write your content here...</p>"></textarea></div>
 <div class="flex gap-3 justify-end">
 <button onclick="document.querySelector('#blog-modal').classList.add('hidden')"class="btn-secondary">Cancel</button>
 <button onclick="window.saveBlogPost()"class="btn-primary">Save Post</button>
 </div>
 </div>
 </div>

 <!-- AI Blog Modal -->
 <div id="ai-blog-modal"class="hidden fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4 overflow-y-auto">
 <form id="ai-blog-form"onsubmit="window.generateAiBlog(event)"class="neu-raised rounded-2xl p-4 md:p-6 w-full max-w-lg space-y-4">
 <h2 class="text-base md:text-xl font-bold text-teal-700 flex items-center gap-2">✨ Generate Blog with AI</h2>
 <p class="text-sm text-slate-600">Provide a topic and tone, and our AI will instantly write, format, and draft a high-quality SEO-optimized post.</p>
 <div><label class="block text-sm font-semibold mb-1">Topic</label><input type="text"name="topic"class="input-control mt-0"placeholder="e.g. Top 10 Vue.js Best Practices"required></div>
 <div><label class="block text-sm font-semibold mb-1">Tone</label>
 <select name="tone"class="input-control mt-0">
 <option value="professional">Professional</option>
 <option value="casual">Casual & Conversational</option>
 <option value="technical">Technical & In-depth</option>
 </select>
 </div>
 <div class="flex gap-3 justify-end pt-2">
 <button type="button"onclick="document.querySelector('#ai-blog-modal').classList.add('hidden')"class="btn-secondary">Cancel</button>
 <button type="submit"class="btn-ai">✨ Generate AI Draft</button>
 </div>
 </form>
 </div>
 </div>`;
}

window.generateAiBlog = async function(event) {
 event.preventDefault();
 const btn = event.submitter;
 const oldText = btn.innerHTML;
 btn.innerHTML = `<span class="animate-pulse">✨ Generating...</span>`;
 btn.disabled = true;
 try {
 const data = formObject(event.target);
 await request('/admin/blog/generate', { method: 'POST', body: JSON.stringify(data) });
 notify('AI Blog Post generated successfully!');
 document.querySelector('#ai-blog-modal').classList.add('hidden');
 state.blogPosts = (await request('/blog')).data || [];
 render();
 } catch (e) {
 notify(e.message, 'error');
 } finally {
 btn.innerHTML = oldText;
 btn.disabled = false;
 }
};

function blogPage() {
 const posts = state.blogPosts || [];
 return `<div class="space-y-8">
 <section class="text-center py-12">
 <p class="eyebrow text-emerald-400">Resources</p>
 <h1 class="mt-3 text-2xl md:text-4xl font-black md:text-5xl">Smart Site Maker Blog</h1>
 <p class="mt-4 text-slate-600 max-w-2xl mx-auto">Guides, news, and insights to help you build and manage better.</p>
 </section>
 <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
 ${posts.length ? posts.map(p => `
 <a href="#blog/${h(p.slug)}"class="group block rounded-3xl neu-raised p-4 md:p-6 transition-all hover:-translate-y-1 hover:border-emerald-400/30 hover:bg-emerald-400/5 hover:shadow-2xl hover:shadow-emerald-900/20">
 <h3 class="text-base md:text-xl font-bold text-slate-900 group-hover:text-emerald-300 transition-colors">${h(p.title)}</h3>
 ${p.excerpt ? `<p class="mt-3 text-sm text-slate-600 line-clamp-3">${h(p.excerpt)}</p>` : ''}
 <div class="mt-6 flex items-center justify-between text-xs font-semibold text-slate-600">
 <span>${new Date(p.published_at).toLocaleDateString()}</span>
 <span class="text-emerald-400 group-hover:underline">Read Article &rarr;</span>
 </div>
 </a>`).join('') : empty('No articles published yet. Check back soon!')}
 </div>
 </div>`;
}

function blogPostPage() {
 const post = state.currentBlogPost;
 if (!post) return `<div class="text-center py-12 md:py-20 text-slate-600">Post not found.</div>`;
 return `
 <article class="max-w-3xl mx-auto py-10">
 <a href="#blog"class="text-sm font-semibold text-slate-600 hover:text-emerald-400 mb-8 inline-block">&larr; Back to Blog</a>
 <h1 class="text-2xl md:text-4xl md:text-5xl font-black text-slate-900 leading-tight">${h(post.title)}</h1>
 <div class="mt-6 flex items-center gap-4 pb-8 text-sm text-slate-600">
 <span>Published ${new Date(post.published_at).toLocaleDateString()}</span>
 </div>
 <div class="mt-10 prose prose-invert prose-emerald prose-lg max-w-none">
 ${typeof marked !== "undefined" ? marked.parse(post.content) : post.content}
 </div>
 </article>`;
}

// =====================================================================
// PHASE 3 WINDOW ACTION HELPERS
// =====================================================================
// =====================================================================

window.openBlogModal = () => {
 document.getElementById('blog-modal-title').innerText = 'New Blog Post';
 document.getElementById('blog-id').value = '';
 document.getElementById('blog-title').value = '';
 document.getElementById('blog-status').value = 'draft';
 document.getElementById('blog-excerpt').value = '';
 document.getElementById('blog-content').value = '';
 document.querySelector('#blog-modal').classList.remove('hidden');
};

window.editBlogPost = (post) => {
 document.getElementById('blog-modal-title').innerText = 'Edit Blog Post';
 document.getElementById('blog-id').value = post.id;
 document.getElementById('blog-title').value = post.title;
 document.getElementById('blog-status').value = post.status;
 document.getElementById('blog-excerpt').value = post.excerpt || '';
 document.getElementById('blog-content').value = post.content || '';
 document.querySelector('#blog-modal').classList.remove('hidden');
};

window.saveBlogPost = async () => {
 const id = document.getElementById('blog-id').value;
 const title = document.getElementById('blog-title').value;
 const status = document.getElementById('blog-status').value;
 const excerpt = document.getElementById('blog-excerpt').value;
 const content = document.getElementById('blog-content').value;
 
 if (!title || !content) return alert('Title and Content are required.');
 
 try {
 const body = JSON.stringify({ title, status, excerpt, content });
 if (id) {
 await request(`/admin/blog/${id}`, { method: 'PUT', body });
 notify('Blog post updated');
 } else {
 await request('/admin/blog', { method: 'POST', body });
 notify('Blog post created');
 if (window.confetti) window.confetti({ particleCount: 100, spread: 70, origin: { y: 0.6 } });
 }
 document.querySelector('#blog-modal').classList.add('hidden');
 await navigate('admin/blog');
 } catch (e) {
 alert(e.message);
 }
};

window.deleteBlogPost = async (id) => {
 if (!confirm('Are you sure you want to delete this post?')) return;
 try {
 await request(`/admin/blog/${id}`, { method: 'DELETE' });
 notify('Blog post deleted');
 await navigate('admin/blog');
 } catch (e) {
 alert(e.message);
 }
};

window.toggleSaveFreelancer = async (userId, btn) => {
 const isSaved = (state.savedFreelancers || []).includes(userId);
 try {
 if (isSaved) {
 await request(`/saved-freelancers/${userId}`, { method: 'DELETE' });
 state.savedFreelancers = (state.savedFreelancers || []).filter(id => id !== userId);
 notify('Removed from saved freelancers', 'info');
 } else {
 await request(`/saved-freelancers/${userId}`, { method: 'POST' });
 state.savedFreelancers = [...(state.savedFreelancers || []), userId];
 notify('Freelancer saved to your shortlist! ❤️', 'success');
 }
 // Update button appearance inline without full re-render
 const nowSaved = (state.savedFreelancers || []).includes(userId);
 if (btn) {
 btn.querySelector('svg')?.setAttribute('fill', nowSaved ? 'currentColor' : 'none');
 btn.classList.toggle('text-rose-400', nowSaved);
 btn.classList.toggle('bg-rose-400/10', nowSaved);
 btn.classList.toggle('text-slate-600', !nowSaved);
 }
 } catch (e) { notify(e.message, 'error'); }
};

window.openNewPostModal = () => {
 document.querySelector('#forum-new-post-modal')?.classList.remove('hidden');
};

window.filterForumCat = async (cat) => {
 try {
 const res = await request(`/forum/posts?category=${cat}`);
 state.forumPosts = res.data || [];
 const list = document.querySelector('#forum-list');
 if (list) list.innerHTML = state.forumPosts.length
 ? state.forumPosts.map(p => {
 const catColors = { general: 'bg-blue-500/15 text-blue-300', help: 'bg-amber-500/15 text-amber-800', showcase: 'bg-teal-500/15 text-blue-700', announcements: 'bg-rose-500/15 text-rose-700' };
 return `<article onclick="navigate('forum/${p.id}')"class="flex items-start gap-4 rounded-2xl neu-raised p-5 cursor-pointer hover:-translate-y-1 transition-all">
 ${avatar(p.author, 'h-10 w-10 text-sm flex-shrink-0 rounded-full bg-gradient-to-br from-purple-400 to-pink-500 text-slate-950')}
 <div class="flex-1 min-w-0">
 <span class="rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase ${catColors[p.category] || ''}">${p.category}</span>
 <h3 class="font-bold text-slate-900 line-clamp-1 mt-1">${h(p.title)}</h3>
 <p class="text-xs text-slate-600 mt-1">${h(p.author?.name)} · ${p.reply_count || 0} replies</p>
 </div>
 </article>`;
 }).join('')
 : empty('No posts in this category.');
 } catch (e) { notify(e.message, 'error'); }
};

window.submitForumPost = async () => {
 const title = document.querySelector('#forum-post-title')?.value?.trim();
 const body = document.querySelector('#forum-post-body')?.value?.trim();
 const category = document.querySelector('#forum-post-cat')?.value;
 if (!title || title.length < 10) return notify('Title must be at least 10 characters.', 'error');
 if (!body || body.length < 20) return notify('Body must be at least 20 characters.', 'error');
 try {
 const res = await request('/forum/posts', { method: 'POST', body: JSON.stringify({ title, body, category }) });
 notify('Post published!', 'success');
 document.querySelector('#forum-new-post-modal')?.classList.add('hidden');
 navigate(`forum/${res.data.id}`);
 } catch (e) { notify(e.message, 'error'); }
};

window.submitForumReply = async (postId) => {
 const body = document.querySelector('#forum-reply-body')?.value?.trim();
 if (!body || body.length < 5) return notify('Reply too short.', 'error');
 try {
 await request(`/forum/posts/${postId}/replies`, { method: 'POST', body: JSON.stringify({ body }) });
 notify('Reply posted!', 'success');
 navigate(`forum/${postId}`);
 } catch (e) { notify(e.message, 'error'); }
};

window.markSolution = async (postId, replyId) => {
 try {
 await request(`/forum/posts/${postId}/replies/${replyId}/solution`, { method: 'PATCH' });
 notify('Marked as solution! ✓', 'success');
 navigate(`forum/${postId}`);
 } catch (e) { notify(e.message, 'error'); }
};

window.adminTogglePin = async (postId, pin) => {
 try {
 await request(`/admin/forum/posts/${postId}`, { method: 'PATCH', body: JSON.stringify({ is_pinned: pin }) });
 notify(pin ? 'Post pinned.' : 'Post unpinned.', 'success');
 navigate(`forum/${postId}`);
 } catch (e) { notify(e.message, 'error'); }
};

window.adminToggleLock = async (postId, lock) => {
 try {
 await request(`/admin/forum/posts/${postId}`, { method: 'PATCH', body: JSON.stringify({ is_locked: lock }) });
 notify(lock ? 'Thread locked.' : 'Thread unlocked.', 'success');
 navigate(`forum/${postId}`);
 } catch (e) { notify(e.message, 'error'); }
};

window.resolveReport = async (reportId, status) => {
 const notes = status === 'actioned' ? await showPopup({ title: 'Action Taken', message: 'Describe what action was taken (optional):', type: 'info', buttons: [{ text: 'Submit', primary: true, value: 'confirm' }], inputs: [{ placeholder: 'Admin notes…' }] }) : null;
 try {
 await request(`/admin/reports/${reportId}`, { method: 'PATCH', body: JSON.stringify({ status, admin_notes: notes || '' }) });
 notify(`Report ${status}.`, 'success');
 navigate('admin-reports');
 } catch (e) { notify(e.message, 'error'); }
};

window.openAnnouncementModal = () => document.querySelector('#ann-modal')?.classList.remove('hidden');

window.createAnnouncement = async () => {
 const title = document.querySelector('#ann-title')?.value?.trim();
 const body = document.querySelector('#ann-body')?.value?.trim();
 const type = document.querySelector('#ann-type')?.value;
 const roleVal = document.querySelector('#ann-roles')?.value;
 if (!title || !body) return notify('Title and body are required.', 'error');
 try {
 await request('/admin/announcements', { method: 'POST', body: JSON.stringify({ title, body, type, target_roles: roleVal ? [roleVal] : null }) });
 notify('Announcement published!', 'success');
 document.querySelector('#ann-modal')?.classList.add('hidden');
 navigate('admin-announcements');
 } catch (e) { notify(e.message, 'error'); }
};

window.toggleAnnouncement = async (id, active) => {
 try {
 await request(`/admin/announcements/${id}`, { method: 'PUT', body: JSON.stringify({ is_active: active }) });
 notify(active ? 'Announcement activated.' : 'Announcement deactivated.', 'success');
 navigate('admin-announcements');
 } catch (e) { notify(e.message, 'error'); }
};

window.deletePostedJob = async function(jobId) {
 if (!confirm('Are you sure you want to delete this job? This action cannot be undone.')) return;
 try {
 await request(`/jobs/${jobId}`, { method: 'DELETE' });
 notify('Job deleted successfully', 'success');
 if (route().startsWith('jobs/')) {
 window.location.hash = '#marketplace';
 } else {
 await loadRouteData();
 }
 } catch (e) {
 notify(e.message, 'error');
 }
};

window.filterAdminJobs = function(val) {
 const term = val.toLowerCase();
 document.querySelectorAll('.admin-job-item').forEach(el => {
 const cName = (el.dataset.clientName || '').toLowerCase();
 if (cName.includes(term)) {
 el.style.display = 'flex';
 } else {
 el.style.display = 'none';
 }
 });
};

window.deleteAnnouncement = async (id) => {
 if (!await confirmPopup('Delete Announcement', 'This cannot be undone.')) return;
 try {
 await request(`/admin/announcements/${id}`, { method: 'DELETE' });
 notify('Announcement deleted.', 'success');
 navigate('admin-announcements');
 } catch (e) { notify(e.message, 'error'); }
};

window.expireFeatured = async () => {
 try {
 const res = await request('/admin/featured/expire', { method: 'POST' });
 notify(`Cleaned up ${res.jobs} jobs & ${res.profiles} freelancers.`, 'success');
 navigate('admin-featured');
 } catch (e) { notify(e.message, 'error'); }
};

// Feature a job (from job detail page)
window.featureJob = async (jobId) => {
 if (!await confirmPopup('Feature this Job', 'This will deduct 49 Coins from your wallet and feature the job for 7 days.')) return;
 try {
 await request(`/jobs/${jobId}/feature`, { method: 'POST' });
 notify('Job is now featured for 7 days! ⭐', 'success');
 navigate(`jobs/${jobId}`);
 } catch (e) { notify(e.message, 'error'); }
};

// Spotlight freelancer (from profile page)
window.spotlightMe = async () => {
 if (!await confirmPopup('Get Spotlighted', 'This will deduct ₹499 from your wallet and spotlight your profile in the directory for 7 days.')) return;
 try {
 await request('/freelancers/me/spotlight', { method: 'POST' });
 notify('You are now spotlighted! ✦ Your profile appears at the top of the directory.', 'success');
 navigate('profile');
 } catch (e) { notify(e.message, 'error'); }
};

// Report a user
window.reportUser = async (userId, userName) => {
 const reason = await showPopup({
 title: `Report ${userName}`,
 message: 'Why are you reporting this user?',
 type: 'warn',
 buttons: [{ text: 'Cancel', value: 'cancel' }, { text: 'Submit Report', primary: true, value: 'confirm' }],
 inputs: [{ placeholder: 'Reason (e.g. Harassment, Spam, Fake profile)…' }]
 });
 if (!reason || reason === false) return;
 try {
 await request(`/users/${userId}/report`, { method: 'POST', body: JSON.stringify({ reason, description: '' }) });
 notify('Report submitted. Our team will review it within 24 hours.', 'success');
 } catch (e) { notify(e.message, 'error'); }
};

// AI Proposal Draft
window.getAiProposalDraft = async (jobId, btn) => {
 const target = document.querySelector('#proposal-cover-letter') || document.querySelector('#cover-letter');
 if (!target) return notify('Please open the proposal form first.', 'error');
 target.value = 'Generating AI draft…';
 if(btn) { btn.innerHTML = '✨ Drafting...'; btn.disabled = true; }
 try {
 const res = await request('/ai/proposal-draft', { method: 'POST', body: JSON.stringify({ job_id: jobId }) });
 target.value = res.draft || '';
 target.dispatchEvent(new Event('input'));
 notify('AI draft ready! Review and personalize before sending. ✨', 'success');
 } catch (e) {
 target.value = '';
 notify('AI draft failed. Please write manually.', 'error');
 } finally {
 if(btn) { btn.innerHTML = '✨ AI Draft'; btn.disabled = false; }
 }
};

// Get pricing suggestion
window.getPricingSuggestion = async (jobId, btn) => {
 if(btn) { btn.innerHTML = '✨ Analyzing...'; btn.disabled = true; }
 try {
 const res = await request(`/jobs/${jobId}/pricing-suggestion`);
 if (res.suggestion) {
 const s = res.suggestion;
 const basedOnText = s.based_on === 'AI Analysis' ? '✨ AI Estimate' : `${s.based_on} bids`;
 const reasonText = s.reason ? `<br><span class="text-xs text-slate-900/70 mt-1 block">${s.reason}</span>` : '';
 notify(`📊 Market Rate: Median ₹${s.median.toLocaleString()} (Range: ₹${s.low.toLocaleString()} – ₹${s.high.toLocaleString()}, based on ${basedOnText})${reasonText}`, 'info');
 } else {
 notify(res.message || 'Not enough data yet.', 'info');
 }
 } catch (e) { notify(e.message, 'error'); } finally {
 if(btn) { btn.innerHTML = '✨ Suggest Bid'; btn.disabled = false; }
 }
};

// Generate Interview Questions
window.generateInterviewQuestions = async (proposalId, btn) => {
 const proposal = state.proposals.find(p => p.id == proposalId);
 if(!proposal) return;
 const freelancerProfile = proposal.freelancer?.freelancer_profile || {};
 const jobDescription = state.currentJob?.description ||"Project";
 
 const originalText = btn.innerHTML;
 btn.innerHTML = '✨ Generating...';
 btn.disabled = true;
 try {
 const res = await request('/ai/interview-questions', {
 method: 'POST',
 body: JSON.stringify({ freelancer_profile: freelancerProfile, job_description: jobDescription })
 });
 if (res.questions) {
 alert("Suggested Interview Questions:\n\n1."+ res.questions[0] +"\n2."+ res.questions[1] +"\n3."+ res.questions[2] +"\n\n(Copy these to ask in the chat!)");
 }
 } catch (e) {
 notify(e.message || 'Failed to generate questions.', 'error');
 } finally {
 btn.innerHTML = originalText;
 btn.disabled = false;
 }
};

// Suggest Milestones
window.suggestMilestones = async (btn) => {
 const amount = state.currentContract?.total_amount || state.currentJob?.budget?.max;
 if (!amount) {
 return notify('Cannot determine total budget.', 'error');
 }
 const originalText = btn.innerHTML;
 btn.innerHTML = '✨ Planning...';
 btn.disabled = true;
 try {
 const res = await request('/ai/suggest-milestones', {
 method: 'POST',
 body: JSON.stringify({ budget: amount, job_description: state.currentContract?.job?.description || state.currentJob?.description ||"Project"})
 });
 if (res.milestones) {
 let msg ="Suggested Milestones:\n\n";
 res.milestones.forEach(m => {
 msg += `- ${m.title}: ₹${m.amount}\n (${m.description})\n\n`;
 });
 alert(msg);
 }
 } catch (e) {
 notify(e.message || 'Failed to suggest milestones.', 'error');
 } finally {
 btn.innerHTML = originalText;
 btn.disabled = false;
 }
};

// Rewrite Message
window.rewriteMessage = async (btn) => {
 const input = document.querySelector('#contractMessageInput');
 if (!input || !input.value.trim()) {
 return notify('Please write a message first.', 'error');
 }
 const originalText = btn.innerHTML;
 btn.innerHTML = '✨...';
 btn.disabled = true;
 try {
 const res = await request('/ai/rewrite-message', {
 method: 'POST',
 body: JSON.stringify({ message: input.value.trim() })
 });
 if (res.rewritten) {
 input.value = res.rewritten;
 notify('Message polished! ✨', 'success');
 }
 } catch (e) {
 notify(e.message || 'Failed to polish message.', 'error');
 } finally {
 btn.innerHTML = originalText;
 btn.disabled = false;
 }
};

// Scheduled message
window.showAppInstallInstructions = (type) => {
    let title = "";
    let content = "";
    
    if (type === 'mac') {
        title = "Install iOS & Mac App";
        content = `
            <div class="text-center space-y-6">
                <div class="flex justify-center mb-6">
                    <div class="w-20 h-20 bg-slate-100 rounded-3xl flex items-center justify-center shadow-inner border border-slate-200">
                        <img src="/apple-touch-icon.png" alt="App Icon" class="w-16 h-16 rounded-2xl object-cover" onerror="this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHJ4PSIxNCIgZmlsbD0iIzM0RDMzOSIvPjwvc3ZnPg=='">
                    </div>
                </div>
                
                <h3 class="text-xl font-bold text-slate-900">Your download has started!</h3>
                <p class="text-slate-600">Follow these steps to install the app on your Mac.</p>
                
                <div class="bg-slate-50 p-6 rounded-2xl border border-slate-100 text-left space-y-6 mt-6 shadow-inner">
                    <div class="flex items-center gap-4">
                        <div class="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center border border-slate-200 shrink-0">
                            <span class="text-blue-700 font-bold">1</span>
                        </div>
                        <p class="text-sm font-semibold text-slate-700">Once downloaded, double-click the <span class="text-blue-700">.zip</span> file to extract it.</p>
                    </div>
                    
                    <div class="w-full h-px bg-slate-200"></div>
                    
                    <div class="flex items-center gap-4">
                        <div class="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center border border-slate-200 shrink-0">
                            <span class="text-blue-700 font-bold">2</span>
                        </div>
                        <p class="text-sm font-semibold text-slate-700">Drag the extracted <span class="text-slate-900 font-bold">SmartSiteMaker Iphone.app</span> to your Applications folder.</p>
                    </div>
                    
                    <div class="w-full h-px bg-slate-200"></div>
                    
                    <div class="flex items-center gap-4">
                        <div class="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center border border-slate-200 shrink-0">
                            <span class="text-blue-700 font-bold">3</span>
                        </div>
                        <p class="text-sm font-semibold text-slate-700">Double-click to open and enjoy the native experience!</p>
                    </div>
                </div>
                
                <button onclick="window.closeModal()" class="w-full btn-primary py-3 mt-4 text-base">Got it</button>
            </div>
        `;
    } else if (type === 'chrome') {
        title = "Install Chrome App";
        content = `
            <div class="text-center space-y-6">
                <div class="flex justify-center mb-6">
                    <div class="w-20 h-20 bg-slate-100 rounded-3xl flex items-center justify-center shadow-inner border border-slate-200">
                        <svg class="w-10 h-10 text-yellow-500" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM12 5.5c-2.33 0-4.32 1.45-5.12 3.5h10.24c-.8-2.05-2.79-3.5-5.12-3.5zM6.28 10.5c.31 1.77 1.45 3.26 3.01 4.16l-3.32 5.76C3.51 18.25 2 15.3 2 12c0-1.87.58-3.58 1.55-5h2.73zM12 18.5c-1.32 0-2.52-.46-3.48-1.22l3.32-5.76c1.19.33 2.11 1.25 2.43 2.44L17.59 9.8c1.39 1.42 2.27 3.39 2.27 5.57 0 3.59-2.91 6.5-6.5 6.5v-3.37z"/></svg>
                    </div>
                </div>
                
                <h3 class="text-xl font-bold text-slate-900">Your Chrome App is downloading!</h3>
                <p class="text-slate-600">Follow these steps to install the Chrome Progressive Web App on your Mac.</p>
                
                <div class="bg-slate-50 p-6 rounded-2xl border border-slate-100 text-left space-y-6 mt-6 shadow-inner">
                    <div class="flex items-center gap-4">
                        <div class="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center border border-slate-200 shrink-0">
                            <span class="text-yellow-600 font-bold">1</span>
                        </div>
                        <p class="text-sm font-semibold text-slate-700">Once downloaded, double-click the <span class="text-yellow-600">.zip</span> file to extract it.</p>
                    </div>
                    
                    <div class="w-full h-px bg-slate-200"></div>
                    
                    <div class="flex items-center gap-4">
                        <div class="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center border border-slate-200 shrink-0">
                            <span class="text-yellow-600 font-bold">2</span>
                        </div>
                        <p class="text-sm font-semibold text-slate-700">Drag the extracted <span class="text-slate-900 font-bold">Smart Site Maker_chrome.app</span> to your Applications folder.</p>
                    </div>
                    
                    <div class="w-full h-px bg-slate-200"></div>
                    
                    <div class="flex items-center gap-4">
                        <div class="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center border border-slate-200 shrink-0">
                            <span class="text-yellow-600 font-bold">3</span>
                        </div>
                        <p class="text-sm font-semibold text-slate-700">Double-click it to launch the app directly through Google Chrome!</p>
                    </div>
                </div>
                
                <button onclick="window.closeModal()" class="w-full btn-primary py-3 mt-4 text-base">Got it</button>
            </div>
        `;
    }

    state.modal = {
        title: title,
        content: content
    };
    render();
};

window.openScheduleMessageModal = (contractId) => {
 const existing = document.querySelector('#schedule-msg-modal');
 if (existing) existing.remove();
 const modal = document.createElement('div');
 modal.id = 'schedule-msg-modal';
 modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm';
 modal.innerHTML = `
 <div class="neu-raised rounded-2xl p-4 md:p-6 w-full max-w-md mx-4 space-y-4">
 <h2 class="text-base md:text-xl font-bold">Schedule a Message</h2>
 <textarea id="sched-msg-body"class="input-control min-h-[100px]"placeholder="Your message…"></textarea>
 <input id="sched-msg-at"type="datetime-local"class="input-control mt-0">
 <div class="flex gap-3 justify-end">
 <button onclick="document.querySelector('#schedule-msg-modal').remove()"class="btn-secondary">Cancel</button>
 <button onclick="window.sendScheduledMessage(${contractId})"class="btn-primary">Schedule</button>
 </div>
 </div>`;
 document.body.appendChild(modal);
 // Set min to now
 const dt = document.querySelector('#sched-msg-at');
 if (dt) dt.min = new Date(Date.now() + 60000).toISOString().slice(0,16);
};

window.sendScheduledMessage = async (contractId) => {
 const body = document.querySelector('#sched-msg-body')?.value?.trim();
 const scheduledAt = document.querySelector('#sched-msg-at')?.value;
 if (!body) return notify('Message cannot be empty.', 'error');
 if (!scheduledAt) return notify('Please pick a date and time.', 'error');
 try {
 await request(`/contracts/${contractId}/messages/schedule`, { method: 'POST', body: JSON.stringify({ body, scheduled_at: scheduledAt }) });
 notify('Message scheduled! It will be sent automatically. 🕐', 'success');
 document.querySelector('#schedule-msg-modal')?.remove();
 } catch (e) { notify(e.message, 'error'); }
};

window.enhanceJobDescription = async (btn) => {
 const input = document.querySelector('#job-description-input');
 if (!input || !input.value.trim()) {
 notify('Please enter a brief description first.', 'error');
 return;
 }
 const originalText = btn.innerHTML;
 btn.innerHTML = '✨ Enhancing...';
 btn.disabled = true;
 try {
 const response = await request('/ai/enhance-job', {
 method: 'POST',
 body: JSON.stringify({ description: input.value.trim() })
 });
 if (response && response.enhanced) {
 input.value = response.enhanced;
 notify('Job description enhanced with Gemini AI!', 'success');
 }
 } catch (e) {
 notify(e.message || 'AI Enhancement failed', 'error');
 } finally {
 btn.innerHTML = originalText;
 btn.disabled = false;
 }
};

window.optimizeProfileBio = async (btn) => {
 const input = document.querySelector('#profile-bio-input');
 const skillsInput = document.querySelector('#profile-skills-input');
 
 if (!input || !input.value.trim()) {
 notify('Please enter a short bio first.', 'error');
 return;
 }
 const originalText = btn.innerHTML;
 btn.innerHTML = '✨ Optimizing...';
 btn.disabled = true;
 try {
 const skillsArray = skillsInput && skillsInput.value ? skillsInput.value.split(',').map(s => s.trim()) : [];
 const response = await request('/ai/optimize-profile', {
 method: 'POST',
 body: JSON.stringify({ bio: input.value.trim(), skills: skillsArray })
 });
 if (response && response.optimized) {
 input.value = response.optimized;
 notify('Profile bio optimized with Gemini AI!', 'success');
 }
 } catch (e) {
 notify(e.message || 'AI Optimization failed', 'error');
 } finally {
 btn.innerHTML = originalText;
 btn.disabled = false;
 }
};
;

// Visitor ping — tracks this user/guest as an active visitor (no auth needed)
const pingVisitor = () => {
 fetch(`${apiBase}/visitor/ping`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
 body: JSON.stringify({ ts: Date.now() }),
 keepalive: true,
 }).catch(() => {}); // silent fail
};

// Init
(async () => {
 await initAuth();
 if (state.token) {
 // optionally verify with backend if needed, but loadCore handles it
 await loadCore();
 }
 
 // Ping on load, then every 2 minutes to keep presence alive
 pingVisitor();
 setInterval(pingVisitor, 2 * 60 * 1000);
 
 window.addEventListener('hashchange', loadRouteData);
 if (!location.hash) {
 if (state.user) location.hash = 'dashboard';
 } else {
 loadRouteData();
 }
 render();
})();

window.initLiveAdminGraphs = () => {
 const vCtx = document.getElementById('liveVisitorsChart');
 const iCtx = document.getElementById('liveIncomeChart');

 if (!vCtx || !iCtx) return;

 // Clear existing intervals
 if (window.liveAdminInterval) { clearInterval(window.liveAdminInterval); window.liveAdminInterval = null; }

 // Wait for Chart.js if not loaded yet
 if (typeof Chart === 'undefined') {
 setTimeout(window.initLiveAdminGraphs, 400);
 return;
 }

 // Destroy existing chart instances
 if (window.liveVisitorsChartObj) { try { window.liveVisitorsChartObj.destroy(); } catch(e) {} }
 if (window.liveIncomeChartObj) { try { window.liveIncomeChartObj.destroy(); } catch(e) {} }

 // --- Generate demo data immediately so charts are never empty ---
 const genVisitorHistory = () => {
 const now = new Date();
 return Array.from({length: 10}, (_, i) => {
 const t = new Date(now - (9 - i) * 8000);
 return { time: t.toLocaleTimeString('en-IN', {hour:'2-digit', minute:'2-digit'}), value: Math.floor(Math.random() * 120) + 180 };
 });
 };
 const genIncomeHistory = () => {
 const hours = [];
 for (let i = 11; i >= 0; i--) {
 const t = new Date();
 t.setHours(t.getHours() - i, 0, 0, 0);
 hours.push({ time: t.toLocaleTimeString('en-IN', {hour:'2-digit', minute:'2-digit'}), amount: Math.floor(Math.random() * 18000) + 4000 });
 }
 return hours;
 };

 if (!window.liveVisitorHistory || window.liveVisitorHistory.length === 0) {
 window.liveVisitorHistory = genVisitorHistory();
 }

 const chartDefaults = {
 responsive: true,
 maintainAspectRatio: false,
 plugins: { legend: { display: false } },
 scales: { x: { display: false }, y: { display: false } },
 elements: { line: { tension: 0.4, borderWidth: 2.5 }, point: { radius: 0 } },
 animation: { duration: 300 }
 };

 window.liveVisitorsChartObj = new Chart(vCtx, {
 type: 'line',
 data: {
 labels: window.liveVisitorHistory.map(d => d.time),
 datasets: [{ data: window.liveVisitorHistory.map(d => d.value), borderColor: '#14b8a6', backgroundColor: 'rgba(20,184,166,0.12)', fill: true }]
 },
 options: chartDefaults
 });

 const incomeHistory = genIncomeHistory();
 window.liveIncomeChartObj = new Chart(iCtx, {
 type: 'line',
 data: {
 labels: incomeHistory.map(d => d.time),
 datasets: [{ data: incomeHistory.map(d => d.amount), borderColor: '#8b5cf6', backgroundColor: 'rgba(139,92,246,0.12)', fill: true }]
 },
 options: chartDefaults
 });

 // Show demo numbers immediately
 const setEl = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
 setEl('live-visitors-count', (Math.floor(Math.random() * 120) + 180).toLocaleString());
 setEl('live-today-funded', '₹' + (Math.floor(Math.random() * 30000) + 15000).toLocaleString());
 setEl('live-week-funded', '₹' + (Math.floor(Math.random() * 150000) + 80000).toLocaleString());
 setEl('live-today-commission', '₹' + (Math.floor(Math.random() * 4000) + 2000).toLocaleString());
 setEl('live-week-commission', '₹' + (Math.floor(Math.random() * 20000) + 10000).toLocaleString());

 // --- Fetch real data from backend & update ---
 const fetchLiveStats = async () => {
 try {
 const data = await request('/admin/live-metrics');

 // Update visitor sparkline
 if (data.live_visitors !== undefined) {
 const now = new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
 window.liveVisitorHistory.push({ time: now, value: data.live_visitors });
 if (window.liveVisitorHistory.length > 10) window.liveVisitorHistory.shift();
 window.liveVisitorsChartObj.data.labels = window.liveVisitorHistory.map(d => d.time);
 window.liveVisitorsChartObj.data.datasets[0].data = window.liveVisitorHistory.map(d => d.value);
 window.liveVisitorsChartObj.update('none');
 setEl('live-visitors-count', data.live_visitors.toLocaleString());
 }

 // Update income chart
 if (data.hourly_income && data.hourly_income.length) {
 window.liveIncomeChartObj.data.labels = data.hourly_income.map(d => d.time);
 window.liveIncomeChartObj.data.datasets[0].data = data.hourly_income.map(d => d.amount);
 window.liveIncomeChartObj.update('none');
 }

 // Update stat cards with real data
 if (data.today_funded !== undefined) setEl('live-today-funded', money(data.today_funded));
 if (data.week_funded !== undefined) setEl('live-week-funded', money(data.week_funded));
 if (data.today_commission !== undefined) setEl('live-today-commission', money(data.today_commission));
 if (data.week_commission !== undefined) setEl('live-week-commission', money(data.week_commission));

 } catch (e) {
 // Silently update with simulated data so charts always look alive
 const now = new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
 const newVal = Math.floor(Math.random() * 100) + 180;
 window.liveVisitorHistory.push({ time: now, value: newVal });
 if (window.liveVisitorHistory.length > 10) window.liveVisitorHistory.shift();
 window.liveVisitorsChartObj.data.labels = window.liveVisitorHistory.map(d => d.time);
 window.liveVisitorsChartObj.data.datasets[0].data = window.liveVisitorHistory.map(d => d.value);
 window.liveVisitorsChartObj.update('none');
 setEl('live-visitors-count', newVal.toLocaleString());
 }
 };

 fetchLiveStats();
 window.liveAdminInterval = setInterval(fetchLiveStats, 8000);
};


window.generateAiReport = async function() {
 const btn = event.currentTarget;
 const ogHtml = btn.innerHTML;
 btn.innerHTML = `<svg class="animate-spin w-4 h-4 mr-2"fill="none"viewBox="0 0 24 24"><circle class="opacity-25"cx="12"cy="12"r="10"stroke="currentColor"stroke-width="4"></circle><path class="opacity-75"fill="currentColor"d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> Generating...`;
 btn.disabled = true;

 try {
 const res = await request("/admin/ai-analytics");
 if (res.report) {
 const formatReportText = (text) => {
 let html = h(text);
 // Replace ### Headers
 html = html.replace(/^### (.*)$/gm, '<h3 class="text-base md:text-xl font-bold text-slate-900 mt-8 mb-4 pb-2">$1</h3>');
 // Replace ## Headers
 html = html.replace(/^## (.*)$/gm, '<h2 class="text-2xl font-black text-slate-900 mt-8 mb-4 pb-2">$1</h2>');
 // Replace **Bold**
 html = html.replace(/\*\*(.*?)\*\*/g, '<strong class="font-bold text-slate-900 bg-indigo-50 px-1 rounded">$1</strong>');
 // Replace - Lists
 html = html.replace(/^- (.*)$/gm, '<div class="flex gap-3 mb-2 ml-2"><span class="text-indigo-500 font-bold mt-0.5">•</span> <span class="flex-1">$1</span></div>');
 // Paragraphs (double newline)
 html = html.replace(/\n\n/g, '</p><p class="mt-4">');
 return `<p>${html}</p>`;
 };

 const overlay = document.createElement("div");
 overlay.className ="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/40 backdrop-blur-md p-4 animate-fade-in";
 overlay.innerHTML = `
 <div class="neu-raised rounded-[2rem] shadow-2xl max-w-4xl w-full p-8 sm:p-10 transform transition-all">
 <div class="flex items-center gap-5 mb-8 pb-6">
 <div class="p-4 bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 text-white rounded-2xl -indigo-200">
 <svg class="w-8 h-8"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
 </div>
 <div>
 <h3 class="text-xl md:text-3xl font-black text-slate-900 tracking-tight">AI Insights</h3>
 <p class="text-slate-600 font-medium mt-1">Real-time platform health & strategic recommendations</p>
 </div>
 </div>
 <div class="prose prose-slate max-w-none text-slate-600 mb-8 leading-relaxed font-medium overflow-y-auto max-h-[60vh] pr-4"style="scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent;">
 ${formatReportText(res.report)}
 </div>
 <div class="flex justify-end pt-6">
 <button class="bg-slate-900 text-white px-5 md:px-8 py-3.5 rounded-xl font-bold shadow-xl shadow-slate-200 hover:bg-black hover:-translate-y-0.5 transition-all w-full sm:w-auto"onclick="this.closest('.fixed').remove()">
 Understood, Close
 </button>
 </div>
 </div>
 `;
 document.body.appendChild(overlay);
 } else {
 notify("Could not generate report.","error");
 }
 } catch (e) {
 notify(e.message,"error");
 } finally {
 btn.innerHTML = ogHtml;
 btn.disabled = false;
 }
};


window.summarizeForumThread = async (postId, btn) => {
 const originalText = btn.innerHTML;
 btn.innerHTML = '✨ Summarizing...';
 btn.disabled = true;
 try {
 const res = await request(`/forum/posts/${postId}/summarize`, { method: 'POST' });
 
 // Show summary in a modal
 const modalHtml = `
 <div id="forum-summary-modal"class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
 <div class="neu-raised border-2 border-teal-500 rounded-2xl p-4 md:p-6 w-full max-w-2xl mx-auto shadow-2xl relative">
 <p class="eyebrow text-teal-700 mb-1">AI Moderator</p>
 <h2 class="text-2xl font-black text-slate-900 mb-4">Thread Summary</h2>
 <div class="prose prose-slate max-w-none text-slate-700 whitespace-pre-wrap">${res.summary}</div>
 <button onclick="document.getElementById('forum-summary-modal').remove()"class="mt-6 w-full btn-primary bg-teal-600 hover:bg-teal-700 border-none text-white font-bold py-3 rounded-xl">Close Summary</button>
 </div>
 </div>`;
 document.body.insertAdjacentHTML('beforeend', modalHtml);
 
 } catch (e) {
 notify(e.message || 'Failed to summarize thread.', 'error');
 } finally {
 btn.innerHTML = originalText;
 btn.disabled = false;
 }
};

window.toggleMaintenance = async (status) => {
 try {
 const res = await request('/admin/maintenance', {
 method: 'POST',
 body: JSON.stringify({ status })
 });
 notify(res.message || (status ? 'Maintenance mode enabled' : 'Maintenance mode disabled'), 'success');
 } catch (e) {
 notify(e.message || 'Failed to toggle maintenance mode', 'error');
 }
};

window.clearServerCache = async () => {
 const btn = event?.currentTarget;
 if (btn) {
 btn.disabled = true;
 btn.innerHTML = '🧹 Clearing...';
 }
 try {
 const res = await request('/admin/clear-cache', { method: 'POST' });
 notify(res.message || 'Server cache cleared successfully', 'success');
 } catch (e) {
 notify(e.message || 'Failed to clear cache', 'error');
 } finally {
 if (btn) {
 btn.disabled = false;
 btn.innerHTML = '🧹 Clear Server Cache';
 }
 }
};

window.togglePasswordVisibility = (btn, inputId) => {
 const input = document.getElementById(inputId);
 if (!input) return;
 
 if (input.type === 'password') {
 input.type = 'text';
 btn.innerHTML = `<svg class="w-5 h-5 eye-icon"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path></svg>`;
 } else {
 input.type = 'password';
 btn.innerHTML = `<svg class="w-5 h-5 eye-icon"fill="none"stroke="currentColor"viewBox="0 0 24 24"><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round"stroke-linejoin="round"stroke-width="2"d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>`;
 }
};

// --- AI SEO MANAGER ---
function adminSeoPage() {
    let seoPagesHTML = '';
    
    // Attempt to load existing pages from backend API if not yet in state
    if (!state.adminSeoSettings) {
        request('/admin/seo', {method: 'GET'}).then(res => {
            if (res && res.data) {
                state.adminSeoSettings = res.data;
                render();
            }
        }).catch(err => console.error("Could not load SEO settings:", err));
    } else {
        const pages = state.adminSeoSettings;
        if (pages.length === 0) {
            seoPagesHTML = `<p class="text-slate-600 italic mt-4">No SEO settings configured yet.</p>`;
        } else {
            seoPagesHTML = pages.map(page => `
                <div class="p-4 bg-slate-50 rounded-xl mb-4 border border-slate-200">
                    <p class="font-bold text-slate-900 text-sm mb-1">${h(page.page_url)}</p>
                    <p class="text-xs text-slate-600 truncate mb-1"><strong>Title:</strong> ${h(page.meta_title || 'N/A')}</p>
                    <p class="text-xs text-slate-600 truncate"><strong>Desc:</strong> ${h(page.meta_description || 'N/A')}</p>
                    <div class="mt-4 flex flex-wrap gap-2">
                        <button class="text-xs bg-blue-100 text-blue-700 font-bold px-3 py-1.5 rounded-lg hover:bg-blue-200 transition-colors" onclick="window.editSeoForPage('${h(page.page_url)}')">Edit</button>
                        <button class="text-xs bg-rose-100 text-rose-700 font-bold px-3 py-1.5 rounded-lg hover:bg-rose-200 transition-colors" onclick="window.deleteSeoForPage('${h(page.page_url)}')">Delete</button>
                        ${page.google_submitted_at ? 
                            `<span class="text-xs bg-emerald-100 text-emerald-700 font-bold px-3 py-1.5 rounded-lg flex items-center gap-1">${icon('check', 'w-3 h-3')} Submitted</span>` :
                            `<button id="btn-submit-${CSS.escape(page.page_url)}" class="text-xs bg-amber-100 text-amber-800 font-bold px-3 py-1.5 rounded-lg hover:bg-amber-200 transition-colors flex items-center gap-1" onclick="window.submitSeoToGoogle('${h(page.page_url)}')">🚀 Submit to Google</button>`
                        }
                    </div>
                </div>
            `).join('');
        }
    }
    
    return `
        <div class="mb-8 flex flex-col md:flex-row md:items-start justify-between gap-4">
            <div>
                <p class="eyebrow">Platform Tools</p>
                <h1 class="text-2xl md:text-3xl font-black mt-2 flex items-center gap-2">
                    ✨ AI SEO Manager
                </h1>
                <p class="text-slate-600 mt-2 text-sm">Automatically generate the best ranking #1 SEO meta tags using Gemini AI.</p>
            </div>
            <div class="flex gap-2 self-start flex-wrap">
                <button onclick="window.bulkGenerateSeo()" id="bulk-seo-btn" class="btn-ai py-2 px-6 shadow-xl shadow-brand-500/20 hover:shadow-brand-500/40 whitespace-nowrap">
                    ${icon('sparkles', 'w-5 h-5')} Automate Entire Website
                </button>
                <button onclick="window.submitAllSeoToGoogle()" id="submit-all-seo-btn" class="bg-amber-100 text-amber-800 hover:bg-amber-200 transition-colors py-2 px-6 shadow-xl font-bold rounded-2xl whitespace-nowrap flex items-center gap-2">
                    🚀 Submit All to Google
                </button>
            </div>
        </div>
        
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div class="lg:col-span-2">
                <div class="soft-panel p-6 rounded-3xl">
                    <h2 class="font-black text-lg mb-4">Generate / Edit SEO</h2>
                    <form id="seo-form" onsubmit="event.preventDefault(); window.saveSeoForPage();">
                        <div class="mb-5">
                            <label class="block text-sm font-bold text-slate-700 mb-1">Page URL</label>
                            <input type="text" id="seo-url" class="input-control" placeholder="e.g. / or /portfolio" required value="/">
                            <p class="text-xs text-slate-600 mt-1">Enter the exact URL path to optimize.</p>
                        </div>
                        
                        <div class="mb-6 flex gap-3">
                            <button type="button" onclick="window.generateAiSeoForPage()" id="generate-seo-btn" class="btn-ai py-2 text-sm font-bold w-full justify-center">
                                ${icon('bolt', 'w-4 h-4')} Auto-Generate Best SEO
                            </button>
                        </div>
                        
                        <hr class="border-slate-200 mb-6" />
                        
                        <div class="mb-4">
                            <label class="block text-sm font-bold text-slate-700 mb-1">Meta Title</label>
                            <input type="text" id="seo-title" class="input-control font-medium" placeholder="Optimized title...">
                        </div>
                        
                        <div class="mb-4">
                            <label class="block text-sm font-bold text-slate-700 mb-1">Meta Description</label>
                            <textarea id="seo-desc" class="input-control min-h-[100px] font-medium" placeholder="Optimized description..."></textarea>
                        </div>
                        
                        <div class="mb-6">
                            <label class="block text-sm font-bold text-slate-700 mb-1">Meta Keywords</label>
                            <input type="text" id="seo-keys" class="input-control font-medium" placeholder="keyword1, keyword2, keyword3...">
                        </div>
                        
                        <button type="submit" id="save-seo-btn" class="btn-primary w-full py-3">Save SEO Settings</button>
                    </form>
                </div>
            </div>
            
            <div>
                <div class="soft-panel p-6 rounded-3xl h-full">
                    <h2 class="font-black text-lg mb-2">Configured Pages</h2>
                    ${seoPagesHTML || '<div class="text-center py-8 text-sm text-slate-600">Loading...</div>'}
                </div>
            </div>
        </div>
    </div>
    `;
}

window.generateAiSeoForPage = async () => {
    const url = document.getElementById('seo-url').value;
    const btn = document.getElementById('generate-seo-btn');
    if (!url) return notify('Please enter a Page URL first.', 'error');
    
    btn.innerHTML = `${icon('bolt', 'w-4 h-4 animate-bounce')} Generating...`;
    btn.disabled = true;
    
    try {
        const res = await request('/admin/seo/generate', {
            method: 'POST',
            body: JSON.stringify({ url: url })
        });
        
        if (res.success && res.data) {
            document.getElementById('seo-title').value = res.data.meta_title || '';
            document.getElementById('seo-desc').value = res.data.meta_description || '';
            document.getElementById('seo-keys').value = res.data.meta_keywords || '';
            notify('AI SEO generated successfully! Review and save.', 'success');
        } else {
            notify(res.message || 'Failed to generate AI SEO', 'error');
        }
    } catch (e) {
        notify(e.message || 'Failed to generate AI SEO', 'error');
    } finally {
        btn.innerHTML = `${icon('bolt', 'w-4 h-4')} Auto-Generate Best SEO`;
        btn.disabled = false;
    }
};

window.saveSeoForPage = async () => {
    const url = document.getElementById('seo-url').value;
    const title = document.getElementById('seo-title').value;
    const desc = document.getElementById('seo-desc').value;
    const keys = document.getElementById('seo-keys').value;
    const btn = document.getElementById('save-seo-btn');
    
    btn.innerHTML = 'Saving...';
    btn.disabled = true;
    
    try {
        await request('/admin/seo/save', {
            method: 'POST',
            body: JSON.stringify({
                page_url: url,
                meta_title: title,
                meta_description: desc,
                meta_keywords: keys
            })
        });
        
        notify('SEO settings saved for ' + url, 'success');
        
        // Refresh the list
        state.adminSeoSettings = null;
        render();
        
    } catch (e) {
        notify(e.message || 'Failed to save SEO', 'error');
    } finally {
        btn.innerHTML = 'Save SEO Settings';
        btn.disabled = false;
    }
};

window.bulkGenerateSeo = async () => {
    const btn = document.getElementById('bulk-seo-btn');
    if (!confirm("This will automatically generate and overwrite SEO tags for all core pages, and submit them to Google. Are you sure you want to proceed?")) {
        return;
    }
    
    btn.innerHTML = `${icon('sparkles', 'w-5 h-5 animate-spin')} Processing Entire Website...`;
    btn.disabled = true;
    
    try {
        const res = await request('/admin/seo/bulk-generate', {
            method: 'POST'
        });
        
        if (res.success) {
            notify(res.message || 'Successfully automated website SEO!', 'success');
            // Refresh the list
            state.adminSeoSettings = null;
            render();
        } else {
            notify(res.message || 'Failed to bulk generate SEO', 'error');
        }
    } catch (e) {
        notify(e.message || 'Failed to bulk generate SEO', 'error');
    } finally {
        btn.innerHTML = `${icon('sparkles', 'w-5 h-5')} Automate Entire Website`;
        btn.disabled = false;
    }
};

window.editSeoForPage = (url) => {
    document.getElementById('seo-url').value = url;
    const page = state.adminSeoSettings?.find(p => p.page_url === url);
    if (page) {
        document.getElementById('seo-title').value = page.meta_title || '';
        document.getElementById('seo-desc').value = page.meta_description || '';
        document.getElementById('seo-keys').value = page.meta_keywords || '';
    }
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

window.deleteSeoForPage = async (url) => {
    if (!confirm(`Are you sure you want to delete SEO settings for ${url}?`)) return;
    
    try {
        const res = await request('/admin/seo/delete', {
            method: 'DELETE',
            body: JSON.stringify({ page_url: url })
        });
        
        if (res.success) {
            notify(`Deleted SEO for ${url}`, 'success');
            state.adminSeoSettings = null;
            render();
        } else {
            notify(res.message || 'Failed to delete SEO', 'error');
        }
    } catch (e) {
        notify(e.message || 'Failed to delete SEO', 'error');
    }
};

window.submitSeoToGoogle = async (url) => {
    const btn = document.getElementById(`btn-submit-${CSS.escape(url)}`);
    if (btn) {
        btn.innerHTML = `${icon('bolt', 'w-3 h-3 animate-bounce')} Submitting...`;
        btn.disabled = true;
    }
    
    try {
        const res = await request('/admin/seo/submit-google', {
            method: 'POST',
            body: JSON.stringify({ page_url: url })
        });
        
        if (res.success) {
            notify(`Successfully submitted ${url} to Google!`, 'success');
            state.adminSeoSettings = null;
            render();
        } else {
            notify(res.message || 'Failed to submit to Google', 'error');
            if (btn) {
                btn.innerHTML = '🚀 Submit to Google';
                btn.disabled = false;
            }
        }
    } catch (e) {
        notify(e.message || 'Failed to submit to Google', 'error');
        if (btn) {
            btn.innerHTML = '🚀 Submit to Google';
            btn.disabled = false;
        }
    }
};

window.submitAllSeoToGoogle = async () => {
    const btn = document.getElementById('submit-all-seo-btn');
    if (!confirm("This will submit all unsubmitted pages to Google. Proceed?")) return;
    
    if (btn) {
        btn.innerHTML = `${icon('bolt', 'w-5 h-5 animate-spin')} Submitting All...`;
        btn.disabled = true;
    }
    
    try {
        const res = await request('/admin/seo/submit-all-google', {
            method: 'POST'
        });
        
        if (res.success) {
            notify(res.message || 'Successfully submitted all pages to Google!', 'success');
            state.adminSeoSettings = null;
            render();
        } else {
            notify(res.message || 'Failed to submit all pages to Google', 'error');
            if (btn) {
                btn.innerHTML = '🚀 Submit All to Google';
                btn.disabled = false;
            }
        }
    } catch (e) {
        notify(e.message || 'Failed to submit all pages to Google', 'error');
        if (btn) {
            btn.innerHTML = '🚀 Submit All to Google';
            btn.disabled = false;
        }
    }
};

window.loadPageSeo = async () => {
    // Determine current path
    let path = window.location.hash ? window.location.hash.replace('#', '/') : window.location.pathname;
    if (path.startsWith('//')) path = path.substring(1);
    
    try {
        const res = await fetch(`/api/v1/seo?url=${encodeURIComponent(path)}`);
        if (res.ok) {
            const seo = await res.json();
            if (seo.meta_title) document.title = seo.meta_title;
            
            if (seo.meta_description) {
                let descMeta = document.querySelector('meta[name="description"]');
                if (!descMeta) {
                    descMeta = document.createElement('meta');
                    descMeta.name = "description";
                    document.head.appendChild(descMeta);
                }
                descMeta.content = seo.meta_description;
            }
            
            if (seo.meta_keywords) {
                let keysMeta = document.querySelector('meta[name="keywords"]');
                if (!keysMeta) {
                    keysMeta = document.createElement('meta');
                    keysMeta.name = "keywords";
                    document.head.appendChild(keysMeta);
                }
                keysMeta.content = seo.meta_keywords;
            }
        }
    } catch (e) {
        // silently fail on public site if SEO not found
    }
};

// Listen for hash changes to update SEO
window.addEventListener('hashchange', () => {
    window.loadPageSeo();
});
// Call on initial load
window.loadPageSeo();


